// This file is auto-generated by @hey-api/openapi-ts

export type AIChatRelatedData = {
    ai_chat_session_uuid?: string | null;
    ai_chat_session_message_uuid?: string | null;
};

export type AIChatSession = {
    readonly uuid: string;
    readonly created_at: string;
    readonly messages: Array<AIChatSessionMessage>;
    title?: string;
    description?: string;
    readonly session_state: SessionStateEnum;
    readonly started_by_user: string;
    readonly system_rating: string | null;
    human_rating?: string | null;
    readonly system_rating_explanation: string;
    readonly system_rating_improvement_suggestions: string;
};

export type AIChatSessionMessage = {
    content: string;
    role: AIChatSessionMessageRoleEnum;
    created_at?: string | null;
    uuid?: string | null;
    user_uuid?: string | null;
    context?: CaseAiContext | null;
    organization_context?: OrganizationAiContext | null;
};

export type AIChatSessionMessageRoleEnum = 'system' | 'user' | 'assistant';

export const AIChatSessionMessageRoleEnum = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
} as const;

export type AIChatSessionRequest = {
    title?: string;
    description?: string;
    case_uuid: string;
    human_rating?: string | null;
};

export type AIChatSessionSendMessageRequestRequest = {
    /**
     * The message to send to the AI chat session.
     */
    content: string;
};

export type AIChatSessionSendMessageResponse = {
    message: string;
};

export type ActaportDataRequest = {
    clerk: string;
    assistant: string;
    title: string;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type AdvoluxDataRequest = {
    label: string;
    caseGroup?: number | null;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type AdvowareDataRequest = {
    rubrum: string;
    lawField: string;
    lawTopic: string;
    clerk: string;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type AiAnalysisRelatedData = {
    ai_augmentation_uuid?: string | null;
};

/**
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 * * `law.criminal_law_amount_of_daily_rates` - law.criminal_law_amount_of_daily_rates
 * * `law.criminal_law_applicable_laws` - law.criminal_law_applicable_laws
 * * `law.criminal_law_charge_description` - law.criminal_law_charge_description
 * * `law.criminal_law_complaint` - law.criminal_law_complaint
 * * `law.criminal_law_criminal_warrant` - law.criminal_law_criminal_warrant
 * * `law.criminal_law_damage_description` - law.criminal_law_damage_description
 * * `law.criminal_law_damage_value` - law.criminal_law_damage_value
 * * `law.criminal_law_date_of_offense` - law.criminal_law_date_of_offense
 * * `law.criminal_law_duration_of_prison_sentence` - law.criminal_law_duration_of_prison_sentence
 * * `law.criminal_law_evidence_location` - law.criminal_law_evidence_location
 * * `law.criminal_law_evidence` - law.criminal_law_evidence
 * * `law.criminal_law_incident_description` - law.criminal_law_incident_description
 * * `law.criminal_law_indictment_date` - law.criminal_law_indictment_date
 * * `law.criminal_law_indictment_delivery_date` - law.criminal_law_indictment_delivery_date
 * * `law.criminal_law_indictment` - law.criminal_law_indictment
 * * `law.criminal_law_legal_classification_of_offense` - law.criminal_law_legal_classification_of_offense
 * * `law.criminal_law_means_of_evidence` - law.criminal_law_means_of_evidence
 * * `law.criminal_law_number_of_daily_rates` - law.criminal_law_number_of_daily_rates
 * * `law.criminal_law_offense_type` - law.criminal_law_offense_type
 * * `law.criminal_law_penalty_infromation` - law.criminal_law_penalty_infromation
 * * `law.criminal_law_physical_evidence` - law.criminal_law_physical_evidence
 * * `law.criminal_law_place_of_offense` - law.criminal_law_place_of_offense
 * * `law.criminal_law_police_file_number` - law.criminal_law_police_file_number
 * * `law.criminal_law_preliminary_proceedings_date` - law.criminal_law_preliminary_proceedings_date
 * * `law.criminal_law_prison_sentence` - law.criminal_law_prison_sentence
 * * `law.criminal_law_probation` - law.criminal_law_probation
 * * `law.criminal_law_prosecution_file_number` - law.criminal_law_prosecution_file_number
 * * `law.criminal_law_report_date` - law.criminal_law_report_date
 * * `law.criminal_law_report_time` - law.criminal_law_report_time
 * * `law.criminal_law_time_of_offense` - law.criminal_law_time_of_offense
 * * `law.debt_collection_law_business_fee` - law.debt_collection_law_business_fee
 * * `law.debt_collection_law_case_value` - law.debt_collection_law_case_value
 * * `law.debt_collection_law_invoice_amount` - law.debt_collection_law_invoice_amount
 * * `law.debt_collection_law_invoice_date` - law.debt_collection_law_invoice_date
 * * `law.debt_collection_law_invoice_ground` - law.debt_collection_law_invoice_ground
 * * `law.debt_collection_law_invoice_lawyer` - law.debt_collection_law_invoice_lawyer
 * * `law.debt_collection_law_invoice` - law.debt_collection_law_invoice
 * * `law.debt_collection_law_invoice_number` - law.debt_collection_law_invoice_number
 * * `law.debt_collection_law_invoice_recipient` - law.debt_collection_law_invoice_recipient
 * * `law.debt_collection_law_invoice_tax_number` - law.debt_collection_law_invoice_tax_number
 * * `law.debt_collection_law_lumps_sum_expenses` - law.debt_collection_law_lumps_sum_expenses
 * * `law.debt_collection_law_sales_tax` - law.debt_collection_law_sales_tax
 * * `law.debt_collection_law_subtotal_lawyer_fees` - law.debt_collection_law_subtotal_lawyer_fees
 * * `law.debt_collection_law_total_amount` - law.debt_collection_law_total_amount
 * * `law.external_case_id` - law.external_case_id
 * * `law.family_law_average_net_income` - law.family_law_average_net_income
 * * `law.family_law_birth_certificate` - law.family_law_birth_certificate
 * * `law.family_law_birth_register_number` - law.family_law_birth_register_number
 * * `law.family_law_birth_register_office_location` - law.family_law_birth_register_office_location
 * * `law.family_law_children` - law.family_law_children
 * * `law.family_law_date_of_marriage` - law.family_law_date_of_marriage
 * * `law.family_law_divorce_application` - law.family_law_divorce_application
 * * `law.family_law_divorce_settlement_agreement` - law.family_law_divorce_settlement_agreement
 * * `law.family_law_marriage_certificate` - law.family_law_marriage_certificate
 * * `law.family_law_marriage_contract_date` - law.family_law_marriage_contract_date
 * * `law.family_law_marriage_contract` - law.family_law_marriage_contract
 * * `law.family_law_marriage_register_number` - law.family_law_marriage_register_number
 * * `law.family_law_registry_office_location` - law.family_law_registry_office_location
 * * `law.family_law_separation_date` - law.family_law_separation_date
 * * `law.field` - law.field
 * * `law.generic_document` - law.generic_document
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - law.inheritance_law_certificate_of_inheritance_applicable_law
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - law.inheritance_law_certificate_of_inheritance_date_death
 * * `law.inheritance_law_certificate_of_inheritance_date` - law.inheritance_law_certificate_of_inheritance_date
 * * `law.inheritance_law_certificate_of_inheritance` - law.inheritance_law_certificate_of_inheritance
 * * `law.inheritance_law_certificate_of_inheritance_number` - law.inheritance_law_certificate_of_inheritance_number
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - law.inheritance_law_certificate_of_inheritance_place_of_death
 * * `law.inheritance_law_death_certificate_date_death` - law.inheritance_law_death_certificate_date_death
 * * `law.inheritance_law_death_certificate_date` - law.inheritance_law_death_certificate_date
 * * `law.inheritance_law_death_certificate` - law.inheritance_law_death_certificate
 * * `law.inheritance_law_death_certificate_number` - law.inheritance_law_death_certificate_number
 * * `law.inheritance_law_death_certificate_place_death` - law.inheritance_law_death_certificate_place_death
 * * `law.inheritance_law_death_certificate_place` - law.inheritance_law_death_certificate_place
 * * `law.inheritance_law_death_certificate_time_death` - law.inheritance_law_death_certificate_time_death
 * * `law.inheritance_law_estate_inventory_amount` - law.inheritance_law_estate_inventory_amount
 * * `law.inheritance_law_estate_inventory_date` - law.inheritance_law_estate_inventory_date
 * * `law.inheritance_law_estate_inventory_status` - law.inheritance_law_estate_inventory_status
 * * `law.inheritance_law_inheritance_contract_date` - law.inheritance_law_inheritance_contract_date
 * * `law.inheritance_law_inheritance_contract` - law.inheritance_law_inheritance_contract
 * * `law.inheritance_law_lasting_power_of_attorney_date` - law.inheritance_law_lasting_power_of_attorney_date
 * * `law.inheritance_law_lasting_power_of_attorney` - law.inheritance_law_lasting_power_of_attorney
 * * `law.inheritance_law_list_of_estate` - law.inheritance_law_list_of_estate
 * * `law.inheritance_law_living_will` - law.inheritance_law_living_will
 * * `law.inheritance_law_patient_enrollment_date` - law.inheritance_law_patient_enrollment_date
 * * `law.inheritance_law_testament_date` - law.inheritance_law_testament_date
 * * `law.inheritance_law_will` - law.inheritance_law_will
 * * `law.labor_law_beginning_of_employment` - law.labor_law_beginning_of_employment
 * * `law.labor_law_child_allowances` - law.labor_law_child_allowances
 * * `law.labor_law_collective_agreement` - law.labor_law_collective_agreement
 * * `law.labor_law_company_agreement` - law.labor_law_company_agreement
 * * `law.labor_law_different_place_of_work` - law.labor_law_different_place_of_work
 * * `law.labor_law_employee_probation_period_end_date` - law.labor_law_employee_probation_period_end_date
 * * `law.labor_law_fixed_term_contract_duration` - law.labor_law_fixed_term_contract_duration
 * * `law.labor_law_fixed_term_contract` - law.labor_law_fixed_term_contract
 * * `law.labor_law_is_employee_in_probation_period` - law.labor_law_is_employee_in_probation_period
 * * `law.labor_law_job_title` - law.labor_law_job_title
 * * `law.labor_law_married` - law.labor_law_married
 * * `law.labor_law_monthly_gross_salary` - law.labor_law_monthly_gross_salary
 * * `law.labor_law_monthly_working_days` - law.labor_law_monthly_working_days
 * * `law.labor_law_notice_period` - law.labor_law_notice_period
 * * `law.labor_law_payslip` - law.labor_law_payslip
 * * `law.labor_law_place_of_work` - law.labor_law_place_of_work
 * * `law.labor_law_settlement_agreement_date` - law.labor_law_settlement_agreement_date
 * * `law.labor_law_settlement_agreement` - law.labor_law_settlement_agreement
 * * `law.labor_law_signature_of_employer` - law.labor_law_signature_of_employer
 * * `law.labor_law_special_payments_amount` - law.labor_law_special_payments_amount
 * * `law.labor_law_special_payments` - law.labor_law_special_payments
 * * `law.labor_law_special_protection_against_dismissal` - law.labor_law_special_protection_against_dismissal
 * * `law.labor_law_termination_access_to_termination_to_employee` - law.labor_law_termination_access_to_termination_to_employee
 * * `law.labor_law_termination_agreement_date` - law.labor_law_termination_agreement_date
 * * `law.labor_law_termination_agreement` - law.labor_law_termination_agreement
 * * `law.labor_law_termination_agreement_severance_pay_amount` - law.labor_law_termination_agreement_severance_pay_amount
 * * `law.labor_law_termination_agreement_termination_date` - law.labor_law_termination_agreement_termination_date
 * * `law.labor_law_termination_date_effective` - law.labor_law_termination_date_effective
 * * `law.labor_law_termination_date` - law.labor_law_termination_date
 * * `law.labor_law_termination_employer_more_than_10_employees` - law.labor_law_termination_employer_more_than_10_employees
 * * `law.labor_law_termination_is_agreement_severance_pay` - law.labor_law_termination_is_agreement_severance_pay
 * * `law.labor_law_termination` - law.labor_law_termination
 * * `law.labor_law_vacation_days` - law.labor_law_vacation_days
 * * `law.labor_law_wanring_letter_access_to_warning_letter_to_employee` - law.labor_law_wanring_letter_access_to_warning_letter_to_employee
 * * `law.labor_law_warning_letter_date` - law.labor_law_warning_letter_date
 * * `law.labor_law_warning_letter_incident_date` - law.labor_law_warning_letter_incident_date
 * * `law.labor_law_warning_letter_incident_location` - law.labor_law_warning_letter_incident_location
 * * `law.labor_law_warning_letter_incident_time` - law.labor_law_warning_letter_incident_time
 * * `law.labor_law_warning_letter` - law.labor_law_warning_letter
 * * `law.labor_law_warning_letter_reason` - law.labor_law_warning_letter_reason
 * * `law.labor_law_work_contract` - law.labor_law_work_contract
 * * `law.labor_law_work_council` - law.labor_law_work_council
 * * `law.labor_law_work_hours_per_week` - law.labor_law_work_hours_per_week
 * * `law.labor_law_yearly_gross_salary` - law.labor_law_yearly_gross_salary
 * * `law.real_estate_law_basic_debts_amount` - law.real_estate_law_basic_debts_amount
 * * `law.real_estate_law_encumbrance_restrictions` - law.real_estate_law_encumbrance_restrictions
 * * `law.real_estate_law_land_register_address` - law.real_estate_law_land_register_address
 * * `law.real_estate_law_land_register_city` - law.real_estate_law_land_register_city
 * * `law.real_estate_law_land_register_date` - law.real_estate_law_land_register_date
 * * `law.real_estate_law_land_register` - law.real_estate_law_land_register
 * * `law.real_estate_law_land_register_number` - law.real_estate_law_land_register_number
 * * `law.real_estate_law_land_register_plot_of_land` - law.real_estate_law_land_register_plot_of_land
 * * `law.real_estate_law_purchase_contract_amount` - law.real_estate_law_purchase_contract_amount
 * * `law.real_estate_law_purchase_contract_date` - law.real_estate_law_purchase_contract_date
 * * `law.real_estate_law_purchase_contract_description` - law.real_estate_law_purchase_contract_description
 * * `law.real_estate_law_purchase_contract` - law.real_estate_law_purchase_contract
 * * `law.real_estate_law_purchase_contract_registration_date` - law.real_estate_law_purchase_contract_registration_date
 * * `law.residential_property_law_co_ownership_shares` - law.residential_property_law_co_ownership_shares
 * * `law.residential_property_law_contract_date` - law.residential_property_law_contract_date
 * * `law.residential_property_law_contract` - law.residential_property_law_contract
 * * `law.residential_property_law_inventory` - law.residential_property_law_inventory
 * * `law.residential_property_law_land_register_address` - law.residential_property_law_land_register_address
 * * `law.residential_property_law_land_register_city` - law.residential_property_law_land_register_city
 * * `law.residential_property_law_land_register_number` - law.residential_property_law_land_register_number
 * * `law.residential_property_law_land_register_plot_of_land` - law.residential_property_law_land_register_plot_of_land
 * * `law.social_law_application_arrival_date` - law.social_law_application_arrival_date
 * * `law.social_law_application_date` - law.social_law_application_date
 * * `law.social_law_notice_date` - law.social_law_notice_date
 * * `law.social_law_notice_of_objection_date` - law.social_law_notice_of_objection_date
 * * `law.social_law_notice_of_objection` - law.social_law_notice_of_objection
 * * `law.social_law_summary_grounds_opposition` - law.social_law_summary_grounds_opposition
 * * `law.tenancy_law_adress_rental_property` - law.tenancy_law_adress_rental_property
 * * `law.tenancy_law_advance_payment_service_charge` - law.tenancy_law_advance_payment_service_charge
 * * `law.tenancy_law_advance_payment_service_charges` - law.tenancy_law_advance_payment_service_charges
 * * `law.tenancy_law_cost_share` - law.tenancy_law_cost_share
 * * `law.tenancy_law_cost_shares` - law.tenancy_law_cost_shares
 * * `law.tenancy_law_counter_number` - law.tenancy_law_counter_number
 * * `law.tenancy_law_description_of_rental_property` - law.tenancy_law_description_of_rental_property
 * * `law.tenancy_law_duration_of_lease` - law.tenancy_law_duration_of_lease
 * * `law.tenancy_law_fixed_term_tenancy` - law.tenancy_law_fixed_term_tenancy
 * * `law.tenancy_law_gross_rent` - law.tenancy_law_gross_rent
 * * `law.tenancy_law_handover_counter` - law.tenancy_law_handover_counter
 * * `law.tenancy_law_handover_date` - law.tenancy_law_handover_date
 * * `law.tenancy_law_handover_defects` - law.tenancy_law_handover_defects
 * * `law.tenancy_law_handover_protocol` - law.tenancy_law_handover_protocol
 * * `law.tenancy_law_lease_agreement` - law.tenancy_law_lease_agreement
 * * `law.tenancy_law_location_in_rental_property` - law.tenancy_law_location_in_rental_property
 * * `law.tenancy_law_net_rent` - law.tenancy_law_net_rent
 * * `law.tenancy_law_rental_agreement_date` - law.tenancy_law_rental_agreement_date
 * * `law.tenancy_law_rental_agreement` - law.tenancy_law_rental_agreement
 * * `law.tenancy_law_rental_agreement_validity_end` - law.tenancy_law_rental_agreement_validity_end
 * * `law.tenancy_law_rental_agreement_validity_start` - law.tenancy_law_rental_agreement_validity_start
 * * `law.tenancy_law_repayment` - law.tenancy_law_repayment
 * * `law.tenancy_law_repayment_period_end` - law.tenancy_law_repayment_period_end
 * * `law.tenancy_law_repayment_period_start` - law.tenancy_law_repayment_period_start
 * * `law.tenancy_law_service_charge_settlement` - law.tenancy_law_service_charge_settlement
 * * `law.tenancy_law_staggered_rental_agreement` - law.tenancy_law_staggered_rental_agreement
 * * `law.tenancy_law_start_of_lease` - law.tenancy_law_start_of_lease
 * * `law.tenancy_law_total_cost_service_charge` - law.tenancy_law_total_cost_service_charge
 * * `law.tenancy_law_total_rent` - law.tenancy_law_total_rent
 * * `law.tenancy_law_unlimited_term_tenancy` - law.tenancy_law_unlimited_term_tenancy
 * * `law.topic` - law.topic
 * * `law.traffic_law_accident_date` - law.traffic_law_accident_date
 * * `law.traffic_law_accident_report` - law.traffic_law_accident_report
 * * `law.traffic_law_amount_of_fine` - law.traffic_law_amount_of_fine
 * * `law.traffic_law_appeal_instruction` - law.traffic_law_appeal_instruction
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - law.traffic_law_at_fault_driver_drivers_license_issued_by
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - law.traffic_law_at_fault_driver_drivers_license_valid_until
 * * `law.traffic_law_at_fault_driver_green_card_number` - law.traffic_law_at_fault_driver_green_card_number
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - law.traffic_law_at_fault_driver_insurance_expiry_date
 * * `law.traffic_law_at_fault_driver_insurance_number` - law.traffic_law_at_fault_driver_insurance_number
 * * `law.traffic_law_at_fault_driver_insurer` - law.traffic_law_at_fault_driver_insurer
 * * `law.traffic_law_blood_alcohol_concentration` - law.traffic_law_blood_alcohol_concentration
 * * `law.traffic_law_calculated_total_damage_costs` - law.traffic_law_calculated_total_damage_costs
 * * `law.traffic_law_calculated_total_days` - law.traffic_law_calculated_total_days
 * * `law.traffic_law_charges` - law.traffic_law_charges
 * * `law.traffic_law_cost_per_scale` - law.traffic_law_cost_per_scale
 * * `law.traffic_law_daily_rate` - law.traffic_law_daily_rate
 * * `law.traffic_law_damage_number` - law.traffic_law_damage_number
 * * `law.traffic_law_damage_scope` - law.traffic_law_damage_scope
 * * `law.traffic_law_date_of_accident` - law.traffic_law_date_of_accident
 * * `law.traffic_law_date_of_crime` - law.traffic_law_date_of_crime
 * * `law.traffic_law_date_of_fine` - law.traffic_law_date_of_fine
 * * `law.traffic_law_date_of_infraction` - law.traffic_law_date_of_infraction
 * * `law.traffic_law_date_of_inspection` - law.traffic_law_date_of_inspection
 * * `law.traffic_law_date_of_issue` - law.traffic_law_date_of_issue
 * * `law.traffic_law_date_of_offense` - law.traffic_law_date_of_offense
 * * `law.traffic_law_date_of_report` - law.traffic_law_date_of_report
 * * `law.traffic_law_differencial_tax` - law.traffic_law_differencial_tax
 * * `law.traffic_law_driver_logbook_required` - law.traffic_law_driver_logbook_required
 * * `law.traffic_law_driving_ban_duration` - law.traffic_law_driving_ban_duration
 * * `law.traffic_law_driving_ban` - law.traffic_law_driving_ban
 * * `law.traffic_law_evidence_infraction` - law.traffic_law_evidence_infraction
 * * `law.traffic_law_expert_cost` - law.traffic_law_expert_cost
 * * `law.traffic_law_expert_date` - law.traffic_law_expert_date
 * * `law.traffic_law_expert_report` - law.traffic_law_expert_report
 * * `law.traffic_law_expert_report_number` - law.traffic_law_expert_report_number
 * * `law.traffic_law_file_number` - law.traffic_law_file_number
 * * `law.traffic_law_fine` - law.traffic_law_fine
 * * `law.traffic_law_fine_notice` - law.traffic_law_fine_notice
 * * `law.traffic_law_gross_gross_replacement_value` - law.traffic_law_gross_gross_replacement_value
 * * `law.traffic_law_gross_replacement_value` - law.traffic_law_gross_replacement_value
 * * `law.traffic_law_injured` - law.traffic_law_injured
 * * `law.traffic_law_insurance_holder` - law.traffic_law_insurance_holder
 * * `law.traffic_law_insurance` - law.traffic_law_insurance
 * * `law.traffic_law_insurance_policy_number` - law.traffic_law_insurance_policy_number
 * * `law.traffic_law_legal_basis_infraction` - law.traffic_law_legal_basis_infraction
 * * `law.traffic_law_legal_basis` - law.traffic_law_legal_basis
 * * `law.traffic_law_licenseplate_at_fault_driver` - law.traffic_law_licenseplate_at_fault_driver
 * * `law.traffic_law_licenseplate` - law.traffic_law_licenseplate
 * * `law.traffic_law_licenseplate_victim_driver` - law.traffic_law_licenseplate_victim_driver
 * * `law.traffic_law_loss_amount_repair_case` - law.traffic_law_loss_amount_repair_case
 * * `law.traffic_law_loss_amount_total_damage_case` - law.traffic_law_loss_amount_total_damage_case
 * * `law.traffic_law_loss_of_use_per_day` - law.traffic_law_loss_of_use_per_day
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - law.traffic_law_mark_and_type_of_at_fault_driver
 * * `law.traffic_law_mark_and_type_of_victim_driver` - law.traffic_law_mark_and_type_of_victim_driver
 * * `law.traffic_law_merantile_value_loss` - law.traffic_law_merantile_value_loss
 * * `law.traffic_law_net_gross_replacement_value` - law.traffic_law_net_gross_replacement_value
 * * `law.traffic_law_net_replacement_value` - law.traffic_law_net_replacement_value
 * * `law.traffic_law_number_of_daily_rates` - law.traffic_law_number_of_daily_rates
 * * `law.traffic_law_offense_infraction_description` - law.traffic_law_offense_infraction_description
 * * `law.traffic_law_other_damages` - law.traffic_law_other_damages
 * * `law.traffic_law_payment_deadline` - law.traffic_law_payment_deadline
 * * `law.traffic_law_penalty_order` - law.traffic_law_penalty_order
 * * `law.traffic_law_place_of_accident` - law.traffic_law_place_of_accident
 * * `law.traffic_law_place_of_crime` - law.traffic_law_place_of_crime
 * * `law.traffic_law_place_of_infraction` - law.traffic_law_place_of_infraction
 * * `law.traffic_law_place_of_inspection` - law.traffic_law_place_of_inspection
 * * `law.traffic_law_place_of_issue` - law.traffic_law_place_of_issue
 * * `law.traffic_law_place_of_offense` - law.traffic_law_place_of_offense
 * * `law.traffic_law_points_for_offense` - law.traffic_law_points_for_offense
 * * `law.traffic_law_police_case_number` - law.traffic_law_police_case_number
 * * `law.traffic_law_procedure_costs` - law.traffic_law_procedure_costs
 * * `law.traffic_law_prosecution_number` - law.traffic_law_prosecution_number
 * * `law.traffic_law_regular_tax` - law.traffic_law_regular_tax
 * * `law.traffic_law_repair_costs_with_vat` - law.traffic_law_repair_costs_with_vat
 * * `law.traffic_law_repair_costs_without_vat` - law.traffic_law_repair_costs_without_vat
 * * `law.traffic_law_repair_duration` - law.traffic_law_repair_duration
 * * `law.traffic_law_replacement_cost` - law.traffic_law_replacement_cost
 * * `law.traffic_law_replacement_value` - law.traffic_law_replacement_value
 * * `law.traffic_law_reregistration_cost` - law.traffic_law_reregistration_cost
 * * `law.traffic_law_residual_value` - law.traffic_law_residual_value
 * * `law.traffic_law_speed_allowed` - law.traffic_law_speed_allowed
 * * `law.traffic_law_speed_driven` - law.traffic_law_speed_driven
 * * `law.traffic_law_speed_too_high` - law.traffic_law_speed_too_high
 * * `law.traffic_law_time_of_accident` - law.traffic_law_time_of_accident
 * * `law.traffic_law_time_of_crime` - law.traffic_law_time_of_crime
 * * `law.traffic_law_time_of_infraction` - law.traffic_law_time_of_infraction
 * * `law.traffic_law_time_of_inspection` - law.traffic_law_time_of_inspection
 * * `law.traffic_law_time_of_issue` - law.traffic_law_time_of_issue
 * * `law.traffic_law_time_of_offense` - law.traffic_law_time_of_offense
 * * `law.traffic_law_vehicle_age_months` - law.traffic_law_vehicle_age_months
 * * `law.traffic_law_vehicle_mileage` - law.traffic_law_vehicle_mileage
 * * `law.traffic_law_vehicle_type_and_brand` - law.traffic_law_vehicle_type_and_brand
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - law.traffic_law_victim_driver_drivers_license_issued_by
 * * `law.traffic_law_victim_driver_green_card_number` - law.traffic_law_victim_driver_green_card_number
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - law.traffic_law_victim_driver_insurance_expiry_date
 * * `law.traffic_law_victim_driver_insurance_number` - law.traffic_law_victim_driver_insurance_number
 * * `law.traffic_law_victim_driver_insurer` - law.traffic_law_victim_driver_insurer
 * * `law.traffic_law_victim_driver_license_valid_until` - law.traffic_law_victim_driver_license_valid_until
 * * `law.traffic_law_violated_section` - law.traffic_law_violated_section
 * * `law.traffic_law_violation_type` - law.traffic_law_violation_type
 * * `law.traffic_law_warning_fee_infraction` - law.traffic_law_warning_fee_infraction
 * * `law.traffic_law_warning_notice` - law.traffic_law_warning_notice
 */
export type AiAugmentedByMapperKeysEnum = 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip' | 'law.criminal_law_amount_of_daily_rates' | 'law.criminal_law_applicable_laws' | 'law.criminal_law_charge_description' | 'law.criminal_law_complaint' | 'law.criminal_law_criminal_warrant' | 'law.criminal_law_damage_description' | 'law.criminal_law_damage_value' | 'law.criminal_law_date_of_offense' | 'law.criminal_law_duration_of_prison_sentence' | 'law.criminal_law_evidence_location' | 'law.criminal_law_evidence' | 'law.criminal_law_incident_description' | 'law.criminal_law_indictment_date' | 'law.criminal_law_indictment_delivery_date' | 'law.criminal_law_indictment' | 'law.criminal_law_legal_classification_of_offense' | 'law.criminal_law_means_of_evidence' | 'law.criminal_law_number_of_daily_rates' | 'law.criminal_law_offense_type' | 'law.criminal_law_penalty_infromation' | 'law.criminal_law_physical_evidence' | 'law.criminal_law_place_of_offense' | 'law.criminal_law_police_file_number' | 'law.criminal_law_preliminary_proceedings_date' | 'law.criminal_law_prison_sentence' | 'law.criminal_law_probation' | 'law.criminal_law_prosecution_file_number' | 'law.criminal_law_report_date' | 'law.criminal_law_report_time' | 'law.criminal_law_time_of_offense' | 'law.debt_collection_law_business_fee' | 'law.debt_collection_law_case_value' | 'law.debt_collection_law_invoice_amount' | 'law.debt_collection_law_invoice_date' | 'law.debt_collection_law_invoice_ground' | 'law.debt_collection_law_invoice_lawyer' | 'law.debt_collection_law_invoice' | 'law.debt_collection_law_invoice_number' | 'law.debt_collection_law_invoice_recipient' | 'law.debt_collection_law_invoice_tax_number' | 'law.debt_collection_law_lumps_sum_expenses' | 'law.debt_collection_law_sales_tax' | 'law.debt_collection_law_subtotal_lawyer_fees' | 'law.debt_collection_law_total_amount' | 'law.external_case_id' | 'law.family_law_average_net_income' | 'law.family_law_birth_certificate' | 'law.family_law_birth_register_number' | 'law.family_law_birth_register_office_location' | 'law.family_law_children' | 'law.family_law_date_of_marriage' | 'law.family_law_divorce_application' | 'law.family_law_divorce_settlement_agreement' | 'law.family_law_marriage_certificate' | 'law.family_law_marriage_contract_date' | 'law.family_law_marriage_contract' | 'law.family_law_marriage_register_number' | 'law.family_law_registry_office_location' | 'law.family_law_separation_date' | 'law.field' | 'law.generic_document' | 'law.inheritance_law_certificate_of_inheritance_applicable_law' | 'law.inheritance_law_certificate_of_inheritance_date_death' | 'law.inheritance_law_certificate_of_inheritance_date' | 'law.inheritance_law_certificate_of_inheritance' | 'law.inheritance_law_certificate_of_inheritance_number' | 'law.inheritance_law_certificate_of_inheritance_place_of_death' | 'law.inheritance_law_death_certificate_date_death' | 'law.inheritance_law_death_certificate_date' | 'law.inheritance_law_death_certificate' | 'law.inheritance_law_death_certificate_number' | 'law.inheritance_law_death_certificate_place_death' | 'law.inheritance_law_death_certificate_place' | 'law.inheritance_law_death_certificate_time_death' | 'law.inheritance_law_estate_inventory_amount' | 'law.inheritance_law_estate_inventory_date' | 'law.inheritance_law_estate_inventory_status' | 'law.inheritance_law_inheritance_contract_date' | 'law.inheritance_law_inheritance_contract' | 'law.inheritance_law_lasting_power_of_attorney_date' | 'law.inheritance_law_lasting_power_of_attorney' | 'law.inheritance_law_list_of_estate' | 'law.inheritance_law_living_will' | 'law.inheritance_law_patient_enrollment_date' | 'law.inheritance_law_testament_date' | 'law.inheritance_law_will' | 'law.labor_law_beginning_of_employment' | 'law.labor_law_child_allowances' | 'law.labor_law_collective_agreement' | 'law.labor_law_company_agreement' | 'law.labor_law_different_place_of_work' | 'law.labor_law_employee_probation_period_end_date' | 'law.labor_law_fixed_term_contract_duration' | 'law.labor_law_fixed_term_contract' | 'law.labor_law_is_employee_in_probation_period' | 'law.labor_law_job_title' | 'law.labor_law_married' | 'law.labor_law_monthly_gross_salary' | 'law.labor_law_monthly_working_days' | 'law.labor_law_notice_period' | 'law.labor_law_payslip' | 'law.labor_law_place_of_work' | 'law.labor_law_settlement_agreement_date' | 'law.labor_law_settlement_agreement' | 'law.labor_law_signature_of_employer' | 'law.labor_law_special_payments_amount' | 'law.labor_law_special_payments' | 'law.labor_law_special_protection_against_dismissal' | 'law.labor_law_termination_access_to_termination_to_employee' | 'law.labor_law_termination_agreement_date' | 'law.labor_law_termination_agreement' | 'law.labor_law_termination_agreement_severance_pay_amount' | 'law.labor_law_termination_agreement_termination_date' | 'law.labor_law_termination_date_effective' | 'law.labor_law_termination_date' | 'law.labor_law_termination_employer_more_than_10_employees' | 'law.labor_law_termination_is_agreement_severance_pay' | 'law.labor_law_termination' | 'law.labor_law_vacation_days' | 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee' | 'law.labor_law_warning_letter_date' | 'law.labor_law_warning_letter_incident_date' | 'law.labor_law_warning_letter_incident_location' | 'law.labor_law_warning_letter_incident_time' | 'law.labor_law_warning_letter' | 'law.labor_law_warning_letter_reason' | 'law.labor_law_work_contract' | 'law.labor_law_work_council' | 'law.labor_law_work_hours_per_week' | 'law.labor_law_yearly_gross_salary' | 'law.real_estate_law_basic_debts_amount' | 'law.real_estate_law_encumbrance_restrictions' | 'law.real_estate_law_land_register_address' | 'law.real_estate_law_land_register_city' | 'law.real_estate_law_land_register_date' | 'law.real_estate_law_land_register' | 'law.real_estate_law_land_register_number' | 'law.real_estate_law_land_register_plot_of_land' | 'law.real_estate_law_purchase_contract_amount' | 'law.real_estate_law_purchase_contract_date' | 'law.real_estate_law_purchase_contract_description' | 'law.real_estate_law_purchase_contract' | 'law.real_estate_law_purchase_contract_registration_date' | 'law.residential_property_law_co_ownership_shares' | 'law.residential_property_law_contract_date' | 'law.residential_property_law_contract' | 'law.residential_property_law_inventory' | 'law.residential_property_law_land_register_address' | 'law.residential_property_law_land_register_city' | 'law.residential_property_law_land_register_number' | 'law.residential_property_law_land_register_plot_of_land' | 'law.social_law_application_arrival_date' | 'law.social_law_application_date' | 'law.social_law_notice_date' | 'law.social_law_notice_of_objection_date' | 'law.social_law_notice_of_objection' | 'law.social_law_summary_grounds_opposition' | 'law.tenancy_law_adress_rental_property' | 'law.tenancy_law_advance_payment_service_charge' | 'law.tenancy_law_advance_payment_service_charges' | 'law.tenancy_law_cost_share' | 'law.tenancy_law_cost_shares' | 'law.tenancy_law_counter_number' | 'law.tenancy_law_description_of_rental_property' | 'law.tenancy_law_duration_of_lease' | 'law.tenancy_law_fixed_term_tenancy' | 'law.tenancy_law_gross_rent' | 'law.tenancy_law_handover_counter' | 'law.tenancy_law_handover_date' | 'law.tenancy_law_handover_defects' | 'law.tenancy_law_handover_protocol' | 'law.tenancy_law_lease_agreement' | 'law.tenancy_law_location_in_rental_property' | 'law.tenancy_law_net_rent' | 'law.tenancy_law_rental_agreement_date' | 'law.tenancy_law_rental_agreement' | 'law.tenancy_law_rental_agreement_validity_end' | 'law.tenancy_law_rental_agreement_validity_start' | 'law.tenancy_law_repayment' | 'law.tenancy_law_repayment_period_end' | 'law.tenancy_law_repayment_period_start' | 'law.tenancy_law_service_charge_settlement' | 'law.tenancy_law_staggered_rental_agreement' | 'law.tenancy_law_start_of_lease' | 'law.tenancy_law_total_cost_service_charge' | 'law.tenancy_law_total_rent' | 'law.tenancy_law_unlimited_term_tenancy' | 'law.topic' | 'law.traffic_law_accident_date' | 'law.traffic_law_accident_report' | 'law.traffic_law_amount_of_fine' | 'law.traffic_law_appeal_instruction' | 'law.traffic_law_at_fault_driver_drivers_license_issued_by' | 'law.traffic_law_at_fault_driver_drivers_license_valid_until' | 'law.traffic_law_at_fault_driver_green_card_number' | 'law.traffic_law_at_fault_driver_insurance_expiry_date' | 'law.traffic_law_at_fault_driver_insurance_number' | 'law.traffic_law_at_fault_driver_insurer' | 'law.traffic_law_blood_alcohol_concentration' | 'law.traffic_law_calculated_total_damage_costs' | 'law.traffic_law_calculated_total_days' | 'law.traffic_law_charges' | 'law.traffic_law_cost_per_scale' | 'law.traffic_law_daily_rate' | 'law.traffic_law_damage_number' | 'law.traffic_law_damage_scope' | 'law.traffic_law_date_of_accident' | 'law.traffic_law_date_of_crime' | 'law.traffic_law_date_of_fine' | 'law.traffic_law_date_of_infraction' | 'law.traffic_law_date_of_inspection' | 'law.traffic_law_date_of_issue' | 'law.traffic_law_date_of_offense' | 'law.traffic_law_date_of_report' | 'law.traffic_law_differencial_tax' | 'law.traffic_law_driver_logbook_required' | 'law.traffic_law_driving_ban_duration' | 'law.traffic_law_driving_ban' | 'law.traffic_law_evidence_infraction' | 'law.traffic_law_expert_cost' | 'law.traffic_law_expert_date' | 'law.traffic_law_expert_report' | 'law.traffic_law_expert_report_number' | 'law.traffic_law_file_number' | 'law.traffic_law_fine' | 'law.traffic_law_fine_notice' | 'law.traffic_law_gross_gross_replacement_value' | 'law.traffic_law_gross_replacement_value' | 'law.traffic_law_injured' | 'law.traffic_law_insurance_holder' | 'law.traffic_law_insurance' | 'law.traffic_law_insurance_policy_number' | 'law.traffic_law_legal_basis_infraction' | 'law.traffic_law_legal_basis' | 'law.traffic_law_licenseplate_at_fault_driver' | 'law.traffic_law_licenseplate' | 'law.traffic_law_licenseplate_victim_driver' | 'law.traffic_law_loss_amount_repair_case' | 'law.traffic_law_loss_amount_total_damage_case' | 'law.traffic_law_loss_of_use_per_day' | 'law.traffic_law_mark_and_type_of_at_fault_driver' | 'law.traffic_law_mark_and_type_of_victim_driver' | 'law.traffic_law_merantile_value_loss' | 'law.traffic_law_net_gross_replacement_value' | 'law.traffic_law_net_replacement_value' | 'law.traffic_law_number_of_daily_rates' | 'law.traffic_law_offense_infraction_description' | 'law.traffic_law_other_damages' | 'law.traffic_law_payment_deadline' | 'law.traffic_law_penalty_order' | 'law.traffic_law_place_of_accident' | 'law.traffic_law_place_of_crime' | 'law.traffic_law_place_of_infraction' | 'law.traffic_law_place_of_inspection' | 'law.traffic_law_place_of_issue' | 'law.traffic_law_place_of_offense' | 'law.traffic_law_points_for_offense' | 'law.traffic_law_police_case_number' | 'law.traffic_law_procedure_costs' | 'law.traffic_law_prosecution_number' | 'law.traffic_law_regular_tax' | 'law.traffic_law_repair_costs_with_vat' | 'law.traffic_law_repair_costs_without_vat' | 'law.traffic_law_repair_duration' | 'law.traffic_law_replacement_cost' | 'law.traffic_law_replacement_value' | 'law.traffic_law_reregistration_cost' | 'law.traffic_law_residual_value' | 'law.traffic_law_speed_allowed' | 'law.traffic_law_speed_driven' | 'law.traffic_law_speed_too_high' | 'law.traffic_law_time_of_accident' | 'law.traffic_law_time_of_crime' | 'law.traffic_law_time_of_infraction' | 'law.traffic_law_time_of_inspection' | 'law.traffic_law_time_of_issue' | 'law.traffic_law_time_of_offense' | 'law.traffic_law_vehicle_age_months' | 'law.traffic_law_vehicle_mileage' | 'law.traffic_law_vehicle_type_and_brand' | 'law.traffic_law_victim_driver_drivers_license_issued_by' | 'law.traffic_law_victim_driver_green_card_number' | 'law.traffic_law_victim_driver_insurance_expiry_date' | 'law.traffic_law_victim_driver_insurance_number' | 'law.traffic_law_victim_driver_insurer' | 'law.traffic_law_victim_driver_license_valid_until' | 'law.traffic_law_violated_section' | 'law.traffic_law_violation_type' | 'law.traffic_law_warning_fee_infraction' | 'law.traffic_law_warning_notice';

/**
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 * * `law.criminal_law_amount_of_daily_rates` - law.criminal_law_amount_of_daily_rates
 * * `law.criminal_law_applicable_laws` - law.criminal_law_applicable_laws
 * * `law.criminal_law_charge_description` - law.criminal_law_charge_description
 * * `law.criminal_law_complaint` - law.criminal_law_complaint
 * * `law.criminal_law_criminal_warrant` - law.criminal_law_criminal_warrant
 * * `law.criminal_law_damage_description` - law.criminal_law_damage_description
 * * `law.criminal_law_damage_value` - law.criminal_law_damage_value
 * * `law.criminal_law_date_of_offense` - law.criminal_law_date_of_offense
 * * `law.criminal_law_duration_of_prison_sentence` - law.criminal_law_duration_of_prison_sentence
 * * `law.criminal_law_evidence_location` - law.criminal_law_evidence_location
 * * `law.criminal_law_evidence` - law.criminal_law_evidence
 * * `law.criminal_law_incident_description` - law.criminal_law_incident_description
 * * `law.criminal_law_indictment_date` - law.criminal_law_indictment_date
 * * `law.criminal_law_indictment_delivery_date` - law.criminal_law_indictment_delivery_date
 * * `law.criminal_law_indictment` - law.criminal_law_indictment
 * * `law.criminal_law_legal_classification_of_offense` - law.criminal_law_legal_classification_of_offense
 * * `law.criminal_law_means_of_evidence` - law.criminal_law_means_of_evidence
 * * `law.criminal_law_number_of_daily_rates` - law.criminal_law_number_of_daily_rates
 * * `law.criminal_law_offense_type` - law.criminal_law_offense_type
 * * `law.criminal_law_penalty_infromation` - law.criminal_law_penalty_infromation
 * * `law.criminal_law_physical_evidence` - law.criminal_law_physical_evidence
 * * `law.criminal_law_place_of_offense` - law.criminal_law_place_of_offense
 * * `law.criminal_law_police_file_number` - law.criminal_law_police_file_number
 * * `law.criminal_law_preliminary_proceedings_date` - law.criminal_law_preliminary_proceedings_date
 * * `law.criminal_law_prison_sentence` - law.criminal_law_prison_sentence
 * * `law.criminal_law_probation` - law.criminal_law_probation
 * * `law.criminal_law_prosecution_file_number` - law.criminal_law_prosecution_file_number
 * * `law.criminal_law_report_date` - law.criminal_law_report_date
 * * `law.criminal_law_report_time` - law.criminal_law_report_time
 * * `law.criminal_law_time_of_offense` - law.criminal_law_time_of_offense
 * * `law.debt_collection_law_business_fee` - law.debt_collection_law_business_fee
 * * `law.debt_collection_law_case_value` - law.debt_collection_law_case_value
 * * `law.debt_collection_law_invoice_amount` - law.debt_collection_law_invoice_amount
 * * `law.debt_collection_law_invoice_date` - law.debt_collection_law_invoice_date
 * * `law.debt_collection_law_invoice_ground` - law.debt_collection_law_invoice_ground
 * * `law.debt_collection_law_invoice_lawyer` - law.debt_collection_law_invoice_lawyer
 * * `law.debt_collection_law_invoice` - law.debt_collection_law_invoice
 * * `law.debt_collection_law_invoice_number` - law.debt_collection_law_invoice_number
 * * `law.debt_collection_law_invoice_recipient` - law.debt_collection_law_invoice_recipient
 * * `law.debt_collection_law_invoice_tax_number` - law.debt_collection_law_invoice_tax_number
 * * `law.debt_collection_law_lumps_sum_expenses` - law.debt_collection_law_lumps_sum_expenses
 * * `law.debt_collection_law_sales_tax` - law.debt_collection_law_sales_tax
 * * `law.debt_collection_law_subtotal_lawyer_fees` - law.debt_collection_law_subtotal_lawyer_fees
 * * `law.debt_collection_law_total_amount` - law.debt_collection_law_total_amount
 * * `law.external_case_id` - law.external_case_id
 * * `law.family_law_average_net_income` - law.family_law_average_net_income
 * * `law.family_law_birth_certificate` - law.family_law_birth_certificate
 * * `law.family_law_birth_register_number` - law.family_law_birth_register_number
 * * `law.family_law_birth_register_office_location` - law.family_law_birth_register_office_location
 * * `law.family_law_children` - law.family_law_children
 * * `law.family_law_date_of_marriage` - law.family_law_date_of_marriage
 * * `law.family_law_divorce_application` - law.family_law_divorce_application
 * * `law.family_law_divorce_settlement_agreement` - law.family_law_divorce_settlement_agreement
 * * `law.family_law_marriage_certificate` - law.family_law_marriage_certificate
 * * `law.family_law_marriage_contract_date` - law.family_law_marriage_contract_date
 * * `law.family_law_marriage_contract` - law.family_law_marriage_contract
 * * `law.family_law_marriage_register_number` - law.family_law_marriage_register_number
 * * `law.family_law_registry_office_location` - law.family_law_registry_office_location
 * * `law.family_law_separation_date` - law.family_law_separation_date
 * * `law.field` - law.field
 * * `law.generic_document` - law.generic_document
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - law.inheritance_law_certificate_of_inheritance_applicable_law
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - law.inheritance_law_certificate_of_inheritance_date_death
 * * `law.inheritance_law_certificate_of_inheritance_date` - law.inheritance_law_certificate_of_inheritance_date
 * * `law.inheritance_law_certificate_of_inheritance` - law.inheritance_law_certificate_of_inheritance
 * * `law.inheritance_law_certificate_of_inheritance_number` - law.inheritance_law_certificate_of_inheritance_number
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - law.inheritance_law_certificate_of_inheritance_place_of_death
 * * `law.inheritance_law_death_certificate_date_death` - law.inheritance_law_death_certificate_date_death
 * * `law.inheritance_law_death_certificate_date` - law.inheritance_law_death_certificate_date
 * * `law.inheritance_law_death_certificate` - law.inheritance_law_death_certificate
 * * `law.inheritance_law_death_certificate_number` - law.inheritance_law_death_certificate_number
 * * `law.inheritance_law_death_certificate_place_death` - law.inheritance_law_death_certificate_place_death
 * * `law.inheritance_law_death_certificate_place` - law.inheritance_law_death_certificate_place
 * * `law.inheritance_law_death_certificate_time_death` - law.inheritance_law_death_certificate_time_death
 * * `law.inheritance_law_estate_inventory_amount` - law.inheritance_law_estate_inventory_amount
 * * `law.inheritance_law_estate_inventory_date` - law.inheritance_law_estate_inventory_date
 * * `law.inheritance_law_estate_inventory_status` - law.inheritance_law_estate_inventory_status
 * * `law.inheritance_law_inheritance_contract_date` - law.inheritance_law_inheritance_contract_date
 * * `law.inheritance_law_inheritance_contract` - law.inheritance_law_inheritance_contract
 * * `law.inheritance_law_lasting_power_of_attorney_date` - law.inheritance_law_lasting_power_of_attorney_date
 * * `law.inheritance_law_lasting_power_of_attorney` - law.inheritance_law_lasting_power_of_attorney
 * * `law.inheritance_law_list_of_estate` - law.inheritance_law_list_of_estate
 * * `law.inheritance_law_living_will` - law.inheritance_law_living_will
 * * `law.inheritance_law_patient_enrollment_date` - law.inheritance_law_patient_enrollment_date
 * * `law.inheritance_law_testament_date` - law.inheritance_law_testament_date
 * * `law.inheritance_law_will` - law.inheritance_law_will
 * * `law.labor_law_beginning_of_employment` - law.labor_law_beginning_of_employment
 * * `law.labor_law_child_allowances` - law.labor_law_child_allowances
 * * `law.labor_law_collective_agreement` - law.labor_law_collective_agreement
 * * `law.labor_law_company_agreement` - law.labor_law_company_agreement
 * * `law.labor_law_different_place_of_work` - law.labor_law_different_place_of_work
 * * `law.labor_law_employee_probation_period_end_date` - law.labor_law_employee_probation_period_end_date
 * * `law.labor_law_fixed_term_contract_duration` - law.labor_law_fixed_term_contract_duration
 * * `law.labor_law_fixed_term_contract` - law.labor_law_fixed_term_contract
 * * `law.labor_law_is_employee_in_probation_period` - law.labor_law_is_employee_in_probation_period
 * * `law.labor_law_job_title` - law.labor_law_job_title
 * * `law.labor_law_married` - law.labor_law_married
 * * `law.labor_law_monthly_gross_salary` - law.labor_law_monthly_gross_salary
 * * `law.labor_law_monthly_working_days` - law.labor_law_monthly_working_days
 * * `law.labor_law_notice_period` - law.labor_law_notice_period
 * * `law.labor_law_payslip` - law.labor_law_payslip
 * * `law.labor_law_place_of_work` - law.labor_law_place_of_work
 * * `law.labor_law_settlement_agreement_date` - law.labor_law_settlement_agreement_date
 * * `law.labor_law_settlement_agreement` - law.labor_law_settlement_agreement
 * * `law.labor_law_signature_of_employer` - law.labor_law_signature_of_employer
 * * `law.labor_law_special_payments_amount` - law.labor_law_special_payments_amount
 * * `law.labor_law_special_payments` - law.labor_law_special_payments
 * * `law.labor_law_special_protection_against_dismissal` - law.labor_law_special_protection_against_dismissal
 * * `law.labor_law_termination_access_to_termination_to_employee` - law.labor_law_termination_access_to_termination_to_employee
 * * `law.labor_law_termination_agreement_date` - law.labor_law_termination_agreement_date
 * * `law.labor_law_termination_agreement` - law.labor_law_termination_agreement
 * * `law.labor_law_termination_agreement_severance_pay_amount` - law.labor_law_termination_agreement_severance_pay_amount
 * * `law.labor_law_termination_agreement_termination_date` - law.labor_law_termination_agreement_termination_date
 * * `law.labor_law_termination_date_effective` - law.labor_law_termination_date_effective
 * * `law.labor_law_termination_date` - law.labor_law_termination_date
 * * `law.labor_law_termination_employer_more_than_10_employees` - law.labor_law_termination_employer_more_than_10_employees
 * * `law.labor_law_termination_is_agreement_severance_pay` - law.labor_law_termination_is_agreement_severance_pay
 * * `law.labor_law_termination` - law.labor_law_termination
 * * `law.labor_law_vacation_days` - law.labor_law_vacation_days
 * * `law.labor_law_wanring_letter_access_to_warning_letter_to_employee` - law.labor_law_wanring_letter_access_to_warning_letter_to_employee
 * * `law.labor_law_warning_letter_date` - law.labor_law_warning_letter_date
 * * `law.labor_law_warning_letter_incident_date` - law.labor_law_warning_letter_incident_date
 * * `law.labor_law_warning_letter_incident_location` - law.labor_law_warning_letter_incident_location
 * * `law.labor_law_warning_letter_incident_time` - law.labor_law_warning_letter_incident_time
 * * `law.labor_law_warning_letter` - law.labor_law_warning_letter
 * * `law.labor_law_warning_letter_reason` - law.labor_law_warning_letter_reason
 * * `law.labor_law_work_contract` - law.labor_law_work_contract
 * * `law.labor_law_work_council` - law.labor_law_work_council
 * * `law.labor_law_work_hours_per_week` - law.labor_law_work_hours_per_week
 * * `law.labor_law_yearly_gross_salary` - law.labor_law_yearly_gross_salary
 * * `law.real_estate_law_basic_debts_amount` - law.real_estate_law_basic_debts_amount
 * * `law.real_estate_law_encumbrance_restrictions` - law.real_estate_law_encumbrance_restrictions
 * * `law.real_estate_law_land_register_address` - law.real_estate_law_land_register_address
 * * `law.real_estate_law_land_register_city` - law.real_estate_law_land_register_city
 * * `law.real_estate_law_land_register_date` - law.real_estate_law_land_register_date
 * * `law.real_estate_law_land_register` - law.real_estate_law_land_register
 * * `law.real_estate_law_land_register_number` - law.real_estate_law_land_register_number
 * * `law.real_estate_law_land_register_plot_of_land` - law.real_estate_law_land_register_plot_of_land
 * * `law.real_estate_law_purchase_contract_amount` - law.real_estate_law_purchase_contract_amount
 * * `law.real_estate_law_purchase_contract_date` - law.real_estate_law_purchase_contract_date
 * * `law.real_estate_law_purchase_contract_description` - law.real_estate_law_purchase_contract_description
 * * `law.real_estate_law_purchase_contract` - law.real_estate_law_purchase_contract
 * * `law.real_estate_law_purchase_contract_registration_date` - law.real_estate_law_purchase_contract_registration_date
 * * `law.residential_property_law_co_ownership_shares` - law.residential_property_law_co_ownership_shares
 * * `law.residential_property_law_contract_date` - law.residential_property_law_contract_date
 * * `law.residential_property_law_contract` - law.residential_property_law_contract
 * * `law.residential_property_law_inventory` - law.residential_property_law_inventory
 * * `law.residential_property_law_land_register_address` - law.residential_property_law_land_register_address
 * * `law.residential_property_law_land_register_city` - law.residential_property_law_land_register_city
 * * `law.residential_property_law_land_register_number` - law.residential_property_law_land_register_number
 * * `law.residential_property_law_land_register_plot_of_land` - law.residential_property_law_land_register_plot_of_land
 * * `law.social_law_application_arrival_date` - law.social_law_application_arrival_date
 * * `law.social_law_application_date` - law.social_law_application_date
 * * `law.social_law_notice_date` - law.social_law_notice_date
 * * `law.social_law_notice_of_objection_date` - law.social_law_notice_of_objection_date
 * * `law.social_law_notice_of_objection` - law.social_law_notice_of_objection
 * * `law.social_law_summary_grounds_opposition` - law.social_law_summary_grounds_opposition
 * * `law.tenancy_law_adress_rental_property` - law.tenancy_law_adress_rental_property
 * * `law.tenancy_law_advance_payment_service_charge` - law.tenancy_law_advance_payment_service_charge
 * * `law.tenancy_law_advance_payment_service_charges` - law.tenancy_law_advance_payment_service_charges
 * * `law.tenancy_law_cost_share` - law.tenancy_law_cost_share
 * * `law.tenancy_law_cost_shares` - law.tenancy_law_cost_shares
 * * `law.tenancy_law_counter_number` - law.tenancy_law_counter_number
 * * `law.tenancy_law_description_of_rental_property` - law.tenancy_law_description_of_rental_property
 * * `law.tenancy_law_duration_of_lease` - law.tenancy_law_duration_of_lease
 * * `law.tenancy_law_fixed_term_tenancy` - law.tenancy_law_fixed_term_tenancy
 * * `law.tenancy_law_gross_rent` - law.tenancy_law_gross_rent
 * * `law.tenancy_law_handover_counter` - law.tenancy_law_handover_counter
 * * `law.tenancy_law_handover_date` - law.tenancy_law_handover_date
 * * `law.tenancy_law_handover_defects` - law.tenancy_law_handover_defects
 * * `law.tenancy_law_handover_protocol` - law.tenancy_law_handover_protocol
 * * `law.tenancy_law_lease_agreement` - law.tenancy_law_lease_agreement
 * * `law.tenancy_law_location_in_rental_property` - law.tenancy_law_location_in_rental_property
 * * `law.tenancy_law_net_rent` - law.tenancy_law_net_rent
 * * `law.tenancy_law_rental_agreement_date` - law.tenancy_law_rental_agreement_date
 * * `law.tenancy_law_rental_agreement` - law.tenancy_law_rental_agreement
 * * `law.tenancy_law_rental_agreement_validity_end` - law.tenancy_law_rental_agreement_validity_end
 * * `law.tenancy_law_rental_agreement_validity_start` - law.tenancy_law_rental_agreement_validity_start
 * * `law.tenancy_law_repayment` - law.tenancy_law_repayment
 * * `law.tenancy_law_repayment_period_end` - law.tenancy_law_repayment_period_end
 * * `law.tenancy_law_repayment_period_start` - law.tenancy_law_repayment_period_start
 * * `law.tenancy_law_service_charge_settlement` - law.tenancy_law_service_charge_settlement
 * * `law.tenancy_law_staggered_rental_agreement` - law.tenancy_law_staggered_rental_agreement
 * * `law.tenancy_law_start_of_lease` - law.tenancy_law_start_of_lease
 * * `law.tenancy_law_total_cost_service_charge` - law.tenancy_law_total_cost_service_charge
 * * `law.tenancy_law_total_rent` - law.tenancy_law_total_rent
 * * `law.tenancy_law_unlimited_term_tenancy` - law.tenancy_law_unlimited_term_tenancy
 * * `law.topic` - law.topic
 * * `law.traffic_law_accident_date` - law.traffic_law_accident_date
 * * `law.traffic_law_accident_report` - law.traffic_law_accident_report
 * * `law.traffic_law_amount_of_fine` - law.traffic_law_amount_of_fine
 * * `law.traffic_law_appeal_instruction` - law.traffic_law_appeal_instruction
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - law.traffic_law_at_fault_driver_drivers_license_issued_by
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - law.traffic_law_at_fault_driver_drivers_license_valid_until
 * * `law.traffic_law_at_fault_driver_green_card_number` - law.traffic_law_at_fault_driver_green_card_number
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - law.traffic_law_at_fault_driver_insurance_expiry_date
 * * `law.traffic_law_at_fault_driver_insurance_number` - law.traffic_law_at_fault_driver_insurance_number
 * * `law.traffic_law_at_fault_driver_insurer` - law.traffic_law_at_fault_driver_insurer
 * * `law.traffic_law_blood_alcohol_concentration` - law.traffic_law_blood_alcohol_concentration
 * * `law.traffic_law_calculated_total_damage_costs` - law.traffic_law_calculated_total_damage_costs
 * * `law.traffic_law_calculated_total_days` - law.traffic_law_calculated_total_days
 * * `law.traffic_law_charges` - law.traffic_law_charges
 * * `law.traffic_law_cost_per_scale` - law.traffic_law_cost_per_scale
 * * `law.traffic_law_daily_rate` - law.traffic_law_daily_rate
 * * `law.traffic_law_damage_number` - law.traffic_law_damage_number
 * * `law.traffic_law_damage_scope` - law.traffic_law_damage_scope
 * * `law.traffic_law_date_of_accident` - law.traffic_law_date_of_accident
 * * `law.traffic_law_date_of_crime` - law.traffic_law_date_of_crime
 * * `law.traffic_law_date_of_fine` - law.traffic_law_date_of_fine
 * * `law.traffic_law_date_of_infraction` - law.traffic_law_date_of_infraction
 * * `law.traffic_law_date_of_inspection` - law.traffic_law_date_of_inspection
 * * `law.traffic_law_date_of_issue` - law.traffic_law_date_of_issue
 * * `law.traffic_law_date_of_offense` - law.traffic_law_date_of_offense
 * * `law.traffic_law_date_of_report` - law.traffic_law_date_of_report
 * * `law.traffic_law_differencial_tax` - law.traffic_law_differencial_tax
 * * `law.traffic_law_driver_logbook_required` - law.traffic_law_driver_logbook_required
 * * `law.traffic_law_driving_ban_duration` - law.traffic_law_driving_ban_duration
 * * `law.traffic_law_driving_ban` - law.traffic_law_driving_ban
 * * `law.traffic_law_evidence_infraction` - law.traffic_law_evidence_infraction
 * * `law.traffic_law_expert_cost` - law.traffic_law_expert_cost
 * * `law.traffic_law_expert_date` - law.traffic_law_expert_date
 * * `law.traffic_law_expert_report` - law.traffic_law_expert_report
 * * `law.traffic_law_expert_report_number` - law.traffic_law_expert_report_number
 * * `law.traffic_law_file_number` - law.traffic_law_file_number
 * * `law.traffic_law_fine` - law.traffic_law_fine
 * * `law.traffic_law_fine_notice` - law.traffic_law_fine_notice
 * * `law.traffic_law_gross_gross_replacement_value` - law.traffic_law_gross_gross_replacement_value
 * * `law.traffic_law_gross_replacement_value` - law.traffic_law_gross_replacement_value
 * * `law.traffic_law_injured` - law.traffic_law_injured
 * * `law.traffic_law_insurance_holder` - law.traffic_law_insurance_holder
 * * `law.traffic_law_insurance` - law.traffic_law_insurance
 * * `law.traffic_law_insurance_policy_number` - law.traffic_law_insurance_policy_number
 * * `law.traffic_law_legal_basis_infraction` - law.traffic_law_legal_basis_infraction
 * * `law.traffic_law_legal_basis` - law.traffic_law_legal_basis
 * * `law.traffic_law_licenseplate_at_fault_driver` - law.traffic_law_licenseplate_at_fault_driver
 * * `law.traffic_law_licenseplate` - law.traffic_law_licenseplate
 * * `law.traffic_law_licenseplate_victim_driver` - law.traffic_law_licenseplate_victim_driver
 * * `law.traffic_law_loss_amount_repair_case` - law.traffic_law_loss_amount_repair_case
 * * `law.traffic_law_loss_amount_total_damage_case` - law.traffic_law_loss_amount_total_damage_case
 * * `law.traffic_law_loss_of_use_per_day` - law.traffic_law_loss_of_use_per_day
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - law.traffic_law_mark_and_type_of_at_fault_driver
 * * `law.traffic_law_mark_and_type_of_victim_driver` - law.traffic_law_mark_and_type_of_victim_driver
 * * `law.traffic_law_merantile_value_loss` - law.traffic_law_merantile_value_loss
 * * `law.traffic_law_net_gross_replacement_value` - law.traffic_law_net_gross_replacement_value
 * * `law.traffic_law_net_replacement_value` - law.traffic_law_net_replacement_value
 * * `law.traffic_law_number_of_daily_rates` - law.traffic_law_number_of_daily_rates
 * * `law.traffic_law_offense_infraction_description` - law.traffic_law_offense_infraction_description
 * * `law.traffic_law_other_damages` - law.traffic_law_other_damages
 * * `law.traffic_law_payment_deadline` - law.traffic_law_payment_deadline
 * * `law.traffic_law_penalty_order` - law.traffic_law_penalty_order
 * * `law.traffic_law_place_of_accident` - law.traffic_law_place_of_accident
 * * `law.traffic_law_place_of_crime` - law.traffic_law_place_of_crime
 * * `law.traffic_law_place_of_infraction` - law.traffic_law_place_of_infraction
 * * `law.traffic_law_place_of_inspection` - law.traffic_law_place_of_inspection
 * * `law.traffic_law_place_of_issue` - law.traffic_law_place_of_issue
 * * `law.traffic_law_place_of_offense` - law.traffic_law_place_of_offense
 * * `law.traffic_law_points_for_offense` - law.traffic_law_points_for_offense
 * * `law.traffic_law_police_case_number` - law.traffic_law_police_case_number
 * * `law.traffic_law_procedure_costs` - law.traffic_law_procedure_costs
 * * `law.traffic_law_prosecution_number` - law.traffic_law_prosecution_number
 * * `law.traffic_law_regular_tax` - law.traffic_law_regular_tax
 * * `law.traffic_law_repair_costs_with_vat` - law.traffic_law_repair_costs_with_vat
 * * `law.traffic_law_repair_costs_without_vat` - law.traffic_law_repair_costs_without_vat
 * * `law.traffic_law_repair_duration` - law.traffic_law_repair_duration
 * * `law.traffic_law_replacement_cost` - law.traffic_law_replacement_cost
 * * `law.traffic_law_replacement_value` - law.traffic_law_replacement_value
 * * `law.traffic_law_reregistration_cost` - law.traffic_law_reregistration_cost
 * * `law.traffic_law_residual_value` - law.traffic_law_residual_value
 * * `law.traffic_law_speed_allowed` - law.traffic_law_speed_allowed
 * * `law.traffic_law_speed_driven` - law.traffic_law_speed_driven
 * * `law.traffic_law_speed_too_high` - law.traffic_law_speed_too_high
 * * `law.traffic_law_time_of_accident` - law.traffic_law_time_of_accident
 * * `law.traffic_law_time_of_crime` - law.traffic_law_time_of_crime
 * * `law.traffic_law_time_of_infraction` - law.traffic_law_time_of_infraction
 * * `law.traffic_law_time_of_inspection` - law.traffic_law_time_of_inspection
 * * `law.traffic_law_time_of_issue` - law.traffic_law_time_of_issue
 * * `law.traffic_law_time_of_offense` - law.traffic_law_time_of_offense
 * * `law.traffic_law_vehicle_age_months` - law.traffic_law_vehicle_age_months
 * * `law.traffic_law_vehicle_mileage` - law.traffic_law_vehicle_mileage
 * * `law.traffic_law_vehicle_type_and_brand` - law.traffic_law_vehicle_type_and_brand
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - law.traffic_law_victim_driver_drivers_license_issued_by
 * * `law.traffic_law_victim_driver_green_card_number` - law.traffic_law_victim_driver_green_card_number
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - law.traffic_law_victim_driver_insurance_expiry_date
 * * `law.traffic_law_victim_driver_insurance_number` - law.traffic_law_victim_driver_insurance_number
 * * `law.traffic_law_victim_driver_insurer` - law.traffic_law_victim_driver_insurer
 * * `law.traffic_law_victim_driver_license_valid_until` - law.traffic_law_victim_driver_license_valid_until
 * * `law.traffic_law_violated_section` - law.traffic_law_violated_section
 * * `law.traffic_law_violation_type` - law.traffic_law_violation_type
 * * `law.traffic_law_warning_fee_infraction` - law.traffic_law_warning_fee_infraction
 * * `law.traffic_law_warning_notice` - law.traffic_law_warning_notice
 */
export const AiAugmentedByMapperKeysEnum = {
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip',
    LAW_CRIMINAL_LAW_AMOUNT_OF_DAILY_RATES: 'law.criminal_law_amount_of_daily_rates',
    LAW_CRIMINAL_LAW_APPLICABLE_LAWS: 'law.criminal_law_applicable_laws',
    LAW_CRIMINAL_LAW_CHARGE_DESCRIPTION: 'law.criminal_law_charge_description',
    LAW_CRIMINAL_LAW_COMPLAINT: 'law.criminal_law_complaint',
    LAW_CRIMINAL_LAW_CRIMINAL_WARRANT: 'law.criminal_law_criminal_warrant',
    LAW_CRIMINAL_LAW_DAMAGE_DESCRIPTION: 'law.criminal_law_damage_description',
    LAW_CRIMINAL_LAW_DAMAGE_VALUE: 'law.criminal_law_damage_value',
    LAW_CRIMINAL_LAW_DATE_OF_OFFENSE: 'law.criminal_law_date_of_offense',
    LAW_CRIMINAL_LAW_DURATION_OF_PRISON_SENTENCE: 'law.criminal_law_duration_of_prison_sentence',
    LAW_CRIMINAL_LAW_EVIDENCE_LOCATION: 'law.criminal_law_evidence_location',
    LAW_CRIMINAL_LAW_EVIDENCE: 'law.criminal_law_evidence',
    LAW_CRIMINAL_LAW_INCIDENT_DESCRIPTION: 'law.criminal_law_incident_description',
    LAW_CRIMINAL_LAW_INDICTMENT_DATE: 'law.criminal_law_indictment_date',
    LAW_CRIMINAL_LAW_INDICTMENT_DELIVERY_DATE: 'law.criminal_law_indictment_delivery_date',
    LAW_CRIMINAL_LAW_INDICTMENT: 'law.criminal_law_indictment',
    LAW_CRIMINAL_LAW_LEGAL_CLASSIFICATION_OF_OFFENSE: 'law.criminal_law_legal_classification_of_offense',
    LAW_CRIMINAL_LAW_MEANS_OF_EVIDENCE: 'law.criminal_law_means_of_evidence',
    LAW_CRIMINAL_LAW_NUMBER_OF_DAILY_RATES: 'law.criminal_law_number_of_daily_rates',
    LAW_CRIMINAL_LAW_OFFENSE_TYPE: 'law.criminal_law_offense_type',
    LAW_CRIMINAL_LAW_PENALTY_INFROMATION: 'law.criminal_law_penalty_infromation',
    LAW_CRIMINAL_LAW_PHYSICAL_EVIDENCE: 'law.criminal_law_physical_evidence',
    LAW_CRIMINAL_LAW_PLACE_OF_OFFENSE: 'law.criminal_law_place_of_offense',
    LAW_CRIMINAL_LAW_POLICE_FILE_NUMBER: 'law.criminal_law_police_file_number',
    LAW_CRIMINAL_LAW_PRELIMINARY_PROCEEDINGS_DATE: 'law.criminal_law_preliminary_proceedings_date',
    LAW_CRIMINAL_LAW_PRISON_SENTENCE: 'law.criminal_law_prison_sentence',
    LAW_CRIMINAL_LAW_PROBATION: 'law.criminal_law_probation',
    LAW_CRIMINAL_LAW_PROSECUTION_FILE_NUMBER: 'law.criminal_law_prosecution_file_number',
    LAW_CRIMINAL_LAW_REPORT_DATE: 'law.criminal_law_report_date',
    LAW_CRIMINAL_LAW_REPORT_TIME: 'law.criminal_law_report_time',
    LAW_CRIMINAL_LAW_TIME_OF_OFFENSE: 'law.criminal_law_time_of_offense',
    LAW_DEBT_COLLECTION_LAW_BUSINESS_FEE: 'law.debt_collection_law_business_fee',
    LAW_DEBT_COLLECTION_LAW_CASE_VALUE: 'law.debt_collection_law_case_value',
    LAW_DEBT_COLLECTION_LAW_INVOICE_AMOUNT: 'law.debt_collection_law_invoice_amount',
    LAW_DEBT_COLLECTION_LAW_INVOICE_DATE: 'law.debt_collection_law_invoice_date',
    LAW_DEBT_COLLECTION_LAW_INVOICE_GROUND: 'law.debt_collection_law_invoice_ground',
    LAW_DEBT_COLLECTION_LAW_INVOICE_LAWYER: 'law.debt_collection_law_invoice_lawyer',
    LAW_DEBT_COLLECTION_LAW_INVOICE: 'law.debt_collection_law_invoice',
    LAW_DEBT_COLLECTION_LAW_INVOICE_NUMBER: 'law.debt_collection_law_invoice_number',
    LAW_DEBT_COLLECTION_LAW_INVOICE_RECIPIENT: 'law.debt_collection_law_invoice_recipient',
    LAW_DEBT_COLLECTION_LAW_INVOICE_TAX_NUMBER: 'law.debt_collection_law_invoice_tax_number',
    LAW_DEBT_COLLECTION_LAW_LUMPS_SUM_EXPENSES: 'law.debt_collection_law_lumps_sum_expenses',
    LAW_DEBT_COLLECTION_LAW_SALES_TAX: 'law.debt_collection_law_sales_tax',
    LAW_DEBT_COLLECTION_LAW_SUBTOTAL_LAWYER_FEES: 'law.debt_collection_law_subtotal_lawyer_fees',
    LAW_DEBT_COLLECTION_LAW_TOTAL_AMOUNT: 'law.debt_collection_law_total_amount',
    LAW_EXTERNAL_CASE_ID: 'law.external_case_id',
    LAW_FAMILY_LAW_AVERAGE_NET_INCOME: 'law.family_law_average_net_income',
    LAW_FAMILY_LAW_BIRTH_CERTIFICATE: 'law.family_law_birth_certificate',
    LAW_FAMILY_LAW_BIRTH_REGISTER_NUMBER: 'law.family_law_birth_register_number',
    LAW_FAMILY_LAW_BIRTH_REGISTER_OFFICE_LOCATION: 'law.family_law_birth_register_office_location',
    LAW_FAMILY_LAW_CHILDREN: 'law.family_law_children',
    LAW_FAMILY_LAW_DATE_OF_MARRIAGE: 'law.family_law_date_of_marriage',
    LAW_FAMILY_LAW_DIVORCE_APPLICATION: 'law.family_law_divorce_application',
    LAW_FAMILY_LAW_DIVORCE_SETTLEMENT_AGREEMENT: 'law.family_law_divorce_settlement_agreement',
    LAW_FAMILY_LAW_MARRIAGE_CERTIFICATE: 'law.family_law_marriage_certificate',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT_DATE: 'law.family_law_marriage_contract_date',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT: 'law.family_law_marriage_contract',
    LAW_FAMILY_LAW_MARRIAGE_REGISTER_NUMBER: 'law.family_law_marriage_register_number',
    LAW_FAMILY_LAW_REGISTRY_OFFICE_LOCATION: 'law.family_law_registry_office_location',
    LAW_FAMILY_LAW_SEPARATION_DATE: 'law.family_law_separation_date',
    LAW_FIELD: 'law.field',
    LAW_GENERIC_DOCUMENT: 'law.generic_document',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_APPLICABLE_LAW: 'law.inheritance_law_certificate_of_inheritance_applicable_law',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE_DEATH: 'law.inheritance_law_certificate_of_inheritance_date_death',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE: 'law.inheritance_law_certificate_of_inheritance_date',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE: 'law.inheritance_law_certificate_of_inheritance',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_NUMBER: 'law.inheritance_law_certificate_of_inheritance_number',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_PLACE_OF_DEATH: 'law.inheritance_law_certificate_of_inheritance_place_of_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE_DEATH: 'law.inheritance_law_death_certificate_date_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE: 'law.inheritance_law_death_certificate_date',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE: 'law.inheritance_law_death_certificate',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_NUMBER: 'law.inheritance_law_death_certificate_number',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE_DEATH: 'law.inheritance_law_death_certificate_place_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE: 'law.inheritance_law_death_certificate_place',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_TIME_DEATH: 'law.inheritance_law_death_certificate_time_death',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_AMOUNT: 'law.inheritance_law_estate_inventory_amount',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_DATE: 'law.inheritance_law_estate_inventory_date',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_STATUS: 'law.inheritance_law_estate_inventory_status',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT_DATE: 'law.inheritance_law_inheritance_contract_date',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT: 'law.inheritance_law_inheritance_contract',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY_DATE: 'law.inheritance_law_lasting_power_of_attorney_date',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY: 'law.inheritance_law_lasting_power_of_attorney',
    LAW_INHERITANCE_LAW_LIST_OF_ESTATE: 'law.inheritance_law_list_of_estate',
    LAW_INHERITANCE_LAW_LIVING_WILL: 'law.inheritance_law_living_will',
    LAW_INHERITANCE_LAW_PATIENT_ENROLLMENT_DATE: 'law.inheritance_law_patient_enrollment_date',
    LAW_INHERITANCE_LAW_TESTAMENT_DATE: 'law.inheritance_law_testament_date',
    LAW_INHERITANCE_LAW_WILL: 'law.inheritance_law_will',
    LAW_LABOR_LAW_BEGINNING_OF_EMPLOYMENT: 'law.labor_law_beginning_of_employment',
    LAW_LABOR_LAW_CHILD_ALLOWANCES: 'law.labor_law_child_allowances',
    LAW_LABOR_LAW_COLLECTIVE_AGREEMENT: 'law.labor_law_collective_agreement',
    LAW_LABOR_LAW_COMPANY_AGREEMENT: 'law.labor_law_company_agreement',
    LAW_LABOR_LAW_DIFFERENT_PLACE_OF_WORK: 'law.labor_law_different_place_of_work',
    LAW_LABOR_LAW_EMPLOYEE_PROBATION_PERIOD_END_DATE: 'law.labor_law_employee_probation_period_end_date',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT_DURATION: 'law.labor_law_fixed_term_contract_duration',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT: 'law.labor_law_fixed_term_contract',
    LAW_LABOR_LAW_IS_EMPLOYEE_IN_PROBATION_PERIOD: 'law.labor_law_is_employee_in_probation_period',
    LAW_LABOR_LAW_JOB_TITLE: 'law.labor_law_job_title',
    LAW_LABOR_LAW_MARRIED: 'law.labor_law_married',
    LAW_LABOR_LAW_MONTHLY_GROSS_SALARY: 'law.labor_law_monthly_gross_salary',
    LAW_LABOR_LAW_MONTHLY_WORKING_DAYS: 'law.labor_law_monthly_working_days',
    LAW_LABOR_LAW_NOTICE_PERIOD: 'law.labor_law_notice_period',
    LAW_LABOR_LAW_PAYSLIP: 'law.labor_law_payslip',
    LAW_LABOR_LAW_PLACE_OF_WORK: 'law.labor_law_place_of_work',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT_DATE: 'law.labor_law_settlement_agreement_date',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT: 'law.labor_law_settlement_agreement',
    LAW_LABOR_LAW_SIGNATURE_OF_EMPLOYER: 'law.labor_law_signature_of_employer',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS_AMOUNT: 'law.labor_law_special_payments_amount',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS: 'law.labor_law_special_payments',
    LAW_LABOR_LAW_SPECIAL_PROTECTION_AGAINST_DISMISSAL: 'law.labor_law_special_protection_against_dismissal',
    LAW_LABOR_LAW_TERMINATION_ACCESS_TO_TERMINATION_TO_EMPLOYEE: 'law.labor_law_termination_access_to_termination_to_employee',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_DATE: 'law.labor_law_termination_agreement_date',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT: 'law.labor_law_termination_agreement',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_SEVERANCE_PAY_AMOUNT: 'law.labor_law_termination_agreement_severance_pay_amount',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_TERMINATION_DATE: 'law.labor_law_termination_agreement_termination_date',
    LAW_LABOR_LAW_TERMINATION_DATE_EFFECTIVE: 'law.labor_law_termination_date_effective',
    LAW_LABOR_LAW_TERMINATION_DATE: 'law.labor_law_termination_date',
    LAW_LABOR_LAW_TERMINATION_EMPLOYER_MORE_THAN_10_EMPLOYEES: 'law.labor_law_termination_employer_more_than_10_employees',
    LAW_LABOR_LAW_TERMINATION_IS_AGREEMENT_SEVERANCE_PAY: 'law.labor_law_termination_is_agreement_severance_pay',
    LAW_LABOR_LAW_TERMINATION: 'law.labor_law_termination',
    LAW_LABOR_LAW_VACATION_DAYS: 'law.labor_law_vacation_days',
    LAW_LABOR_LAW_WANRING_LETTER_ACCESS_TO_WARNING_LETTER_TO_EMPLOYEE: 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee',
    LAW_LABOR_LAW_WARNING_LETTER_DATE: 'law.labor_law_warning_letter_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_DATE: 'law.labor_law_warning_letter_incident_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_LOCATION: 'law.labor_law_warning_letter_incident_location',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_TIME: 'law.labor_law_warning_letter_incident_time',
    LAW_LABOR_LAW_WARNING_LETTER: 'law.labor_law_warning_letter',
    LAW_LABOR_LAW_WARNING_LETTER_REASON: 'law.labor_law_warning_letter_reason',
    LAW_LABOR_LAW_WORK_CONTRACT: 'law.labor_law_work_contract',
    LAW_LABOR_LAW_WORK_COUNCIL: 'law.labor_law_work_council',
    LAW_LABOR_LAW_WORK_HOURS_PER_WEEK: 'law.labor_law_work_hours_per_week',
    LAW_LABOR_LAW_YEARLY_GROSS_SALARY: 'law.labor_law_yearly_gross_salary',
    LAW_REAL_ESTATE_LAW_BASIC_DEBTS_AMOUNT: 'law.real_estate_law_basic_debts_amount',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCE_RESTRICTIONS: 'law.real_estate_law_encumbrance_restrictions',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_ADDRESS: 'law.real_estate_law_land_register_address',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_CITY: 'law.real_estate_law_land_register_city',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_DATE: 'law.real_estate_law_land_register_date',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER: 'law.real_estate_law_land_register',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_NUMBER: 'law.real_estate_law_land_register_number',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.real_estate_law_land_register_plot_of_land',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_AMOUNT: 'law.real_estate_law_purchase_contract_amount',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DATE: 'law.real_estate_law_purchase_contract_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DESCRIPTION: 'law.real_estate_law_purchase_contract_description',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT: 'law.real_estate_law_purchase_contract',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_DATE: 'law.real_estate_law_purchase_contract_registration_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CO_OWNERSHIP_SHARES: 'law.residential_property_law_co_ownership_shares',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT_DATE: 'law.residential_property_law_contract_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT: 'law.residential_property_law_contract',
    LAW_RESIDENTIAL_PROPERTY_LAW_INVENTORY: 'law.residential_property_law_inventory',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_ADDRESS: 'law.residential_property_law_land_register_address',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_CITY: 'law.residential_property_law_land_register_city',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_NUMBER: 'law.residential_property_law_land_register_number',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.residential_property_law_land_register_plot_of_land',
    LAW_SOCIAL_LAW_APPLICATION_ARRIVAL_DATE: 'law.social_law_application_arrival_date',
    LAW_SOCIAL_LAW_APPLICATION_DATE: 'law.social_law_application_date',
    LAW_SOCIAL_LAW_NOTICE_DATE: 'law.social_law_notice_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_DATE: 'law.social_law_notice_of_objection_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION: 'law.social_law_notice_of_objection',
    LAW_SOCIAL_LAW_SUMMARY_GROUNDS_OPPOSITION: 'law.social_law_summary_grounds_opposition',
    LAW_TENANCY_LAW_ADRESS_RENTAL_PROPERTY: 'law.tenancy_law_adress_rental_property',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGE: 'law.tenancy_law_advance_payment_service_charge',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGES: 'law.tenancy_law_advance_payment_service_charges',
    LAW_TENANCY_LAW_COST_SHARE: 'law.tenancy_law_cost_share',
    LAW_TENANCY_LAW_COST_SHARES: 'law.tenancy_law_cost_shares',
    LAW_TENANCY_LAW_COUNTER_NUMBER: 'law.tenancy_law_counter_number',
    LAW_TENANCY_LAW_DESCRIPTION_OF_RENTAL_PROPERTY: 'law.tenancy_law_description_of_rental_property',
    LAW_TENANCY_LAW_DURATION_OF_LEASE: 'law.tenancy_law_duration_of_lease',
    LAW_TENANCY_LAW_FIXED_TERM_TENANCY: 'law.tenancy_law_fixed_term_tenancy',
    LAW_TENANCY_LAW_GROSS_RENT: 'law.tenancy_law_gross_rent',
    LAW_TENANCY_LAW_HANDOVER_COUNTER: 'law.tenancy_law_handover_counter',
    LAW_TENANCY_LAW_HANDOVER_DATE: 'law.tenancy_law_handover_date',
    LAW_TENANCY_LAW_HANDOVER_DEFECTS: 'law.tenancy_law_handover_defects',
    LAW_TENANCY_LAW_HANDOVER_PROTOCOL: 'law.tenancy_law_handover_protocol',
    LAW_TENANCY_LAW_LEASE_AGREEMENT: 'law.tenancy_law_lease_agreement',
    LAW_TENANCY_LAW_LOCATION_IN_RENTAL_PROPERTY: 'law.tenancy_law_location_in_rental_property',
    LAW_TENANCY_LAW_NET_RENT: 'law.tenancy_law_net_rent',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DATE: 'law.tenancy_law_rental_agreement_date',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT: 'law.tenancy_law_rental_agreement',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_END: 'law.tenancy_law_rental_agreement_validity_end',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_START: 'law.tenancy_law_rental_agreement_validity_start',
    LAW_TENANCY_LAW_REPAYMENT: 'law.tenancy_law_repayment',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_END: 'law.tenancy_law_repayment_period_end',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_START: 'law.tenancy_law_repayment_period_start',
    LAW_TENANCY_LAW_SERVICE_CHARGE_SETTLEMENT: 'law.tenancy_law_service_charge_settlement',
    LAW_TENANCY_LAW_STAGGERED_RENTAL_AGREEMENT: 'law.tenancy_law_staggered_rental_agreement',
    LAW_TENANCY_LAW_START_OF_LEASE: 'law.tenancy_law_start_of_lease',
    LAW_TENANCY_LAW_TOTAL_COST_SERVICE_CHARGE: 'law.tenancy_law_total_cost_service_charge',
    LAW_TENANCY_LAW_TOTAL_RENT: 'law.tenancy_law_total_rent',
    LAW_TENANCY_LAW_UNLIMITED_TERM_TENANCY: 'law.tenancy_law_unlimited_term_tenancy',
    LAW_TOPIC: 'law.topic',
    LAW_TRAFFIC_LAW_ACCIDENT_DATE: 'law.traffic_law_accident_date',
    LAW_TRAFFIC_LAW_ACCIDENT_REPORT: 'law.traffic_law_accident_report',
    LAW_TRAFFIC_LAW_AMOUNT_OF_FINE: 'law.traffic_law_amount_of_fine',
    LAW_TRAFFIC_LAW_APPEAL_INSTRUCTION: 'law.traffic_law_appeal_instruction',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_at_fault_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_VALID_UNTIL: 'law.traffic_law_at_fault_driver_drivers_license_valid_until',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_at_fault_driver_green_card_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_at_fault_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_at_fault_driver_insurance_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURER: 'law.traffic_law_at_fault_driver_insurer',
    LAW_TRAFFIC_LAW_BLOOD_ALCOHOL_CONCENTRATION: 'law.traffic_law_blood_alcohol_concentration',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAMAGE_COSTS: 'law.traffic_law_calculated_total_damage_costs',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAYS: 'law.traffic_law_calculated_total_days',
    LAW_TRAFFIC_LAW_CHARGES: 'law.traffic_law_charges',
    LAW_TRAFFIC_LAW_COST_PER_SCALE: 'law.traffic_law_cost_per_scale',
    LAW_TRAFFIC_LAW_DAILY_RATE: 'law.traffic_law_daily_rate',
    LAW_TRAFFIC_LAW_DAMAGE_NUMBER: 'law.traffic_law_damage_number',
    LAW_TRAFFIC_LAW_DAMAGE_SCOPE: 'law.traffic_law_damage_scope',
    LAW_TRAFFIC_LAW_DATE_OF_ACCIDENT: 'law.traffic_law_date_of_accident',
    LAW_TRAFFIC_LAW_DATE_OF_CRIME: 'law.traffic_law_date_of_crime',
    LAW_TRAFFIC_LAW_DATE_OF_FINE: 'law.traffic_law_date_of_fine',
    LAW_TRAFFIC_LAW_DATE_OF_INFRACTION: 'law.traffic_law_date_of_infraction',
    LAW_TRAFFIC_LAW_DATE_OF_INSPECTION: 'law.traffic_law_date_of_inspection',
    LAW_TRAFFIC_LAW_DATE_OF_ISSUE: 'law.traffic_law_date_of_issue',
    LAW_TRAFFIC_LAW_DATE_OF_OFFENSE: 'law.traffic_law_date_of_offense',
    LAW_TRAFFIC_LAW_DATE_OF_REPORT: 'law.traffic_law_date_of_report',
    LAW_TRAFFIC_LAW_DIFFERENCIAL_TAX: 'law.traffic_law_differencial_tax',
    LAW_TRAFFIC_LAW_DRIVER_LOGBOOK_REQUIRED: 'law.traffic_law_driver_logbook_required',
    LAW_TRAFFIC_LAW_DRIVING_BAN_DURATION: 'law.traffic_law_driving_ban_duration',
    LAW_TRAFFIC_LAW_DRIVING_BAN: 'law.traffic_law_driving_ban',
    LAW_TRAFFIC_LAW_EVIDENCE_INFRACTION: 'law.traffic_law_evidence_infraction',
    LAW_TRAFFIC_LAW_EXPERT_COST: 'law.traffic_law_expert_cost',
    LAW_TRAFFIC_LAW_EXPERT_DATE: 'law.traffic_law_expert_date',
    LAW_TRAFFIC_LAW_EXPERT_REPORT: 'law.traffic_law_expert_report',
    LAW_TRAFFIC_LAW_EXPERT_REPORT_NUMBER: 'law.traffic_law_expert_report_number',
    LAW_TRAFFIC_LAW_FILE_NUMBER: 'law.traffic_law_file_number',
    LAW_TRAFFIC_LAW_FINE: 'law.traffic_law_fine',
    LAW_TRAFFIC_LAW_FINE_NOTICE: 'law.traffic_law_fine_notice',
    LAW_TRAFFIC_LAW_GROSS_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_gross_replacement_value',
    LAW_TRAFFIC_LAW_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_replacement_value',
    LAW_TRAFFIC_LAW_INJURED: 'law.traffic_law_injured',
    LAW_TRAFFIC_LAW_INSURANCE_HOLDER: 'law.traffic_law_insurance_holder',
    LAW_TRAFFIC_LAW_INSURANCE: 'law.traffic_law_insurance',
    LAW_TRAFFIC_LAW_INSURANCE_POLICY_NUMBER: 'law.traffic_law_insurance_policy_number',
    LAW_TRAFFIC_LAW_LEGAL_BASIS_INFRACTION: 'law.traffic_law_legal_basis_infraction',
    LAW_TRAFFIC_LAW_LEGAL_BASIS: 'law.traffic_law_legal_basis',
    LAW_TRAFFIC_LAW_LICENSEPLATE_AT_FAULT_DRIVER: 'law.traffic_law_licenseplate_at_fault_driver',
    LAW_TRAFFIC_LAW_LICENSEPLATE: 'law.traffic_law_licenseplate',
    LAW_TRAFFIC_LAW_LICENSEPLATE_VICTIM_DRIVER: 'law.traffic_law_licenseplate_victim_driver',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_REPAIR_CASE: 'law.traffic_law_loss_amount_repair_case',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_TOTAL_DAMAGE_CASE: 'law.traffic_law_loss_amount_total_damage_case',
    LAW_TRAFFIC_LAW_LOSS_OF_USE_PER_DAY: 'law.traffic_law_loss_of_use_per_day',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_AT_FAULT_DRIVER: 'law.traffic_law_mark_and_type_of_at_fault_driver',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_VICTIM_DRIVER: 'law.traffic_law_mark_and_type_of_victim_driver',
    LAW_TRAFFIC_LAW_MERANTILE_VALUE_LOSS: 'law.traffic_law_merantile_value_loss',
    LAW_TRAFFIC_LAW_NET_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_net_gross_replacement_value',
    LAW_TRAFFIC_LAW_NET_REPLACEMENT_VALUE: 'law.traffic_law_net_replacement_value',
    LAW_TRAFFIC_LAW_NUMBER_OF_DAILY_RATES: 'law.traffic_law_number_of_daily_rates',
    LAW_TRAFFIC_LAW_OFFENSE_INFRACTION_DESCRIPTION: 'law.traffic_law_offense_infraction_description',
    LAW_TRAFFIC_LAW_OTHER_DAMAGES: 'law.traffic_law_other_damages',
    LAW_TRAFFIC_LAW_PAYMENT_DEADLINE: 'law.traffic_law_payment_deadline',
    LAW_TRAFFIC_LAW_PENALTY_ORDER: 'law.traffic_law_penalty_order',
    LAW_TRAFFIC_LAW_PLACE_OF_ACCIDENT: 'law.traffic_law_place_of_accident',
    LAW_TRAFFIC_LAW_PLACE_OF_CRIME: 'law.traffic_law_place_of_crime',
    LAW_TRAFFIC_LAW_PLACE_OF_INFRACTION: 'law.traffic_law_place_of_infraction',
    LAW_TRAFFIC_LAW_PLACE_OF_INSPECTION: 'law.traffic_law_place_of_inspection',
    LAW_TRAFFIC_LAW_PLACE_OF_ISSUE: 'law.traffic_law_place_of_issue',
    LAW_TRAFFIC_LAW_PLACE_OF_OFFENSE: 'law.traffic_law_place_of_offense',
    LAW_TRAFFIC_LAW_POINTS_FOR_OFFENSE: 'law.traffic_law_points_for_offense',
    LAW_TRAFFIC_LAW_POLICE_CASE_NUMBER: 'law.traffic_law_police_case_number',
    LAW_TRAFFIC_LAW_PROCEDURE_COSTS: 'law.traffic_law_procedure_costs',
    LAW_TRAFFIC_LAW_PROSECUTION_NUMBER: 'law.traffic_law_prosecution_number',
    LAW_TRAFFIC_LAW_REGULAR_TAX: 'law.traffic_law_regular_tax',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITH_VAT: 'law.traffic_law_repair_costs_with_vat',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITHOUT_VAT: 'law.traffic_law_repair_costs_without_vat',
    LAW_TRAFFIC_LAW_REPAIR_DURATION: 'law.traffic_law_repair_duration',
    LAW_TRAFFIC_LAW_REPLACEMENT_COST: 'law.traffic_law_replacement_cost',
    LAW_TRAFFIC_LAW_REPLACEMENT_VALUE: 'law.traffic_law_replacement_value',
    LAW_TRAFFIC_LAW_REREGISTRATION_COST: 'law.traffic_law_reregistration_cost',
    LAW_TRAFFIC_LAW_RESIDUAL_VALUE: 'law.traffic_law_residual_value',
    LAW_TRAFFIC_LAW_SPEED_ALLOWED: 'law.traffic_law_speed_allowed',
    LAW_TRAFFIC_LAW_SPEED_DRIVEN: 'law.traffic_law_speed_driven',
    LAW_TRAFFIC_LAW_SPEED_TOO_HIGH: 'law.traffic_law_speed_too_high',
    LAW_TRAFFIC_LAW_TIME_OF_ACCIDENT: 'law.traffic_law_time_of_accident',
    LAW_TRAFFIC_LAW_TIME_OF_CRIME: 'law.traffic_law_time_of_crime',
    LAW_TRAFFIC_LAW_TIME_OF_INFRACTION: 'law.traffic_law_time_of_infraction',
    LAW_TRAFFIC_LAW_TIME_OF_INSPECTION: 'law.traffic_law_time_of_inspection',
    LAW_TRAFFIC_LAW_TIME_OF_ISSUE: 'law.traffic_law_time_of_issue',
    LAW_TRAFFIC_LAW_TIME_OF_OFFENSE: 'law.traffic_law_time_of_offense',
    LAW_TRAFFIC_LAW_VEHICLE_AGE_MONTHS: 'law.traffic_law_vehicle_age_months',
    LAW_TRAFFIC_LAW_VEHICLE_MILEAGE: 'law.traffic_law_vehicle_mileage',
    LAW_TRAFFIC_LAW_VEHICLE_TYPE_AND_BRAND: 'law.traffic_law_vehicle_type_and_brand',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_victim_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_victim_driver_green_card_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_victim_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_victim_driver_insurance_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURER: 'law.traffic_law_victim_driver_insurer',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_LICENSE_VALID_UNTIL: 'law.traffic_law_victim_driver_license_valid_until',
    LAW_TRAFFIC_LAW_VIOLATED_SECTION: 'law.traffic_law_violated_section',
    LAW_TRAFFIC_LAW_VIOLATION_TYPE: 'law.traffic_law_violation_type',
    LAW_TRAFFIC_LAW_WARNING_FEE_INFRACTION: 'law.traffic_law_warning_fee_infraction',
    LAW_TRAFFIC_LAW_WARNING_NOTICE: 'law.traffic_law_warning_notice'
} as const;

export type AiAugmentedFieldsRequest = {
    client: EntityAugmentedFieldsRequest;
    opponent: EntityAugmentedFieldsRequest;
    law: LawAugmentedFieldsRequest;
};

export type AiChatQuestionTemplate = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    readonly is_jupus_template: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly created_by_user: string | null;
    prompt: string;
    title: string;
    readonly org: string;
};

export type AiChatQuestionTemplateRequest = {
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    prompt: string;
    title: string;
};

export type AnnotextRequest = {
    fileData?: Array<FileDataRequest>;
    export_opponent_information?: boolean;
    use_legal_insurance?: boolean;
};

export type AppointmentSettings = {
    start_of_working_day: string;
    end_of_working_day: string;
    working_days?: unknown;
};

/**
 * * `DOCUMENT ANALYSIS` - Document Analysis
 * * `EMAIL EXTRACTION` - Email Extraction
 * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
 * * `CALL` - Call
 * * `CHATBOT` - Chatbot
 */
export type AugmentationVariantEnum = 'DOCUMENT ANALYSIS' | 'EMAIL EXTRACTION' | 'CONTEXTUAL ANALYSIS' | 'CALL' | 'CHATBOT';

/**
 * * `DOCUMENT ANALYSIS` - Document Analysis
 * * `EMAIL EXTRACTION` - Email Extraction
 * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
 * * `CALL` - Call
 * * `CHATBOT` - Chatbot
 */
export const AugmentationVariantEnum = {
    DOCUMENT_ANALYSIS: 'DOCUMENT ANALYSIS',
    EMAIL_EXTRACTION: 'EMAIL EXTRACTION',
    CONTEXTUAL_ANALYSIS: 'CONTEXTUAL ANALYSIS',
    CALL: 'CALL',
    CHATBOT: 'CHATBOT'
} as const;

export type BlankEnum = '';

export const BlankEnum = {
    EMPTY_STRING: ''
} as const;

export type BlockEvaluation = {
    block_variable: string;
    is_true: boolean;
};

/**
 * * `top-left` - Oben links
 * * `top-right` - Oben rechts
 * * `top-center` - Oben zentriert
 * * `bottom-left` - Unten links
 * * `bottom-right` - Unten rechts
 * * `bottom-center` - Unten zentriert
 * * `middle-left` - Links zentriert
 * * `middle-right` - Rechts zentriert
 * * `none` - Nicht anzeigen
 */
export type BotButtonPositionEnum = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center' | 'middle-left' | 'middle-right' | 'none';

/**
 * * `top-left` - Oben links
 * * `top-right` - Oben rechts
 * * `top-center` - Oben zentriert
 * * `bottom-left` - Unten links
 * * `bottom-right` - Unten rechts
 * * `bottom-center` - Unten zentriert
 * * `middle-left` - Links zentriert
 * * `middle-right` - Rechts zentriert
 * * `none` - Nicht anzeigen
 */
export const BotButtonPositionEnum = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center',
    MIDDLE_LEFT: 'middle-left',
    MIDDLE_RIGHT: 'middle-right',
    NONE: 'none'
} as const;

/**
 * * `0` - 0 Minuten
 * * `5` - 5 Minuten
 * * `10` - 10 Minuten
 * * `15` - 15 Minuten
 * * `30` - 30 Minuten
 * * `45` - 45 Minuten
 * * `60` - 60 Minuten
 * * `90` - 90 Minuten
 * * `120` - 120 Minuten
 */
export type BufferMinsEnum = 0 | 5 | 10 | 15 | 30 | 45 | 60 | 90 | 120;

/**
 * * `0` - 0 Minuten
 * * `5` - 5 Minuten
 * * `10` - 10 Minuten
 * * `15` - 15 Minuten
 * * `30` - 30 Minuten
 * * `45` - 45 Minuten
 * * `60` - 60 Minuten
 * * `90` - 90 Minuten
 * * `120` - 120 Minuten
 */
export const BufferMinsEnum = {
    '_0': 0,
    '_5': 5,
    '_10': 10,
    '_15': 15,
    '_30': 30,
    '_45': 45,
    '_60': 60,
    '_90': 90,
    '_120': 120
} as const;

export type CallTranscriptMessage = {
    role: string;
    content: string;
};

export type CallTranscriptMessageRequest = {
    role: string;
    content: string;
};

export type CaseAiContext = {
    created_at?: string | null;
    case_created_at: string;
    updated_document_context_at?: string | null;
    inquiry: string;
    data: CaseDataAiContext;
    entities: CaseEntityAiContext;
    documents: DocumentAiContext;
};

export type CaseCreateEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    institution_name?: string;
    phone?: string;
    email?: string;
    date_of_birth?: string | null;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
};

export type CaseCreateLawRequest = {
    field: FieldEnum | BlankEnum;
    topic: TopicEnum | BlankEnum;
};

export type CaseCreateRequest = {
    clerk_uuid: string | null;
    client: CaseCreateEntityRequest;
    opponent: CaseCreateEntityRequest;
    law: CaseCreateLawRequest;
    inquiry?: string;
    note?: string;
    document_uuids: Array<(string)>;
    ai_augmented_fields: (AiAugmentedFieldsRequest) | null;
};

export type CaseCreatorTempDocument = {
    readonly uuid: string;
    readonly created_at: string;
    original_filename: string;
    file: string;
    readonly extraction_result: UUIDExtractionResult;
    readonly images: Array<ImageproxyImagePreset>;
};

export type CaseCreatorTempDocumentRequest = {
    original_filename: string;
    file: (Blob | File);
};

export type CaseDataAiContext = {
    key: string;
    label: string;
    data?: string | null;
    is_default: boolean;
    uuid: string;
};

export type CaseEntityAiContext = {
    uuid: string;
    entity_type: EntityTypeC7aEnum;
    first_name?: string | null;
    last_name?: string | null;
    company_name?: string | null;
    institution_name?: string | null;
};

/**
 * * `API` - API
 * * `CHAT BOT` - Chat
 * * `QUESTIONNAIRE` - Fragebogen
 * * `EMAIL` - E-Mail
 * * `MANUAL` - Manuell
 * * `PHONE` - Telefon
 * * `APPOINTMENT` - Terminbuchung
 */
export type CaseType = 'API' | 'CHAT BOT' | 'QUESTIONNAIRE' | 'EMAIL' | 'MANUAL' | 'PHONE' | 'APPOINTMENT';

/**
 * * `API` - API
 * * `CHAT BOT` - Chat
 * * `QUESTIONNAIRE` - Fragebogen
 * * `EMAIL` - E-Mail
 * * `MANUAL` - Manuell
 * * `PHONE` - Telefon
 * * `APPOINTMENT` - Terminbuchung
 */
export const CaseType = {
    API: 'API',
    CHAT_BOT: 'CHAT BOT',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    EMAIL: 'EMAIL',
    MANUAL: 'MANUAL',
    PHONE: 'PHONE',
    APPOINTMENT: 'APPOINTMENT'
} as const;

/**
 * * `Allgemein` - General
 * * `Rechtsspezifisch` - Law Specific
 */
export type CategoryEnum = 'Allgemein' | 'Rechtsspezifisch';

/**
 * * `Allgemein` - General
 * * `Rechtsspezifisch` - Law Specific
 */
export const CategoryEnum = {
    ALLGEMEIN: 'Allgemein',
    RECHTSSPEZIFISCH: 'Rechtsspezifisch'
} as const;

/**
 * * `USER` - User
 * * `AI` - Ai
 * * `QUESTIONNAIRE` - Questionnaire
 * * `APPOINTMENT` - Appointment
 * * `SYSTEM` - System
 */
export type ChangeSourceEnum = 'USER' | 'AI' | 'QUESTIONNAIRE' | 'APPOINTMENT' | 'SYSTEM';

/**
 * * `USER` - User
 * * `AI` - Ai
 * * `QUESTIONNAIRE` - Questionnaire
 * * `APPOINTMENT` - Appointment
 * * `SYSTEM` - System
 */
export const ChangeSourceEnum = {
    USER: 'USER',
    AI: 'AI',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    APPOINTMENT: 'APPOINTMENT',
    SYSTEM: 'SYSTEM'
} as const;

/**
 * * `EXISTING_CLIENT_CALL_BACK` - Bestandsmandant
 * * `NEW_CLIENT_CALL` - Neumandant
 * * `GENERAL_ENQUIRY` - Allgemeine Anfrage
 * * `QUESTION` - Frage
 * * `NOT_COMPLETED` - Ohne Nachricht
 * * `LAWFIRM_PARTNER` - Geschäftspartner
 */
export type ClassificationEnum = 'EXISTING_CLIENT_CALL_BACK' | 'NEW_CLIENT_CALL' | 'GENERAL_ENQUIRY' | 'QUESTION' | 'NOT_COMPLETED' | 'LAWFIRM_PARTNER';

/**
 * * `EXISTING_CLIENT_CALL_BACK` - Bestandsmandant
 * * `NEW_CLIENT_CALL` - Neumandant
 * * `GENERAL_ENQUIRY` - Allgemeine Anfrage
 * * `QUESTION` - Frage
 * * `NOT_COMPLETED` - Ohne Nachricht
 * * `LAWFIRM_PARTNER` - Geschäftspartner
 */
export const ClassificationEnum = {
    EXISTING_CLIENT_CALL_BACK: 'EXISTING_CLIENT_CALL_BACK',
    NEW_CLIENT_CALL: 'NEW_CLIENT_CALL',
    GENERAL_ENQUIRY: 'GENERAL_ENQUIRY',
    QUESTION: 'QUESTION',
    NOT_COMPLETED: 'NOT_COMPLETED',
    LAWFIRM_PARTNER: 'LAWFIRM_PARTNER'
} as const;

export type ClientAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type ClientAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type ClientAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type ClientAiAugmentationRequest = {
    document: DocumentRequest;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * Case representation for clients.
 */
export type ClientCase = {
    readonly uuid: string;
    readonly questionnaire_submissions: Array<ClientQuestionnaireSubmission>;
    readonly form_requests: Array<ClientRequest>;
    readonly org: ClientOrganisation;
    readonly user_access_token: string;
};

/**
 * Entity representation for clients.
 */
export type ClientEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<(number)>;
};

/**
 * Entity representation for clients.
 */
export type ClientEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Form representation for clients.
 */
export type ClientForm = {
    readonly id: string;
    readonly organisation: ClientOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly tag: FormTag;
    readonly title: string;
    readonly description: string;
    readonly file: string | null;
    readonly due_at: string;
};

/**
 * Organisation representation for clients.
 */
export type ClientOrganisation = {
    readonly uuid: string;
    readonly name: string | null;
    readonly logo: string | null;
    readonly description: string;
};

/**
 * Questionnaire submission representation for clients.
 */
export type ClientQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for clients.
 */
export type ClientQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type ClientRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
};

export type ClientRequestRequest = {
    token: string;
    form: string;
};

/**
 * * `` -
 * * `GmbH` - GmbH
 * * `UG` - UG
 * * `GmbH & Co. KG` - GmbH & Co. KG
 * * `GBR` - GbR
 * * `OHG` - OHG
 * * `KG` - KG
 * * `AG` - AG
 * * `SE` - SE
 * * `eG` - eG
 * * `eV` - eV
 * * `AG & Co. KG` - AG & Co. KG
 */
export type CompanyLegalFormEnum = 'GmbH' | 'UG' | 'GmbH & Co. KG' | 'GBR' | 'OHG' | 'KG' | 'AG' | 'SE' | 'eG' | 'eV' | 'AG & Co. KG';

/**
 * * `` -
 * * `GmbH` - GmbH
 * * `UG` - UG
 * * `GmbH & Co. KG` - GmbH & Co. KG
 * * `GBR` - GbR
 * * `OHG` - OHG
 * * `KG` - KG
 * * `AG` - AG
 * * `SE` - SE
 * * `eG` - eG
 * * `eV` - eV
 * * `AG & Co. KG` - AG & Co. KG
 */
export const CompanyLegalFormEnum = {
    GMB_H: 'GmbH',
    UG: 'UG',
    GMB_H___CO__KG: 'GmbH & Co. KG',
    GBR: 'GBR',
    OHG: 'OHG',
    KG: 'KG',
    AG: 'AG',
    SE: 'SE',
    E_G: 'eG',
    E_V: 'eV',
    AG___CO__KG: 'AG & Co. KG'
} as const;

export type ContextRequest = {
    key: string;
    context: {
        [key: string]: unknown;
    };
};

export type CreateCaseFromInboundEmailRequest = {
    inquiry: string;
    client_title: string;
    client_first_name?: string;
    client_last_name: string;
    client_email: string;
    client_phone?: string;
};

export type CreateWordDocumentFromPlaceholderValuesRequestRequest = {
    word_document_template_uuid: string;
    name: string;
    placeholder_values: Array<PlaceholderValueRequest>;
    create_pdf?: boolean;
};

export type CreateWordDocumentFromPlaceholderValuesResponse = {
    url: string;
    document_uuid: string;
};

export type CreateWordDocumentPreviewBlobRequest = {
    word_document_template_uuid: string;
    placeholder_values: Array<PlaceholderValueRequest>;
    /**
     * If true, use the AI-generated template with placeholders instead of the original template
     */
    use_ai_template?: boolean;
};

export type CreateWordDocumentRequestRequest = {
    name: string;
    html: string;
    create_pdf: boolean;
};

export type CreateWordDocumentResponse = {
    url: string;
    document_uuid: string;
};

export type CreateWordDocumentTemplateDocxWithPlaceholdersRequest = {
    word_document_template_uuid: string;
};

export type CustomerAccount = {
    uuid?: string;
    account_id: string;
};

export type CustomerAccountRequest = {
    uuid?: string;
    account_id: string;
};

export type CustomerAdminAccount = {
    uuid?: string;
    account_id: string;
};

export type CustomerAdminAccountRequest = {
    uuid?: string;
    account_id: string;
};

export type CustomerAdminAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAdminAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAdminAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type CustomerAdminAiAugmentationRequest = {
    document: DocumentRequest;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * Appointment representation for customer admins.
 */
export type CustomerAdminAppointment = {
    uuid?: string;
    readonly service: CustomerAdminService;
    readonly calendar: CustomerAdminCalendar;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type CustomerAdminAppointmentProposal = {
    uuid?: string;
    readonly service: CustomerAdminService;
    readonly calendar: CustomerAdminCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message: string | null;
    readonly channel: string | null;
};

export type CustomerAdminAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Appointment representation for customer admins.
 */
export type CustomerAdminAppointmentRequest = {
    uuid?: string;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type CustomerAdminCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: CustomerAdminAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type CustomerAdminCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Case representation for customer admins.
 */
export type CustomerAdminCase = {
    readonly id: number;
    uuid?: string;
    readonly questionnaire_submissions: Array<CustomerAdminQuestionnaireSubmission>;
    readonly form_requests: Array<CustomerAdminRequest>;
    readonly org: CustomerAdminOrganisation;
    readonly modified_at: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: CustomerAdminCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    readonly documents: Array<Document>;
    readonly clerk: CustomerAdminOrganisationUser;
    readonly appointments: Array<CustomerAdminAppointment>;
    readonly appointment_proposals: Array<CustomerAdminAppointmentProposal>;
    readonly chat_sessions: Array<AIChatSession>;
};

export type CustomerAdminCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<CustomerAdminEntityWithRelationship>;
    readonly changes: Array<CustomerAdminCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type CustomerAdminCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAdminAiAugmentation;
};

export type CustomerAdminCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAdminAiAugmentationRequest;
};

export type CustomerAdminCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Case representation for customer admins.
 */
export type CustomerAdminCaseRequest = {
    uuid?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: CustomerAdminCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
};

export type CustomerAdminDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type CustomerAdminDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type CustomerAdminEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
};

export type CustomerAdminEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<CustomerAdminQuestionnaire>;
    readonly forms: Array<CustomerAdminForm>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type CustomerAdminEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for customer admins.
 */
export type CustomerAdminEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<CustomerAdminEntityChange>;
};

export type CustomerAdminEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAdminAiAugmentation;
};

export type CustomerAdminEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAdminAiAugmentationRequest;
};

/**
 * Entity representation for customer admins.
 */
export type CustomerAdminEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type CustomerAdminEntityWithRelationship = {
    uuid?: string;
    entity: CustomerAdminEntity;
    relationships: Array<EntityRelationship>;
};

export type CustomerAdminEntityWithRelationshipRequest = {
    uuid?: string;
    entity: CustomerAdminEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

/**
 * Form representation for customer admins.
 */
export type CustomerAdminForm = {
    readonly id: string;
    readonly organisation: CustomerAdminOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly tag: FormTag;
    readonly title: string;
    readonly description: string;
    readonly md5: string;
    readonly file: string | null;
    readonly due_at: string;
};

/**
 * Organisation representation for customer admins.
 */
export type CustomerAdminOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    description?: string;
    readonly law_fields: unknown;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    readonly inbound_email_slug: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    readonly seats: number;
    readonly appointments_seats: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    readonly is_actaport_export_integration_enabled: boolean;
    readonly questionnaire_creation_token: string;
    readonly ai_enabled: boolean;
    readonly is_iusta_egress_integration_enabled: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    readonly is_annotext_export_integration_enabled: boolean;
    readonly is_advolux_export_integration_enabled: boolean;
    readonly is_webhooks_egress_integration_enabled: boolean;
    webhook_urls?: string | null;
    readonly is_email_egress_integration_enabled: boolean;
    email_egress_address?: string | null;
    readonly is_kleos_integration_enabled: boolean;
    readonly is_advoware_export_integration_enabled: boolean;
    readonly is_law_firm_software_exportation_enabled: boolean;
    readonly enable_appointments: boolean;
    readonly enable_voice: boolean;
    readonly enable_cases: boolean;
    readonly is_hubspot_egress_integration_enabled: boolean;
    readonly is_haveibeenpwned_integration_enabled: boolean;
    readonly is_jurnodes_export_integration_enabled: boolean;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly users: Array<CustomerAdminOrganisationUser>;
    readonly receive_monthly_updates_summary: boolean;
    has_churned?: boolean;
    readonly enable_law_specific_data: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
};

/**
 * Organisation representation for customer admins.
 */
export type CustomerAdminOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    has_churned?: boolean;
};

export type CustomerAdminOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type CustomerAdminPhoneNumber = {
    readonly uuid: string;
    active?: boolean;
    readonly org: CustomerOrganisation;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type CustomerAdminPhoneNumberRequest = {
    active?: boolean;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type CustomerAdminQuestionnaire = {
    readonly uuid: string;
    readonly title: string;
    readonly description: string;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type CustomerAdminQuestionnaireRequest = {
    schema: Array<QuestionnaireSectionRequest>;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type CustomerAdminQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type CustomerAdminQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type CustomerAdminRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
};

export type CustomerAdminRequestRequest = {
    token: string;
    form: string;
};

export type CustomerAdminService = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

export type CustomerAdminServiceRequest = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customer admins.
 */
export type CustomerAdminUser = {
    readonly uuid: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: string | null;
    readonly org: CustomerAdminOrganisation;
    readonly uid: number;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
};

/**
 * User representation for customer admins.
 */
export type CustomerAdminUserRequest = {
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
};

export type CustomerAdminWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type CustomerAdminWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type CustomerAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type CustomerAiAugmentationRequest = {
    document: DocumentRequest;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * Appointment representation for customers.
 */
export type CustomerAppointment = {
    uuid?: string;
    readonly service: CustomerService;
    readonly calendar: CustomerCalendar;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type CustomerAppointmentProposal = {
    uuid?: string;
    readonly service: CustomerService;
    readonly calendar: CustomerCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message: string | null;
    readonly channel: string | null;
};

export type CustomerAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Appointment representation for customers.
 */
export type CustomerAppointmentRequest = {
    uuid?: string;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type CustomerCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: CustomerAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type CustomerCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Call representation for customers.
 */
export type CustomerCall = {
    readonly uuid: string;
    /**
     * Return the URL of the audio recording of the call.
     */
    readonly audio_recording_url: string | null;
    readonly call_start_time: string;
    readonly call_end_time: string | null;
    readonly phone_number: CustomerPhoneNumber;
    result: CustomerCallResult;
    readonly lawyer_feedback: CustomerLawyerFeedback;
    readonly duration: number;
    readonly case_uuid: string;
};

/**
 * Call representation for customers.
 */
export type CustomerCallRequest = {
    result: CustomerCallResultRequest;
};

export type CustomerCallResult = {
    readonly uuid: string;
    readonly classification: ClassificationEnum;
    readonly inquiry: string;
    data: ShallowCaseData;
    readonly first_name_recording_start_seconds: string | null;
    readonly first_name_recording_end_seconds: string | null;
    readonly last_name_recording_start_seconds: string | null;
    readonly last_name_recording_end_seconds: string | null;
    readonly email_recording_start_seconds: string | null;
    readonly email_recording_end_seconds: string | null;
    readonly phone_number_recording_start_seconds: string | null;
    readonly phone_number_recording_end_seconds: string | null;
};

export type CustomerCallResultRequest = {
    data: ShallowCaseDataRequest;
};

/**
 * Case representation for customers.
 */
export type CustomerCase = {
    readonly id: number;
    uuid?: string;
    readonly questionnaire_submissions: Array<CustomerQuestionnaireSubmission>;
    readonly form_requests: Array<CustomerRequest>;
    readonly org: CustomerOrganisation;
    readonly modified_at: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: CustomerCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    readonly documents: Array<Document>;
    readonly clerk: CustomerOrganisationUser;
    readonly appointments: Array<CustomerAppointment>;
    readonly appointment_proposals: Array<CustomerAppointmentProposal>;
    readonly chat_sessions: Array<AIChatSession>;
};

export type CustomerCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<CustomerEntityWithRelationship>;
    readonly changes: Array<CustomerCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type CustomerCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAiAugmentation;
};

export type CustomerCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAiAugmentationRequest;
};

export type CustomerCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Case representation for customers.
 */
export type CustomerCaseRequest = {
    uuid?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: CustomerCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
};

export type CustomerDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type CustomerDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type CustomerEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
};

export type CustomerEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<CustomerQuestionnaire>;
    readonly forms: Array<CustomerForm>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type CustomerEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for customers.
 */
export type CustomerEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<CustomerEntityChange>;
};

export type CustomerEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAiAugmentation;
};

export type CustomerEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAiAugmentationRequest;
};

/**
 * Entity representation for customers.
 */
export type CustomerEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type CustomerEntityWithRelationship = {
    uuid?: string;
    entity: CustomerEntity;
    relationships: Array<EntityRelationship>;
};

export type CustomerEntityWithRelationshipRequest = {
    uuid?: string;
    entity: CustomerEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

/**
 * Form representation for customers.
 */
export type CustomerForm = {
    readonly id: string;
    readonly organisation: CustomerOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly tag: FormTag;
    readonly title: string;
    readonly description: string;
    readonly file: string | null;
    readonly due_at: string;
};

export type CustomerLawyerFeedback = {
    readonly uuid: string;
    rating: string;
    feedback?: string;
};

export type CustomerLawyerFeedbackRequest = {
    rating: string;
    feedback?: string;
    call_uuid: string;
};

/**
 * Organisation representation for customers.
 */
export type CustomerOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    readonly law_fields: unknown;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    readonly inbound_email_slug: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    readonly seats: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    readonly is_actaport_export_integration_enabled: boolean;
    readonly questionnaire_creation_token: string;
    readonly ai_enabled: boolean;
    readonly is_iusta_egress_integration_enabled: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    readonly ra_micro_export_integration_type: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    readonly ra_micro_oma_email_id: string | null;
    readonly ra_micro_oma_email: string | null;
    readonly is_annotext_export_integration_enabled: boolean;
    readonly is_advolux_export_integration_enabled: boolean;
    readonly is_webhooks_egress_integration_enabled: boolean;
    webhook_urls?: string | null;
    readonly is_email_egress_integration_enabled: boolean;
    email_egress_address?: string | null;
    readonly is_kleos_integration_enabled: boolean;
    readonly is_advoware_export_integration_enabled: boolean;
    readonly is_law_firm_software_exportation_enabled: boolean;
    readonly enable_appointments: boolean;
    readonly appointments_seats: number;
    enable_cases?: boolean;
    readonly enable_voice: boolean;
    readonly is_hubspot_egress_integration_enabled: boolean;
    readonly is_haveibeenpwned_integration_enabled: boolean;
    readonly is_jurnodes_export_integration_enabled: boolean;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly users: Array<CustomerOrganisationUser>;
    receive_monthly_updates_summary?: boolean;
    readonly enable_law_specific_data: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
};

/**
 * Organisation representation for customers.
 */
export type CustomerOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    enable_cases?: boolean;
    receive_monthly_updates_summary?: boolean;
};

export type CustomerOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * PhoneNumber representation for customers.
 */
export type CustomerPhoneNumber = {
    readonly uuid: string;
    readonly active: boolean;
    readonly org: CustomerOrganisation;
    readonly phone_number: string | null;
    readonly law_fields: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    readonly description: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    readonly lawfirm_name: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    readonly address: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    readonly opening_hours: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    readonly lawyer_names: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    readonly has_free_initial_consultation: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    readonly original_phone_number: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    readonly can_record_calls: boolean;
};

/**
 * Questionnaire representation for customers.
 */
export type CustomerQuestionnaire = {
    readonly uuid: string;
    readonly title: string;
    readonly description: string;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
};

/**
 * Questionnaire representation for customers.
 */
export type CustomerQuestionnaireRequest = {
    schema: Array<QuestionnaireSectionRequest>;
};

/**
 * Questionnaire submission representation for customers.
 */
export type CustomerQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for customers.
 */
export type CustomerQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type CustomerRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
};

export type CustomerRequestRequest = {
    token: string;
    form: string;
};

export type CustomerService = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

export type CustomerServiceRequest = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customers.
 */
export type CustomerUser = {
    readonly uuid: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: string | null;
    readonly org: CustomerOrganisation;
    readonly uid: number;
    readonly role: Role5ccEnum | NullEnum | null;
    email_signature?: string;
};

/**
 * User representation for customers.
 */
export type CustomerUserRequest = {
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    email_signature?: string;
};

export type CustomerWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type CustomerWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type Document = {
    uuid?: string;
    readonly created_at: string;
    document_type: DocumentTypeEnum;
    title: string;
    filename: string;
    is_uploaded: boolean;
    upload_origin?: UploadOriginEnum | BlankEnum | NullEnum | null;
    readonly url: string;
    page_count?: number;
    filesize?: number;
    images: Array<ImageproxyImagePreset>;
    needs_ocr?: boolean;
    ocr_started_at?: string | null;
    ocr_finished_at?: string | null;
    ocr_is_finished?: boolean | null;
    needs_embeddings?: boolean;
    embeddings_started_at?: string | null;
    embeddings_finished_at?: string | null;
    embeddings_is_finished?: boolean | null;
    needs_summary?: boolean;
    summary_started_at?: string | null;
    summary_finished_at?: string | null;
    summary_is_finished?: boolean | null;
    needs_summary_embedding?: boolean;
    summary_embedding_started_at?: string | null;
    summary_embedding_finished_at?: string | null;
    summary_embedding_is_finished?: boolean | null;
    needs_raptor_summaries?: boolean;
    raptor_summaries_started_at?: string | null;
    raptor_summaries_finished_at?: string | null;
    raptor_summaries_is_finished?: boolean | null;
    needs_analysis?: boolean;
    analysis_started_at?: string | null;
    analysis_finished_at?: string | null;
    analysis_is_finished?: boolean | null;
    needs_metadata_enrichment?: boolean;
    metadata_enrichment_started_at?: string | null;
    metadata_enrichment_finished_at?: string | null;
    metadata_enrichment_is_finished?: boolean | null;
    metadata_enrichment_error?: string | null;
    embeddings_error?: string | null;
    summary_error?: string | null;
    summary_embedding_error?: string | null;
    raptor_summaries_error?: string | null;
    analysis_error?: string | null;
};

export type DocumentAiContext = {
    created_at: string;
    uuid: string;
    document_type: string;
    is_uploaded: boolean;
    upload_origin?: string | null;
    title: string;
    summary: string;
    relevant_content: DocumentContent;
};

export type DocumentContent = {
    pages: number;
    text: string;
};

export type DocumentGeneratorRelatedData = {
    template_uuid?: string | null;
    document_uuid?: string | null;
};

export type DocumentRequest = {
    uuid?: string;
    document_type: DocumentTypeEnum;
    title: string;
    filename: string;
    is_uploaded: boolean;
    upload_origin?: UploadOriginEnum | BlankEnum | NullEnum | null;
    page_count?: number;
    filesize?: number;
    images: Array<ImageproxyImagePresetRequest>;
    needs_ocr?: boolean;
    ocr_started_at?: string | null;
    ocr_finished_at?: string | null;
    ocr_is_finished?: boolean | null;
    needs_embeddings?: boolean;
    embeddings_started_at?: string | null;
    embeddings_finished_at?: string | null;
    embeddings_is_finished?: boolean | null;
    needs_summary?: boolean;
    summary_started_at?: string | null;
    summary_finished_at?: string | null;
    summary_is_finished?: boolean | null;
    needs_summary_embedding?: boolean;
    summary_embedding_started_at?: string | null;
    summary_embedding_finished_at?: string | null;
    summary_embedding_is_finished?: boolean | null;
    needs_raptor_summaries?: boolean;
    raptor_summaries_started_at?: string | null;
    raptor_summaries_finished_at?: string | null;
    raptor_summaries_is_finished?: boolean | null;
    needs_analysis?: boolean;
    analysis_started_at?: string | null;
    analysis_finished_at?: string | null;
    analysis_is_finished?: boolean | null;
    needs_metadata_enrichment?: boolean;
    metadata_enrichment_started_at?: string | null;
    metadata_enrichment_finished_at?: string | null;
    metadata_enrichment_is_finished?: boolean | null;
    metadata_enrichment_error?: string | null;
    embeddings_error?: string | null;
    summary_error?: string | null;
    summary_embedding_error?: string | null;
    raptor_summaries_error?: string | null;
    analysis_error?: string | null;
};

/**
 * * `Anfrage` - Case
 * * `E-Mail` - Email
 * * `Upload` - Upload
 * * `Fragebogen` - Questionnaire
 * * `Dokumentenvorlage` - Pdf Template
 * * `Transkript` - Call Transcript
 * * `KI Dokumentengenerator Vorlage` - Ai Document Generator Template
 * * `KI generiertes Dokument` - Ai Generated Document
 * * `KI Chat` - Ai Case Chat
 */
export type DocumentTypeEnum = 'Anfrage' | 'E-Mail' | 'Upload' | 'Fragebogen' | 'Dokumentenvorlage' | 'Transkript' | 'KI Dokumentengenerator Vorlage' | 'KI generiertes Dokument' | 'KI Chat';

/**
 * * `Anfrage` - Case
 * * `E-Mail` - Email
 * * `Upload` - Upload
 * * `Fragebogen` - Questionnaire
 * * `Dokumentenvorlage` - Pdf Template
 * * `Transkript` - Call Transcript
 * * `KI Dokumentengenerator Vorlage` - Ai Document Generator Template
 * * `KI generiertes Dokument` - Ai Generated Document
 * * `KI Chat` - Ai Case Chat
 */
export const DocumentTypeEnum = {
    ANFRAGE: 'Anfrage',
    E_MAIL: 'E-Mail',
    UPLOAD: 'Upload',
    FRAGEBOGEN: 'Fragebogen',
    DOKUMENTENVORLAGE: 'Dokumentenvorlage',
    TRANSKRIPT: 'Transkript',
    KI_DOKUMENTENGENERATOR_VORLAGE: 'KI Dokumentengenerator Vorlage',
    KI_GENERIERTES_DOKUMENT: 'KI generiertes Dokument',
    KI_CHAT: 'KI Chat'
} as const;

export type DocumentUpload = {
    file: string;
    /**
     * Origin of the document upload
     *
     * * `None` - Not Set
     * * `Chatbot Upload` - Chatbot
     * * `Email Anhang` - Email
     * * `Terminbuchung` - Appointment
     * * `Fragebogen` - Questionnaire
     * * `Manuell hinzugefügt` - Manual
     * * `AI CASE CHAT` - Ai Case Chat
     */
    upload_origin?: UploadOriginEnum;
};

export type DocumentUploadRequest = {
    file: (Blob | File);
    /**
     * Origin of the document upload
     *
     * * `None` - Not Set
     * * `Chatbot Upload` - Chatbot
     * * `Email Anhang` - Email
     * * `Terminbuchung` - Appointment
     * * `Fragebogen` - Questionnaire
     * * `Manuell hinzugefügt` - Manual
     * * `AI CASE CHAT` - Ai Case Chat
     */
    upload_origin?: UploadOriginEnum;
};

/**
 * * `5` - 5 Minuten
 * * `10` - 10 Minuten
 * * `15` - 15 Minuten
 * * `30` - 30 Minuten
 * * `45` - 45 Minuten
 * * `60` - 60 Minuten
 * * `90` - 90 Minuten
 * * `120` - 120 Minuten
 * * `180` - 180 Minuten
 * * `240` - 240 Minuten
 * * `300` - 300 Minuten
 */
export type DurationMinsEnum = 5 | 10 | 15 | 30 | 45 | 60 | 90 | 120 | 180 | 240 | 300;

/**
 * * `5` - 5 Minuten
 * * `10` - 10 Minuten
 * * `15` - 15 Minuten
 * * `30` - 30 Minuten
 * * `45` - 45 Minuten
 * * `60` - 60 Minuten
 * * `90` - 90 Minuten
 * * `120` - 120 Minuten
 * * `180` - 180 Minuten
 * * `240` - 240 Minuten
 * * `300` - 300 Minuten
 */
export const DurationMinsEnum = {
    '_5': 5,
    '_10': 10,
    '_15': 15,
    '_30': 30,
    '_45': 45,
    '_60': 60,
    '_90': 90,
    '_120': 120,
    '_180': 180,
    '_240': 240,
    '_300': 300
} as const;

export type EditorUploadRequest = {
    is_private: boolean;
};

export type EditorUploadResponse = {
    link: string;
};

export type EmailAddress = {
    uuid?: string;
    email: string;
    name: string;
};

export type EmailRenderTemplateRequestRequest = {
    template_html: string;
    case_uuid?: string | null;
    subject: string;
    contexts?: Array<ContextRequest>;
};

export type EmailRenderTemplateResponse = {
    subject: string;
    text: string;
    html: string;
};

export type EmailRequest = {
    uuid?: string;
};

/**
 * * `create` - Mandatsaufnahme
 * * `reject` - Mandatsablehnung
 */
export type EmailTemplateType = 'create' | 'reject';

/**
 * * `create` - Mandatsaufnahme
 * * `reject` - Mandatsablehnung
 */
export const EmailTemplateType = {
    CREATE: 'create',
    REJECT: 'reject'
} as const;

/**
 * * `#000000` - Black
 * * `#28324E` - Dark Grey
 * * `#2969B0` - Darker Blue
 * * `#2C82C9` - Dark Blue
 * * `#553982` - Dark Purple
 * * `#E25041` - Dark Red
 * * `#475577` - Grey
 * * `#9365B8` - Purple
 * * `#A38F84` - Brown
 * * `#1ABC9C` - Teal
 * * `#00A885` - Aqua
 * * `#3D8EB9` - Light Blue
 * * `#61BD6D` - Green
 * * `#41A85F` - Light Green
 * * `#54ACD2` - Blue
 * * `#EB6B56` - Red
 * * `#FBA026` - Orange
 * * `#F7DA64` - Yellow
 * * `#CCCCCC` - Light Grey
 */
export type EmailTextColorEnum = '#000000' | '#28324E' | '#2969B0' | '#2C82C9' | '#553982' | '#E25041' | '#475577' | '#9365B8' | '#A38F84' | '#1ABC9C' | '#00A885' | '#3D8EB9' | '#61BD6D' | '#41A85F' | '#54ACD2' | '#EB6B56' | '#FBA026' | '#F7DA64' | '#CCCCCC';

/**
 * * `#000000` - Black
 * * `#28324E` - Dark Grey
 * * `#2969B0` - Darker Blue
 * * `#2C82C9` - Dark Blue
 * * `#553982` - Dark Purple
 * * `#E25041` - Dark Red
 * * `#475577` - Grey
 * * `#9365B8` - Purple
 * * `#A38F84` - Brown
 * * `#1ABC9C` - Teal
 * * `#00A885` - Aqua
 * * `#3D8EB9` - Light Blue
 * * `#61BD6D` - Green
 * * `#41A85F` - Light Green
 * * `#54ACD2` - Blue
 * * `#EB6B56` - Red
 * * `#FBA026` - Orange
 * * `#F7DA64` - Yellow
 * * `#CCCCCC` - Light Grey
 */
export const EmailTextColorEnum = {
    _000000: '#000000',
    _28324E: '#28324E',
    _2969B0: '#2969B0',
    _2C82C9: '#2C82C9',
    _553982: '#553982',
    _E25041: '#E25041',
    _475577: '#475577',
    _9365B8: '#9365B8',
    _A38F84: '#A38F84',
    _1ABC9C: '#1ABC9C',
    _00A885: '#00A885',
    _3D8EB9: '#3D8EB9',
    _61BD6D: '#61BD6D',
    _41A85F: '#41A85F',
    _54ACD2: '#54ACD2',
    _EB6B56: '#EB6B56',
    _FBA026: '#FBA026',
    _F7DA64: '#F7DA64',
    _CCCCCC: '#CCCCCC'
} as const;

/**
 * * `Arial,Helvetica,sans-serif` - Arial
 * * `Georgia,serif` - Georgia
 * * `Impact,Charcoal,sans-serif` - Impact
 * * `Tahoma,Geneva,sans-serif` - Tahoma
 * * `'Times New Roman',Times,serif` - Times New Roman
 * * `Verdana,Geneva,sans-serif` - Verdana
 */
export type EmailTextFontEnum = 'Arial,Helvetica,sans-serif' | 'Georgia,serif' | 'Impact,Charcoal,sans-serif' | 'Tahoma,Geneva,sans-serif' | "'Times New Roman',Times,serif" | 'Verdana,Geneva,sans-serif';

/**
 * * `Arial,Helvetica,sans-serif` - Arial
 * * `Georgia,serif` - Georgia
 * * `Impact,Charcoal,sans-serif` - Impact
 * * `Tahoma,Geneva,sans-serif` - Tahoma
 * * `'Times New Roman',Times,serif` - Times New Roman
 * * `Verdana,Geneva,sans-serif` - Verdana
 */
export const EmailTextFontEnum = {
    ARIAL_HELVETICA_SANS_SERIF: 'Arial,Helvetica,sans-serif',
    GEORGIA_SERIF: 'Georgia,serif',
    IMPACT_CHARCOAL_SANS_SERIF: 'Impact,Charcoal,sans-serif',
    TAHOMA_GENEVA_SANS_SERIF: 'Tahoma,Geneva,sans-serif',
    _TIMES_NEW_ROMAN__TIMES_SERIF: "'Times New Roman',Times,serif",
    VERDANA_GENEVA_SANS_SERIF: 'Verdana,Geneva,sans-serif'
} as const;

/**
 * * `8` - Size 8
 * * `9` - Size 9
 * * `10` - Size 10
 * * `11` - Size 11
 * * `12` - Size 12
 * * `14` - Size 14
 * * `18` - Size 18
 */
export type EmailTextSizeEnum = 8 | 9 | 10 | 11 | 12 | 14 | 18;

/**
 * * `8` - Size 8
 * * `9` - Size 9
 * * `10` - Size 10
 * * `11` - Size 11
 * * `12` - Size 12
 * * `14` - Size 14
 * * `18` - Size 18
 */
export const EmailTextSizeEnum = {
    '_8': 8,
    '_9': 9,
    '_10': 10,
    '_11': 11,
    '_12': 12,
    '_14': 14,
    '_18': 18
} as const;

/**
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 */
export type EntitiesMapperKeyEnum = 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip';

/**
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 */
export const EntitiesMapperKeyEnum = {
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip'
} as const;

export type Entity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<(number)>;
};

export type EntityAddCaseDataRelationshipRequest = {
    case_data_uuid: string;
    relationship_type: RelationshipTypeEnum;
    number?: number | null;
};

export type EntityAugmentedFieldsRequest = {
    entity_type: string | null;
    title: string | null;
    first_name: string | null;
    last_name: string | null;
    company_name: string | null;
    company_legal_form: string | null;
    institution_name: string | null;
    phone: string | null;
    email: string | null;
    date_of_birth: string | null;
    street: string | null;
    street_number: string | null;
    zip: string | null;
    city: string | null;
    legal_insurance: string | null;
    legal_insurance_number: string | null;
    legal_insurance_name: string | null;
};

export type EntityRelationship = {
    uuid?: string;
    relationship_type: RelationshipTypeEnum;
    is_unique_per_case: boolean;
    number: number | null;
};

export type EntityRelationshipRequest = {
    uuid?: string;
    relationship_type: RelationshipTypeEnum;
    is_unique_per_case: boolean;
    number: number | null;
};

export type EntityRemoveCaseDataRelationshipCustomerResponse = {
    relationship: (CustomerEntityWithRelationship) | null;
};

export type EntityRemoveCaseDataRelationshipRequestRequest = {
    case_data_uuid: string;
    relationship_uuid?: string | null;
    remove_case_data_association_if_no_relationships_exist?: boolean;
};

export type EntityRemoveCaseDataRelationshipSuperUserResponse = {
    relationship: (SuperUserEntityWithRelationship) | null;
};

export type EntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type EntityTypeC7aEnum = 'natural_person' | 'legal_person' | 'institution';

export const EntityTypeC7aEnum = {
    NATURAL_PERSON: 'natural_person',
    LEGAL_PERSON: 'legal_person',
    INSTITUTION: 'institution'
} as const;

/**
 * * `natural_person` - Natürliche Person
 * * `legal_person` - Juristische Person
 * * `institution` - Institution
 */
export type EntityTypeEnum = 'natural_person' | 'legal_person' | 'institution';

/**
 * * `natural_person` - Natürliche Person
 * * `legal_person` - Juristische Person
 * * `institution` - Institution
 */
export const EntityTypeEnum = {
    NATURAL_PERSON: 'natural_person',
    LEGAL_PERSON: 'legal_person',
    INSTITUTION: 'institution'
} as const;

export type ExternalIntegrationCaseCreationResponse = {
    caseId: string;
    status: string;
    message: string;
};

export type ExternalIntegrationFileDownloadResponse = {
    fileName: string;
    content: string;
    contentType: string;
    message: string;
};

/**
 * * `ai_chat` - Ai Chat
 * * `document_generator` - Document Generator
 * * `ai_analysis` - Ai Analysis
 */
export type FeatureEnum = 'ai_chat' | 'document_generator' | 'ai_analysis';

/**
 * * `ai_chat` - Ai Chat
 * * `document_generator` - Document Generator
 * * `ai_analysis` - Ai Analysis
 */
export const FeatureEnum = {
    AI_CHAT: 'ai_chat',
    DOCUMENT_GENERATOR: 'document_generator',
    AI_ANALYSIS: 'ai_analysis'
} as const;

export type Feedback = {
    readonly uuid: string;
    readonly created_at: string;
    url: string;
    readonly user: number | null;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

export type FeedbackRelatedData = {
    document_generator?: DocumentGeneratorRelatedData | null;
    ai_chat?: AIChatRelatedData | null;
    ai_analysis?: AiAnalysisRelatedData | null;
};

export type FeedbackRequest = {
    url: string;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

/**
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen Löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - It Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-Und Presserecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export type FieldEnum = 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'Immobilienrecht' | 'Inkasso' | 'IT Recht' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';

/**
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen Löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - It Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-Und Presserecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export const FieldEnum = {
    ARBEITSRECHT: 'Arbeitsrecht',
    ASYLRECHT: 'Asylrecht',
    'AUSLÄNDERRECHT': 'Ausländerrecht',
    BANKRECHT: 'Bankrecht',
    BAURECHT: 'Baurecht',
    BEAMTENRECHT: 'Beamtenrecht',
    'BEWERTUNGEN_LÖSCHEN': 'Bewertungen löschen',
    CASINO: 'Casino',
    COACHING: 'Coaching',
    COMPLIANCE: 'Compliance',
    'CORONA_ÜBERBRÜCKUNGSHILFE': 'Corona Überbrückungshilfe',
    DATENLECK: 'Datenleck',
    ERBRECHT: 'Erbrecht',
    FAMILIENRECHT: 'Familienrecht',
    GESELLSCHAFTSRECHT: 'Gesellschaftsrecht',
    GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT: 'Gewerblicher Rechtsschutz/Urheberrecht',
    HOCHSCHULRECHT: 'Hochschulrecht',
    IMMOBILIENRECHT: 'Immobilienrecht',
    INKASSO: 'Inkasso',
    IT_RECHT: 'IT Recht',
    INSOLVENZBERATUNG: 'Insolvenzberatung',
    MARKENRECHT: 'Markenrecht',
    MEDIEN_UND_PRESSERECHT: 'Medien-und Presserecht',
    MIETRECHT: 'Mietrecht',
    MIGRATIONSRECHT: 'Migrationsrecht',
    MUSIKRECHT: 'Musikrecht',
    NOTARIAT: 'Notariat',
    'PERSONENSCHÄDEN': 'Personenschäden',
    SCHUFA: 'Schufa',
    SCHULRECHT: 'Schulrecht',
    SOCIAL_MEDIA_RECHT: 'Social Media Recht',
    SOZIALRECHT: 'Sozialrecht',
    STEUERBERATUNG: 'Steuerberatung',
    STEUERRECHT: 'Steuerrecht',
    STRAFRECHT: 'Strafrecht',
    TESLA_WIDERRUF: 'Tesla_Widerruf',
    TIERRECHT: 'Tierrecht',
    VERKEHRSRECHT: 'Verkehrsrecht',
    VERSICHERUNGSRECHT: 'Versicherungsrecht',
    VERWALTUNGSRECHT: 'Verwaltungsrecht',
    WEGRECHT: 'Wegrecht',
    ZIVILRECHT: 'Zivilrecht'
} as const;

/**
 * * `multiselect` - multiselect
 * * `select` - select
 * * `textarea` - textarea
 * * `filefield` - filefield
 * * `multifilefield` - multifilefield
 * * `timefield` - timefield
 * * `decimalnumberinput` - decimalnumberinput
 * * `datefield` - datefield
 * * `textinput` - textinput
 * * `numberinput` - numberinput
 * * `emailinput` - emailinput
 * * `phoneinput` - phoneinput
 * * `urlinput` - urlinput
 * * `yesno` - yesno
 */
export type FieldTypeEnum = 'multiselect' | 'select' | 'textarea' | 'filefield' | 'multifilefield' | 'timefield' | 'decimalnumberinput' | 'datefield' | 'textinput' | 'numberinput' | 'emailinput' | 'phoneinput' | 'urlinput' | 'yesno';

/**
 * * `multiselect` - multiselect
 * * `select` - select
 * * `textarea` - textarea
 * * `filefield` - filefield
 * * `multifilefield` - multifilefield
 * * `timefield` - timefield
 * * `decimalnumberinput` - decimalnumberinput
 * * `datefield` - datefield
 * * `textinput` - textinput
 * * `numberinput` - numberinput
 * * `emailinput` - emailinput
 * * `phoneinput` - phoneinput
 * * `urlinput` - urlinput
 * * `yesno` - yesno
 */
export const FieldTypeEnum = {
    MULTISELECT: 'multiselect',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    FILEFIELD: 'filefield',
    MULTIFILEFIELD: 'multifilefield',
    TIMEFIELD: 'timefield',
    DECIMALNUMBERINPUT: 'decimalnumberinput',
    DATEFIELD: 'datefield',
    TEXTINPUT: 'textinput',
    NUMBERINPUT: 'numberinput',
    EMAILINPUT: 'emailinput',
    PHONEINPUT: 'phoneinput',
    URLINPUT: 'urlinput',
    YESNO: 'yesno'
} as const;

export type FileDataRequest = {
    uuid: string;
    filename: string;
};

export type FindWordDocumentTemplatePlaceholderValuesRequestRequest = {
    word_document_template_uuid: string;
};

export type FindWordDocumentTemplatePlaceholderValuesResponse = {
    readonly replaceable_variables: ReplaceableVariables;
};

/**
 * * `MASTER` - Master
 * * `PREFILLED` - Prefilled
 * * `SIGNED` - Signed
 */
export type FormTag = 'MASTER' | 'PREFILLED' | 'SIGNED';

/**
 * * `MASTER` - Master
 * * `PREFILLED` - Prefilled
 * * `SIGNED` - Signed
 */
export const FormTag = {
    MASTER: 'MASTER',
    PREFILLED: 'PREFILLED',
    SIGNED: 'SIGNED'
} as const;

export type GenerateDocumentChatRequest = {
    role: GenerateDocumentChatRoleEnum;
    content: string;
    is_template: boolean;
};

/**
 * * `system` - System
 * * `user` - User
 * * `assistant` - Assistant
 */
export type GenerateDocumentChatRoleEnum = 'system' | 'user' | 'assistant';

/**
 * * `system` - System
 * * `user` - User
 * * `assistant` - Assistant
 */
export const GenerateDocumentChatRoleEnum = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
} as const;

export type GenerateDocumentRequestRequest = {
    document_template_uuid: string;
    chat: Array<GenerateDocumentChatRequest>;
};

export type GenericDataMapper = {
    key: AiAugmentedByMapperKeysEnum;
    label: string;
    field_type: FieldTypeEnum;
    choices?: Array<(string)>;
    is_law_specific_field: boolean;
    is_entity_field: boolean;
    law_field?: LawFieldEnum;
    max_length?: number | null;
    is_nullable: boolean;
    default: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    starts_ai_analysis: boolean;
    ai_augments_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
    ai_augmented_by_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
};

export type GenericDataMapperRequest = {
    key: AiAugmentedByMapperKeysEnum;
    label: string;
    field_type: FieldTypeEnum;
    choices?: Array<(string)>;
    is_law_specific_field: boolean;
    is_entity_field: boolean;
    law_field?: LawFieldEnum;
    max_length?: number | null;
    is_nullable: boolean;
    default: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    starts_ai_analysis: boolean;
    ai_augments_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
    ai_augmented_by_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
};

/**
 * * `thumbnail` - thumbnail
 * * `small` - small
 * * `medium` - medium
 * * `large` - large
 */
export type ImagePresetEnum = 'thumbnail' | 'small' | 'medium' | 'large';

/**
 * * `thumbnail` - thumbnail
 * * `small` - small
 * * `medium` - medium
 * * `large` - large
 */
export const ImagePresetEnum = {
    THUMBNAIL: 'thumbnail',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
} as const;

export type ImageproxyImagePreset = {
    url: string;
    image_preset: ImagePresetEnum;
};

export type ImageproxyImagePresetRequest = {
    url: string;
    image_preset: ImagePresetEnum;
};

export type InboundEmailAttachment = {
    uuid?: string;
    file_name: string;
    file: string;
};

export type InboundEmailRequest = {
    uuid?: string;
};

export type IntegrationSpecificDataRequest = ActaportDataRequest | AdvoluxDataRequest | AdvowareDataRequest | LawFirmSoftwareDataRequest | RaMicroDataRequest | RaMicroApiDataRequest | JurnodesDataRequest | KleosDataRequest | AnnotextRequest;

/**
 * * `actaport` - Actaport
 * * `advolux` - Advolux
 * * `advoware` - Advoware
 * * `lawfirm` - LawFirm
 * * `ramicro` - RaMicro
 * * `ramicroapi` - RaMicroApi
 * * `jurnodes` - Jurnodes
 * * `kleos` - Kleos
 * * `annotext` - Annotext
 */
export type IntegrationTypeEnum = 'actaport' | 'advolux' | 'advoware' | 'lawfirm' | 'ramicro' | 'ramicroapi' | 'jurnodes' | 'kleos' | 'annotext';

/**
 * * `actaport` - Actaport
 * * `advolux` - Advolux
 * * `advoware` - Advoware
 * * `lawfirm` - LawFirm
 * * `ramicro` - RaMicro
 * * `ramicroapi` - RaMicroApi
 * * `jurnodes` - Jurnodes
 * * `kleos` - Kleos
 * * `annotext` - Annotext
 */
export const IntegrationTypeEnum = {
    ACTAPORT: 'actaport',
    ADVOLUX: 'advolux',
    ADVOWARE: 'advoware',
    LAWFIRM: 'lawfirm',
    RAMICRO: 'ramicro',
    RAMICROAPI: 'ramicroapi',
    JURNODES: 'jurnodes',
    KLEOS: 'kleos',
    ANNOTEXT: 'annotext'
} as const;

export type JumpTo = {
    uuid: string | null;
    value: string;
};

export type JumpToRequest = {
    uuid: string | null;
    value: string;
};

export type JurnodesDataRequest = {
    datapool: number;
    rubrum: string;
    lawCategory: number;
    recordSchema: number;
    lawyers?: Array<(number)>;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type JurnodesLawCategory = {
    id: number;
    name: string;
};

export type JurnodesRecordSchema = {
    id: number;
    name: string;
    lawCategory: number;
};

export type JurnodesUser = {
    id: number;
    displayName: string;
    abbreviation: string;
    department: string;
    position: string;
    privateFileFolder: string;
    contact: string;
};

export type KleosCaseType = {
    id: number;
    name: string;
    defaultRegister: number | null;
};

export type KleosCaseTypes = {
    caseTypes: Array<KleosCaseType>;
};

export type KleosDataRequest = {
    name: string;
    description: string | null;
    caseResponsibleId?: number | null;
    typeId: number;
    creationDate: string;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type LawAugmentedFieldsRequest = {
    field: string | null;
    topic: string | null;
};

export type LawData = {
    uuid?: string;
    readonly created_at: string;
    readonly updated_at: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_wanring_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
    readonly labor_law_work_contract: Array<DocumentUpload>;
    readonly labor_law_termination: Array<DocumentUpload>;
    readonly labor_law_termination_agreement: Array<DocumentUpload>;
    readonly labor_law_settlement_agreement: Array<DocumentUpload>;
    readonly labor_law_warning_letter: Array<DocumentUpload>;
    readonly labor_law_payslip: Array<DocumentUpload>;
    readonly traffic_law_fine_notice: Array<DocumentUpload>;
    readonly traffic_law_accident_report: Array<DocumentUpload>;
    readonly traffic_law_expert_report: Array<DocumentUpload>;
    readonly traffic_law_warning_notice: Array<DocumentUpload>;
    readonly traffic_law_penalty_order: Array<DocumentUpload>;
    readonly criminal_law_criminal_warrant: Array<DocumentUpload>;
    readonly criminal_law_complaint: Array<DocumentUpload>;
    readonly criminal_law_indictment: Array<DocumentUpload>;
    readonly family_law_divorce_application: Array<DocumentUpload>;
    readonly family_law_marriage_certificate: Array<DocumentUpload>;
    readonly family_law_birth_certificate: Array<DocumentUpload>;
    readonly family_law_marriage_contract: Array<DocumentUpload>;
    readonly social_law_notice_of_objection: Array<DocumentUpload>;
    readonly debt_collection_law_invoice: Array<DocumentUpload>;
    readonly debt_collection_law_invoice_lawyer: Array<DocumentUpload>;
    readonly tenancy_law_rental_agreement: Array<DocumentUpload>;
    readonly tenancy_law_lease_agreement: Array<DocumentUpload>;
    readonly tenancy_law_service_charge_settlement: Array<DocumentUpload>;
    readonly tenancy_law_handover_protocol: Array<DocumentUpload>;
    readonly residential_property_law_contract: Array<DocumentUpload>;
    readonly inheritance_law_certificate_of_inheritance: Array<DocumentUpload>;
    readonly inheritance_law_inheritance_contract: Array<DocumentUpload>;
    readonly inheritance_law_death_certificate: Array<DocumentUpload>;
    readonly inheritance_law_will: Array<DocumentUpload>;
    readonly inheritance_law_list_of_estate: Array<DocumentUpload>;
    readonly inheritance_law_living_will: Array<DocumentUpload>;
    readonly inheritance_law_lasting_power_of_attorney: Array<DocumentUpload>;
    readonly real_estate_law_land_register: Array<DocumentUpload>;
    readonly real_estate_law_purchase_contract: Array<DocumentUpload>;
    readonly generic_document: Array<DocumentUpload>;
};

export type LawDataRequest = {
    uuid?: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_wanring_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

/**
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - IT Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-und Presserecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla_Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export type LawFieldEnum = 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'Immobilienrecht' | 'Inkasso' | 'IT Recht' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';

/**
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - IT Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-und Presserecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla_Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export const LawFieldEnum = {
    ARBEITSRECHT: 'Arbeitsrecht',
    ASYLRECHT: 'Asylrecht',
    'AUSLÄNDERRECHT': 'Ausländerrecht',
    BANKRECHT: 'Bankrecht',
    BAURECHT: 'Baurecht',
    BEAMTENRECHT: 'Beamtenrecht',
    'BEWERTUNGEN_LÖSCHEN': 'Bewertungen löschen',
    CASINO: 'Casino',
    COACHING: 'Coaching',
    COMPLIANCE: 'Compliance',
    'CORONA_ÜBERBRÜCKUNGSHILFE': 'Corona Überbrückungshilfe',
    DATENLECK: 'Datenleck',
    ERBRECHT: 'Erbrecht',
    FAMILIENRECHT: 'Familienrecht',
    GESELLSCHAFTSRECHT: 'Gesellschaftsrecht',
    GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT: 'Gewerblicher Rechtsschutz/Urheberrecht',
    HOCHSCHULRECHT: 'Hochschulrecht',
    IMMOBILIENRECHT: 'Immobilienrecht',
    INKASSO: 'Inkasso',
    IT_RECHT: 'IT Recht',
    INSOLVENZBERATUNG: 'Insolvenzberatung',
    MARKENRECHT: 'Markenrecht',
    MEDIEN_UND_PRESSERECHT: 'Medien-und Presserecht',
    MIETRECHT: 'Mietrecht',
    MIGRATIONSRECHT: 'Migrationsrecht',
    MUSIKRECHT: 'Musikrecht',
    NOTARIAT: 'Notariat',
    'PERSONENSCHÄDEN': 'Personenschäden',
    SCHUFA: 'Schufa',
    SCHULRECHT: 'Schulrecht',
    SOCIAL_MEDIA_RECHT: 'Social Media Recht',
    SOZIALRECHT: 'Sozialrecht',
    STEUERBERATUNG: 'Steuerberatung',
    STEUERRECHT: 'Steuerrecht',
    STRAFRECHT: 'Strafrecht',
    TESLA_WIDERRUF: 'Tesla_Widerruf',
    TIERRECHT: 'Tierrecht',
    VERKEHRSRECHT: 'Verkehrsrecht',
    VERSICHERUNGSRECHT: 'Versicherungsrecht',
    VERWALTUNGSRECHT: 'Verwaltungsrecht',
    WEGRECHT: 'Wegrecht',
    ZIVILRECHT: 'Zivilrecht'
} as const;

export type LawFields = {
    data: {
        [key: string]: Array<(string)>;
    };
};

export type LawFirmSoftwareDataRequest = {
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

/**
 * * `AGB` - AGB
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung nicht eingehalten
 * * `Account hacking` - Account hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/ALG/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß gegen die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung zu Lebzeiten
 */
export type LawTopicEnum = 'AGB' | 'Abfindung' | 'Abmahnung' | 'Abmahnung Wettbewerbsrecht' | 'Abschiebungshaft' | 'Abschlussarbeit' | 'Abstandsregelung nicht eingehalten' | 'Account hacking' | 'Allgemein' | 'Allgemeines Prüfungsrecht' | 'Anderes' | 'Arbeitsamt/ALG/Sperrzeit' | 'Arbeitsunfall' | 'Arbeitsvertrag' | 'Arbeitszeugnis' | 'Aufbau Compliancesystem' | 'Aufenthaltserlaubnis' | 'Aufhebungsvertrag' | 'Auftragsdatenverarbeitung' | 'Auseinandersetzung Erbengemeinschaft' | 'Auskunft prüfen' | 'Ausweisung' | 'Autokauf' | 'Bankkonto leergeräumt' | 'Bankrecht' | 'Baumangel' | 'Bauvertrag' | 'Behandlungsfehler Allgemein' | 'Behandlungsfehler Querschnittslähmung' | 'Behandlungsfehler Schlaganfall' | 'Beißvorfall' | 'Beratung zu Erbfall' | 'Beschlagnahme Allgemein' | 'Beschlagnahme Tierquälerei' | 'Betreuungsrecht' | 'Betrug Geldanlage' | 'Betäubungsmittel' | 'Burgschild Inkasso' | 'Bußgeldbescheid' | 'Bürgergeld' | 'Coaching' | 'Datenschutz' | 'Datenschutz Schadensersatz' | 'Datenschutzverstoß' | 'Domains' | 'Ehevertrag' | 'Eigentumsdelikte' | 'Einbürgerung' | 'Einreisesperre' | 'Eintrag löschen' | 'Erbauseinandersetzung' | 'Erbausschlagung' | 'Erben/Schenken' | 'Erbengemeinschaft' | 'Erbschein' | 'Erbscheinsantrag' | 'Erbvertrag' | 'Exmatrikulation' | 'Fahren ohne Führerschein' | 'Fahren unter Alkohol - / Drogeneinfluss' | 'Fahrer - / Unfallflucht' | 'Fahrverbot / Führerscheinentzug' | 'Falschaussage/ Meineid' | 'Familie Vorsorge' | 'Forderung löschen' | 'Geburtsfehler' | 'Geburtsfehler Mutter' | 'Geschwindigkeitsüberschreitung' | 'Gesetzliche Erbfolge' | 'Gewerblicher Rechtsschutz' | 'Grundschuld' | 'Gründung' | 'Handy am Steuer' | 'Hauskauf' | 'Härtefallantrag' | 'Immobilien' | 'Immobilienübertragung' | 'Kaufvertragsprüfung' | 'Körperverletzung' | 'Kündigung' | 'Lohnzahlung' | 'Maklerangelegenheit' | 'Markenanmeldung' | 'Markenverteidigung' | 'Markenüberwachung' | 'Mieterhöhung' | 'Mietkaution' | 'Mietminderung' | 'Mietvertrag' | 'Nebenkostenabrechnung' | 'Niederlassungserlaubnis' | 'Nutzerbewertungen Verfasser' | 'Patientenverfügung/Vorsorgevollmacht' | 'Personenverwechselung' | 'Pflege-/Krankenversicherung' | 'Pflichtteil' | 'Pflichtteil Geltendmachung' | 'Pflichtteil abwehren' | 'Plagiatsvorwurf' | 'Remonstration' | 'Rente' | 'Rotlichtverstoß' | 'Räumungsklage' | 'Schadensersatz' | 'Scheidung' | 'Schenkung' | 'Schenkung Immobilie' | 'Schulplatz einklagen' | 'Schwerbehinderung' | 'Sexualdelikt' | 'Software Hardware' | 'Sonstige Beglaubigung' | 'Sorgerecht und Umgangsrecht' | 'Testament' | 'Testament/Erbvertrag' | 'Tierkauf' | 'Tierärztliche Behandlungsfehler' | 'Trennung' | 'Tuning' | 'Täuschungsversuch' | 'Tötungsdelikte' | 'Unfall Querschnittslähmung' | 'Unfall mit Personenschaden' | 'Unterhalt' | 'Unternehmen' | 'Unternehmensauflösung' | 'Unternehmensgründung' | 'Unternehmenskauf' | 'Urheberrecht' | 'Urlaub' | 'Vaterschaftsanerkennung' | 'Vererben' | 'Verkehrsunfall' | 'Vermögensauseinandersetzung' | 'Vermögensdelikte' | 'Verstoß gegen die Anschnallpflicht' | 'Vertragsprüfung' | 'Vertragsrecht' | 'Visum' | 'Vorfälligkeitsentschädigung' | 'Vorsorge' | 'Vorsorgevollmacht/Patientenverfügung' | 'Waffendelikte' | 'Wettbewerbsrecht' | 'Widerrufsrechte' | 'Widerspruch/ Klage' | 'Wucherzinsen Darlehen' | 'Zugewinnausgleich' | 'Zweiradunfall' | 'unbezahlte Rechnungen' | 'unerlaubtes Glücksspiel' | 'Überstunden' | 'Übertragung zu Lebzeiten';

/**
 * * `AGB` - AGB
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung nicht eingehalten
 * * `Account hacking` - Account hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/ALG/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß gegen die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung zu Lebzeiten
 */
export const LawTopicEnum = {
    AGB: 'AGB',
    ABFINDUNG: 'Abfindung',
    ABMAHNUNG: 'Abmahnung',
    ABMAHNUNG_WETTBEWERBSRECHT: 'Abmahnung Wettbewerbsrecht',
    ABSCHIEBUNGSHAFT: 'Abschiebungshaft',
    ABSCHLUSSARBEIT: 'Abschlussarbeit',
    ABSTANDSREGELUNG_NICHT_EINGEHALTEN: 'Abstandsregelung nicht eingehalten',
    ACCOUNT_HACKING: 'Account hacking',
    ALLGEMEIN: 'Allgemein',
    'ALLGEMEINES_PRÜFUNGSRECHT': 'Allgemeines Prüfungsrecht',
    ANDERES: 'Anderes',
    ARBEITSAMT_ALG_SPERRZEIT: 'Arbeitsamt/ALG/Sperrzeit',
    ARBEITSUNFALL: 'Arbeitsunfall',
    ARBEITSVERTRAG: 'Arbeitsvertrag',
    ARBEITSZEUGNIS: 'Arbeitszeugnis',
    AUFBAU_COMPLIANCESYSTEM: 'Aufbau Compliancesystem',
    AUFENTHALTSERLAUBNIS: 'Aufenthaltserlaubnis',
    AUFHEBUNGSVERTRAG: 'Aufhebungsvertrag',
    AUFTRAGSDATENVERARBEITUNG: 'Auftragsdatenverarbeitung',
    AUSEINANDERSETZUNG_ERBENGEMEINSCHAFT: 'Auseinandersetzung Erbengemeinschaft',
    'AUSKUNFT_PRÜFEN': 'Auskunft prüfen',
    AUSWEISUNG: 'Ausweisung',
    AUTOKAUF: 'Autokauf',
    'BANKKONTO_LEERGERÄUMT': 'Bankkonto leergeräumt',
    BANKRECHT: 'Bankrecht',
    BAUMANGEL: 'Baumangel',
    BAUVERTRAG: 'Bauvertrag',
    BEHANDLUNGSFEHLER_ALLGEMEIN: 'Behandlungsfehler Allgemein',
    'BEHANDLUNGSFEHLER_QUERSCHNITTSLÄHMUNG': 'Behandlungsfehler Querschnittslähmung',
    BEHANDLUNGSFEHLER_SCHLAGANFALL: 'Behandlungsfehler Schlaganfall',
    BEISSVORFALL: 'Beißvorfall',
    BERATUNG_ZU_ERBFALL: 'Beratung zu Erbfall',
    BESCHLAGNAHME_ALLGEMEIN: 'Beschlagnahme Allgemein',
    'BESCHLAGNAHME_TIERQUÄLEREI': 'Beschlagnahme Tierquälerei',
    BETREUUNGSRECHT: 'Betreuungsrecht',
    BETRUG_GELDANLAGE: 'Betrug Geldanlage',
    'BETÄUBUNGSMITTEL': 'Betäubungsmittel',
    BURGSCHILD_INKASSO: 'Burgschild Inkasso',
    BUSSGELDBESCHEID: 'Bußgeldbescheid',
    'BÜRGERGELD': 'Bürgergeld',
    COACHING: 'Coaching',
    DATENSCHUTZ: 'Datenschutz',
    DATENSCHUTZ_SCHADENSERSATZ: 'Datenschutz Schadensersatz',
    DATENSCHUTZVERSTOSS: 'Datenschutzverstoß',
    DOMAINS: 'Domains',
    EHEVERTRAG: 'Ehevertrag',
    EIGENTUMSDELIKTE: 'Eigentumsdelikte',
    'EINBÜRGERUNG': 'Einbürgerung',
    EINREISESPERRE: 'Einreisesperre',
    'EINTRAG_LÖSCHEN': 'Eintrag löschen',
    ERBAUSEINANDERSETZUNG: 'Erbauseinandersetzung',
    ERBAUSSCHLAGUNG: 'Erbausschlagung',
    ERBEN_SCHENKEN: 'Erben/Schenken',
    ERBENGEMEINSCHAFT: 'Erbengemeinschaft',
    ERBSCHEIN: 'Erbschein',
    ERBSCHEINSANTRAG: 'Erbscheinsantrag',
    ERBVERTRAG: 'Erbvertrag',
    EXMATRIKULATION: 'Exmatrikulation',
    'FAHREN_OHNE_FÜHRERSCHEIN': 'Fahren ohne Führerschein',
    FAHREN_UNTER_ALKOHOL_____DROGENEINFLUSS: 'Fahren unter Alkohol - / Drogeneinfluss',
    FAHRER_____UNFALLFLUCHT: 'Fahrer - / Unfallflucht',
    'FAHRVERBOT___FÜHRERSCHEINENTZUG': 'Fahrverbot / Führerscheinentzug',
    FALSCHAUSSAGE__MEINEID: 'Falschaussage/ Meineid',
    FAMILIE_VORSORGE: 'Familie Vorsorge',
    'FORDERUNG_LÖSCHEN': 'Forderung löschen',
    GEBURTSFEHLER: 'Geburtsfehler',
    GEBURTSFEHLER_MUTTER: 'Geburtsfehler Mutter',
    'GESCHWINDIGKEITSÜBERSCHREITUNG': 'Geschwindigkeitsüberschreitung',
    GESETZLICHE_ERBFOLGE: 'Gesetzliche Erbfolge',
    GEWERBLICHER_RECHTSSCHUTZ: 'Gewerblicher Rechtsschutz',
    GRUNDSCHULD: 'Grundschuld',
    'GRÜNDUNG': 'Gründung',
    HANDY_AM_STEUER: 'Handy am Steuer',
    HAUSKAUF: 'Hauskauf',
    'HÄRTEFALLANTRAG': 'Härtefallantrag',
    IMMOBILIEN: 'Immobilien',
    'IMMOBILIENÜBERTRAGUNG': 'Immobilienübertragung',
    'KAUFVERTRAGSPRÜFUNG': 'Kaufvertragsprüfung',
    'KÖRPERVERLETZUNG': 'Körperverletzung',
    'KÜNDIGUNG': 'Kündigung',
    LOHNZAHLUNG: 'Lohnzahlung',
    MAKLERANGELEGENHEIT: 'Maklerangelegenheit',
    MARKENANMELDUNG: 'Markenanmeldung',
    MARKENVERTEIDIGUNG: 'Markenverteidigung',
    'MARKENÜBERWACHUNG': 'Markenüberwachung',
    'MIETERHÖHUNG': 'Mieterhöhung',
    MIETKAUTION: 'Mietkaution',
    MIETMINDERUNG: 'Mietminderung',
    MIETVERTRAG: 'Mietvertrag',
    NEBENKOSTENABRECHNUNG: 'Nebenkostenabrechnung',
    NIEDERLASSUNGSERLAUBNIS: 'Niederlassungserlaubnis',
    NUTZERBEWERTUNGEN_VERFASSER: 'Nutzerbewertungen Verfasser',
    'PATIENTENVERFÜGUNG_VORSORGEVOLLMACHT': 'Patientenverfügung/Vorsorgevollmacht',
    PERSONENVERWECHSELUNG: 'Personenverwechselung',
    PFLEGE__KRANKENVERSICHERUNG: 'Pflege-/Krankenversicherung',
    PFLICHTTEIL: 'Pflichtteil',
    PFLICHTTEIL_GELTENDMACHUNG: 'Pflichtteil Geltendmachung',
    PFLICHTTEIL_ABWEHREN: 'Pflichtteil abwehren',
    PLAGIATSVORWURF: 'Plagiatsvorwurf',
    REMONSTRATION: 'Remonstration',
    RENTE: 'Rente',
    ROTLICHTVERSTOSS: 'Rotlichtverstoß',
    'RÄUMUNGSKLAGE': 'Räumungsklage',
    SCHADENSERSATZ: 'Schadensersatz',
    SCHEIDUNG: 'Scheidung',
    SCHENKUNG: 'Schenkung',
    SCHENKUNG_IMMOBILIE: 'Schenkung Immobilie',
    SCHULPLATZ_EINKLAGEN: 'Schulplatz einklagen',
    SCHWERBEHINDERUNG: 'Schwerbehinderung',
    SEXUALDELIKT: 'Sexualdelikt',
    SOFTWARE_HARDWARE: 'Software Hardware',
    SONSTIGE_BEGLAUBIGUNG: 'Sonstige Beglaubigung',
    SORGERECHT_UND_UMGANGSRECHT: 'Sorgerecht und Umgangsrecht',
    TESTAMENT: 'Testament',
    TESTAMENT_ERBVERTRAG: 'Testament/Erbvertrag',
    TIERKAUF: 'Tierkauf',
    'TIERÄRZTLICHE_BEHANDLUNGSFEHLER': 'Tierärztliche Behandlungsfehler',
    TRENNUNG: 'Trennung',
    TUNING: 'Tuning',
    'TÄUSCHUNGSVERSUCH': 'Täuschungsversuch',
    'TÖTUNGSDELIKTE': 'Tötungsdelikte',
    'UNFALL_QUERSCHNITTSLÄHMUNG': 'Unfall Querschnittslähmung',
    UNFALL_MIT_PERSONENSCHADEN: 'Unfall mit Personenschaden',
    UNTERHALT: 'Unterhalt',
    UNTERNEHMEN: 'Unternehmen',
    'UNTERNEHMENSAUFLÖSUNG': 'Unternehmensauflösung',
    'UNTERNEHMENSGRÜNDUNG': 'Unternehmensgründung',
    UNTERNEHMENSKAUF: 'Unternehmenskauf',
    URHEBERRECHT: 'Urheberrecht',
    URLAUB: 'Urlaub',
    VATERSCHAFTSANERKENNUNG: 'Vaterschaftsanerkennung',
    VERERBEN: 'Vererben',
    VERKEHRSUNFALL: 'Verkehrsunfall',
    'VERMÖGENSAUSEINANDERSETZUNG': 'Vermögensauseinandersetzung',
    'VERMÖGENSDELIKTE': 'Vermögensdelikte',
    VERSTOSS_GEGEN_DIE_ANSCHNALLPFLICHT: 'Verstoß gegen die Anschnallpflicht',
    'VERTRAGSPRÜFUNG': 'Vertragsprüfung',
    VERTRAGSRECHT: 'Vertragsrecht',
    VISUM: 'Visum',
    'VORFÄLLIGKEITSENTSCHÄDIGUNG': 'Vorfälligkeitsentschädigung',
    VORSORGE: 'Vorsorge',
    'VORSORGEVOLLMACHT_PATIENTENVERFÜGUNG': 'Vorsorgevollmacht/Patientenverfügung',
    WAFFENDELIKTE: 'Waffendelikte',
    WETTBEWERBSRECHT: 'Wettbewerbsrecht',
    WIDERRUFSRECHTE: 'Widerrufsrechte',
    WIDERSPRUCH__KLAGE: 'Widerspruch/ Klage',
    WUCHERZINSEN_DARLEHEN: 'Wucherzinsen Darlehen',
    ZUGEWINNAUSGLEICH: 'Zugewinnausgleich',
    ZWEIRADUNFALL: 'Zweiradunfall',
    UNBEZAHLTE_RECHNUNGEN: 'unbezahlte Rechnungen',
    'UNERLAUBTES_GLÜCKSSPIEL': 'unerlaubtes Glücksspiel',
    'ÜBERSTUNDEN': 'Überstunden',
    'ÜBERTRAGUNG_ZU_LEBZEITEN': 'Übertragung zu Lebzeiten'
} as const;

export type LawyerFeedback = {
    readonly uuid: string;
};

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export type LocationTypeEnum = 'ONLINE' | 'TELEPHONE' | 'IN_PERSON';

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export const LocationTypeEnum = {
    ONLINE: 'ONLINE',
    TELEPHONE: 'TELEPHONE',
    IN_PERSON: 'IN_PERSON'
} as const;

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export type LocationTypesEnum = 'ONLINE' | 'TELEPHONE' | 'IN_PERSON';

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export const LocationTypesEnum = {
    ONLINE: 'ONLINE',
    TELEPHONE: 'TELEPHONE',
    IN_PERSON: 'IN_PERSON'
} as const;

export type NullEnum = unknown;

export type OrganizationAiContext = {
    uuid: string;
    name: string;
    customer_number: string;
    law_firm: boolean;
    law_fields: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    description?: string | null;
};

export type PaginatedSuperUserHubSpotCompanyList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SuperUserHubSpotCompany>;
};

export type PaginatedSuperUserHubSpotContactList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SuperUserHubSpotContact>;
};

export type PaginatedTAIChatSessionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAIChatSession>;
};

export type PaginatedTAccountList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAccount>;
};

export type PaginatedTAiAnalysisList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiAnalysis>;
};

export type PaginatedTAiAugmentationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiAugmentation>;
};

export type PaginatedTAiChatQuestionTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiChatQuestionTemplate>;
};

export type PaginatedTAppointmentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAppointment>;
};

export type PaginatedTAppointmentProposalList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAppointmentProposal>;
};

export type PaginatedTCalendarList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCalendar>;
};

export type PaginatedTCallList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCall>;
};

export type PaginatedTCaseCreatorTempDocumentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCaseCreatorTempDocument>;
};

export type PaginatedTCaseList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCase>;
};

export type PaginatedTDocumentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TDocument>;
};

export type PaginatedTDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TDocumentTemplate>;
};

export type PaginatedTEmailList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEmail>;
};

export type PaginatedTEmailTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEmailTemplate>;
};

export type PaginatedTEntityList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEntity>;
};

export type PaginatedTFeedbackList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TFeedback>;
};

export type PaginatedTFormList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TForm>;
};

export type PaginatedTGenericDataMapperList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TGenericDataMapper>;
};

export type PaginatedTInboundEmailList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TInboundEmail>;
};

export type PaginatedTLawyerFeedbackList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TLawyerFeedback>;
};

export type PaginatedTOrganisationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TOrganisation>;
};

export type PaginatedTPhoneNumberList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TPhoneNumber>;
};

export type PaginatedTQuestionnaireList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TQuestionnaire>;
};

export type PaginatedTQuestionnaireSubmissionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TQuestionnaireSubmission>;
};

export type PaginatedTRetellAgentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TRetellAgent>;
};

export type PaginatedTServiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TService>;
};

export type PaginatedTStripeCustomerList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TStripeCustomer>;
};

export type PaginatedTStripeInvoiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TStripeInvoice>;
};

export type PaginatedTUserList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TUser>;
};

export type PaginatedTWordDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TWordDocumentTemplate>;
};

export type PatchedAIChatSessionRequest = {
    title?: string;
    description?: string;
    case_uuid?: string;
    human_rating?: string | null;
};

export type PatchedAiChatQuestionTemplateRequest = {
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    prompt?: string;
    title?: string;
};

export type PatchedCaseCreatorTempDocumentRequest = {
    original_filename?: string;
    file?: (Blob | File);
};

export type PatchedClientAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedClientAiAugmentationRequest = {
    document?: DocumentRequest;
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

/**
 * Entity representation for clients.
 */
export type PatchedClientEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Questionnaire submission representation for clients.
 */
export type PatchedClientQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedCustomerAccountRequest = {
    uuid?: string;
    account_id?: string;
};

export type PatchedCustomerAdminAccountRequest = {
    uuid?: string;
    account_id?: string;
};

export type PatchedCustomerAdminAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedCustomerAdminAiAugmentationRequest = {
    document?: DocumentRequest;
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

export type PatchedCustomerAdminAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

export type PatchedCustomerAdminCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Case representation for customer admins.
 */
export type PatchedCustomerAdminCaseRequest = {
    uuid?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerAdminCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
};

export type PatchedCustomerAdminDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedCustomerAdminEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for customer admins.
 */
export type PatchedCustomerAdminEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Organisation representation for customer admins.
 */
export type PatchedCustomerAdminOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    has_churned?: boolean;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type PatchedCustomerAdminPhoneNumberRequest = {
    active?: boolean;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type PatchedCustomerAdminQuestionnaireRequest = {
    schema?: Array<QuestionnaireSectionRequest>;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type PatchedCustomerAdminQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedCustomerAdminServiceRequest = {
    uuid?: string;
    org?: number;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customer admins.
 */
export type PatchedCustomerAdminUserRequest = {
    email?: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
};

export type PatchedCustomerAdminWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type PatchedCustomerAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedCustomerAiAugmentationRequest = {
    document?: DocumentRequest;
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

export type PatchedCustomerAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

/**
 * Appointment representation for customers.
 */
export type PatchedCustomerAppointmentRequest = {
    uuid?: string;
    start?: string;
    end?: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status?: Status6d9Enum;
};

export type PatchedCustomerCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Call representation for customers.
 */
export type PatchedCustomerCallRequest = {
    result?: CustomerCallResultRequest;
};

/**
 * Case representation for customers.
 */
export type PatchedCustomerCaseRequest = {
    uuid?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
};

export type PatchedCustomerDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedCustomerEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for customers.
 */
export type PatchedCustomerEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type PatchedCustomerLawyerFeedbackRequest = {
    rating?: string;
    feedback?: string;
    call_uuid?: string;
};

/**
 * Organisation representation for customers.
 */
export type PatchedCustomerOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    enable_cases?: boolean;
    receive_monthly_updates_summary?: boolean;
};

/**
 * Questionnaire representation for customers.
 */
export type PatchedCustomerQuestionnaireRequest = {
    schema?: Array<QuestionnaireSectionRequest>;
};

/**
 * Questionnaire submission representation for customers.
 */
export type PatchedCustomerQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedCustomerServiceRequest = {
    uuid?: string;
    org?: number;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customers.
 */
export type PatchedCustomerUserRequest = {
    email?: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    email_signature?: string;
};

export type PatchedCustomerWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type PatchedDocumentRequest = {
    uuid?: string;
    document_type?: DocumentTypeEnum;
    title?: string;
    filename?: string;
    is_uploaded?: boolean;
    upload_origin?: UploadOriginEnum | BlankEnum | NullEnum | null;
    page_count?: number;
    filesize?: number;
    images?: Array<ImageproxyImagePresetRequest>;
    needs_ocr?: boolean;
    ocr_started_at?: string | null;
    ocr_finished_at?: string | null;
    ocr_is_finished?: boolean | null;
    needs_embeddings?: boolean;
    embeddings_started_at?: string | null;
    embeddings_finished_at?: string | null;
    embeddings_is_finished?: boolean | null;
    needs_summary?: boolean;
    summary_started_at?: string | null;
    summary_finished_at?: string | null;
    summary_is_finished?: boolean | null;
    needs_summary_embedding?: boolean;
    summary_embedding_started_at?: string | null;
    summary_embedding_finished_at?: string | null;
    summary_embedding_is_finished?: boolean | null;
    needs_raptor_summaries?: boolean;
    raptor_summaries_started_at?: string | null;
    raptor_summaries_finished_at?: string | null;
    raptor_summaries_is_finished?: boolean | null;
    needs_analysis?: boolean;
    analysis_started_at?: string | null;
    analysis_finished_at?: string | null;
    analysis_is_finished?: boolean | null;
    needs_metadata_enrichment?: boolean;
    metadata_enrichment_started_at?: string | null;
    metadata_enrichment_finished_at?: string | null;
    metadata_enrichment_is_finished?: boolean | null;
    metadata_enrichment_error?: string | null;
    embeddings_error?: string | null;
    summary_error?: string | null;
    summary_embedding_error?: string | null;
    raptor_summaries_error?: string | null;
    analysis_error?: string | null;
};

export type PatchedEmailRequest = {
    uuid?: string;
};

export type PatchedFeedbackRequest = {
    url?: string;
    rating?: string;
    feature?: FeatureEnum;
    comment?: string;
    related_data?: FeedbackRelatedData;
};

export type PatchedInboundEmailRequest = {
    uuid?: string;
};

export type PatchedSuperUserAccountRequest = {
    uuid?: string;
    account_id?: string;
};

export type PatchedSuperUserAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedSuperUserAiAugmentationRequest = {
    document?: DocumentRequest;
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

export type PatchedSuperUserAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

export type PatchedSuperUserCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Call representation for super users.
 */
export type PatchedSuperUserCallRequest = {
    user_phone_number?: string;
    phone_number_uuid?: string;
    retell_call_id?: string;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResultRequest;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    had_caller_accent?: boolean | null;
};

/**
 * Case representation for super users.
 */
export type PatchedSuperUserCaseRequest = {
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: SuperUserCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
};

export type PatchedSuperUserDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedSuperUserEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for super users.
 */
export type PatchedSuperUserEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type PatchedSuperUserFeedbackRequest = {
    url?: string;
    user?: SuperUserUserRequest;
    rating?: string;
    feature?: FeatureEnum;
    comment?: string;
    related_data?: FeedbackRelatedData;
};

/**
 * Form representation for superusers.
 */
export type PatchedSuperUserFormRequest = {
    organisation_uuid?: string;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: (Blob | File) | null;
};

export type PatchedSuperUserLawyerFeedbackRequest = {
    rating?: string;
    feedback?: string;
    call_uuid?: string;
};

/**
 * Organisation representation for superusers.
 */
export type PatchedSuperUserOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    is_annotext_export_integration_enabled?: boolean;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    stripe_customer_uuid?: string | null;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    hubspot_company_uuid?: string | null;
    has_churned?: boolean;
    enable_law_specific_data?: boolean;
};

/**
 * PhoneNumber representation for superusers.
 */
export type PatchedSuperUserPhoneNumberRequest = {
    uuid?: string;
    active?: boolean;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    agent_uuid?: string;
    org_uuid?: string;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for superusers.
 */
export type PatchedSuperUserQuestionnaireRequest = {
    title?: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema?: Array<QuestionnaireSectionRequest>;
    enabled_all_orgs?: boolean;
    enabled_custom_orgs?: Array<(string)>;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type PatchedSuperUserQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedSuperUserServiceRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for superusers.
 */
export type PatchedSuperUserUserRequest = {
    uuid?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
};

export type PatchedSuperUserWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    docx_template?: (Blob | File) | null;
    /**
     * AI-generated template with placeholders
     */
    ai_docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type PatchedTAIChatSessionRequest = PatchedAIChatSessionRequest;

export type PatchedTAccountRequest = PatchedCustomerAccountRequest | PatchedCustomerAdminAccountRequest | PatchedSuperUserAccountRequest;

export type PatchedTAiAnalysisRequest = PatchedClientAiAnalysisRequest | PatchedCustomerAiAnalysisRequest | PatchedCustomerAdminAiAnalysisRequest | PatchedSuperUserAiAnalysisRequest;

export type PatchedTAiAugmentationRequest = PatchedClientAiAugmentationRequest | PatchedCustomerAiAugmentationRequest | PatchedCustomerAdminAiAugmentationRequest | PatchedSuperUserAiAugmentationRequest;

export type PatchedTAiChatQuestionTemplateRequest = PatchedAiChatQuestionTemplateRequest;

export type PatchedTAppointmentProposalRequest = PatchedCustomerAppointmentProposalRequest | PatchedCustomerAdminAppointmentProposalRequest | PatchedSuperUserAppointmentProposalRequest;

export type PatchedTAppointmentRequest = PatchedCustomerAppointmentRequest | PatchedCustomerAdminAccountRequest | PatchedSuperUserAccountRequest;

export type PatchedTCalendarRequest = PatchedCustomerCalendarRequest | PatchedCustomerAdminCalendarRequest | PatchedSuperUserCalendarRequest;

export type PatchedTCallRequest = PatchedCustomerCallRequest | PatchedSuperUserCallRequest;

export type PatchedTCaseCreatorTempDocumentRequest = PatchedCaseCreatorTempDocumentRequest;

export type PatchedTCaseRequest = PatchedCustomerCaseRequest | PatchedCustomerAdminCaseRequest | PatchedSuperUserCaseRequest;

export type PatchedTDocumentRequest = PatchedDocumentRequest;

export type PatchedTDocumentTemplateRequest = PatchedCustomerDocumentTemplateRequest | PatchedCustomerAdminDocumentTemplateRequest | PatchedSuperUserDocumentTemplateRequest;

export type PatchedTEmailTemplateRequest = PatchedCustomerEmailTemplateRequest | PatchedCustomerAdminEmailTemplateRequest | PatchedSuperUserEmailTemplateRequest;

export type PatchedTEntityRequest = PatchedClientEntityRequest | PatchedCustomerEntityRequest | PatchedCustomerAdminEntityRequest | PatchedSuperUserEntityRequest;

export type PatchedTFeedbackRequest = PatchedFeedbackRequest | PatchedSuperUserFeedbackRequest;

export type PatchedTFormRequest = PatchedSuperUserFormRequest;

export type PatchedTLawyerFeedbackRequest = PatchedCustomerLawyerFeedbackRequest | PatchedSuperUserLawyerFeedbackRequest;

export type PatchedTOrganisationRequest = PatchedCustomerOrganisationRequest | PatchedCustomerAdminOrganisationRequest | PatchedSuperUserOrganisationRequest;

export type PatchedTPhoneNumberRequest = PatchedCustomerAdminPhoneNumberRequest | PatchedSuperUserPhoneNumberRequest;

export type PatchedTQuestionnaireRequest = PatchedCustomerQuestionnaireRequest | PatchedCustomerAdminQuestionnaireRequest | PatchedSuperUserQuestionnaireRequest;

export type PatchedTQuestionnaireSubmissionRequest = PatchedClientQuestionnaireSubmissionRequest | PatchedCustomerQuestionnaireSubmissionRequest | PatchedCustomerAdminQuestionnaireSubmissionRequest | PatchedSuperUserQuestionnaireSubmissionRequest;

export type PatchedTRetellAgentRequest = unknown;

export type PatchedTServiceRequest = PatchedCustomerServiceRequest | PatchedCustomerAdminServiceRequest | PatchedSuperUserServiceRequest;

export type PatchedTStripeCustomerRequest = unknown;

export type PatchedTStripeInvoiceRequest = unknown;

export type PatchedTUserRequest = PatchedCustomerUserRequest | PatchedCustomerAdminUserRequest | PatchedSuperUserUserRequest;

export type PatchedTWordDocumentTemplateRequest = PatchedCustomerWordDocumentTemplateRequest | PatchedCustomerAdminWordDocumentTemplateRequest | PatchedSuperUserWordDocumentTemplateRequest;

export type Placeholder = {
    key: PlaceholderKeyEnum;
    placeholder: string;
    label: string;
    html: string;
    is_context_aware: boolean;
    demo_context_dict?: unknown;
    rendered_demo_context_html?: string | null;
    variant: string;
    description: string;
};

/**
 * * `clerk_first_name` - clerk_first_name
 * * `clerk_last_name` - clerk_last_name
 * * `lawfirm_name` - lawfirm_name
 * * `client_first_name` - client_first_name
 * * `client_formal_greeting` - client_formal_greeting
 * * `client_last_name` - client_last_name
 * * `client_title` - client_title
 * * `clerk_signature` - clerk_signature
 * * `full_signature` - full_signature
 * * `lawfirm_signature` - lawfirm_signature
 * * `appointment_key_facts` - appointment_key_facts
 * * `appointment_proposal_message` - appointment_proposal_message
 * * `appointment_proposal_url` - appointment_proposal_url
 * * `appointment_url` - appointment_url
 * * `questionnaires_and_documents` - questionnaires_and_documents
 */
export type PlaceholderKeyEnum = 'clerk_first_name' | 'clerk_last_name' | 'lawfirm_name' | 'client_first_name' | 'client_formal_greeting' | 'client_last_name' | 'client_title' | 'clerk_signature' | 'full_signature' | 'lawfirm_signature' | 'appointment_key_facts' | 'appointment_proposal_message' | 'appointment_proposal_url' | 'appointment_url' | 'questionnaires_and_documents';

/**
 * * `clerk_first_name` - clerk_first_name
 * * `clerk_last_name` - clerk_last_name
 * * `lawfirm_name` - lawfirm_name
 * * `client_first_name` - client_first_name
 * * `client_formal_greeting` - client_formal_greeting
 * * `client_last_name` - client_last_name
 * * `client_title` - client_title
 * * `clerk_signature` - clerk_signature
 * * `full_signature` - full_signature
 * * `lawfirm_signature` - lawfirm_signature
 * * `appointment_key_facts` - appointment_key_facts
 * * `appointment_proposal_message` - appointment_proposal_message
 * * `appointment_proposal_url` - appointment_proposal_url
 * * `appointment_url` - appointment_url
 * * `questionnaires_and_documents` - questionnaires_and_documents
 */
export const PlaceholderKeyEnum = {
    CLERK_FIRST_NAME: 'clerk_first_name',
    CLERK_LAST_NAME: 'clerk_last_name',
    LAWFIRM_NAME: 'lawfirm_name',
    CLIENT_FIRST_NAME: 'client_first_name',
    CLIENT_FORMAL_GREETING: 'client_formal_greeting',
    CLIENT_LAST_NAME: 'client_last_name',
    CLIENT_TITLE: 'client_title',
    CLERK_SIGNATURE: 'clerk_signature',
    FULL_SIGNATURE: 'full_signature',
    LAWFIRM_SIGNATURE: 'lawfirm_signature',
    APPOINTMENT_KEY_FACTS: 'appointment_key_facts',
    APPOINTMENT_PROPOSAL_MESSAGE: 'appointment_proposal_message',
    APPOINTMENT_PROPOSAL_URL: 'appointment_proposal_url',
    APPOINTMENT_URL: 'appointment_url',
    QUESTIONNAIRES_AND_DOCUMENTS: 'questionnaires_and_documents'
} as const;

export type PlaceholderSuggestion = {
    suggested_value: string;
    score: number;
};

export type PlaceholderValueRequest = {
    placeholder: string;
    value: string;
};

export type PlaceholderValueSuggestions = {
    placeholder_variable: string;
    suggestions: PlaceholderSuggestion;
};

export type QuestionnaireGenerateRequest = {
    file?: (Blob | File) | null;
    prompt?: string | null;
};

export type QuestionnaireQuestion = {
    uuid: string;
    help: string;
    type: QuestionnaireQuestionTypeEnum;
    tag: QuestionnaireQuestionTagEnum | BlankEnum | NullEnum | null;
    tag_relationship: TagRelationshipEnum | BlankEnum | NullEnum | null;
    tag_number: number | null;
    label: string;
    value: string | null;
    choices?: Array<(string)>;
    jump_to: Array<JumpTo> | null;
    optional: boolean;
    starts_ai_analysis: boolean;
};

export type QuestionnaireQuestionRequest = {
    uuid: string;
    help: string;
    type: QuestionnaireQuestionTypeEnum;
    tag: QuestionnaireQuestionTagEnum | BlankEnum | NullEnum | null;
    tag_relationship: TagRelationshipEnum | BlankEnum | NullEnum | null;
    tag_number: number | null;
    label: string;
    value: string | null;
    choices?: Array<(string)>;
    jump_to: Array<JumpToRequest> | null;
    optional: boolean;
    starts_ai_analysis: boolean;
};

/**
 * * `entities.field.bank_name` - Bankname
 * * `entities.field.bic` - BIC
 * * `entities.field.city` - Ort
 * * `entities.field.company_legal_form` - Rechtsform
 * * `entities.field.company_name` - Firmenname
 * * `entities.field.company_register_court` - Amtsgericht
 * * `entities.field.company_register_number` - Handelsregisternummer
 * * `entities.field.company_tax_id` - Steuernummer
 * * `entities.field.company_vat_id` - USt. ID
 * * `entities.field.date_of_birth` - Geburtsdatum
 * * `entities.field.date_of_death` - Sterbedatum
 * * `entities.field.email` - E-Mail
 * * `entities.field.entity_type` - Personentyp
 * * `entities.field.fax` - Fax
 * * `entities.field.first_name` - Vorname
 * * `entities.field.iban` - IBAN
 * * `entities.field.institution_name` - Name der Institution
 * * `entities.field.is_entitled_to_deduct_vat` - Vorsteuerabzugsberechtigt
 * * `entities.field.last_name` - Nachname
 * * `entities.field.legal_insurance_deductible_amount` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
 * * `entities.field.legal_insurance` - Rechtsschutzversicherung
 * * `entities.field.legal_insurance_name` - Name der Rechtsschutzversicherung
 * * `entities.field.legal_insurance_number` - Nummer der Rechtsschutzversicherung
 * * `entities.field.marital_status` - Familienstand
 * * `entities.field.phone` - Telefon
 * * `entities.field.specific_title` - Titel
 * * `entities.field.street` - Straße
 * * `entities.field.street_number` - Hausnummer
 * * `entities.field.title` - Anrede
 * * `entities.field.website` - Website
 * * `entities.field.zip` - PLZ
 * * `law.criminal_law_amount_of_daily_rates` - Betrag der Tagessatz
 * * `law.criminal_law_applicable_laws` - Anwendbare Vorschriften
 * * `law.criminal_law_charge_description` - Anklagesatz
 * * `law.criminal_law_complaint` - Anzeige
 * * `law.criminal_law_criminal_warrant` - Strafbefehl
 * * `law.criminal_law_damage_description` - Beschreibung des Schadens
 * * `law.criminal_law_damage_value` - Schadenshöhe in EUR
 * * `law.criminal_law_date_of_offense` - Datum der Tat
 * * `law.criminal_law_duration_of_prison_sentence` - Dauer der Freiheitsstrafe
 * * `law.criminal_law_evidence_location` - Standort der Beweismittel
 * * `law.criminal_law_evidence` - Beweis
 * * `law.criminal_law_incident_description` - Sachverhalt
 * * `law.criminal_law_indictment_date` - Datum der Anklageschrift
 * * `law.criminal_law_indictment_delivery_date` - Datum der Zustellung der Anklageschrift
 * * `law.criminal_law_indictment` - Anklageschrift
 * * `law.criminal_law_legal_classification_of_offense` - Vergehen auf der Grundlage von
 * * `law.criminal_law_means_of_evidence` - Beweismittel
 * * `law.criminal_law_number_of_daily_rates` - Tagessatz
 * * `law.criminal_law_offense_type` - Art des Delikts
 * * `law.criminal_law_penalty_infromation` - Strafe
 * * `law.criminal_law_physical_evidence` - Beschreibung der Beweismittel
 * * `law.criminal_law_place_of_offense` - Ort der Tat
 * * `law.criminal_law_police_file_number` - Vorgangsnummer
 * * `law.criminal_law_preliminary_proceedings_date` - Datum der Einleitung des Ermittlungsverfahrens
 * * `law.criminal_law_prison_sentence` - Freiheitsstrafe
 * * `law.criminal_law_probation` - Bewärung
 * * `law.criminal_law_prosecution_file_number` - Aktenzeichen der Staatsanwaltschaft
 * * `law.criminal_law_report_date` - Datum der Anzeigenerstattung
 * * `law.criminal_law_report_time` - Uhrzeit der Anzeigenerstattung
 * * `law.criminal_law_time_of_offense` - Uhrzeit der Tat
 * * `law.debt_collection_law_business_fee` - 1,3 Geschäftsgebühr (Nr. 2300 VV RVG)
 * * `law.debt_collection_law_case_value` - Gegenstandswert
 * * `law.debt_collection_law_invoice_amount` - Rechnungsbetrag
 * * `law.debt_collection_law_invoice_date` - Rechnungsdatum
 * * `law.debt_collection_law_invoice_ground` - Rechnungsgrund
 * * `law.debt_collection_law_invoice_lawyer` - Rechnung Anwalt
 * * `law.debt_collection_law_invoice` - Rechnung
 * * `law.debt_collection_law_invoice_number` - Rechnungsnummer
 * * `law.debt_collection_law_invoice_recipient` - Rechnungsadressat
 * * `law.debt_collection_law_invoice_tax_number` - Steuernummer
 * * `law.debt_collection_law_lumps_sum_expenses` - Auslagenpauschale (Nr. 7002 VV RVG)
 * * `law.debt_collection_law_sales_tax` - Umsatzsteuer (19%)
 * * `law.debt_collection_law_subtotal_lawyer_fees` - Zwischensumme netto
 * * `law.debt_collection_law_total_amount` - Gesamtbetrag
 * * `law.external_case_id` - external case id
 * * `law.family_law_average_net_income` - Durchschnittliches Nettoeinkommen
 * * `law.family_law_birth_certificate` - Geburtsurkunden
 * * `law.family_law_birth_register_number` - Geburtsurkundennummer
 * * `law.family_law_birth_register_office_location` - Standesamt Geburtsurkunde
 * * `law.family_law_children` - Kinder vorhanden
 * * `law.family_law_date_of_marriage` - Eheschließungsdatum
 * * `law.family_law_divorce_application` - Ehescheidungsantrag
 * * `law.family_law_divorce_settlement_agreement` - Scheidungsfolgenvereinbarung
 * * `law.family_law_marriage_certificate` - Eheurkunde
 * * `law.family_law_marriage_contract_date` - Ehevertragsdatum
 * * `law.family_law_marriage_contract` - Ehevertrag
 * * `law.family_law_marriage_register_number` - Eheregisternummer
 * * `law.family_law_registry_office_location` - Standesamt Ort
 * * `law.family_law_separation_date` - Trennungsdatumdatum
 * * `law.field` - Rechtsgebiet
 * * `law.generic_document` - Anderes Dokument
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - Anwendbares Recht
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - Todesdatum
 * * `law.inheritance_law_certificate_of_inheritance_date` - Datum Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance` - Erbschein
 * * `law.inheritance_law_certificate_of_inheritance_number` - Nummer des Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - Todesort
 * * `law.inheritance_law_death_certificate_date_death` - Todesdatum
 * * `law.inheritance_law_death_certificate_date` - Datum Sterbeurkunde
 * * `law.inheritance_law_death_certificate` - Sterbeurkunde
 * * `law.inheritance_law_death_certificate_number` - Nummer Sterbeurkunde
 * * `law.inheritance_law_death_certificate_place_death` - Ort des Todes
 * * `law.inheritance_law_death_certificate_place` - Ort Sterbeurkunde
 * * `law.inheritance_law_death_certificate_time_death` - Uhrzeit des Todes
 * * `law.inheritance_law_estate_inventory_amount` - Nettonachlass
 * * `law.inheritance_law_estate_inventory_date` - Datum Nachlassverzeichnis
 * * `law.inheritance_law_estate_inventory_status` - Güterstand
 * * `law.inheritance_law_inheritance_contract_date` - Datum des Erbvertrags
 * * `law.inheritance_law_inheritance_contract` - Erbvertrag
 * * `law.inheritance_law_lasting_power_of_attorney_date` - Datum Vorsorgevollmacht
 * * `law.inheritance_law_lasting_power_of_attorney` - Vorsorgevollmacht
 * * `law.inheritance_law_list_of_estate` - Nachlassverzeichnis
 * * `law.inheritance_law_living_will` - Patientenverfügung
 * * `law.inheritance_law_patient_enrollment_date` - Datum Patientenverfügung
 * * `law.inheritance_law_testament_date` - Datum des Testaments
 * * `law.inheritance_law_will` - Testament
 * * `law.labor_law_beginning_of_employment` - Datum Beginn des Arbeitsverhältnisses
 * * `law.labor_law_child_allowances` - Kinderfreibeträge
 * * `law.labor_law_collective_agreement` - Tarifvertrag
 * * `law.labor_law_company_agreement` - Betriebsvereinbarung
 * * `law.labor_law_different_place_of_work` - Abweichender Arbeitsort
 * * `law.labor_law_employee_probation_period_end_date` - Datum Ende der Probezeit
 * * `law.labor_law_fixed_term_contract_duration` - Ende befristetes Arbeitsverhältnis
 * * `law.labor_law_fixed_term_contract` - Befristetes Arbeitsverhältnis
 * * `law.labor_law_is_employee_in_probation_period` - Arbeitnehmer in Probezeit
 * * `law.labor_law_job_title` - Berufsbezeichnung
 * * `law.labor_law_married` - Verheiratet
 * * `law.labor_law_monthly_gross_salary` - Gehalt, monatlich, brutto
 * * `law.labor_law_monthly_working_days` - Arbeitsstunden pro Monat
 * * `law.labor_law_notice_period` - Kündigungsfrist in Monaten
 * * `law.labor_law_payslip` - Lohnabrechnung
 * * `law.labor_law_place_of_work` - Arbeitsort
 * * `law.labor_law_settlement_agreement_date` - Datum Abwicklungsvertrag
 * * `law.labor_law_settlement_agreement` - Abwicklungsvertrag
 * * `law.labor_law_signature_of_employer` - Unterschrift Arbeitgeber
 * * `law.labor_law_special_payments_amount` - Höhe Sonderzahlungen
 * * `law.labor_law_special_payments` - Sonderzahlungen
 * * `law.labor_law_special_protection_against_dismissal` - Sonderkündigungsschutz
 * * `law.labor_law_termination_access_to_termination_to_employee` - Datum Zugang Kündigung beim Arbeitnehmer
 * * `law.labor_law_termination_agreement_date` - Datum Aufhebungsvertrag
 * * `law.labor_law_termination_agreement` - Aufhebungsvertrag
 * * `law.labor_law_termination_agreement_severance_pay_amount` - Abfindung Höhe
 * * `law.labor_law_termination_agreement_termination_date` - Datum Beendigung Arbeitsverhältnis
 * * `law.labor_law_termination_date_effective` - Kündigung erfolgt zu welchem Datum
 * * `law.labor_law_termination_date` - Datum Kündigung durch Arbeitgeber
 * * `law.labor_law_termination_employer_more_than_10_employees` - Arbeitgeber hat mehr als 10 Mitarbeiter
 * * `law.labor_law_termination_is_agreement_severance_pay` - Abfindung vereinbart
 * * `law.labor_law_termination` - Kündigung
 * * `law.labor_law_vacation_days` - Urlaubstage
 * * `law.labor_law_wanring_letter_access_to_warning_letter_to_employee` - Datum Zugang Abmahnung beim Arbeitnehmer
 * * `law.labor_law_warning_letter_date` - Datum Abmahnung
 * * `law.labor_law_warning_letter_incident_date` - Datum des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_location` - Ort des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_time` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter` - Abmahnung
 * * `law.labor_law_warning_letter_reason` - Grund der Abmahnung
 * * `law.labor_law_work_contract` - Arbeitsvertrag
 * * `law.labor_law_work_council` - Betriebsrat
 * * `law.labor_law_work_hours_per_week` - Arbeitsstunden pro Woche
 * * `law.labor_law_yearly_gross_salary` - Gehalt, jährlich, brutto
 * * `law.real_estate_law_basic_debts_amount` - Grundschulden
 * * `law.real_estate_law_encumbrance_restrictions` - Lasten und Beschränkungen
 * * `law.real_estate_law_land_register_address` - Grundbuch Lage
 * * `law.real_estate_law_land_register_city` - Grundbuch Stadt
 * * `law.real_estate_law_land_register_date` - Grundbuchauszugdatum
 * * `law.real_estate_law_land_register` - Grundbuchauszug
 * * `law.real_estate_law_land_register_number` - Grundbuch Nr.
 * * `law.real_estate_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.real_estate_law_purchase_contract_amount` - Kaufvertragsbetrag
 * * `law.real_estate_law_purchase_contract_date` - Kaufvertragsdatum
 * * `law.real_estate_law_purchase_contract_description` - Kaufvertrag Objektbeschreibung
 * * `law.real_estate_law_purchase_contract` - Kaufvertrag
 * * `law.real_estate_law_purchase_contract_registration_date` - Kaufvertragsbeurkundungsdatum
 * * `law.residential_property_law_co_ownership_shares` - Miteigentumsanteile
 * * `law.residential_property_law_contract_date` - Wegvertragsdatum
 * * `law.residential_property_law_contract` - Wegvertrag
 * * `law.residential_property_law_inventory` - Bestandsverzeichnis
 * * `law.residential_property_law_land_register_address` - Grundbuch Lage
 * * `law.residential_property_law_land_register_city` - Grundbuch Stadt
 * * `law.residential_property_law_land_register_number` - Grundbuch Nr.
 * * `law.residential_property_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.social_law_application_arrival_date` - Eingang Antrag Datum
 * * `law.social_law_application_date` - Antrag Datum
 * * `law.social_law_notice_date` - Bescheid Datum
 * * `law.social_law_notice_of_objection_date` - Widerspruchbescheid Datum
 * * `law.social_law_notice_of_objection` - Widerspruchbescheid
 * * `law.social_law_summary_grounds_opposition` - Begründung des Widerspruchs
 * * `law.tenancy_law_adress_rental_property` - Adresse Mietobjekt
 * * `law.tenancy_law_advance_payment_service_charge` - Vorauszahlungen Nebenkostenabrechnung
 * * `law.tenancy_law_advance_payment_service_charges` - Nebenkostenvorauszahlungshöhe
 * * `law.tenancy_law_cost_share` - Kostenanteil Mieter
 * * `law.tenancy_law_cost_shares` - Umlageschlüssel
 * * `law.tenancy_law_counter_number` - Zählerstandnummer
 * * `law.tenancy_law_description_of_rental_property` - Beschreibung Mietobjekt
 * * `law.tenancy_law_duration_of_lease` - Dauer Pachtvertrag
 * * `law.tenancy_law_fixed_term_tenancy` - befristeter Mietvertrag
 * * `law.tenancy_law_gross_rent` - Bruttomiete
 * * `law.tenancy_law_handover_counter` - Zählerstand
 * * `law.tenancy_law_handover_date` - Übergabedatum
 * * `law.tenancy_law_handover_defects` - Mängel
 * * `law.tenancy_law_handover_protocol` - Übergabeprotokoll
 * * `law.tenancy_law_lease_agreement` - Pachtvertrag
 * * `law.tenancy_law_location_in_rental_property` - Lage im Mietobjekt
 * * `law.tenancy_law_net_rent` - Nettomiete
 * * `law.tenancy_law_rental_agreement_date` - Mietvertragsdatum
 * * `law.tenancy_law_rental_agreement` - Mietvertrag
 * * `law.tenancy_law_rental_agreement_validity_end` - Mietvertragsende
 * * `law.tenancy_law_rental_agreement_validity_start` - Mietvertragsbeginn
 * * `law.tenancy_law_repayment` - Nachzahlung/Guthaben
 * * `law.tenancy_law_repayment_period_end` - Ende Abrechnungszeitraum
 * * `law.tenancy_law_repayment_period_start` - Beginn Abrechnungszeitraum
 * * `law.tenancy_law_service_charge_settlement` - Nebenkostenabrechnung
 * * `law.tenancy_law_staggered_rental_agreement` - Staffelmietvereinbarung
 * * `law.tenancy_law_start_of_lease` - Beginn Pachtvertrag
 * * `law.tenancy_law_total_cost_service_charge` - Gesamtkosten Nebenkostenabrechnung
 * * `law.tenancy_law_total_rent` - Gesamtmiete
 * * `law.tenancy_law_unlimited_term_tenancy` - unbefristeter Mietvertrag
 * * `law.topic` - Rechtsthema
 * * `law.traffic_law_accident_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_accident_report` - Unfallbericht
 * * `law.traffic_law_amount_of_fine` - Bußgeldhöhe
 * * `law.traffic_law_appeal_instruction` - Rechtsbehelfsbelehrung
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - Unfallverursacher - Führerschein ausgestellt durch
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - Unfallverursacher - Führerschein gültig bis
 * * `law.traffic_law_at_fault_driver_green_card_number` - Unfallverursacher - Nr. der Grünen Karte
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_at_fault_driver_insurance_number` - Unfallverursacher - Vers.-Nr.
 * * `law.traffic_law_at_fault_driver_insurer` - Unfallverursacher - Versicherer
 * * `law.traffic_law_blood_alcohol_concentration` - Blutalkoholkonzentration
 * * `law.traffic_law_calculated_total_damage_costs` - Gesamtschadenshöhe
 * * `law.traffic_law_calculated_total_days` - Gesamttagen
 * * `law.traffic_law_charges` - Tatvorwurf
 * * `law.traffic_law_cost_per_scale` - Kostenpauschale
 * * `law.traffic_law_daily_rate` - Höhe des Tagessatzes
 * * `law.traffic_law_damage_number` - Schadennummer
 * * `law.traffic_law_damage_scope` - Schadenumfang
 * * `law.traffic_law_date_of_accident` - Unfalltag
 * * `law.traffic_law_date_of_crime` - Datum der Tat
 * * `law.traffic_law_date_of_fine` - Datum Bußgeldbescheid
 * * `law.traffic_law_date_of_infraction` - Datum der Ordnungswidrigkeit
 * * `law.traffic_law_date_of_inspection` - Besichtigungsdatum
 * * `law.traffic_law_date_of_issue` - Datum der Ausstellung
 * * `law.traffic_law_date_of_offense` - Datum der Tat
 * * `law.traffic_law_date_of_report` - Datum Sachverständigengutachten
 * * `law.traffic_law_differencial_tax` - Differenzsteuer
 * * `law.traffic_law_driver_logbook_required` - Fahrtenbuch erforderlich
 * * `law.traffic_law_driving_ban_duration` - Fahrverbot Dauer
 * * `law.traffic_law_driving_ban` - Fahrverbot verhängt
 * * `law.traffic_law_evidence_infraction` - Beweismittel
 * * `law.traffic_law_expert_cost` - Sachverständigenkosten
 * * `law.traffic_law_expert_date` - Unfallverursacher - Sachverständigengutachten
 * * `law.traffic_law_expert_report` - Sachverständigengutachten
 * * `law.traffic_law_expert_report_number` - Gutachten Nummer
 * * `law.traffic_law_file_number` - Aktenzeichen
 * * `law.traffic_law_fine` - Geldstrafe
 * * `law.traffic_law_fine_notice` - Bußgeldbescheid
 * * `law.traffic_law_gross_gross_replacement_value` - Brutto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_gross_replacement_value` - Bruttowiederbeschaffungswert
 * * `law.traffic_law_injured` - Verletzte
 * * `law.traffic_law_insurance_holder` - Versicherungsnehmer
 * * `law.traffic_law_insurance` - Versicherung
 * * `law.traffic_law_insurance_policy_number` - Versicherungsscheinnummer
 * * `law.traffic_law_legal_basis_infraction` - Gesetzliche Grundlage
 * * `law.traffic_law_legal_basis` - Gesetzliche Grundlage
 * * `law.traffic_law_licenseplate_at_fault_driver` - KFZ-Kennzeichen des Unfallverursachers
 * * `law.traffic_law_licenseplate` - KFZ-Kennzeichen
 * * `law.traffic_law_licenseplate_victim_driver` - KFZ-Kennzeichen des Unfallgeschädigten
 * * `law.traffic_law_loss_amount_repair_case` - Restschaden Reparaturschaden
 * * `law.traffic_law_loss_amount_total_damage_case` - Restschaden Totalschaden
 * * `law.traffic_law_loss_of_use_per_day` - Nutzungsausfallentschädigung pro Tag
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - Unfallverursacher - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_mark_and_type_of_victim_driver` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_merantile_value_loss` - Merkantile Wertminderung
 * * `law.traffic_law_net_gross_replacement_value` - Netto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_net_replacement_value` - Nettowiederbeschaffungswert
 * * `law.traffic_law_number_of_daily_rates` - Anzahl der Tagessätze
 * * `law.traffic_law_offense_infraction_description` - Tatbestand
 * * `law.traffic_law_other_damages` - Andere Sachschäden
 * * `law.traffic_law_payment_deadline` - Zahlungsfrist
 * * `law.traffic_law_penalty_order` - Strafbefehl
 * * `law.traffic_law_place_of_accident` - Unfallort
 * * `law.traffic_law_place_of_crime` - Ort der Tat
 * * `law.traffic_law_place_of_infraction` - Ort der Ordnungswidrigkeit
 * * `law.traffic_law_place_of_inspection` - Besichtigungsort
 * * `law.traffic_law_place_of_issue` - Ort der Ausstellung
 * * `law.traffic_law_place_of_offense` - Ort der Tat
 * * `law.traffic_law_points_for_offense` - Punkte
 * * `law.traffic_law_police_case_number` - Polizeiliches Aktenzeichen
 * * `law.traffic_law_procedure_costs` - Verfahrenskosten
 * * `law.traffic_law_prosecution_number` - Geschäftsnummer
 * * `law.traffic_law_regular_tax` - Regelsteuer
 * * `law.traffic_law_repair_costs_with_vat` - Reparaturkosten Brutto
 * * `law.traffic_law_repair_costs_without_vat` - Reparaturkosten Netto
 * * `law.traffic_law_repair_duration` - Reparaturdauer Tage
 * * `law.traffic_law_replacement_cost` - Wiederbeschaffungsaufwand
 * * `law.traffic_law_replacement_value` - Wiederbeschaffungswert
 * * `law.traffic_law_reregistration_cost` - Ummeldekosten
 * * `law.traffic_law_residual_value` - Restwert Brutto
 * * `law.traffic_law_speed_allowed` - Erlaubte Geschwindigkeit
 * * `law.traffic_law_speed_driven` - Gefahrene Geschwindigkeit
 * * `law.traffic_law_speed_too_high` - Überschreitung Geschwindigkeit
 * * `law.traffic_law_time_of_accident` - Uhrzeit Unfall
 * * `law.traffic_law_time_of_crime` - Uhrzeit der Tat
 * * `law.traffic_law_time_of_infraction` - Uhrzeit der Ordnungswidrigkeit
 * * `law.traffic_law_time_of_inspection` - Besichtigungszeit
 * * `law.traffic_law_time_of_issue` - Tag der Ausstellung
 * * `law.traffic_law_time_of_offense` - Uhrzeit der Tat
 * * `law.traffic_law_vehicle_age_months` - Fahrzeugalter in Monaten
 * * `law.traffic_law_vehicle_mileage` - Fahrzeugleistung in km
 * * `law.traffic_law_vehicle_type_and_brand` - Fahrzeugtyp und Marke
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - Unfallgeschädigter - Führerschein ausgestellt durch
 * * `law.traffic_law_victim_driver_green_card_number` - Unfallgeschädigter - Nr. der Grünen Karte
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - Unfallgeschädigter - Vers.-Schein gültig bis
 * * `law.traffic_law_victim_driver_insurance_number` - Unfallgeschädigter - Vers.-Nr.
 * * `law.traffic_law_victim_driver_insurer` - Unfallgeschädigter - Versicherer
 * * `law.traffic_law_victim_driver_license_valid_until` - Unfallgeschädigter - Führerschein gültig bis
 * * `law.traffic_law_violated_section` - Verletzte Vorschrift
 * * `law.traffic_law_violation_type` - Tatvorwurf
 * * `law.traffic_law_warning_fee_infraction` - Verwarnungsgeldbetrag
 * * `law.traffic_law_warning_notice` - Verwarnungsgeldbescheid
 */
export type QuestionnaireQuestionTagEnum = 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip' | 'law.criminal_law_amount_of_daily_rates' | 'law.criminal_law_applicable_laws' | 'law.criminal_law_charge_description' | 'law.criminal_law_complaint' | 'law.criminal_law_criminal_warrant' | 'law.criminal_law_damage_description' | 'law.criminal_law_damage_value' | 'law.criminal_law_date_of_offense' | 'law.criminal_law_duration_of_prison_sentence' | 'law.criminal_law_evidence_location' | 'law.criminal_law_evidence' | 'law.criminal_law_incident_description' | 'law.criminal_law_indictment_date' | 'law.criminal_law_indictment_delivery_date' | 'law.criminal_law_indictment' | 'law.criminal_law_legal_classification_of_offense' | 'law.criminal_law_means_of_evidence' | 'law.criminal_law_number_of_daily_rates' | 'law.criminal_law_offense_type' | 'law.criminal_law_penalty_infromation' | 'law.criminal_law_physical_evidence' | 'law.criminal_law_place_of_offense' | 'law.criminal_law_police_file_number' | 'law.criminal_law_preliminary_proceedings_date' | 'law.criminal_law_prison_sentence' | 'law.criminal_law_probation' | 'law.criminal_law_prosecution_file_number' | 'law.criminal_law_report_date' | 'law.criminal_law_report_time' | 'law.criminal_law_time_of_offense' | 'law.debt_collection_law_business_fee' | 'law.debt_collection_law_case_value' | 'law.debt_collection_law_invoice_amount' | 'law.debt_collection_law_invoice_date' | 'law.debt_collection_law_invoice_ground' | 'law.debt_collection_law_invoice_lawyer' | 'law.debt_collection_law_invoice' | 'law.debt_collection_law_invoice_number' | 'law.debt_collection_law_invoice_recipient' | 'law.debt_collection_law_invoice_tax_number' | 'law.debt_collection_law_lumps_sum_expenses' | 'law.debt_collection_law_sales_tax' | 'law.debt_collection_law_subtotal_lawyer_fees' | 'law.debt_collection_law_total_amount' | 'law.external_case_id' | 'law.family_law_average_net_income' | 'law.family_law_birth_certificate' | 'law.family_law_birth_register_number' | 'law.family_law_birth_register_office_location' | 'law.family_law_children' | 'law.family_law_date_of_marriage' | 'law.family_law_divorce_application' | 'law.family_law_divorce_settlement_agreement' | 'law.family_law_marriage_certificate' | 'law.family_law_marriage_contract_date' | 'law.family_law_marriage_contract' | 'law.family_law_marriage_register_number' | 'law.family_law_registry_office_location' | 'law.family_law_separation_date' | 'law.field' | 'law.generic_document' | 'law.inheritance_law_certificate_of_inheritance_applicable_law' | 'law.inheritance_law_certificate_of_inheritance_date_death' | 'law.inheritance_law_certificate_of_inheritance_date' | 'law.inheritance_law_certificate_of_inheritance' | 'law.inheritance_law_certificate_of_inheritance_number' | 'law.inheritance_law_certificate_of_inheritance_place_of_death' | 'law.inheritance_law_death_certificate_date_death' | 'law.inheritance_law_death_certificate_date' | 'law.inheritance_law_death_certificate' | 'law.inheritance_law_death_certificate_number' | 'law.inheritance_law_death_certificate_place_death' | 'law.inheritance_law_death_certificate_place' | 'law.inheritance_law_death_certificate_time_death' | 'law.inheritance_law_estate_inventory_amount' | 'law.inheritance_law_estate_inventory_date' | 'law.inheritance_law_estate_inventory_status' | 'law.inheritance_law_inheritance_contract_date' | 'law.inheritance_law_inheritance_contract' | 'law.inheritance_law_lasting_power_of_attorney_date' | 'law.inheritance_law_lasting_power_of_attorney' | 'law.inheritance_law_list_of_estate' | 'law.inheritance_law_living_will' | 'law.inheritance_law_patient_enrollment_date' | 'law.inheritance_law_testament_date' | 'law.inheritance_law_will' | 'law.labor_law_beginning_of_employment' | 'law.labor_law_child_allowances' | 'law.labor_law_collective_agreement' | 'law.labor_law_company_agreement' | 'law.labor_law_different_place_of_work' | 'law.labor_law_employee_probation_period_end_date' | 'law.labor_law_fixed_term_contract_duration' | 'law.labor_law_fixed_term_contract' | 'law.labor_law_is_employee_in_probation_period' | 'law.labor_law_job_title' | 'law.labor_law_married' | 'law.labor_law_monthly_gross_salary' | 'law.labor_law_monthly_working_days' | 'law.labor_law_notice_period' | 'law.labor_law_payslip' | 'law.labor_law_place_of_work' | 'law.labor_law_settlement_agreement_date' | 'law.labor_law_settlement_agreement' | 'law.labor_law_signature_of_employer' | 'law.labor_law_special_payments_amount' | 'law.labor_law_special_payments' | 'law.labor_law_special_protection_against_dismissal' | 'law.labor_law_termination_access_to_termination_to_employee' | 'law.labor_law_termination_agreement_date' | 'law.labor_law_termination_agreement' | 'law.labor_law_termination_agreement_severance_pay_amount' | 'law.labor_law_termination_agreement_termination_date' | 'law.labor_law_termination_date_effective' | 'law.labor_law_termination_date' | 'law.labor_law_termination_employer_more_than_10_employees' | 'law.labor_law_termination_is_agreement_severance_pay' | 'law.labor_law_termination' | 'law.labor_law_vacation_days' | 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee' | 'law.labor_law_warning_letter_date' | 'law.labor_law_warning_letter_incident_date' | 'law.labor_law_warning_letter_incident_location' | 'law.labor_law_warning_letter_incident_time' | 'law.labor_law_warning_letter' | 'law.labor_law_warning_letter_reason' | 'law.labor_law_work_contract' | 'law.labor_law_work_council' | 'law.labor_law_work_hours_per_week' | 'law.labor_law_yearly_gross_salary' | 'law.real_estate_law_basic_debts_amount' | 'law.real_estate_law_encumbrance_restrictions' | 'law.real_estate_law_land_register_address' | 'law.real_estate_law_land_register_city' | 'law.real_estate_law_land_register_date' | 'law.real_estate_law_land_register' | 'law.real_estate_law_land_register_number' | 'law.real_estate_law_land_register_plot_of_land' | 'law.real_estate_law_purchase_contract_amount' | 'law.real_estate_law_purchase_contract_date' | 'law.real_estate_law_purchase_contract_description' | 'law.real_estate_law_purchase_contract' | 'law.real_estate_law_purchase_contract_registration_date' | 'law.residential_property_law_co_ownership_shares' | 'law.residential_property_law_contract_date' | 'law.residential_property_law_contract' | 'law.residential_property_law_inventory' | 'law.residential_property_law_land_register_address' | 'law.residential_property_law_land_register_city' | 'law.residential_property_law_land_register_number' | 'law.residential_property_law_land_register_plot_of_land' | 'law.social_law_application_arrival_date' | 'law.social_law_application_date' | 'law.social_law_notice_date' | 'law.social_law_notice_of_objection_date' | 'law.social_law_notice_of_objection' | 'law.social_law_summary_grounds_opposition' | 'law.tenancy_law_adress_rental_property' | 'law.tenancy_law_advance_payment_service_charge' | 'law.tenancy_law_advance_payment_service_charges' | 'law.tenancy_law_cost_share' | 'law.tenancy_law_cost_shares' | 'law.tenancy_law_counter_number' | 'law.tenancy_law_description_of_rental_property' | 'law.tenancy_law_duration_of_lease' | 'law.tenancy_law_fixed_term_tenancy' | 'law.tenancy_law_gross_rent' | 'law.tenancy_law_handover_counter' | 'law.tenancy_law_handover_date' | 'law.tenancy_law_handover_defects' | 'law.tenancy_law_handover_protocol' | 'law.tenancy_law_lease_agreement' | 'law.tenancy_law_location_in_rental_property' | 'law.tenancy_law_net_rent' | 'law.tenancy_law_rental_agreement_date' | 'law.tenancy_law_rental_agreement' | 'law.tenancy_law_rental_agreement_validity_end' | 'law.tenancy_law_rental_agreement_validity_start' | 'law.tenancy_law_repayment' | 'law.tenancy_law_repayment_period_end' | 'law.tenancy_law_repayment_period_start' | 'law.tenancy_law_service_charge_settlement' | 'law.tenancy_law_staggered_rental_agreement' | 'law.tenancy_law_start_of_lease' | 'law.tenancy_law_total_cost_service_charge' | 'law.tenancy_law_total_rent' | 'law.tenancy_law_unlimited_term_tenancy' | 'law.topic' | 'law.traffic_law_accident_date' | 'law.traffic_law_accident_report' | 'law.traffic_law_amount_of_fine' | 'law.traffic_law_appeal_instruction' | 'law.traffic_law_at_fault_driver_drivers_license_issued_by' | 'law.traffic_law_at_fault_driver_drivers_license_valid_until' | 'law.traffic_law_at_fault_driver_green_card_number' | 'law.traffic_law_at_fault_driver_insurance_expiry_date' | 'law.traffic_law_at_fault_driver_insurance_number' | 'law.traffic_law_at_fault_driver_insurer' | 'law.traffic_law_blood_alcohol_concentration' | 'law.traffic_law_calculated_total_damage_costs' | 'law.traffic_law_calculated_total_days' | 'law.traffic_law_charges' | 'law.traffic_law_cost_per_scale' | 'law.traffic_law_daily_rate' | 'law.traffic_law_damage_number' | 'law.traffic_law_damage_scope' | 'law.traffic_law_date_of_accident' | 'law.traffic_law_date_of_crime' | 'law.traffic_law_date_of_fine' | 'law.traffic_law_date_of_infraction' | 'law.traffic_law_date_of_inspection' | 'law.traffic_law_date_of_issue' | 'law.traffic_law_date_of_offense' | 'law.traffic_law_date_of_report' | 'law.traffic_law_differencial_tax' | 'law.traffic_law_driver_logbook_required' | 'law.traffic_law_driving_ban_duration' | 'law.traffic_law_driving_ban' | 'law.traffic_law_evidence_infraction' | 'law.traffic_law_expert_cost' | 'law.traffic_law_expert_date' | 'law.traffic_law_expert_report' | 'law.traffic_law_expert_report_number' | 'law.traffic_law_file_number' | 'law.traffic_law_fine' | 'law.traffic_law_fine_notice' | 'law.traffic_law_gross_gross_replacement_value' | 'law.traffic_law_gross_replacement_value' | 'law.traffic_law_injured' | 'law.traffic_law_insurance_holder' | 'law.traffic_law_insurance' | 'law.traffic_law_insurance_policy_number' | 'law.traffic_law_legal_basis_infraction' | 'law.traffic_law_legal_basis' | 'law.traffic_law_licenseplate_at_fault_driver' | 'law.traffic_law_licenseplate' | 'law.traffic_law_licenseplate_victim_driver' | 'law.traffic_law_loss_amount_repair_case' | 'law.traffic_law_loss_amount_total_damage_case' | 'law.traffic_law_loss_of_use_per_day' | 'law.traffic_law_mark_and_type_of_at_fault_driver' | 'law.traffic_law_mark_and_type_of_victim_driver' | 'law.traffic_law_merantile_value_loss' | 'law.traffic_law_net_gross_replacement_value' | 'law.traffic_law_net_replacement_value' | 'law.traffic_law_number_of_daily_rates' | 'law.traffic_law_offense_infraction_description' | 'law.traffic_law_other_damages' | 'law.traffic_law_payment_deadline' | 'law.traffic_law_penalty_order' | 'law.traffic_law_place_of_accident' | 'law.traffic_law_place_of_crime' | 'law.traffic_law_place_of_infraction' | 'law.traffic_law_place_of_inspection' | 'law.traffic_law_place_of_issue' | 'law.traffic_law_place_of_offense' | 'law.traffic_law_points_for_offense' | 'law.traffic_law_police_case_number' | 'law.traffic_law_procedure_costs' | 'law.traffic_law_prosecution_number' | 'law.traffic_law_regular_tax' | 'law.traffic_law_repair_costs_with_vat' | 'law.traffic_law_repair_costs_without_vat' | 'law.traffic_law_repair_duration' | 'law.traffic_law_replacement_cost' | 'law.traffic_law_replacement_value' | 'law.traffic_law_reregistration_cost' | 'law.traffic_law_residual_value' | 'law.traffic_law_speed_allowed' | 'law.traffic_law_speed_driven' | 'law.traffic_law_speed_too_high' | 'law.traffic_law_time_of_accident' | 'law.traffic_law_time_of_crime' | 'law.traffic_law_time_of_infraction' | 'law.traffic_law_time_of_inspection' | 'law.traffic_law_time_of_issue' | 'law.traffic_law_time_of_offense' | 'law.traffic_law_vehicle_age_months' | 'law.traffic_law_vehicle_mileage' | 'law.traffic_law_vehicle_type_and_brand' | 'law.traffic_law_victim_driver_drivers_license_issued_by' | 'law.traffic_law_victim_driver_green_card_number' | 'law.traffic_law_victim_driver_insurance_expiry_date' | 'law.traffic_law_victim_driver_insurance_number' | 'law.traffic_law_victim_driver_insurer' | 'law.traffic_law_victim_driver_license_valid_until' | 'law.traffic_law_violated_section' | 'law.traffic_law_violation_type' | 'law.traffic_law_warning_fee_infraction' | 'law.traffic_law_warning_notice';

/**
 * * `entities.field.bank_name` - Bankname
 * * `entities.field.bic` - BIC
 * * `entities.field.city` - Ort
 * * `entities.field.company_legal_form` - Rechtsform
 * * `entities.field.company_name` - Firmenname
 * * `entities.field.company_register_court` - Amtsgericht
 * * `entities.field.company_register_number` - Handelsregisternummer
 * * `entities.field.company_tax_id` - Steuernummer
 * * `entities.field.company_vat_id` - USt. ID
 * * `entities.field.date_of_birth` - Geburtsdatum
 * * `entities.field.date_of_death` - Sterbedatum
 * * `entities.field.email` - E-Mail
 * * `entities.field.entity_type` - Personentyp
 * * `entities.field.fax` - Fax
 * * `entities.field.first_name` - Vorname
 * * `entities.field.iban` - IBAN
 * * `entities.field.institution_name` - Name der Institution
 * * `entities.field.is_entitled_to_deduct_vat` - Vorsteuerabzugsberechtigt
 * * `entities.field.last_name` - Nachname
 * * `entities.field.legal_insurance_deductible_amount` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
 * * `entities.field.legal_insurance` - Rechtsschutzversicherung
 * * `entities.field.legal_insurance_name` - Name der Rechtsschutzversicherung
 * * `entities.field.legal_insurance_number` - Nummer der Rechtsschutzversicherung
 * * `entities.field.marital_status` - Familienstand
 * * `entities.field.phone` - Telefon
 * * `entities.field.specific_title` - Titel
 * * `entities.field.street` - Straße
 * * `entities.field.street_number` - Hausnummer
 * * `entities.field.title` - Anrede
 * * `entities.field.website` - Website
 * * `entities.field.zip` - PLZ
 * * `law.criminal_law_amount_of_daily_rates` - Betrag der Tagessatz
 * * `law.criminal_law_applicable_laws` - Anwendbare Vorschriften
 * * `law.criminal_law_charge_description` - Anklagesatz
 * * `law.criminal_law_complaint` - Anzeige
 * * `law.criminal_law_criminal_warrant` - Strafbefehl
 * * `law.criminal_law_damage_description` - Beschreibung des Schadens
 * * `law.criminal_law_damage_value` - Schadenshöhe in EUR
 * * `law.criminal_law_date_of_offense` - Datum der Tat
 * * `law.criminal_law_duration_of_prison_sentence` - Dauer der Freiheitsstrafe
 * * `law.criminal_law_evidence_location` - Standort der Beweismittel
 * * `law.criminal_law_evidence` - Beweis
 * * `law.criminal_law_incident_description` - Sachverhalt
 * * `law.criminal_law_indictment_date` - Datum der Anklageschrift
 * * `law.criminal_law_indictment_delivery_date` - Datum der Zustellung der Anklageschrift
 * * `law.criminal_law_indictment` - Anklageschrift
 * * `law.criminal_law_legal_classification_of_offense` - Vergehen auf der Grundlage von
 * * `law.criminal_law_means_of_evidence` - Beweismittel
 * * `law.criminal_law_number_of_daily_rates` - Tagessatz
 * * `law.criminal_law_offense_type` - Art des Delikts
 * * `law.criminal_law_penalty_infromation` - Strafe
 * * `law.criminal_law_physical_evidence` - Beschreibung der Beweismittel
 * * `law.criminal_law_place_of_offense` - Ort der Tat
 * * `law.criminal_law_police_file_number` - Vorgangsnummer
 * * `law.criminal_law_preliminary_proceedings_date` - Datum der Einleitung des Ermittlungsverfahrens
 * * `law.criminal_law_prison_sentence` - Freiheitsstrafe
 * * `law.criminal_law_probation` - Bewärung
 * * `law.criminal_law_prosecution_file_number` - Aktenzeichen der Staatsanwaltschaft
 * * `law.criminal_law_report_date` - Datum der Anzeigenerstattung
 * * `law.criminal_law_report_time` - Uhrzeit der Anzeigenerstattung
 * * `law.criminal_law_time_of_offense` - Uhrzeit der Tat
 * * `law.debt_collection_law_business_fee` - 1,3 Geschäftsgebühr (Nr. 2300 VV RVG)
 * * `law.debt_collection_law_case_value` - Gegenstandswert
 * * `law.debt_collection_law_invoice_amount` - Rechnungsbetrag
 * * `law.debt_collection_law_invoice_date` - Rechnungsdatum
 * * `law.debt_collection_law_invoice_ground` - Rechnungsgrund
 * * `law.debt_collection_law_invoice_lawyer` - Rechnung Anwalt
 * * `law.debt_collection_law_invoice` - Rechnung
 * * `law.debt_collection_law_invoice_number` - Rechnungsnummer
 * * `law.debt_collection_law_invoice_recipient` - Rechnungsadressat
 * * `law.debt_collection_law_invoice_tax_number` - Steuernummer
 * * `law.debt_collection_law_lumps_sum_expenses` - Auslagenpauschale (Nr. 7002 VV RVG)
 * * `law.debt_collection_law_sales_tax` - Umsatzsteuer (19%)
 * * `law.debt_collection_law_subtotal_lawyer_fees` - Zwischensumme netto
 * * `law.debt_collection_law_total_amount` - Gesamtbetrag
 * * `law.external_case_id` - external case id
 * * `law.family_law_average_net_income` - Durchschnittliches Nettoeinkommen
 * * `law.family_law_birth_certificate` - Geburtsurkunden
 * * `law.family_law_birth_register_number` - Geburtsurkundennummer
 * * `law.family_law_birth_register_office_location` - Standesamt Geburtsurkunde
 * * `law.family_law_children` - Kinder vorhanden
 * * `law.family_law_date_of_marriage` - Eheschließungsdatum
 * * `law.family_law_divorce_application` - Ehescheidungsantrag
 * * `law.family_law_divorce_settlement_agreement` - Scheidungsfolgenvereinbarung
 * * `law.family_law_marriage_certificate` - Eheurkunde
 * * `law.family_law_marriage_contract_date` - Ehevertragsdatum
 * * `law.family_law_marriage_contract` - Ehevertrag
 * * `law.family_law_marriage_register_number` - Eheregisternummer
 * * `law.family_law_registry_office_location` - Standesamt Ort
 * * `law.family_law_separation_date` - Trennungsdatumdatum
 * * `law.field` - Rechtsgebiet
 * * `law.generic_document` - Anderes Dokument
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - Anwendbares Recht
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - Todesdatum
 * * `law.inheritance_law_certificate_of_inheritance_date` - Datum Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance` - Erbschein
 * * `law.inheritance_law_certificate_of_inheritance_number` - Nummer des Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - Todesort
 * * `law.inheritance_law_death_certificate_date_death` - Todesdatum
 * * `law.inheritance_law_death_certificate_date` - Datum Sterbeurkunde
 * * `law.inheritance_law_death_certificate` - Sterbeurkunde
 * * `law.inheritance_law_death_certificate_number` - Nummer Sterbeurkunde
 * * `law.inheritance_law_death_certificate_place_death` - Ort des Todes
 * * `law.inheritance_law_death_certificate_place` - Ort Sterbeurkunde
 * * `law.inheritance_law_death_certificate_time_death` - Uhrzeit des Todes
 * * `law.inheritance_law_estate_inventory_amount` - Nettonachlass
 * * `law.inheritance_law_estate_inventory_date` - Datum Nachlassverzeichnis
 * * `law.inheritance_law_estate_inventory_status` - Güterstand
 * * `law.inheritance_law_inheritance_contract_date` - Datum des Erbvertrags
 * * `law.inheritance_law_inheritance_contract` - Erbvertrag
 * * `law.inheritance_law_lasting_power_of_attorney_date` - Datum Vorsorgevollmacht
 * * `law.inheritance_law_lasting_power_of_attorney` - Vorsorgevollmacht
 * * `law.inheritance_law_list_of_estate` - Nachlassverzeichnis
 * * `law.inheritance_law_living_will` - Patientenverfügung
 * * `law.inheritance_law_patient_enrollment_date` - Datum Patientenverfügung
 * * `law.inheritance_law_testament_date` - Datum des Testaments
 * * `law.inheritance_law_will` - Testament
 * * `law.labor_law_beginning_of_employment` - Datum Beginn des Arbeitsverhältnisses
 * * `law.labor_law_child_allowances` - Kinderfreibeträge
 * * `law.labor_law_collective_agreement` - Tarifvertrag
 * * `law.labor_law_company_agreement` - Betriebsvereinbarung
 * * `law.labor_law_different_place_of_work` - Abweichender Arbeitsort
 * * `law.labor_law_employee_probation_period_end_date` - Datum Ende der Probezeit
 * * `law.labor_law_fixed_term_contract_duration` - Ende befristetes Arbeitsverhältnis
 * * `law.labor_law_fixed_term_contract` - Befristetes Arbeitsverhältnis
 * * `law.labor_law_is_employee_in_probation_period` - Arbeitnehmer in Probezeit
 * * `law.labor_law_job_title` - Berufsbezeichnung
 * * `law.labor_law_married` - Verheiratet
 * * `law.labor_law_monthly_gross_salary` - Gehalt, monatlich, brutto
 * * `law.labor_law_monthly_working_days` - Arbeitsstunden pro Monat
 * * `law.labor_law_notice_period` - Kündigungsfrist in Monaten
 * * `law.labor_law_payslip` - Lohnabrechnung
 * * `law.labor_law_place_of_work` - Arbeitsort
 * * `law.labor_law_settlement_agreement_date` - Datum Abwicklungsvertrag
 * * `law.labor_law_settlement_agreement` - Abwicklungsvertrag
 * * `law.labor_law_signature_of_employer` - Unterschrift Arbeitgeber
 * * `law.labor_law_special_payments_amount` - Höhe Sonderzahlungen
 * * `law.labor_law_special_payments` - Sonderzahlungen
 * * `law.labor_law_special_protection_against_dismissal` - Sonderkündigungsschutz
 * * `law.labor_law_termination_access_to_termination_to_employee` - Datum Zugang Kündigung beim Arbeitnehmer
 * * `law.labor_law_termination_agreement_date` - Datum Aufhebungsvertrag
 * * `law.labor_law_termination_agreement` - Aufhebungsvertrag
 * * `law.labor_law_termination_agreement_severance_pay_amount` - Abfindung Höhe
 * * `law.labor_law_termination_agreement_termination_date` - Datum Beendigung Arbeitsverhältnis
 * * `law.labor_law_termination_date_effective` - Kündigung erfolgt zu welchem Datum
 * * `law.labor_law_termination_date` - Datum Kündigung durch Arbeitgeber
 * * `law.labor_law_termination_employer_more_than_10_employees` - Arbeitgeber hat mehr als 10 Mitarbeiter
 * * `law.labor_law_termination_is_agreement_severance_pay` - Abfindung vereinbart
 * * `law.labor_law_termination` - Kündigung
 * * `law.labor_law_vacation_days` - Urlaubstage
 * * `law.labor_law_wanring_letter_access_to_warning_letter_to_employee` - Datum Zugang Abmahnung beim Arbeitnehmer
 * * `law.labor_law_warning_letter_date` - Datum Abmahnung
 * * `law.labor_law_warning_letter_incident_date` - Datum des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_location` - Ort des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_time` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter` - Abmahnung
 * * `law.labor_law_warning_letter_reason` - Grund der Abmahnung
 * * `law.labor_law_work_contract` - Arbeitsvertrag
 * * `law.labor_law_work_council` - Betriebsrat
 * * `law.labor_law_work_hours_per_week` - Arbeitsstunden pro Woche
 * * `law.labor_law_yearly_gross_salary` - Gehalt, jährlich, brutto
 * * `law.real_estate_law_basic_debts_amount` - Grundschulden
 * * `law.real_estate_law_encumbrance_restrictions` - Lasten und Beschränkungen
 * * `law.real_estate_law_land_register_address` - Grundbuch Lage
 * * `law.real_estate_law_land_register_city` - Grundbuch Stadt
 * * `law.real_estate_law_land_register_date` - Grundbuchauszugdatum
 * * `law.real_estate_law_land_register` - Grundbuchauszug
 * * `law.real_estate_law_land_register_number` - Grundbuch Nr.
 * * `law.real_estate_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.real_estate_law_purchase_contract_amount` - Kaufvertragsbetrag
 * * `law.real_estate_law_purchase_contract_date` - Kaufvertragsdatum
 * * `law.real_estate_law_purchase_contract_description` - Kaufvertrag Objektbeschreibung
 * * `law.real_estate_law_purchase_contract` - Kaufvertrag
 * * `law.real_estate_law_purchase_contract_registration_date` - Kaufvertragsbeurkundungsdatum
 * * `law.residential_property_law_co_ownership_shares` - Miteigentumsanteile
 * * `law.residential_property_law_contract_date` - Wegvertragsdatum
 * * `law.residential_property_law_contract` - Wegvertrag
 * * `law.residential_property_law_inventory` - Bestandsverzeichnis
 * * `law.residential_property_law_land_register_address` - Grundbuch Lage
 * * `law.residential_property_law_land_register_city` - Grundbuch Stadt
 * * `law.residential_property_law_land_register_number` - Grundbuch Nr.
 * * `law.residential_property_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.social_law_application_arrival_date` - Eingang Antrag Datum
 * * `law.social_law_application_date` - Antrag Datum
 * * `law.social_law_notice_date` - Bescheid Datum
 * * `law.social_law_notice_of_objection_date` - Widerspruchbescheid Datum
 * * `law.social_law_notice_of_objection` - Widerspruchbescheid
 * * `law.social_law_summary_grounds_opposition` - Begründung des Widerspruchs
 * * `law.tenancy_law_adress_rental_property` - Adresse Mietobjekt
 * * `law.tenancy_law_advance_payment_service_charge` - Vorauszahlungen Nebenkostenabrechnung
 * * `law.tenancy_law_advance_payment_service_charges` - Nebenkostenvorauszahlungshöhe
 * * `law.tenancy_law_cost_share` - Kostenanteil Mieter
 * * `law.tenancy_law_cost_shares` - Umlageschlüssel
 * * `law.tenancy_law_counter_number` - Zählerstandnummer
 * * `law.tenancy_law_description_of_rental_property` - Beschreibung Mietobjekt
 * * `law.tenancy_law_duration_of_lease` - Dauer Pachtvertrag
 * * `law.tenancy_law_fixed_term_tenancy` - befristeter Mietvertrag
 * * `law.tenancy_law_gross_rent` - Bruttomiete
 * * `law.tenancy_law_handover_counter` - Zählerstand
 * * `law.tenancy_law_handover_date` - Übergabedatum
 * * `law.tenancy_law_handover_defects` - Mängel
 * * `law.tenancy_law_handover_protocol` - Übergabeprotokoll
 * * `law.tenancy_law_lease_agreement` - Pachtvertrag
 * * `law.tenancy_law_location_in_rental_property` - Lage im Mietobjekt
 * * `law.tenancy_law_net_rent` - Nettomiete
 * * `law.tenancy_law_rental_agreement_date` - Mietvertragsdatum
 * * `law.tenancy_law_rental_agreement` - Mietvertrag
 * * `law.tenancy_law_rental_agreement_validity_end` - Mietvertragsende
 * * `law.tenancy_law_rental_agreement_validity_start` - Mietvertragsbeginn
 * * `law.tenancy_law_repayment` - Nachzahlung/Guthaben
 * * `law.tenancy_law_repayment_period_end` - Ende Abrechnungszeitraum
 * * `law.tenancy_law_repayment_period_start` - Beginn Abrechnungszeitraum
 * * `law.tenancy_law_service_charge_settlement` - Nebenkostenabrechnung
 * * `law.tenancy_law_staggered_rental_agreement` - Staffelmietvereinbarung
 * * `law.tenancy_law_start_of_lease` - Beginn Pachtvertrag
 * * `law.tenancy_law_total_cost_service_charge` - Gesamtkosten Nebenkostenabrechnung
 * * `law.tenancy_law_total_rent` - Gesamtmiete
 * * `law.tenancy_law_unlimited_term_tenancy` - unbefristeter Mietvertrag
 * * `law.topic` - Rechtsthema
 * * `law.traffic_law_accident_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_accident_report` - Unfallbericht
 * * `law.traffic_law_amount_of_fine` - Bußgeldhöhe
 * * `law.traffic_law_appeal_instruction` - Rechtsbehelfsbelehrung
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - Unfallverursacher - Führerschein ausgestellt durch
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - Unfallverursacher - Führerschein gültig bis
 * * `law.traffic_law_at_fault_driver_green_card_number` - Unfallverursacher - Nr. der Grünen Karte
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_at_fault_driver_insurance_number` - Unfallverursacher - Vers.-Nr.
 * * `law.traffic_law_at_fault_driver_insurer` - Unfallverursacher - Versicherer
 * * `law.traffic_law_blood_alcohol_concentration` - Blutalkoholkonzentration
 * * `law.traffic_law_calculated_total_damage_costs` - Gesamtschadenshöhe
 * * `law.traffic_law_calculated_total_days` - Gesamttagen
 * * `law.traffic_law_charges` - Tatvorwurf
 * * `law.traffic_law_cost_per_scale` - Kostenpauschale
 * * `law.traffic_law_daily_rate` - Höhe des Tagessatzes
 * * `law.traffic_law_damage_number` - Schadennummer
 * * `law.traffic_law_damage_scope` - Schadenumfang
 * * `law.traffic_law_date_of_accident` - Unfalltag
 * * `law.traffic_law_date_of_crime` - Datum der Tat
 * * `law.traffic_law_date_of_fine` - Datum Bußgeldbescheid
 * * `law.traffic_law_date_of_infraction` - Datum der Ordnungswidrigkeit
 * * `law.traffic_law_date_of_inspection` - Besichtigungsdatum
 * * `law.traffic_law_date_of_issue` - Datum der Ausstellung
 * * `law.traffic_law_date_of_offense` - Datum der Tat
 * * `law.traffic_law_date_of_report` - Datum Sachverständigengutachten
 * * `law.traffic_law_differencial_tax` - Differenzsteuer
 * * `law.traffic_law_driver_logbook_required` - Fahrtenbuch erforderlich
 * * `law.traffic_law_driving_ban_duration` - Fahrverbot Dauer
 * * `law.traffic_law_driving_ban` - Fahrverbot verhängt
 * * `law.traffic_law_evidence_infraction` - Beweismittel
 * * `law.traffic_law_expert_cost` - Sachverständigenkosten
 * * `law.traffic_law_expert_date` - Unfallverursacher - Sachverständigengutachten
 * * `law.traffic_law_expert_report` - Sachverständigengutachten
 * * `law.traffic_law_expert_report_number` - Gutachten Nummer
 * * `law.traffic_law_file_number` - Aktenzeichen
 * * `law.traffic_law_fine` - Geldstrafe
 * * `law.traffic_law_fine_notice` - Bußgeldbescheid
 * * `law.traffic_law_gross_gross_replacement_value` - Brutto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_gross_replacement_value` - Bruttowiederbeschaffungswert
 * * `law.traffic_law_injured` - Verletzte
 * * `law.traffic_law_insurance_holder` - Versicherungsnehmer
 * * `law.traffic_law_insurance` - Versicherung
 * * `law.traffic_law_insurance_policy_number` - Versicherungsscheinnummer
 * * `law.traffic_law_legal_basis_infraction` - Gesetzliche Grundlage
 * * `law.traffic_law_legal_basis` - Gesetzliche Grundlage
 * * `law.traffic_law_licenseplate_at_fault_driver` - KFZ-Kennzeichen des Unfallverursachers
 * * `law.traffic_law_licenseplate` - KFZ-Kennzeichen
 * * `law.traffic_law_licenseplate_victim_driver` - KFZ-Kennzeichen des Unfallgeschädigten
 * * `law.traffic_law_loss_amount_repair_case` - Restschaden Reparaturschaden
 * * `law.traffic_law_loss_amount_total_damage_case` - Restschaden Totalschaden
 * * `law.traffic_law_loss_of_use_per_day` - Nutzungsausfallentschädigung pro Tag
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - Unfallverursacher - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_mark_and_type_of_victim_driver` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_merantile_value_loss` - Merkantile Wertminderung
 * * `law.traffic_law_net_gross_replacement_value` - Netto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_net_replacement_value` - Nettowiederbeschaffungswert
 * * `law.traffic_law_number_of_daily_rates` - Anzahl der Tagessätze
 * * `law.traffic_law_offense_infraction_description` - Tatbestand
 * * `law.traffic_law_other_damages` - Andere Sachschäden
 * * `law.traffic_law_payment_deadline` - Zahlungsfrist
 * * `law.traffic_law_penalty_order` - Strafbefehl
 * * `law.traffic_law_place_of_accident` - Unfallort
 * * `law.traffic_law_place_of_crime` - Ort der Tat
 * * `law.traffic_law_place_of_infraction` - Ort der Ordnungswidrigkeit
 * * `law.traffic_law_place_of_inspection` - Besichtigungsort
 * * `law.traffic_law_place_of_issue` - Ort der Ausstellung
 * * `law.traffic_law_place_of_offense` - Ort der Tat
 * * `law.traffic_law_points_for_offense` - Punkte
 * * `law.traffic_law_police_case_number` - Polizeiliches Aktenzeichen
 * * `law.traffic_law_procedure_costs` - Verfahrenskosten
 * * `law.traffic_law_prosecution_number` - Geschäftsnummer
 * * `law.traffic_law_regular_tax` - Regelsteuer
 * * `law.traffic_law_repair_costs_with_vat` - Reparaturkosten Brutto
 * * `law.traffic_law_repair_costs_without_vat` - Reparaturkosten Netto
 * * `law.traffic_law_repair_duration` - Reparaturdauer Tage
 * * `law.traffic_law_replacement_cost` - Wiederbeschaffungsaufwand
 * * `law.traffic_law_replacement_value` - Wiederbeschaffungswert
 * * `law.traffic_law_reregistration_cost` - Ummeldekosten
 * * `law.traffic_law_residual_value` - Restwert Brutto
 * * `law.traffic_law_speed_allowed` - Erlaubte Geschwindigkeit
 * * `law.traffic_law_speed_driven` - Gefahrene Geschwindigkeit
 * * `law.traffic_law_speed_too_high` - Überschreitung Geschwindigkeit
 * * `law.traffic_law_time_of_accident` - Uhrzeit Unfall
 * * `law.traffic_law_time_of_crime` - Uhrzeit der Tat
 * * `law.traffic_law_time_of_infraction` - Uhrzeit der Ordnungswidrigkeit
 * * `law.traffic_law_time_of_inspection` - Besichtigungszeit
 * * `law.traffic_law_time_of_issue` - Tag der Ausstellung
 * * `law.traffic_law_time_of_offense` - Uhrzeit der Tat
 * * `law.traffic_law_vehicle_age_months` - Fahrzeugalter in Monaten
 * * `law.traffic_law_vehicle_mileage` - Fahrzeugleistung in km
 * * `law.traffic_law_vehicle_type_and_brand` - Fahrzeugtyp und Marke
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - Unfallgeschädigter - Führerschein ausgestellt durch
 * * `law.traffic_law_victim_driver_green_card_number` - Unfallgeschädigter - Nr. der Grünen Karte
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - Unfallgeschädigter - Vers.-Schein gültig bis
 * * `law.traffic_law_victim_driver_insurance_number` - Unfallgeschädigter - Vers.-Nr.
 * * `law.traffic_law_victim_driver_insurer` - Unfallgeschädigter - Versicherer
 * * `law.traffic_law_victim_driver_license_valid_until` - Unfallgeschädigter - Führerschein gültig bis
 * * `law.traffic_law_violated_section` - Verletzte Vorschrift
 * * `law.traffic_law_violation_type` - Tatvorwurf
 * * `law.traffic_law_warning_fee_infraction` - Verwarnungsgeldbetrag
 * * `law.traffic_law_warning_notice` - Verwarnungsgeldbescheid
 */
export const QuestionnaireQuestionTagEnum = {
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip',
    LAW_CRIMINAL_LAW_AMOUNT_OF_DAILY_RATES: 'law.criminal_law_amount_of_daily_rates',
    LAW_CRIMINAL_LAW_APPLICABLE_LAWS: 'law.criminal_law_applicable_laws',
    LAW_CRIMINAL_LAW_CHARGE_DESCRIPTION: 'law.criminal_law_charge_description',
    LAW_CRIMINAL_LAW_COMPLAINT: 'law.criminal_law_complaint',
    LAW_CRIMINAL_LAW_CRIMINAL_WARRANT: 'law.criminal_law_criminal_warrant',
    LAW_CRIMINAL_LAW_DAMAGE_DESCRIPTION: 'law.criminal_law_damage_description',
    LAW_CRIMINAL_LAW_DAMAGE_VALUE: 'law.criminal_law_damage_value',
    LAW_CRIMINAL_LAW_DATE_OF_OFFENSE: 'law.criminal_law_date_of_offense',
    LAW_CRIMINAL_LAW_DURATION_OF_PRISON_SENTENCE: 'law.criminal_law_duration_of_prison_sentence',
    LAW_CRIMINAL_LAW_EVIDENCE_LOCATION: 'law.criminal_law_evidence_location',
    LAW_CRIMINAL_LAW_EVIDENCE: 'law.criminal_law_evidence',
    LAW_CRIMINAL_LAW_INCIDENT_DESCRIPTION: 'law.criminal_law_incident_description',
    LAW_CRIMINAL_LAW_INDICTMENT_DATE: 'law.criminal_law_indictment_date',
    LAW_CRIMINAL_LAW_INDICTMENT_DELIVERY_DATE: 'law.criminal_law_indictment_delivery_date',
    LAW_CRIMINAL_LAW_INDICTMENT: 'law.criminal_law_indictment',
    LAW_CRIMINAL_LAW_LEGAL_CLASSIFICATION_OF_OFFENSE: 'law.criminal_law_legal_classification_of_offense',
    LAW_CRIMINAL_LAW_MEANS_OF_EVIDENCE: 'law.criminal_law_means_of_evidence',
    LAW_CRIMINAL_LAW_NUMBER_OF_DAILY_RATES: 'law.criminal_law_number_of_daily_rates',
    LAW_CRIMINAL_LAW_OFFENSE_TYPE: 'law.criminal_law_offense_type',
    LAW_CRIMINAL_LAW_PENALTY_INFROMATION: 'law.criminal_law_penalty_infromation',
    LAW_CRIMINAL_LAW_PHYSICAL_EVIDENCE: 'law.criminal_law_physical_evidence',
    LAW_CRIMINAL_LAW_PLACE_OF_OFFENSE: 'law.criminal_law_place_of_offense',
    LAW_CRIMINAL_LAW_POLICE_FILE_NUMBER: 'law.criminal_law_police_file_number',
    LAW_CRIMINAL_LAW_PRELIMINARY_PROCEEDINGS_DATE: 'law.criminal_law_preliminary_proceedings_date',
    LAW_CRIMINAL_LAW_PRISON_SENTENCE: 'law.criminal_law_prison_sentence',
    LAW_CRIMINAL_LAW_PROBATION: 'law.criminal_law_probation',
    LAW_CRIMINAL_LAW_PROSECUTION_FILE_NUMBER: 'law.criminal_law_prosecution_file_number',
    LAW_CRIMINAL_LAW_REPORT_DATE: 'law.criminal_law_report_date',
    LAW_CRIMINAL_LAW_REPORT_TIME: 'law.criminal_law_report_time',
    LAW_CRIMINAL_LAW_TIME_OF_OFFENSE: 'law.criminal_law_time_of_offense',
    LAW_DEBT_COLLECTION_LAW_BUSINESS_FEE: 'law.debt_collection_law_business_fee',
    LAW_DEBT_COLLECTION_LAW_CASE_VALUE: 'law.debt_collection_law_case_value',
    LAW_DEBT_COLLECTION_LAW_INVOICE_AMOUNT: 'law.debt_collection_law_invoice_amount',
    LAW_DEBT_COLLECTION_LAW_INVOICE_DATE: 'law.debt_collection_law_invoice_date',
    LAW_DEBT_COLLECTION_LAW_INVOICE_GROUND: 'law.debt_collection_law_invoice_ground',
    LAW_DEBT_COLLECTION_LAW_INVOICE_LAWYER: 'law.debt_collection_law_invoice_lawyer',
    LAW_DEBT_COLLECTION_LAW_INVOICE: 'law.debt_collection_law_invoice',
    LAW_DEBT_COLLECTION_LAW_INVOICE_NUMBER: 'law.debt_collection_law_invoice_number',
    LAW_DEBT_COLLECTION_LAW_INVOICE_RECIPIENT: 'law.debt_collection_law_invoice_recipient',
    LAW_DEBT_COLLECTION_LAW_INVOICE_TAX_NUMBER: 'law.debt_collection_law_invoice_tax_number',
    LAW_DEBT_COLLECTION_LAW_LUMPS_SUM_EXPENSES: 'law.debt_collection_law_lumps_sum_expenses',
    LAW_DEBT_COLLECTION_LAW_SALES_TAX: 'law.debt_collection_law_sales_tax',
    LAW_DEBT_COLLECTION_LAW_SUBTOTAL_LAWYER_FEES: 'law.debt_collection_law_subtotal_lawyer_fees',
    LAW_DEBT_COLLECTION_LAW_TOTAL_AMOUNT: 'law.debt_collection_law_total_amount',
    LAW_EXTERNAL_CASE_ID: 'law.external_case_id',
    LAW_FAMILY_LAW_AVERAGE_NET_INCOME: 'law.family_law_average_net_income',
    LAW_FAMILY_LAW_BIRTH_CERTIFICATE: 'law.family_law_birth_certificate',
    LAW_FAMILY_LAW_BIRTH_REGISTER_NUMBER: 'law.family_law_birth_register_number',
    LAW_FAMILY_LAW_BIRTH_REGISTER_OFFICE_LOCATION: 'law.family_law_birth_register_office_location',
    LAW_FAMILY_LAW_CHILDREN: 'law.family_law_children',
    LAW_FAMILY_LAW_DATE_OF_MARRIAGE: 'law.family_law_date_of_marriage',
    LAW_FAMILY_LAW_DIVORCE_APPLICATION: 'law.family_law_divorce_application',
    LAW_FAMILY_LAW_DIVORCE_SETTLEMENT_AGREEMENT: 'law.family_law_divorce_settlement_agreement',
    LAW_FAMILY_LAW_MARRIAGE_CERTIFICATE: 'law.family_law_marriage_certificate',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT_DATE: 'law.family_law_marriage_contract_date',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT: 'law.family_law_marriage_contract',
    LAW_FAMILY_LAW_MARRIAGE_REGISTER_NUMBER: 'law.family_law_marriage_register_number',
    LAW_FAMILY_LAW_REGISTRY_OFFICE_LOCATION: 'law.family_law_registry_office_location',
    LAW_FAMILY_LAW_SEPARATION_DATE: 'law.family_law_separation_date',
    LAW_FIELD: 'law.field',
    LAW_GENERIC_DOCUMENT: 'law.generic_document',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_APPLICABLE_LAW: 'law.inheritance_law_certificate_of_inheritance_applicable_law',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE_DEATH: 'law.inheritance_law_certificate_of_inheritance_date_death',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE: 'law.inheritance_law_certificate_of_inheritance_date',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE: 'law.inheritance_law_certificate_of_inheritance',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_NUMBER: 'law.inheritance_law_certificate_of_inheritance_number',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_PLACE_OF_DEATH: 'law.inheritance_law_certificate_of_inheritance_place_of_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE_DEATH: 'law.inheritance_law_death_certificate_date_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE: 'law.inheritance_law_death_certificate_date',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE: 'law.inheritance_law_death_certificate',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_NUMBER: 'law.inheritance_law_death_certificate_number',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE_DEATH: 'law.inheritance_law_death_certificate_place_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE: 'law.inheritance_law_death_certificate_place',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_TIME_DEATH: 'law.inheritance_law_death_certificate_time_death',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_AMOUNT: 'law.inheritance_law_estate_inventory_amount',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_DATE: 'law.inheritance_law_estate_inventory_date',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_STATUS: 'law.inheritance_law_estate_inventory_status',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT_DATE: 'law.inheritance_law_inheritance_contract_date',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT: 'law.inheritance_law_inheritance_contract',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY_DATE: 'law.inheritance_law_lasting_power_of_attorney_date',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY: 'law.inheritance_law_lasting_power_of_attorney',
    LAW_INHERITANCE_LAW_LIST_OF_ESTATE: 'law.inheritance_law_list_of_estate',
    LAW_INHERITANCE_LAW_LIVING_WILL: 'law.inheritance_law_living_will',
    LAW_INHERITANCE_LAW_PATIENT_ENROLLMENT_DATE: 'law.inheritance_law_patient_enrollment_date',
    LAW_INHERITANCE_LAW_TESTAMENT_DATE: 'law.inheritance_law_testament_date',
    LAW_INHERITANCE_LAW_WILL: 'law.inheritance_law_will',
    LAW_LABOR_LAW_BEGINNING_OF_EMPLOYMENT: 'law.labor_law_beginning_of_employment',
    LAW_LABOR_LAW_CHILD_ALLOWANCES: 'law.labor_law_child_allowances',
    LAW_LABOR_LAW_COLLECTIVE_AGREEMENT: 'law.labor_law_collective_agreement',
    LAW_LABOR_LAW_COMPANY_AGREEMENT: 'law.labor_law_company_agreement',
    LAW_LABOR_LAW_DIFFERENT_PLACE_OF_WORK: 'law.labor_law_different_place_of_work',
    LAW_LABOR_LAW_EMPLOYEE_PROBATION_PERIOD_END_DATE: 'law.labor_law_employee_probation_period_end_date',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT_DURATION: 'law.labor_law_fixed_term_contract_duration',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT: 'law.labor_law_fixed_term_contract',
    LAW_LABOR_LAW_IS_EMPLOYEE_IN_PROBATION_PERIOD: 'law.labor_law_is_employee_in_probation_period',
    LAW_LABOR_LAW_JOB_TITLE: 'law.labor_law_job_title',
    LAW_LABOR_LAW_MARRIED: 'law.labor_law_married',
    LAW_LABOR_LAW_MONTHLY_GROSS_SALARY: 'law.labor_law_monthly_gross_salary',
    LAW_LABOR_LAW_MONTHLY_WORKING_DAYS: 'law.labor_law_monthly_working_days',
    LAW_LABOR_LAW_NOTICE_PERIOD: 'law.labor_law_notice_period',
    LAW_LABOR_LAW_PAYSLIP: 'law.labor_law_payslip',
    LAW_LABOR_LAW_PLACE_OF_WORK: 'law.labor_law_place_of_work',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT_DATE: 'law.labor_law_settlement_agreement_date',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT: 'law.labor_law_settlement_agreement',
    LAW_LABOR_LAW_SIGNATURE_OF_EMPLOYER: 'law.labor_law_signature_of_employer',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS_AMOUNT: 'law.labor_law_special_payments_amount',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS: 'law.labor_law_special_payments',
    LAW_LABOR_LAW_SPECIAL_PROTECTION_AGAINST_DISMISSAL: 'law.labor_law_special_protection_against_dismissal',
    LAW_LABOR_LAW_TERMINATION_ACCESS_TO_TERMINATION_TO_EMPLOYEE: 'law.labor_law_termination_access_to_termination_to_employee',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_DATE: 'law.labor_law_termination_agreement_date',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT: 'law.labor_law_termination_agreement',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_SEVERANCE_PAY_AMOUNT: 'law.labor_law_termination_agreement_severance_pay_amount',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_TERMINATION_DATE: 'law.labor_law_termination_agreement_termination_date',
    LAW_LABOR_LAW_TERMINATION_DATE_EFFECTIVE: 'law.labor_law_termination_date_effective',
    LAW_LABOR_LAW_TERMINATION_DATE: 'law.labor_law_termination_date',
    LAW_LABOR_LAW_TERMINATION_EMPLOYER_MORE_THAN_10_EMPLOYEES: 'law.labor_law_termination_employer_more_than_10_employees',
    LAW_LABOR_LAW_TERMINATION_IS_AGREEMENT_SEVERANCE_PAY: 'law.labor_law_termination_is_agreement_severance_pay',
    LAW_LABOR_LAW_TERMINATION: 'law.labor_law_termination',
    LAW_LABOR_LAW_VACATION_DAYS: 'law.labor_law_vacation_days',
    LAW_LABOR_LAW_WANRING_LETTER_ACCESS_TO_WARNING_LETTER_TO_EMPLOYEE: 'law.labor_law_wanring_letter_access_to_warning_letter_to_employee',
    LAW_LABOR_LAW_WARNING_LETTER_DATE: 'law.labor_law_warning_letter_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_DATE: 'law.labor_law_warning_letter_incident_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_LOCATION: 'law.labor_law_warning_letter_incident_location',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_TIME: 'law.labor_law_warning_letter_incident_time',
    LAW_LABOR_LAW_WARNING_LETTER: 'law.labor_law_warning_letter',
    LAW_LABOR_LAW_WARNING_LETTER_REASON: 'law.labor_law_warning_letter_reason',
    LAW_LABOR_LAW_WORK_CONTRACT: 'law.labor_law_work_contract',
    LAW_LABOR_LAW_WORK_COUNCIL: 'law.labor_law_work_council',
    LAW_LABOR_LAW_WORK_HOURS_PER_WEEK: 'law.labor_law_work_hours_per_week',
    LAW_LABOR_LAW_YEARLY_GROSS_SALARY: 'law.labor_law_yearly_gross_salary',
    LAW_REAL_ESTATE_LAW_BASIC_DEBTS_AMOUNT: 'law.real_estate_law_basic_debts_amount',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCE_RESTRICTIONS: 'law.real_estate_law_encumbrance_restrictions',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_ADDRESS: 'law.real_estate_law_land_register_address',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_CITY: 'law.real_estate_law_land_register_city',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_DATE: 'law.real_estate_law_land_register_date',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER: 'law.real_estate_law_land_register',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_NUMBER: 'law.real_estate_law_land_register_number',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.real_estate_law_land_register_plot_of_land',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_AMOUNT: 'law.real_estate_law_purchase_contract_amount',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DATE: 'law.real_estate_law_purchase_contract_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DESCRIPTION: 'law.real_estate_law_purchase_contract_description',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT: 'law.real_estate_law_purchase_contract',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_DATE: 'law.real_estate_law_purchase_contract_registration_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CO_OWNERSHIP_SHARES: 'law.residential_property_law_co_ownership_shares',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT_DATE: 'law.residential_property_law_contract_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT: 'law.residential_property_law_contract',
    LAW_RESIDENTIAL_PROPERTY_LAW_INVENTORY: 'law.residential_property_law_inventory',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_ADDRESS: 'law.residential_property_law_land_register_address',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_CITY: 'law.residential_property_law_land_register_city',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_NUMBER: 'law.residential_property_law_land_register_number',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.residential_property_law_land_register_plot_of_land',
    LAW_SOCIAL_LAW_APPLICATION_ARRIVAL_DATE: 'law.social_law_application_arrival_date',
    LAW_SOCIAL_LAW_APPLICATION_DATE: 'law.social_law_application_date',
    LAW_SOCIAL_LAW_NOTICE_DATE: 'law.social_law_notice_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_DATE: 'law.social_law_notice_of_objection_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION: 'law.social_law_notice_of_objection',
    LAW_SOCIAL_LAW_SUMMARY_GROUNDS_OPPOSITION: 'law.social_law_summary_grounds_opposition',
    LAW_TENANCY_LAW_ADRESS_RENTAL_PROPERTY: 'law.tenancy_law_adress_rental_property',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGE: 'law.tenancy_law_advance_payment_service_charge',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGES: 'law.tenancy_law_advance_payment_service_charges',
    LAW_TENANCY_LAW_COST_SHARE: 'law.tenancy_law_cost_share',
    LAW_TENANCY_LAW_COST_SHARES: 'law.tenancy_law_cost_shares',
    LAW_TENANCY_LAW_COUNTER_NUMBER: 'law.tenancy_law_counter_number',
    LAW_TENANCY_LAW_DESCRIPTION_OF_RENTAL_PROPERTY: 'law.tenancy_law_description_of_rental_property',
    LAW_TENANCY_LAW_DURATION_OF_LEASE: 'law.tenancy_law_duration_of_lease',
    LAW_TENANCY_LAW_FIXED_TERM_TENANCY: 'law.tenancy_law_fixed_term_tenancy',
    LAW_TENANCY_LAW_GROSS_RENT: 'law.tenancy_law_gross_rent',
    LAW_TENANCY_LAW_HANDOVER_COUNTER: 'law.tenancy_law_handover_counter',
    LAW_TENANCY_LAW_HANDOVER_DATE: 'law.tenancy_law_handover_date',
    LAW_TENANCY_LAW_HANDOVER_DEFECTS: 'law.tenancy_law_handover_defects',
    LAW_TENANCY_LAW_HANDOVER_PROTOCOL: 'law.tenancy_law_handover_protocol',
    LAW_TENANCY_LAW_LEASE_AGREEMENT: 'law.tenancy_law_lease_agreement',
    LAW_TENANCY_LAW_LOCATION_IN_RENTAL_PROPERTY: 'law.tenancy_law_location_in_rental_property',
    LAW_TENANCY_LAW_NET_RENT: 'law.tenancy_law_net_rent',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DATE: 'law.tenancy_law_rental_agreement_date',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT: 'law.tenancy_law_rental_agreement',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_END: 'law.tenancy_law_rental_agreement_validity_end',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_START: 'law.tenancy_law_rental_agreement_validity_start',
    LAW_TENANCY_LAW_REPAYMENT: 'law.tenancy_law_repayment',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_END: 'law.tenancy_law_repayment_period_end',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_START: 'law.tenancy_law_repayment_period_start',
    LAW_TENANCY_LAW_SERVICE_CHARGE_SETTLEMENT: 'law.tenancy_law_service_charge_settlement',
    LAW_TENANCY_LAW_STAGGERED_RENTAL_AGREEMENT: 'law.tenancy_law_staggered_rental_agreement',
    LAW_TENANCY_LAW_START_OF_LEASE: 'law.tenancy_law_start_of_lease',
    LAW_TENANCY_LAW_TOTAL_COST_SERVICE_CHARGE: 'law.tenancy_law_total_cost_service_charge',
    LAW_TENANCY_LAW_TOTAL_RENT: 'law.tenancy_law_total_rent',
    LAW_TENANCY_LAW_UNLIMITED_TERM_TENANCY: 'law.tenancy_law_unlimited_term_tenancy',
    LAW_TOPIC: 'law.topic',
    LAW_TRAFFIC_LAW_ACCIDENT_DATE: 'law.traffic_law_accident_date',
    LAW_TRAFFIC_LAW_ACCIDENT_REPORT: 'law.traffic_law_accident_report',
    LAW_TRAFFIC_LAW_AMOUNT_OF_FINE: 'law.traffic_law_amount_of_fine',
    LAW_TRAFFIC_LAW_APPEAL_INSTRUCTION: 'law.traffic_law_appeal_instruction',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_at_fault_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_VALID_UNTIL: 'law.traffic_law_at_fault_driver_drivers_license_valid_until',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_at_fault_driver_green_card_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_at_fault_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_at_fault_driver_insurance_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURER: 'law.traffic_law_at_fault_driver_insurer',
    LAW_TRAFFIC_LAW_BLOOD_ALCOHOL_CONCENTRATION: 'law.traffic_law_blood_alcohol_concentration',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAMAGE_COSTS: 'law.traffic_law_calculated_total_damage_costs',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAYS: 'law.traffic_law_calculated_total_days',
    LAW_TRAFFIC_LAW_CHARGES: 'law.traffic_law_charges',
    LAW_TRAFFIC_LAW_COST_PER_SCALE: 'law.traffic_law_cost_per_scale',
    LAW_TRAFFIC_LAW_DAILY_RATE: 'law.traffic_law_daily_rate',
    LAW_TRAFFIC_LAW_DAMAGE_NUMBER: 'law.traffic_law_damage_number',
    LAW_TRAFFIC_LAW_DAMAGE_SCOPE: 'law.traffic_law_damage_scope',
    LAW_TRAFFIC_LAW_DATE_OF_ACCIDENT: 'law.traffic_law_date_of_accident',
    LAW_TRAFFIC_LAW_DATE_OF_CRIME: 'law.traffic_law_date_of_crime',
    LAW_TRAFFIC_LAW_DATE_OF_FINE: 'law.traffic_law_date_of_fine',
    LAW_TRAFFIC_LAW_DATE_OF_INFRACTION: 'law.traffic_law_date_of_infraction',
    LAW_TRAFFIC_LAW_DATE_OF_INSPECTION: 'law.traffic_law_date_of_inspection',
    LAW_TRAFFIC_LAW_DATE_OF_ISSUE: 'law.traffic_law_date_of_issue',
    LAW_TRAFFIC_LAW_DATE_OF_OFFENSE: 'law.traffic_law_date_of_offense',
    LAW_TRAFFIC_LAW_DATE_OF_REPORT: 'law.traffic_law_date_of_report',
    LAW_TRAFFIC_LAW_DIFFERENCIAL_TAX: 'law.traffic_law_differencial_tax',
    LAW_TRAFFIC_LAW_DRIVER_LOGBOOK_REQUIRED: 'law.traffic_law_driver_logbook_required',
    LAW_TRAFFIC_LAW_DRIVING_BAN_DURATION: 'law.traffic_law_driving_ban_duration',
    LAW_TRAFFIC_LAW_DRIVING_BAN: 'law.traffic_law_driving_ban',
    LAW_TRAFFIC_LAW_EVIDENCE_INFRACTION: 'law.traffic_law_evidence_infraction',
    LAW_TRAFFIC_LAW_EXPERT_COST: 'law.traffic_law_expert_cost',
    LAW_TRAFFIC_LAW_EXPERT_DATE: 'law.traffic_law_expert_date',
    LAW_TRAFFIC_LAW_EXPERT_REPORT: 'law.traffic_law_expert_report',
    LAW_TRAFFIC_LAW_EXPERT_REPORT_NUMBER: 'law.traffic_law_expert_report_number',
    LAW_TRAFFIC_LAW_FILE_NUMBER: 'law.traffic_law_file_number',
    LAW_TRAFFIC_LAW_FINE: 'law.traffic_law_fine',
    LAW_TRAFFIC_LAW_FINE_NOTICE: 'law.traffic_law_fine_notice',
    LAW_TRAFFIC_LAW_GROSS_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_gross_replacement_value',
    LAW_TRAFFIC_LAW_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_replacement_value',
    LAW_TRAFFIC_LAW_INJURED: 'law.traffic_law_injured',
    LAW_TRAFFIC_LAW_INSURANCE_HOLDER: 'law.traffic_law_insurance_holder',
    LAW_TRAFFIC_LAW_INSURANCE: 'law.traffic_law_insurance',
    LAW_TRAFFIC_LAW_INSURANCE_POLICY_NUMBER: 'law.traffic_law_insurance_policy_number',
    LAW_TRAFFIC_LAW_LEGAL_BASIS_INFRACTION: 'law.traffic_law_legal_basis_infraction',
    LAW_TRAFFIC_LAW_LEGAL_BASIS: 'law.traffic_law_legal_basis',
    LAW_TRAFFIC_LAW_LICENSEPLATE_AT_FAULT_DRIVER: 'law.traffic_law_licenseplate_at_fault_driver',
    LAW_TRAFFIC_LAW_LICENSEPLATE: 'law.traffic_law_licenseplate',
    LAW_TRAFFIC_LAW_LICENSEPLATE_VICTIM_DRIVER: 'law.traffic_law_licenseplate_victim_driver',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_REPAIR_CASE: 'law.traffic_law_loss_amount_repair_case',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_TOTAL_DAMAGE_CASE: 'law.traffic_law_loss_amount_total_damage_case',
    LAW_TRAFFIC_LAW_LOSS_OF_USE_PER_DAY: 'law.traffic_law_loss_of_use_per_day',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_AT_FAULT_DRIVER: 'law.traffic_law_mark_and_type_of_at_fault_driver',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_VICTIM_DRIVER: 'law.traffic_law_mark_and_type_of_victim_driver',
    LAW_TRAFFIC_LAW_MERANTILE_VALUE_LOSS: 'law.traffic_law_merantile_value_loss',
    LAW_TRAFFIC_LAW_NET_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_net_gross_replacement_value',
    LAW_TRAFFIC_LAW_NET_REPLACEMENT_VALUE: 'law.traffic_law_net_replacement_value',
    LAW_TRAFFIC_LAW_NUMBER_OF_DAILY_RATES: 'law.traffic_law_number_of_daily_rates',
    LAW_TRAFFIC_LAW_OFFENSE_INFRACTION_DESCRIPTION: 'law.traffic_law_offense_infraction_description',
    LAW_TRAFFIC_LAW_OTHER_DAMAGES: 'law.traffic_law_other_damages',
    LAW_TRAFFIC_LAW_PAYMENT_DEADLINE: 'law.traffic_law_payment_deadline',
    LAW_TRAFFIC_LAW_PENALTY_ORDER: 'law.traffic_law_penalty_order',
    LAW_TRAFFIC_LAW_PLACE_OF_ACCIDENT: 'law.traffic_law_place_of_accident',
    LAW_TRAFFIC_LAW_PLACE_OF_CRIME: 'law.traffic_law_place_of_crime',
    LAW_TRAFFIC_LAW_PLACE_OF_INFRACTION: 'law.traffic_law_place_of_infraction',
    LAW_TRAFFIC_LAW_PLACE_OF_INSPECTION: 'law.traffic_law_place_of_inspection',
    LAW_TRAFFIC_LAW_PLACE_OF_ISSUE: 'law.traffic_law_place_of_issue',
    LAW_TRAFFIC_LAW_PLACE_OF_OFFENSE: 'law.traffic_law_place_of_offense',
    LAW_TRAFFIC_LAW_POINTS_FOR_OFFENSE: 'law.traffic_law_points_for_offense',
    LAW_TRAFFIC_LAW_POLICE_CASE_NUMBER: 'law.traffic_law_police_case_number',
    LAW_TRAFFIC_LAW_PROCEDURE_COSTS: 'law.traffic_law_procedure_costs',
    LAW_TRAFFIC_LAW_PROSECUTION_NUMBER: 'law.traffic_law_prosecution_number',
    LAW_TRAFFIC_LAW_REGULAR_TAX: 'law.traffic_law_regular_tax',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITH_VAT: 'law.traffic_law_repair_costs_with_vat',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITHOUT_VAT: 'law.traffic_law_repair_costs_without_vat',
    LAW_TRAFFIC_LAW_REPAIR_DURATION: 'law.traffic_law_repair_duration',
    LAW_TRAFFIC_LAW_REPLACEMENT_COST: 'law.traffic_law_replacement_cost',
    LAW_TRAFFIC_LAW_REPLACEMENT_VALUE: 'law.traffic_law_replacement_value',
    LAW_TRAFFIC_LAW_REREGISTRATION_COST: 'law.traffic_law_reregistration_cost',
    LAW_TRAFFIC_LAW_RESIDUAL_VALUE: 'law.traffic_law_residual_value',
    LAW_TRAFFIC_LAW_SPEED_ALLOWED: 'law.traffic_law_speed_allowed',
    LAW_TRAFFIC_LAW_SPEED_DRIVEN: 'law.traffic_law_speed_driven',
    LAW_TRAFFIC_LAW_SPEED_TOO_HIGH: 'law.traffic_law_speed_too_high',
    LAW_TRAFFIC_LAW_TIME_OF_ACCIDENT: 'law.traffic_law_time_of_accident',
    LAW_TRAFFIC_LAW_TIME_OF_CRIME: 'law.traffic_law_time_of_crime',
    LAW_TRAFFIC_LAW_TIME_OF_INFRACTION: 'law.traffic_law_time_of_infraction',
    LAW_TRAFFIC_LAW_TIME_OF_INSPECTION: 'law.traffic_law_time_of_inspection',
    LAW_TRAFFIC_LAW_TIME_OF_ISSUE: 'law.traffic_law_time_of_issue',
    LAW_TRAFFIC_LAW_TIME_OF_OFFENSE: 'law.traffic_law_time_of_offense',
    LAW_TRAFFIC_LAW_VEHICLE_AGE_MONTHS: 'law.traffic_law_vehicle_age_months',
    LAW_TRAFFIC_LAW_VEHICLE_MILEAGE: 'law.traffic_law_vehicle_mileage',
    LAW_TRAFFIC_LAW_VEHICLE_TYPE_AND_BRAND: 'law.traffic_law_vehicle_type_and_brand',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_victim_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_victim_driver_green_card_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_victim_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_victim_driver_insurance_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURER: 'law.traffic_law_victim_driver_insurer',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_LICENSE_VALID_UNTIL: 'law.traffic_law_victim_driver_license_valid_until',
    LAW_TRAFFIC_LAW_VIOLATED_SECTION: 'law.traffic_law_violated_section',
    LAW_TRAFFIC_LAW_VIOLATION_TYPE: 'law.traffic_law_violation_type',
    LAW_TRAFFIC_LAW_WARNING_FEE_INFRACTION: 'law.traffic_law_warning_fee_infraction',
    LAW_TRAFFIC_LAW_WARNING_NOTICE: 'law.traffic_law_warning_notice'
} as const;

/**
 * * `multiselect` - Multiple choice
 * * `select` - Single choice
 * * `textarea` - Long text
 * * `filefield` - File input
 * * `multifilefield` - Multi file input
 * * `timefield` - Time field
 * * `decimalnumberinput` - Decimal number
 * * `datefield` - Date
 * * `textinput` - Short text
 * * `numberinput` - Number
 * * `emailinput` - Email
 * * `phoneinput` - Phone
 * * `urlinput` - URL
 * * `yesno` - Yes/No
 */
export type QuestionnaireQuestionTypeEnum = 'multiselect' | 'select' | 'textarea' | 'filefield' | 'multifilefield' | 'timefield' | 'decimalnumberinput' | 'datefield' | 'textinput' | 'numberinput' | 'emailinput' | 'phoneinput' | 'urlinput' | 'yesno';

/**
 * * `multiselect` - Multiple choice
 * * `select` - Single choice
 * * `textarea` - Long text
 * * `filefield` - File input
 * * `multifilefield` - Multi file input
 * * `timefield` - Time field
 * * `decimalnumberinput` - Decimal number
 * * `datefield` - Date
 * * `textinput` - Short text
 * * `numberinput` - Number
 * * `emailinput` - Email
 * * `phoneinput` - Phone
 * * `urlinput` - URL
 * * `yesno` - Yes/No
 */
export const QuestionnaireQuestionTypeEnum = {
    MULTISELECT: 'multiselect',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    FILEFIELD: 'filefield',
    MULTIFILEFIELD: 'multifilefield',
    TIMEFIELD: 'timefield',
    DECIMALNUMBERINPUT: 'decimalnumberinput',
    DATEFIELD: 'datefield',
    TEXTINPUT: 'textinput',
    NUMBERINPUT: 'numberinput',
    EMAILINPUT: 'emailinput',
    PHONEINPUT: 'phoneinput',
    URLINPUT: 'urlinput',
    YESNO: 'yesno'
} as const;

export type QuestionnaireSection = {
    uuid: string;
    items: Array<QuestionnaireQuestion>;
    title: string;
};

export type QuestionnaireSectionRequest = {
    uuid: string;
    items: Array<QuestionnaireQuestionRequest>;
    title: string;
};

export type RaMicroApiDataRequest = {
    entities_with_relationships: Array<(string)>;
    fileData?: Array<FileDataRequest>;
};

export type RaMicroDataRequest = {
    entities_with_relationships: Array<(string)>;
};

/**
 * * `DOWNLOAD` - Oma Download
 * * `OMA_EMAIL` - Oma Email
 */
export type RaMicroExportIntegrationTypeEnum = 'DOWNLOAD' | 'OMA_EMAIL';

/**
 * * `DOWNLOAD` - Oma Download
 * * `OMA_EMAIL` - Oma Email
 */
export const RaMicroExportIntegrationTypeEnum = {
    DOWNLOAD: 'DOWNLOAD',
    OMA_EMAIL: 'OMA_EMAIL'
} as const;

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.prosecuting_office` - Prosecuting Office
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.expert_witness` - Expert Witness
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.mahn_court` - Mahn Court
 * * `entities.execution_court` - Execution Court
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 */
export type RelationshipTypeEnum = 'entities.opponent' | 'entities.client' | 'entities.other' | 'entities.labor_law_employee' | 'entities.labor_law_employer' | 'entities.witness' | 'entities.at_fault_driver' | 'entities.victim_driver' | 'entities.accused' | 'entities.defendant' | 'entities.plaintiff' | 'entities.complaint' | 'entities.victim' | 'entities.vehicle_expert' | 'entities.agency' | 'entities.vehicle_owner' | 'entities.insurance' | 'entities.driver' | 'entities.police_officer' | 'entities.police_station' | 'entities.judge' | 'entities.court' | 'entities.prosecutor' | 'entities.prosecuting_office' | 'entities.opposing_counsel' | 'entities.expert_witness' | 'entities.co_plaintiff' | 'entities.probation_officer' | 'entities.tenant' | 'entities.landlord' | 'entities.subtenant' | 'entities.owner' | 'entities.property_management' | 'entities.real_estate_agent' | 'entities.guarantor' | 'entities.co_owner' | 'entities.co_tenant' | 'entities.tenants_association' | 'entities.property_owners_association' | 'entities.complainant' | 'entities.applicant' | 'entities.respondent' | 'entities.child' | 'entities.officiant' | 'entities.wife' | 'entities.husband' | 'entities.legal_representative' | 'entities.korrespondence_lawyer' | 'entities.opposing_lawyer' | 'entities.lawyer' | 'entities.legal_expenses_insurance' | 'entities.liability_insurance' | 'entities.first_instance_court' | 'entities.second_instance_court' | 'entities.third_instance_court' | 'entities.contact_person' | 'entities.public_prosecutor' | 'entities.third_party_debtor' | 'entities.road_traffic_office' | 'entities.debt_collection_agency' | 'entities.expert' | 'entities.tax_office' | 'entities.land_registry' | 'entities.bank' | 'entities.buyer' | 'entities.dunning_court' | 'entities.enforcement_court' | 'entities.general_prosecutor' | 'entities.seller' | 'entities.expert_committee' | 'entities.municipality' | 'entities.administrator' | 'entities.register_court' | 'entities.probate_court' | 'entities.registry_office' | 'entities.hereditary_leaseholder' | 'entities.legal_aid_court' | 'entities.secondary_client' | 'entities.secondary_opponent' | 'entities.court_complaint' | 'entities.fine_authority' | 'entities.resident_registration_office' | 'entities.investigator' | 'entities.bailiff' | 'entities.insolvency_court' | 'entities.integration_office' | 'entities.mahn_court' | 'entities.execution_court' | 'entities.execution_organ' | 'entities.debtor' | 'entities.creditor' | 'entities.lessee' | 'entities.lessor' | 'entities.principal' | 'entities.authorized_representative' | 'entities.testator' | 'entities.heir' | 'entities.preliminary_heir' | 'entities.subsequent_heir' | 'entities.curator_of_the_estate' | 'entities.executor_of_the_will' | 'entities.estate_administrator' | 'entities.compulsory_portion_beneficiary' | 'entities.notary' | 'entities.trustee' | 'entities.insolvency_administrator';

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.prosecuting_office` - Prosecuting Office
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.expert_witness` - Expert Witness
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.mahn_court` - Mahn Court
 * * `entities.execution_court` - Execution Court
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 */
export const RelationshipTypeEnum = {
    ENTITIES_OPPONENT: 'entities.opponent',
    ENTITIES_CLIENT: 'entities.client',
    ENTITIES_OTHER: 'entities.other',
    ENTITIES_LABOR_LAW_EMPLOYEE: 'entities.labor_law_employee',
    ENTITIES_LABOR_LAW_EMPLOYER: 'entities.labor_law_employer',
    ENTITIES_WITNESS: 'entities.witness',
    ENTITIES_AT_FAULT_DRIVER: 'entities.at_fault_driver',
    ENTITIES_VICTIM_DRIVER: 'entities.victim_driver',
    ENTITIES_ACCUSED: 'entities.accused',
    ENTITIES_DEFENDANT: 'entities.defendant',
    ENTITIES_PLAINTIFF: 'entities.plaintiff',
    ENTITIES_COMPLAINT: 'entities.complaint',
    ENTITIES_VICTIM: 'entities.victim',
    ENTITIES_VEHICLE_EXPERT: 'entities.vehicle_expert',
    ENTITIES_AGENCY: 'entities.agency',
    ENTITIES_VEHICLE_OWNER: 'entities.vehicle_owner',
    ENTITIES_INSURANCE: 'entities.insurance',
    ENTITIES_DRIVER: 'entities.driver',
    ENTITIES_POLICE_OFFICER: 'entities.police_officer',
    ENTITIES_POLICE_STATION: 'entities.police_station',
    ENTITIES_JUDGE: 'entities.judge',
    ENTITIES_COURT: 'entities.court',
    ENTITIES_PROSECUTOR: 'entities.prosecutor',
    ENTITIES_PROSECUTING_OFFICE: 'entities.prosecuting_office',
    ENTITIES_OPPOSING_COUNSEL: 'entities.opposing_counsel',
    ENTITIES_EXPERT_WITNESS: 'entities.expert_witness',
    ENTITIES_CO_PLAINTIFF: 'entities.co_plaintiff',
    ENTITIES_PROBATION_OFFICER: 'entities.probation_officer',
    ENTITIES_TENANT: 'entities.tenant',
    ENTITIES_LANDLORD: 'entities.landlord',
    ENTITIES_SUBTENANT: 'entities.subtenant',
    ENTITIES_OWNER: 'entities.owner',
    ENTITIES_PROPERTY_MANAGEMENT: 'entities.property_management',
    ENTITIES_REAL_ESTATE_AGENT: 'entities.real_estate_agent',
    ENTITIES_GUARANTOR: 'entities.guarantor',
    ENTITIES_CO_OWNER: 'entities.co_owner',
    ENTITIES_CO_TENANT: 'entities.co_tenant',
    ENTITIES_TENANTS_ASSOCIATION: 'entities.tenants_association',
    ENTITIES_PROPERTY_OWNERS_ASSOCIATION: 'entities.property_owners_association',
    ENTITIES_COMPLAINANT: 'entities.complainant',
    ENTITIES_APPLICANT: 'entities.applicant',
    ENTITIES_RESPONDENT: 'entities.respondent',
    ENTITIES_CHILD: 'entities.child',
    ENTITIES_OFFICIANT: 'entities.officiant',
    ENTITIES_WIFE: 'entities.wife',
    ENTITIES_HUSBAND: 'entities.husband',
    ENTITIES_LEGAL_REPRESENTATIVE: 'entities.legal_representative',
    ENTITIES_KORRESPONDENCE_LAWYER: 'entities.korrespondence_lawyer',
    ENTITIES_OPPOSING_LAWYER: 'entities.opposing_lawyer',
    ENTITIES_LAWYER: 'entities.lawyer',
    ENTITIES_LEGAL_EXPENSES_INSURANCE: 'entities.legal_expenses_insurance',
    ENTITIES_LIABILITY_INSURANCE: 'entities.liability_insurance',
    ENTITIES_FIRST_INSTANCE_COURT: 'entities.first_instance_court',
    ENTITIES_SECOND_INSTANCE_COURT: 'entities.second_instance_court',
    ENTITIES_THIRD_INSTANCE_COURT: 'entities.third_instance_court',
    ENTITIES_CONTACT_PERSON: 'entities.contact_person',
    ENTITIES_PUBLIC_PROSECUTOR: 'entities.public_prosecutor',
    ENTITIES_THIRD_PARTY_DEBTOR: 'entities.third_party_debtor',
    ENTITIES_ROAD_TRAFFIC_OFFICE: 'entities.road_traffic_office',
    ENTITIES_DEBT_COLLECTION_AGENCY: 'entities.debt_collection_agency',
    ENTITIES_EXPERT: 'entities.expert',
    ENTITIES_TAX_OFFICE: 'entities.tax_office',
    ENTITIES_LAND_REGISTRY: 'entities.land_registry',
    ENTITIES_BANK: 'entities.bank',
    ENTITIES_BUYER: 'entities.buyer',
    ENTITIES_DUNNING_COURT: 'entities.dunning_court',
    ENTITIES_ENFORCEMENT_COURT: 'entities.enforcement_court',
    ENTITIES_GENERAL_PROSECUTOR: 'entities.general_prosecutor',
    ENTITIES_SELLER: 'entities.seller',
    ENTITIES_EXPERT_COMMITTEE: 'entities.expert_committee',
    ENTITIES_MUNICIPALITY: 'entities.municipality',
    ENTITIES_ADMINISTRATOR: 'entities.administrator',
    ENTITIES_REGISTER_COURT: 'entities.register_court',
    ENTITIES_PROBATE_COURT: 'entities.probate_court',
    ENTITIES_REGISTRY_OFFICE: 'entities.registry_office',
    ENTITIES_HEREDITARY_LEASEHOLDER: 'entities.hereditary_leaseholder',
    ENTITIES_LEGAL_AID_COURT: 'entities.legal_aid_court',
    ENTITIES_SECONDARY_CLIENT: 'entities.secondary_client',
    ENTITIES_SECONDARY_OPPONENT: 'entities.secondary_opponent',
    ENTITIES_COURT_COMPLAINT: 'entities.court_complaint',
    ENTITIES_FINE_AUTHORITY: 'entities.fine_authority',
    ENTITIES_RESIDENT_REGISTRATION_OFFICE: 'entities.resident_registration_office',
    ENTITIES_INVESTIGATOR: 'entities.investigator',
    ENTITIES_BAILIFF: 'entities.bailiff',
    ENTITIES_INSOLVENCY_COURT: 'entities.insolvency_court',
    ENTITIES_INTEGRATION_OFFICE: 'entities.integration_office',
    ENTITIES_MAHN_COURT: 'entities.mahn_court',
    ENTITIES_EXECUTION_COURT: 'entities.execution_court',
    ENTITIES_EXECUTION_ORGAN: 'entities.execution_organ',
    ENTITIES_DEBTOR: 'entities.debtor',
    ENTITIES_CREDITOR: 'entities.creditor',
    ENTITIES_LESSEE: 'entities.lessee',
    ENTITIES_LESSOR: 'entities.lessor',
    ENTITIES_PRINCIPAL: 'entities.principal',
    ENTITIES_AUTHORIZED_REPRESENTATIVE: 'entities.authorized_representative',
    ENTITIES_TESTATOR: 'entities.testator',
    ENTITIES_HEIR: 'entities.heir',
    ENTITIES_PRELIMINARY_HEIR: 'entities.preliminary_heir',
    ENTITIES_SUBSEQUENT_HEIR: 'entities.subsequent_heir',
    ENTITIES_CURATOR_OF_THE_ESTATE: 'entities.curator_of_the_estate',
    ENTITIES_EXECUTOR_OF_THE_WILL: 'entities.executor_of_the_will',
    ENTITIES_ESTATE_ADMINISTRATOR: 'entities.estate_administrator',
    ENTITIES_COMPULSORY_PORTION_BENEFICIARY: 'entities.compulsory_portion_beneficiary',
    ENTITIES_NOTARY: 'entities.notary',
    ENTITIES_TRUSTEE: 'entities.trustee',
    ENTITIES_INSOLVENCY_ADMINISTRATOR: 'entities.insolvency_administrator'
} as const;

export type ReplaceableVariables = {
    placeholders?: PlaceholderValueSuggestions | null;
    blocks?: BlockEvaluation | null;
};

/**
 * * `LAWYER` - Anwalt
 * * `ADMIN` - Kanzlei-Administrator
 * * `CLERK` - Sachbearbeiter
 * * `CLIENT` - Mandant
 */
export type Role5ccEnum = 'LAWYER' | 'ADMIN' | 'CLERK' | 'CLIENT';

/**
 * * `LAWYER` - Anwalt
 * * `ADMIN` - Kanzlei-Administrator
 * * `CLERK` - Sachbearbeiter
 * * `CLIENT` - Mandant
 */
export const Role5ccEnum = {
    LAWYER: 'LAWYER',
    ADMIN: 'ADMIN',
    CLERK: 'CLERK',
    CLIENT: 'CLIENT'
} as const;

export type SchemaExternalIntegrationCaseCreationRequest = {
    integrationType: IntegrationTypeEnum;
    mandateId: number;
    integrationSpecificData: IntegrationSpecificDataRequest;
};

/**
 * * `READY` - Ready
 * * `UPDATING_CONTEXT` - Updating Context
 * * `SEARCHING_DOCUMENTS` - Searching Documents
 * * `REASONING` - Reasoning
 */
export type SessionStateEnum = 'READY' | 'UPDATING_CONTEXT' | 'SEARCHING_DOCUMENTS' | 'REASONING';

/**
 * * `READY` - Ready
 * * `UPDATING_CONTEXT` - Updating Context
 * * `SEARCHING_DOCUMENTS` - Searching Documents
 * * `REASONING` - Reasoning
 */
export const SessionStateEnum = {
    READY: 'READY',
    UPDATING_CONTEXT: 'UPDATING_CONTEXT',
    SEARCHING_DOCUMENTS: 'SEARCHING_DOCUMENTS',
    REASONING: 'REASONING'
} as const;

export type ShallowCaseData = {
    uuid?: string;
    client: ShallowEntity;
    opponent: ShallowEntity;
    law: ShallowLawData;
};

export type ShallowCaseDataRequest = {
    uuid?: string;
    client: ShallowEntityRequest;
    opponent: ShallowEntityRequest;
    law: ShallowLawDataRequest;
};

export type ShallowEntity = {
    uuid?: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    changes: Array<(number)>;
};

export type ShallowEntityRequest = {
    uuid?: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    changes: Array<(number)>;
};

export type ShallowLawData = {
    uuid?: string;
    readonly created_at: string;
    readonly updated_at: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_wanring_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

export type ShallowLawDataRequest = {
    uuid?: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_wanring_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

/**
 * * `NEW` - neu
 * * `IN_PROGRESS` - in Bearbeitung
 * * `COMPLETED` - abgeschlossen
 * * `REJECTED` - abgelehnt
 */
export type StateEnum = 'NEW' | 'IN_PROGRESS' | 'COMPLETED' | 'REJECTED';

/**
 * * `NEW` - neu
 * * `IN_PROGRESS` - in Bearbeitung
 * * `COMPLETED` - abgeschlossen
 * * `REJECTED` - abgelehnt
 */
export const StateEnum = {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED'
} as const;

/**
 * * `CONFIRMED` - Bestätigt
 * * `TENTATIVE` - Unbestätigt
 * * `CANCELLED` - Abgesagt
 * * `UNKNOWN` - Unbekannt
 */
export type Status6d9Enum = 'CONFIRMED' | 'TENTATIVE' | 'CANCELLED' | 'UNKNOWN';

/**
 * * `CONFIRMED` - Bestätigt
 * * `TENTATIVE` - Unbestätigt
 * * `CANCELLED` - Abgesagt
 * * `UNKNOWN` - Unbekannt
 */
export const Status6d9Enum = {
    CONFIRMED: 'CONFIRMED',
    TENTATIVE: 'TENTATIVE',
    CANCELLED: 'CANCELLED',
    UNKNOWN: 'UNKNOWN'
} as const;

export type StripeInvoiceExportRequestRequest = {
    month: number;
    year: number;
};

export type StripeInvoiceExportResponse = {
    success: boolean;
    error?: string;
    url?: string;
};

export type SuperUserAccount = {
    uuid?: string;
    account_id: string;
};

export type SuperUserAccountRequest = {
    uuid?: string;
    account_id: string;
};

export type SuperUserAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type SuperUserAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type SuperUserAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type SuperUserAiAugmentationRequest = {
    document: DocumentRequest;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * Appointment representation for superusers.
 */
export type SuperUserAppointment = {
    uuid?: string;
    readonly service: SuperUserService;
    readonly calendar: SuperUserCalendar;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type SuperUserAppointmentProposal = {
    uuid?: string;
    readonly service: SuperUserService;
    readonly calendar: SuperUserCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message: string | null;
    readonly channel: string | null;
};

export type SuperUserAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Appointment representation for superusers.
 */
export type SuperUserAppointmentRequest = {
    uuid?: string;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: Status6d9Enum;
};

export type SuperUserCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: SuperUserAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type SuperUserCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Call representation for super users.
 */
export type SuperUserCall = {
    readonly uuid: string;
    user_phone_number: string;
    phone_number_uuid: string;
    readonly phone_number: SuperUserPhoneNumber;
    retell_call_id?: string;
    /**
     * Return the URL of the audio recording of the call.
     */
    readonly audio_recording_url: string | null;
    /**
     * Return the URL of the langfuse traces of the call.
     */
    readonly langfuse_traces_url: string;
    /**
     * Return the URL of the retell dashboard of the call.
     */
    readonly retell_dashboard_url: string;
    /**
     * Return the URL of the twilio console of the call.
     */
    readonly twilio_console_url: string;
    readonly transcript: Array<CallTranscriptMessage>;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResult;
    readonly user_feedback: (SuperUserCallUserFeedback) | null;
    readonly lawyer_feedback: SuperUserLawyerFeedback;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    readonly case_uuid: string;
    readonly is_rated: boolean;
    had_caller_accent?: boolean | null;
};

/**
 * Call representation for super users.
 */
export type SuperUserCallRequest = {
    user_phone_number: string;
    phone_number_uuid: string;
    retell_call_id?: string;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResultRequest;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    had_caller_accent?: boolean | null;
};

export type SuperUserCallResult = {
    readonly uuid: string;
    classification: ClassificationEnum;
    inquiry?: string;
    data: ShallowCaseData;
    first_name_recording_start_seconds?: string | null;
    first_name_recording_end_seconds?: string | null;
    last_name_recording_start_seconds?: string | null;
    last_name_recording_end_seconds?: string | null;
    email_recording_start_seconds?: string | null;
    email_recording_end_seconds?: string | null;
    phone_number_recording_start_seconds?: string | null;
    phone_number_recording_end_seconds?: string | null;
};

export type SuperUserCallResultRequest = {
    classification: ClassificationEnum;
    inquiry?: string;
    data: ShallowCaseDataRequest;
    first_name_recording_start_seconds?: string | null;
    first_name_recording_end_seconds?: string | null;
    last_name_recording_start_seconds?: string | null;
    last_name_recording_end_seconds?: string | null;
    email_recording_start_seconds?: string | null;
    email_recording_end_seconds?: string | null;
    phone_number_recording_start_seconds?: string | null;
    phone_number_recording_end_seconds?: string | null;
};

/**
 * Call user feedback representation for super users.
 */
export type SuperUserCallUserFeedback = {
    readonly uuid: string;
    rating?: string | null;
    feedback?: string;
    would_call_again?: boolean;
    email?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    is_submitted?: boolean;
};

/**
 * Call user feedback representation for super users.
 */
export type SuperUserCallUserFeedbackRequest = {
    rating?: string | null;
    feedback?: string;
    would_call_again?: boolean;
    email?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    is_submitted?: boolean;
};

/**
 * Case representation for super users.
 */
export type SuperUserCase = {
    readonly id: number;
    readonly uuid: string;
    readonly questionnaire_submissions: Array<SuperUserQuestionnaireSubmission>;
    readonly form_requests: Array<SuperUserRequest>;
    readonly org: SuperUserOrganisation;
    readonly modified_at: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: SuperUserCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
    readonly documents: Array<Document>;
    readonly clerk: SuperUserOrganisationUser;
    readonly appointments: Array<SuperUserAppointment>;
    readonly appointment_proposals: Array<SuperUserAppointmentProposal>;
    readonly chat_sessions: Array<AIChatSession>;
};

export type SuperUserCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<SuperUserEntityWithRelationship>;
    readonly changes: Array<SuperUserCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type SuperUserCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: SuperUserOrganisationUser;
    ai_augmentation: SuperUserAiAugmentation;
};

export type SuperUserCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: SuperUserAiAugmentationRequest;
};

export type SuperUserCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Case representation for super users.
 */
export type SuperUserCaseRequest = {
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data: SuperUserCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
};

export type SuperUserDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type SuperUserDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type SuperUserEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
};

export type SuperUserEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<SuperUserQuestionnaire>;
    readonly forms: Array<SuperUserForm>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type SuperUserEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for super users.
 */
export type SuperUserEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<SuperUserEntityChange>;
};

export type SuperUserEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: SuperUserOrganisationUser;
    ai_augmentation: SuperUserAiAugmentation;
};

export type SuperUserEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: SuperUserAiAugmentationRequest;
};

/**
 * Entity representation for super users.
 */
export type SuperUserEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type SuperUserEntityWithRelationship = {
    uuid?: string;
    entity: SuperUserEntity;
    relationships: Array<EntityRelationship>;
};

export type SuperUserEntityWithRelationshipRequest = {
    uuid?: string;
    entity: SuperUserEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

export type SuperUserFeedback = {
    readonly uuid: string;
    readonly created_at: string;
    url: string;
    user: SuperUserUser;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

export type SuperUserFeedbackRequest = {
    url: string;
    user: SuperUserUserRequest;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

/**
 * Form representation for superusers.
 */
export type SuperUserForm = {
    readonly id: string;
    readonly organisation: SuperUserOrganisation;
    organisation_uuid: string;
    readonly created_at: string;
    readonly modified_at: string;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: string | null;
    readonly due_at: string;
};

/**
 * Form representation for superusers.
 */
export type SuperUserFormRequest = {
    organisation_uuid: string;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: (Blob | File) | null;
};

export type SuperUserHubSpotCompany = {
    readonly uuid: string;
    readonly hubspot_id: string | null;
    readonly hubspot_archived: boolean | null;
    readonly hubspot_archived_at: string | null;
    readonly hubspot_created_at: string | null;
    readonly hubspot_updated_at: string | null;
    readonly create_date: string | null;
    readonly domain: string | null;
    readonly hs_last_modified_date: string | null;
    readonly hs_object_id: string | null;
    readonly hubspot_url: string;
    readonly name: string | null;
};

export type SuperUserHubSpotContact = {
    readonly uuid: string;
    readonly hubspot_id: string | null;
    readonly hubspot_archived: boolean | null;
    readonly hubspot_archived_at: string | null;
    readonly hubspot_created_at: string | null;
    readonly hubspot_updated_at: string | null;
    readonly create_date: string | null;
    readonly email: string | null;
    readonly first_name: string | null;
    readonly hs_object_id: string | null;
    readonly last_modified_date: string | null;
    readonly last_name: string | null;
};

export type SuperUserInboundEmail = {
    uuid?: string;
    readonly email: SuperUserEmail;
    readonly created_at: string;
    readonly org: SuperUserOrganisation;
    is_failed?: boolean;
    readonly from_email: EmailAddress;
    readonly reply_to: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    subject: string;
    html: string;
    text: string;
    readonly attachments: Array<InboundEmailAttachment>;
};

export type SuperUserLawyerFeedback = {
    readonly uuid: string;
    rating: string;
    feedback?: string;
};

export type SuperUserLawyerFeedbackRequest = {
    rating: string;
    feedback?: string;
    call_uuid: string;
};

/**
 * Organisation representation for superusers.
 */
export type SuperUserOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    is_annotext_export_integration_enabled?: boolean;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    readonly stripe_customer: SuperUserStripeCustomer;
    stripe_customer_uuid: string | null;
    readonly customer_number: string;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    readonly hubspot_company: SuperUserHubSpotCompany;
    hubspot_company_uuid: string | null;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly users: Array<SuperUserOrganisationUser>;
    has_churned?: boolean;
    enable_law_specific_data?: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
    readonly vitally_id: string;
    readonly vitally_updated_at: string | null;
    readonly vitally_health_score: string | null;
};

/**
 * Organisation representation for superusers.
 */
export type SuperUserOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    is_annotext_export_integration_enabled?: boolean;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    stripe_customer_uuid: string | null;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    hubspot_company_uuid: string | null;
    has_churned?: boolean;
    enable_law_specific_data?: boolean;
};

export type SuperUserOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * PhoneNumber representation for superusers.
 */
export type SuperUserPhoneNumber = {
    uuid?: string;
    readonly created_at: string;
    active?: boolean;
    readonly org: SuperUserOrganisation;
    readonly phone_number: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * COMPATIBILITY: Return the old field name for the free initial consultation.
     */
    readonly free_initial_consultation: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    readonly phone_number_sid: string | null;
    readonly agent: SuperUserRetellAgent;
    readonly voice_url: string | null;
    readonly voice_method: string | null;
    readonly status_callback: string | null;
    readonly status_callback_method: string | null;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * PhoneNumber representation for superusers.
 */
export type SuperUserPhoneNumberRequest = {
    uuid?: string;
    active?: boolean;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    agent_uuid: string;
    org_uuid: string;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for superusers.
 */
export type SuperUserQuestionnaire = {
    readonly uuid: string;
    title: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
    enabled_all_orgs?: boolean;
    enabled_custom_orgs: Array<(string)>;
};

/**
 * Questionnaire representation for superusers.
 */
export type SuperUserQuestionnaireRequest = {
    title: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema: Array<QuestionnaireSectionRequest>;
    enabled_all_orgs?: boolean;
    enabled_custom_orgs: Array<(string)>;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type SuperUserQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type SuperUserQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type SuperUserRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
};

export type SuperUserRequestRequest = {
    token: string;
    form: string;
};

export type SuperUserRetellAgent = {
    readonly uuid: string;
    readonly retell_agent_id: string;
    readonly agent_name: string | null;
    readonly voice_id: string;
    readonly llm_websocket_url: string;
    readonly opt_out_sensitive_data_storage: boolean;
};

export type SuperUserService = {
    uuid?: string;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

export type SuperUserServiceRequest = {
    uuid?: string;
    active?: boolean;
    name: string;
    description: string;
    duration_mins?: DurationMinsEnum;
    buffer_mins?: BufferMinsEnum;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * StripeCustomer representation for superusers.
 */
export type SuperUserStripeCustomer = {
    readonly uuid: string;
    readonly stripe_id: string;
    readonly stripe_url: string;
    readonly created: string | null;
    readonly name: string | null;
    readonly email: string | null;
    readonly description: string | null;
};

/**
 * StripeInvoice representation for superusers.
 */
export type SuperUserStripeInvoice = {
    readonly uuid: string;
    readonly stripe_id: string;
    readonly created: string;
    readonly customer: SuperUserStripeCustomer;
    readonly amount_due: number;
    readonly currency: string;
    readonly description: string | null;
    readonly invoice_pdf: string | null;
};

/**
 * User representation for superusers.
 */
export type SuperUserUser = {
    uuid?: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: string | null;
    readonly org: SuperUserOrganisation;
    readonly uid: number;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
};

/**
 * User representation for superusers.
 */
export type SuperUserUserRequest = {
    uuid?: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
};

export type SuperUserWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: string | null;
    /**
     * AI-generated template with placeholders
     */
    ai_docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
    readonly org: ClientOrganisation;
};

export type SuperUserWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    docx_template?: (Blob | File) | null;
    /**
     * AI-generated template with placeholders
     */
    ai_docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type SwitchUniqueCaseDataRelationshipRequestRequest = {
    new_entity_relationship_which_should_hold_the_designated_relationship_uuid: string;
    case_data_uuid: string;
    relationship_type: RelationshipTypeEnum;
};

export type SwitchUniqueCaseDataRelationshipResponse = {
    new_entity_relationship_which_should_hold_the_designated_relationship: CustomerEntityWithRelationship;
    entity_relationship_currently_holding_the_designated_relationship: CustomerEntityWithRelationship;
};

export type TAIChatSession = AIChatSession;

export type TAIChatSessionRequest = AIChatSessionRequest;

export type TAccount = CustomerAccount | CustomerAdminAccount | SuperUserAccount;

export type TAccountRequest = CustomerAccountRequest | CustomerAdminAccountRequest | SuperUserAccountRequest;

export type TAiAnalysis = ClientAiAnalysis | CustomerAiAnalysis | CustomerAdminAiAnalysis | SuperUserAiAnalysis;

export type TAiAnalysisRequest = ClientAiAnalysisRequest | CustomerAiAnalysisRequest | CustomerAdminAiAnalysisRequest | SuperUserAiAnalysisRequest;

export type TAiAugmentation = ClientAiAugmentation | CustomerAiAugmentation | CustomerAdminAiAugmentation | SuperUserAiAugmentation;

export type TAiAugmentationRequest = ClientAiAugmentationRequest | CustomerAiAugmentationRequest | CustomerAdminAiAugmentationRequest | SuperUserAiAugmentationRequest;

export type TAiChatQuestionTemplate = AiChatQuestionTemplate;

export type TAiChatQuestionTemplateRequest = AiChatQuestionTemplateRequest;

export type TAppointment = CustomerAppointment | CustomerAdminAccount | SuperUserAccount;

export type TAppointmentProposal = CustomerAppointmentProposal | CustomerAdminAppointmentProposal | SuperUserAppointmentProposal;

export type TAppointmentProposalRequest = CustomerAppointmentProposalRequest | CustomerAdminAppointmentProposalRequest | SuperUserAppointmentProposalRequest;

export type TAppointmentRequest = CustomerAppointmentRequest | CustomerAdminAccountRequest | SuperUserAccountRequest;

export type TCalendar = CustomerCalendar | CustomerAdminCalendar | SuperUserCalendar;

export type TCalendarRequest = CustomerCalendarRequest | CustomerAdminCalendarRequest | SuperUserCalendarRequest;

export type TCall = CustomerCall | SuperUserCall;

export type TCallRequest = CustomerCallRequest | SuperUserCallRequest;

export type TCase = ClientCase | CustomerCase | CustomerAdminCase | SuperUserCase;

export type TCaseCreatorTempDocument = CaseCreatorTempDocument;

export type TCaseCreatorTempDocumentRequest = CaseCreatorTempDocumentRequest;

export type TCaseRequest = CustomerCaseRequest | CustomerAdminCaseRequest | SuperUserCaseRequest;

export type TDocument = Document;

export type TDocumentRequest = DocumentRequest;

export type TDocumentTemplate = CustomerDocumentTemplate | CustomerAdminDocumentTemplate | SuperUserDocumentTemplate;

export type TDocumentTemplateRequest = CustomerDocumentTemplateRequest | CustomerAdminDocumentTemplateRequest | SuperUserDocumentTemplateRequest;

export type TEmail = CustomerEmail | CustomerAdminEmail | SuperUserEmail;

export type TEmailTemplate = CustomerEmailTemplate | CustomerAdminEmailTemplate | SuperUserEmailTemplate;

export type TEmailTemplateRequest = CustomerEmailTemplateRequest | CustomerAdminEmailTemplateRequest | SuperUserEmailTemplateRequest;

export type TEntity = ClientEntity | CustomerEntity | CustomerAdminEntity | SuperUserEntity;

export type TEntityRemoveCaseDataRelationshipResponse = EntityRemoveCaseDataRelationshipCustomerResponse | EntityRemoveCaseDataRelationshipSuperUserResponse;

export type TEntityRequest = ClientEntityRequest | CustomerEntityRequest | CustomerAdminEntityRequest | SuperUserEntityRequest;

export type TEntityWithRelationship = CustomerEntityWithRelationship | CustomerAdminEntityWithRelationship | SuperUserEntityWithRelationship;

export type TFeedback = Feedback | SuperUserFeedback;

export type TFeedbackRequest = FeedbackRequest | SuperUserFeedbackRequest;

export type TForm = ClientForm | CustomerForm | CustomerAdminForm | SuperUserForm;

export type TFormRequest = SuperUserFormRequest;

export type TGenericDataMapper = GenericDataMapper;

export type TInboundEmail = SuperUserInboundEmail;

export type TLawyerFeedback = LawyerFeedback | CustomerLawyerFeedback | SuperUserLawyerFeedback;

export type TLawyerFeedbackRequest = CustomerLawyerFeedbackRequest | SuperUserLawyerFeedbackRequest;

export type TOrganisation = ClientOrganisation | CustomerOrganisation | CustomerAdminOrganisation | SuperUserOrganisation;

export type TOrganisationRequest = CustomerOrganisationRequest | CustomerAdminOrganisationRequest | SuperUserOrganisationRequest;

export type TPhoneNumber = CustomerPhoneNumber | CustomerAdminPhoneNumber | SuperUserPhoneNumber;

export type TPhoneNumberRequest = CustomerAdminPhoneNumberRequest | SuperUserPhoneNumberRequest;

export type TQuestionnaire = CustomerQuestionnaire | CustomerAdminQuestionnaire | SuperUserQuestionnaire;

export type TQuestionnaireRequest = CustomerQuestionnaireRequest | CustomerAdminQuestionnaireRequest | SuperUserQuestionnaireRequest;

export type TQuestionnaireSubmission = ClientQuestionnaireSubmission | CustomerQuestionnaireSubmission | CustomerAdminQuestionnaireSubmission | SuperUserQuestionnaireSubmission;

export type TQuestionnaireSubmissionRequest = ClientQuestionnaireSubmissionRequest | CustomerQuestionnaireSubmissionRequest | CustomerAdminQuestionnaireSubmissionRequest | SuperUserQuestionnaireSubmissionRequest;

export type TRetellAgent = SuperUserRetellAgent;

export type TRetellAgentRequest = unknown;

export type TService = CustomerService | CustomerAdminService | SuperUserService;

export type TServiceRequest = CustomerServiceRequest | CustomerAdminServiceRequest | SuperUserServiceRequest;

export type TStripeCustomer = SuperUserStripeCustomer;

export type TStripeCustomerRequest = unknown;

export type TStripeInvoice = SuperUserStripeInvoice;

export type TStripeInvoiceRequest = unknown;

export type TSwitchUniqueCaseDataRelationshipResponse = SwitchUniqueCaseDataRelationshipResponse;

export type TUser = CustomerUser | CustomerAdminUser | SuperUserUser;

export type TUserRequest = CustomerUserRequest | CustomerAdminUserRequest | SuperUserUserRequest;

export type TWordDocumentTemplate = CustomerWordDocumentTemplate | CustomerAdminWordDocumentTemplate | SuperUserWordDocumentTemplate;

export type TWordDocumentTemplateRequest = CustomerWordDocumentTemplateRequest | CustomerAdminWordDocumentTemplateRequest | SuperUserWordDocumentTemplateRequest;

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.prosecuting_office` - Prosecuting Office
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.expert_witness` - Expert Witness
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.mahn_court` - Mahn Court
 * * `entities.execution_court` - Execution Court
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 */
export type TagRelationshipEnum = 'entities.opponent' | 'entities.client' | 'entities.other' | 'entities.labor_law_employee' | 'entities.labor_law_employer' | 'entities.witness' | 'entities.at_fault_driver' | 'entities.victim_driver' | 'entities.accused' | 'entities.defendant' | 'entities.plaintiff' | 'entities.complaint' | 'entities.victim' | 'entities.vehicle_expert' | 'entities.agency' | 'entities.vehicle_owner' | 'entities.insurance' | 'entities.driver' | 'entities.police_officer' | 'entities.police_station' | 'entities.judge' | 'entities.court' | 'entities.prosecutor' | 'entities.prosecuting_office' | 'entities.opposing_counsel' | 'entities.expert_witness' | 'entities.co_plaintiff' | 'entities.probation_officer' | 'entities.tenant' | 'entities.landlord' | 'entities.subtenant' | 'entities.owner' | 'entities.property_management' | 'entities.real_estate_agent' | 'entities.guarantor' | 'entities.co_owner' | 'entities.co_tenant' | 'entities.tenants_association' | 'entities.property_owners_association' | 'entities.complainant' | 'entities.applicant' | 'entities.respondent' | 'entities.child' | 'entities.officiant' | 'entities.wife' | 'entities.husband' | 'entities.legal_representative' | 'entities.korrespondence_lawyer' | 'entities.opposing_lawyer' | 'entities.lawyer' | 'entities.legal_expenses_insurance' | 'entities.liability_insurance' | 'entities.first_instance_court' | 'entities.second_instance_court' | 'entities.third_instance_court' | 'entities.contact_person' | 'entities.public_prosecutor' | 'entities.third_party_debtor' | 'entities.road_traffic_office' | 'entities.debt_collection_agency' | 'entities.expert' | 'entities.tax_office' | 'entities.land_registry' | 'entities.bank' | 'entities.buyer' | 'entities.dunning_court' | 'entities.enforcement_court' | 'entities.general_prosecutor' | 'entities.seller' | 'entities.expert_committee' | 'entities.municipality' | 'entities.administrator' | 'entities.register_court' | 'entities.probate_court' | 'entities.registry_office' | 'entities.hereditary_leaseholder' | 'entities.legal_aid_court' | 'entities.secondary_client' | 'entities.secondary_opponent' | 'entities.court_complaint' | 'entities.fine_authority' | 'entities.resident_registration_office' | 'entities.investigator' | 'entities.bailiff' | 'entities.insolvency_court' | 'entities.integration_office' | 'entities.mahn_court' | 'entities.execution_court' | 'entities.execution_organ' | 'entities.debtor' | 'entities.creditor' | 'entities.lessee' | 'entities.lessor' | 'entities.principal' | 'entities.authorized_representative' | 'entities.testator' | 'entities.heir' | 'entities.preliminary_heir' | 'entities.subsequent_heir' | 'entities.curator_of_the_estate' | 'entities.executor_of_the_will' | 'entities.estate_administrator' | 'entities.compulsory_portion_beneficiary' | 'entities.notary' | 'entities.trustee' | 'entities.insolvency_administrator';

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.prosecuting_office` - Prosecuting Office
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.expert_witness` - Expert Witness
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.mahn_court` - Mahn Court
 * * `entities.execution_court` - Execution Court
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 */
export const TagRelationshipEnum = {
    ENTITIES_OPPONENT: 'entities.opponent',
    ENTITIES_CLIENT: 'entities.client',
    ENTITIES_OTHER: 'entities.other',
    ENTITIES_LABOR_LAW_EMPLOYEE: 'entities.labor_law_employee',
    ENTITIES_LABOR_LAW_EMPLOYER: 'entities.labor_law_employer',
    ENTITIES_WITNESS: 'entities.witness',
    ENTITIES_AT_FAULT_DRIVER: 'entities.at_fault_driver',
    ENTITIES_VICTIM_DRIVER: 'entities.victim_driver',
    ENTITIES_ACCUSED: 'entities.accused',
    ENTITIES_DEFENDANT: 'entities.defendant',
    ENTITIES_PLAINTIFF: 'entities.plaintiff',
    ENTITIES_COMPLAINT: 'entities.complaint',
    ENTITIES_VICTIM: 'entities.victim',
    ENTITIES_VEHICLE_EXPERT: 'entities.vehicle_expert',
    ENTITIES_AGENCY: 'entities.agency',
    ENTITIES_VEHICLE_OWNER: 'entities.vehicle_owner',
    ENTITIES_INSURANCE: 'entities.insurance',
    ENTITIES_DRIVER: 'entities.driver',
    ENTITIES_POLICE_OFFICER: 'entities.police_officer',
    ENTITIES_POLICE_STATION: 'entities.police_station',
    ENTITIES_JUDGE: 'entities.judge',
    ENTITIES_COURT: 'entities.court',
    ENTITIES_PROSECUTOR: 'entities.prosecutor',
    ENTITIES_PROSECUTING_OFFICE: 'entities.prosecuting_office',
    ENTITIES_OPPOSING_COUNSEL: 'entities.opposing_counsel',
    ENTITIES_EXPERT_WITNESS: 'entities.expert_witness',
    ENTITIES_CO_PLAINTIFF: 'entities.co_plaintiff',
    ENTITIES_PROBATION_OFFICER: 'entities.probation_officer',
    ENTITIES_TENANT: 'entities.tenant',
    ENTITIES_LANDLORD: 'entities.landlord',
    ENTITIES_SUBTENANT: 'entities.subtenant',
    ENTITIES_OWNER: 'entities.owner',
    ENTITIES_PROPERTY_MANAGEMENT: 'entities.property_management',
    ENTITIES_REAL_ESTATE_AGENT: 'entities.real_estate_agent',
    ENTITIES_GUARANTOR: 'entities.guarantor',
    ENTITIES_CO_OWNER: 'entities.co_owner',
    ENTITIES_CO_TENANT: 'entities.co_tenant',
    ENTITIES_TENANTS_ASSOCIATION: 'entities.tenants_association',
    ENTITIES_PROPERTY_OWNERS_ASSOCIATION: 'entities.property_owners_association',
    ENTITIES_COMPLAINANT: 'entities.complainant',
    ENTITIES_APPLICANT: 'entities.applicant',
    ENTITIES_RESPONDENT: 'entities.respondent',
    ENTITIES_CHILD: 'entities.child',
    ENTITIES_OFFICIANT: 'entities.officiant',
    ENTITIES_WIFE: 'entities.wife',
    ENTITIES_HUSBAND: 'entities.husband',
    ENTITIES_LEGAL_REPRESENTATIVE: 'entities.legal_representative',
    ENTITIES_KORRESPONDENCE_LAWYER: 'entities.korrespondence_lawyer',
    ENTITIES_OPPOSING_LAWYER: 'entities.opposing_lawyer',
    ENTITIES_LAWYER: 'entities.lawyer',
    ENTITIES_LEGAL_EXPENSES_INSURANCE: 'entities.legal_expenses_insurance',
    ENTITIES_LIABILITY_INSURANCE: 'entities.liability_insurance',
    ENTITIES_FIRST_INSTANCE_COURT: 'entities.first_instance_court',
    ENTITIES_SECOND_INSTANCE_COURT: 'entities.second_instance_court',
    ENTITIES_THIRD_INSTANCE_COURT: 'entities.third_instance_court',
    ENTITIES_CONTACT_PERSON: 'entities.contact_person',
    ENTITIES_PUBLIC_PROSECUTOR: 'entities.public_prosecutor',
    ENTITIES_THIRD_PARTY_DEBTOR: 'entities.third_party_debtor',
    ENTITIES_ROAD_TRAFFIC_OFFICE: 'entities.road_traffic_office',
    ENTITIES_DEBT_COLLECTION_AGENCY: 'entities.debt_collection_agency',
    ENTITIES_EXPERT: 'entities.expert',
    ENTITIES_TAX_OFFICE: 'entities.tax_office',
    ENTITIES_LAND_REGISTRY: 'entities.land_registry',
    ENTITIES_BANK: 'entities.bank',
    ENTITIES_BUYER: 'entities.buyer',
    ENTITIES_DUNNING_COURT: 'entities.dunning_court',
    ENTITIES_ENFORCEMENT_COURT: 'entities.enforcement_court',
    ENTITIES_GENERAL_PROSECUTOR: 'entities.general_prosecutor',
    ENTITIES_SELLER: 'entities.seller',
    ENTITIES_EXPERT_COMMITTEE: 'entities.expert_committee',
    ENTITIES_MUNICIPALITY: 'entities.municipality',
    ENTITIES_ADMINISTRATOR: 'entities.administrator',
    ENTITIES_REGISTER_COURT: 'entities.register_court',
    ENTITIES_PROBATE_COURT: 'entities.probate_court',
    ENTITIES_REGISTRY_OFFICE: 'entities.registry_office',
    ENTITIES_HEREDITARY_LEASEHOLDER: 'entities.hereditary_leaseholder',
    ENTITIES_LEGAL_AID_COURT: 'entities.legal_aid_court',
    ENTITIES_SECONDARY_CLIENT: 'entities.secondary_client',
    ENTITIES_SECONDARY_OPPONENT: 'entities.secondary_opponent',
    ENTITIES_COURT_COMPLAINT: 'entities.court_complaint',
    ENTITIES_FINE_AUTHORITY: 'entities.fine_authority',
    ENTITIES_RESIDENT_REGISTRATION_OFFICE: 'entities.resident_registration_office',
    ENTITIES_INVESTIGATOR: 'entities.investigator',
    ENTITIES_BAILIFF: 'entities.bailiff',
    ENTITIES_INSOLVENCY_COURT: 'entities.insolvency_court',
    ENTITIES_INTEGRATION_OFFICE: 'entities.integration_office',
    ENTITIES_MAHN_COURT: 'entities.mahn_court',
    ENTITIES_EXECUTION_COURT: 'entities.execution_court',
    ENTITIES_EXECUTION_ORGAN: 'entities.execution_organ',
    ENTITIES_DEBTOR: 'entities.debtor',
    ENTITIES_CREDITOR: 'entities.creditor',
    ENTITIES_LESSEE: 'entities.lessee',
    ENTITIES_LESSOR: 'entities.lessor',
    ENTITIES_PRINCIPAL: 'entities.principal',
    ENTITIES_AUTHORIZED_REPRESENTATIVE: 'entities.authorized_representative',
    ENTITIES_TESTATOR: 'entities.testator',
    ENTITIES_HEIR: 'entities.heir',
    ENTITIES_PRELIMINARY_HEIR: 'entities.preliminary_heir',
    ENTITIES_SUBSEQUENT_HEIR: 'entities.subsequent_heir',
    ENTITIES_CURATOR_OF_THE_ESTATE: 'entities.curator_of_the_estate',
    ENTITIES_EXECUTOR_OF_THE_WILL: 'entities.executor_of_the_will',
    ENTITIES_ESTATE_ADMINISTRATOR: 'entities.estate_administrator',
    ENTITIES_COMPULSORY_PORTION_BENEFICIARY: 'entities.compulsory_portion_beneficiary',
    ENTITIES_NOTARY: 'entities.notary',
    ENTITIES_TRUSTEE: 'entities.trustee',
    ENTITIES_INSOLVENCY_ADMINISTRATOR: 'entities.insolvency_administrator'
} as const;

/**
 * * `` -
 * * `Herr` - Herr
 * * `Frau` - Frau
 * * `Divers` - Divers
 */
export type TitleEnum = 'Herr' | 'Frau' | 'Divers';

/**
 * * `` -
 * * `Herr` - Herr
 * * `Frau` - Frau
 * * `Divers` - Divers
 */
export const TitleEnum = {
    HERR: 'Herr',
    FRAU: 'Frau',
    DIVERS: 'Divers'
} as const;

/**
 * * `AGB` - Agb
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung Nicht Eingehalten
 * * `Account hacking` - Account Hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/Alg/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft Prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto Leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung Zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag Löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren Ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren Unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung Löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy Am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil Abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz Einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht Und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall Mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß Gegen Die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - Unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - Unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung Zu Lebzeiten
 */
export type TopicEnum = 'AGB' | 'Abfindung' | 'Abmahnung' | 'Abmahnung Wettbewerbsrecht' | 'Abschiebungshaft' | 'Abschlussarbeit' | 'Abstandsregelung nicht eingehalten' | 'Account hacking' | 'Allgemein' | 'Allgemeines Prüfungsrecht' | 'Anderes' | 'Arbeitsamt/ALG/Sperrzeit' | 'Arbeitsunfall' | 'Arbeitsvertrag' | 'Arbeitszeugnis' | 'Aufbau Compliancesystem' | 'Aufenthaltserlaubnis' | 'Aufhebungsvertrag' | 'Auftragsdatenverarbeitung' | 'Auseinandersetzung Erbengemeinschaft' | 'Auskunft prüfen' | 'Ausweisung' | 'Autokauf' | 'Bankkonto leergeräumt' | 'Bankrecht' | 'Baumangel' | 'Bauvertrag' | 'Behandlungsfehler Allgemein' | 'Behandlungsfehler Querschnittslähmung' | 'Behandlungsfehler Schlaganfall' | 'Beißvorfall' | 'Beratung zu Erbfall' | 'Beschlagnahme Allgemein' | 'Beschlagnahme Tierquälerei' | 'Betreuungsrecht' | 'Betrug Geldanlage' | 'Betäubungsmittel' | 'Burgschild Inkasso' | 'Bußgeldbescheid' | 'Bürgergeld' | 'Coaching' | 'Datenschutz' | 'Datenschutz Schadensersatz' | 'Datenschutzverstoß' | 'Domains' | 'Ehevertrag' | 'Eigentumsdelikte' | 'Einbürgerung' | 'Einreisesperre' | 'Eintrag löschen' | 'Erbauseinandersetzung' | 'Erbausschlagung' | 'Erben/Schenken' | 'Erbengemeinschaft' | 'Erbschein' | 'Erbscheinsantrag' | 'Erbvertrag' | 'Exmatrikulation' | 'Fahren ohne Führerschein' | 'Fahren unter Alkohol - / Drogeneinfluss' | 'Fahrer - / Unfallflucht' | 'Fahrverbot / Führerscheinentzug' | 'Falschaussage/ Meineid' | 'Familie Vorsorge' | 'Forderung löschen' | 'Geburtsfehler' | 'Geburtsfehler Mutter' | 'Geschwindigkeitsüberschreitung' | 'Gesetzliche Erbfolge' | 'Gewerblicher Rechtsschutz' | 'Grundschuld' | 'Gründung' | 'Handy am Steuer' | 'Hauskauf' | 'Härtefallantrag' | 'Immobilien' | 'Immobilienübertragung' | 'Kaufvertragsprüfung' | 'Körperverletzung' | 'Kündigung' | 'Lohnzahlung' | 'Maklerangelegenheit' | 'Markenanmeldung' | 'Markenverteidigung' | 'Markenüberwachung' | 'Mieterhöhung' | 'Mietkaution' | 'Mietminderung' | 'Mietvertrag' | 'Nebenkostenabrechnung' | 'Niederlassungserlaubnis' | 'Nutzerbewertungen Verfasser' | 'Patientenverfügung/Vorsorgevollmacht' | 'Personenverwechselung' | 'Pflege-/Krankenversicherung' | 'Pflichtteil' | 'Pflichtteil Geltendmachung' | 'Pflichtteil abwehren' | 'Plagiatsvorwurf' | 'Remonstration' | 'Rente' | 'Rotlichtverstoß' | 'Räumungsklage' | 'Schadensersatz' | 'Scheidung' | 'Schenkung' | 'Schenkung Immobilie' | 'Schulplatz einklagen' | 'Schwerbehinderung' | 'Sexualdelikt' | 'Software Hardware' | 'Sonstige Beglaubigung' | 'Sorgerecht und Umgangsrecht' | 'Testament' | 'Testament/Erbvertrag' | 'Tierkauf' | 'Tierärztliche Behandlungsfehler' | 'Trennung' | 'Tuning' | 'Täuschungsversuch' | 'Tötungsdelikte' | 'Unfall Querschnittslähmung' | 'Unfall mit Personenschaden' | 'Unterhalt' | 'Unternehmen' | 'Unternehmensauflösung' | 'Unternehmensgründung' | 'Unternehmenskauf' | 'Urheberrecht' | 'Urlaub' | 'Vaterschaftsanerkennung' | 'Vererben' | 'Verkehrsunfall' | 'Vermögensauseinandersetzung' | 'Vermögensdelikte' | 'Verstoß gegen die Anschnallpflicht' | 'Vertragsprüfung' | 'Vertragsrecht' | 'Visum' | 'Vorfälligkeitsentschädigung' | 'Vorsorge' | 'Vorsorgevollmacht/Patientenverfügung' | 'Waffendelikte' | 'Wettbewerbsrecht' | 'Widerrufsrechte' | 'Widerspruch/ Klage' | 'Wucherzinsen Darlehen' | 'Zugewinnausgleich' | 'Zweiradunfall' | 'unbezahlte Rechnungen' | 'unerlaubtes Glücksspiel' | 'Überstunden' | 'Übertragung zu Lebzeiten';

/**
 * * `AGB` - Agb
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung Nicht Eingehalten
 * * `Account hacking` - Account Hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/Alg/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft Prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto Leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung Zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag Löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren Ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren Unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung Löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy Am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil Abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz Einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht Und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall Mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß Gegen Die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - Unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - Unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung Zu Lebzeiten
 */
export const TopicEnum = {
    AGB: 'AGB',
    ABFINDUNG: 'Abfindung',
    ABMAHNUNG: 'Abmahnung',
    ABMAHNUNG_WETTBEWERBSRECHT: 'Abmahnung Wettbewerbsrecht',
    ABSCHIEBUNGSHAFT: 'Abschiebungshaft',
    ABSCHLUSSARBEIT: 'Abschlussarbeit',
    ABSTANDSREGELUNG_NICHT_EINGEHALTEN: 'Abstandsregelung nicht eingehalten',
    ACCOUNT_HACKING: 'Account hacking',
    ALLGEMEIN: 'Allgemein',
    'ALLGEMEINES_PRÜFUNGSRECHT': 'Allgemeines Prüfungsrecht',
    ANDERES: 'Anderes',
    ARBEITSAMT_ALG_SPERRZEIT: 'Arbeitsamt/ALG/Sperrzeit',
    ARBEITSUNFALL: 'Arbeitsunfall',
    ARBEITSVERTRAG: 'Arbeitsvertrag',
    ARBEITSZEUGNIS: 'Arbeitszeugnis',
    AUFBAU_COMPLIANCESYSTEM: 'Aufbau Compliancesystem',
    AUFENTHALTSERLAUBNIS: 'Aufenthaltserlaubnis',
    AUFHEBUNGSVERTRAG: 'Aufhebungsvertrag',
    AUFTRAGSDATENVERARBEITUNG: 'Auftragsdatenverarbeitung',
    AUSEINANDERSETZUNG_ERBENGEMEINSCHAFT: 'Auseinandersetzung Erbengemeinschaft',
    'AUSKUNFT_PRÜFEN': 'Auskunft prüfen',
    AUSWEISUNG: 'Ausweisung',
    AUTOKAUF: 'Autokauf',
    'BANKKONTO_LEERGERÄUMT': 'Bankkonto leergeräumt',
    BANKRECHT: 'Bankrecht',
    BAUMANGEL: 'Baumangel',
    BAUVERTRAG: 'Bauvertrag',
    BEHANDLUNGSFEHLER_ALLGEMEIN: 'Behandlungsfehler Allgemein',
    'BEHANDLUNGSFEHLER_QUERSCHNITTSLÄHMUNG': 'Behandlungsfehler Querschnittslähmung',
    BEHANDLUNGSFEHLER_SCHLAGANFALL: 'Behandlungsfehler Schlaganfall',
    BEISSVORFALL: 'Beißvorfall',
    BERATUNG_ZU_ERBFALL: 'Beratung zu Erbfall',
    BESCHLAGNAHME_ALLGEMEIN: 'Beschlagnahme Allgemein',
    'BESCHLAGNAHME_TIERQUÄLEREI': 'Beschlagnahme Tierquälerei',
    BETREUUNGSRECHT: 'Betreuungsrecht',
    BETRUG_GELDANLAGE: 'Betrug Geldanlage',
    'BETÄUBUNGSMITTEL': 'Betäubungsmittel',
    BURGSCHILD_INKASSO: 'Burgschild Inkasso',
    BUSSGELDBESCHEID: 'Bußgeldbescheid',
    'BÜRGERGELD': 'Bürgergeld',
    COACHING: 'Coaching',
    DATENSCHUTZ: 'Datenschutz',
    DATENSCHUTZ_SCHADENSERSATZ: 'Datenschutz Schadensersatz',
    DATENSCHUTZVERSTOSS: 'Datenschutzverstoß',
    DOMAINS: 'Domains',
    EHEVERTRAG: 'Ehevertrag',
    EIGENTUMSDELIKTE: 'Eigentumsdelikte',
    'EINBÜRGERUNG': 'Einbürgerung',
    EINREISESPERRE: 'Einreisesperre',
    'EINTRAG_LÖSCHEN': 'Eintrag löschen',
    ERBAUSEINANDERSETZUNG: 'Erbauseinandersetzung',
    ERBAUSSCHLAGUNG: 'Erbausschlagung',
    ERBEN_SCHENKEN: 'Erben/Schenken',
    ERBENGEMEINSCHAFT: 'Erbengemeinschaft',
    ERBSCHEIN: 'Erbschein',
    ERBSCHEINSANTRAG: 'Erbscheinsantrag',
    ERBVERTRAG: 'Erbvertrag',
    EXMATRIKULATION: 'Exmatrikulation',
    'FAHREN_OHNE_FÜHRERSCHEIN': 'Fahren ohne Führerschein',
    FAHREN_UNTER_ALKOHOL_____DROGENEINFLUSS: 'Fahren unter Alkohol - / Drogeneinfluss',
    FAHRER_____UNFALLFLUCHT: 'Fahrer - / Unfallflucht',
    'FAHRVERBOT___FÜHRERSCHEINENTZUG': 'Fahrverbot / Führerscheinentzug',
    FALSCHAUSSAGE__MEINEID: 'Falschaussage/ Meineid',
    FAMILIE_VORSORGE: 'Familie Vorsorge',
    'FORDERUNG_LÖSCHEN': 'Forderung löschen',
    GEBURTSFEHLER: 'Geburtsfehler',
    GEBURTSFEHLER_MUTTER: 'Geburtsfehler Mutter',
    'GESCHWINDIGKEITSÜBERSCHREITUNG': 'Geschwindigkeitsüberschreitung',
    GESETZLICHE_ERBFOLGE: 'Gesetzliche Erbfolge',
    GEWERBLICHER_RECHTSSCHUTZ: 'Gewerblicher Rechtsschutz',
    GRUNDSCHULD: 'Grundschuld',
    'GRÜNDUNG': 'Gründung',
    HANDY_AM_STEUER: 'Handy am Steuer',
    HAUSKAUF: 'Hauskauf',
    'HÄRTEFALLANTRAG': 'Härtefallantrag',
    IMMOBILIEN: 'Immobilien',
    'IMMOBILIENÜBERTRAGUNG': 'Immobilienübertragung',
    'KAUFVERTRAGSPRÜFUNG': 'Kaufvertragsprüfung',
    'KÖRPERVERLETZUNG': 'Körperverletzung',
    'KÜNDIGUNG': 'Kündigung',
    LOHNZAHLUNG: 'Lohnzahlung',
    MAKLERANGELEGENHEIT: 'Maklerangelegenheit',
    MARKENANMELDUNG: 'Markenanmeldung',
    MARKENVERTEIDIGUNG: 'Markenverteidigung',
    'MARKENÜBERWACHUNG': 'Markenüberwachung',
    'MIETERHÖHUNG': 'Mieterhöhung',
    MIETKAUTION: 'Mietkaution',
    MIETMINDERUNG: 'Mietminderung',
    MIETVERTRAG: 'Mietvertrag',
    NEBENKOSTENABRECHNUNG: 'Nebenkostenabrechnung',
    NIEDERLASSUNGSERLAUBNIS: 'Niederlassungserlaubnis',
    NUTZERBEWERTUNGEN_VERFASSER: 'Nutzerbewertungen Verfasser',
    'PATIENTENVERFÜGUNG_VORSORGEVOLLMACHT': 'Patientenverfügung/Vorsorgevollmacht',
    PERSONENVERWECHSELUNG: 'Personenverwechselung',
    PFLEGE__KRANKENVERSICHERUNG: 'Pflege-/Krankenversicherung',
    PFLICHTTEIL: 'Pflichtteil',
    PFLICHTTEIL_GELTENDMACHUNG: 'Pflichtteil Geltendmachung',
    PFLICHTTEIL_ABWEHREN: 'Pflichtteil abwehren',
    PLAGIATSVORWURF: 'Plagiatsvorwurf',
    REMONSTRATION: 'Remonstration',
    RENTE: 'Rente',
    ROTLICHTVERSTOSS: 'Rotlichtverstoß',
    'RÄUMUNGSKLAGE': 'Räumungsklage',
    SCHADENSERSATZ: 'Schadensersatz',
    SCHEIDUNG: 'Scheidung',
    SCHENKUNG: 'Schenkung',
    SCHENKUNG_IMMOBILIE: 'Schenkung Immobilie',
    SCHULPLATZ_EINKLAGEN: 'Schulplatz einklagen',
    SCHWERBEHINDERUNG: 'Schwerbehinderung',
    SEXUALDELIKT: 'Sexualdelikt',
    SOFTWARE_HARDWARE: 'Software Hardware',
    SONSTIGE_BEGLAUBIGUNG: 'Sonstige Beglaubigung',
    SORGERECHT_UND_UMGANGSRECHT: 'Sorgerecht und Umgangsrecht',
    TESTAMENT: 'Testament',
    TESTAMENT_ERBVERTRAG: 'Testament/Erbvertrag',
    TIERKAUF: 'Tierkauf',
    'TIERÄRZTLICHE_BEHANDLUNGSFEHLER': 'Tierärztliche Behandlungsfehler',
    TRENNUNG: 'Trennung',
    TUNING: 'Tuning',
    'TÄUSCHUNGSVERSUCH': 'Täuschungsversuch',
    'TÖTUNGSDELIKTE': 'Tötungsdelikte',
    'UNFALL_QUERSCHNITTSLÄHMUNG': 'Unfall Querschnittslähmung',
    UNFALL_MIT_PERSONENSCHADEN: 'Unfall mit Personenschaden',
    UNTERHALT: 'Unterhalt',
    UNTERNEHMEN: 'Unternehmen',
    'UNTERNEHMENSAUFLÖSUNG': 'Unternehmensauflösung',
    'UNTERNEHMENSGRÜNDUNG': 'Unternehmensgründung',
    UNTERNEHMENSKAUF: 'Unternehmenskauf',
    URHEBERRECHT: 'Urheberrecht',
    URLAUB: 'Urlaub',
    VATERSCHAFTSANERKENNUNG: 'Vaterschaftsanerkennung',
    VERERBEN: 'Vererben',
    VERKEHRSUNFALL: 'Verkehrsunfall',
    'VERMÖGENSAUSEINANDERSETZUNG': 'Vermögensauseinandersetzung',
    'VERMÖGENSDELIKTE': 'Vermögensdelikte',
    VERSTOSS_GEGEN_DIE_ANSCHNALLPFLICHT: 'Verstoß gegen die Anschnallpflicht',
    'VERTRAGSPRÜFUNG': 'Vertragsprüfung',
    VERTRAGSRECHT: 'Vertragsrecht',
    VISUM: 'Visum',
    'VORFÄLLIGKEITSENTSCHÄDIGUNG': 'Vorfälligkeitsentschädigung',
    VORSORGE: 'Vorsorge',
    'VORSORGEVOLLMACHT_PATIENTENVERFÜGUNG': 'Vorsorgevollmacht/Patientenverfügung',
    WAFFENDELIKTE: 'Waffendelikte',
    WETTBEWERBSRECHT: 'Wettbewerbsrecht',
    WIDERRUFSRECHTE: 'Widerrufsrechte',
    WIDERSPRUCH__KLAGE: 'Widerspruch/ Klage',
    WUCHERZINSEN_DARLEHEN: 'Wucherzinsen Darlehen',
    ZUGEWINNAUSGLEICH: 'Zugewinnausgleich',
    ZWEIRADUNFALL: 'Zweiradunfall',
    UNBEZAHLTE_RECHNUNGEN: 'unbezahlte Rechnungen',
    'UNERLAUBTES_GLÜCKSSPIEL': 'unerlaubtes Glücksspiel',
    'ÜBERSTUNDEN': 'Überstunden',
    'ÜBERTRAGUNG_ZU_LEBZEITEN': 'Übertragung zu Lebzeiten'
} as const;

export type TrackingEventRequest = {
    user: string;
    name: string;
    organization_uuid: string;
};

export type UUIDCaseCreatorEntity = {
    entity_type: EntityTypeC7aEnum;
    company_legal_form?: UUIDCaseCreatorEntityCompanyLegalFormEnum | BlankEnum | null;
    company_name?: string | null;
    institution_name?: string | null;
    title?: TitleEnum | BlankEnum | null;
    first_name?: string | null;
    last_name?: string | null;
    phone?: string | null;
    email?: string | null;
    date_of_birth?: string | null;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string | null;
    legal_insurance_name?: string | null;
    uuid: string;
    document_uuid?: string | null;
};

export type UUIDCaseCreatorEntityCompanyLegalFormEnum = 'GmbH' | 'UG' | 'GmbH & Co. KG' | 'GBR' | 'OHG' | 'KG' | 'AG' | 'SE' | 'eG' | 'eV' | 'AG & Co. KG';

export const UUIDCaseCreatorEntityCompanyLegalFormEnum = {
    GMB_H: 'GmbH',
    UG: 'UG',
    GMB_H___CO__KG: 'GmbH & Co. KG',
    GBR: 'GBR',
    OHG: 'OHG',
    KG: 'KG',
    AG: 'AG',
    SE: 'SE',
    E_G: 'eG',
    E_V: 'eV',
    AG___CO__KG: 'AG & Co. KG'
} as const;

export type UUIDExtractedLawData = {
    law_field?: (LawFieldEnum) | null;
    law_topic?: (LawTopicEnum) | null;
    uuid: string;
    document_uuid?: string | null;
};

export type UUIDExtractionResult = {
    extracted_entities: UUIDCaseCreatorEntity;
    extracted_law_data?: UUIDExtractedLawData | null;
};

/**
 * * `None` - Not Set
 * * `Chatbot Upload` - Chatbot
 * * `Email Anhang` - Email
 * * `Terminbuchung` - Appointment
 * * `Fragebogen` - Questionnaire
 * * `Manuell hinzugefügt` - Manual
 * * `AI CASE CHAT` - Ai Case Chat
 */
export type UploadOriginEnum = 'None' | 'Chatbot Upload' | 'Email Anhang' | 'Terminbuchung' | 'Fragebogen' | 'Manuell hinzugefügt' | 'AI CASE CHAT';

/**
 * * `None` - Not Set
 * * `Chatbot Upload` - Chatbot
 * * `Email Anhang` - Email
 * * `Terminbuchung` - Appointment
 * * `Fragebogen` - Questionnaire
 * * `Manuell hinzugefügt` - Manual
 * * `AI CASE CHAT` - Ai Case Chat
 */
export const UploadOriginEnum = {
    NONE: 'None',
    CHATBOT_UPLOAD: 'Chatbot Upload',
    EMAIL_ANHANG: 'Email Anhang',
    TERMINBUCHUNG: 'Terminbuchung',
    FRAGEBOGEN: 'Fragebogen',
    'MANUELL_HINZUGEFÜGT': 'Manuell hinzugefügt',
    AI_CASE_CHAT: 'AI CASE CHAT'
} as const;

/**
 * * `draft` - Draft
 * * `in_review` - In Review
 * * `approved` - Approved
 */
export type WordTemplateStatus = 'draft' | 'in_review' | 'approved';

/**
 * * `draft` - Draft
 * * `in_review` - In Review
 * * `approved` - Approved
 */
export const WordTemplateStatus = {
    DRAFT: 'draft',
    IN_REVIEW: 'in_review',
    APPROVED: 'approved'
} as const;

export type AccountsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AccountsListResponse = PaginatedTAccountList;

export type AccountsCreateData = {
    requestBody?: TAccountRequest;
};

export type AccountsCreateResponse = TAccount;

export type AccountsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AccountsRetrieveResponse = TAccount;

export type AccountsUpdateData = {
    requestBody?: TAccountRequest;
    uuid: string;
};

export type AccountsUpdateResponse = TAccount;

export type AccountsPartialUpdateData = {
    requestBody?: PatchedTAccountRequest;
    uuid: string;
};

export type AccountsPartialUpdateResponse = TAccount;

export type AccountsDestroyData = {
    uuid: string;
};

export type AccountsDestroyResponse = TAccount;

export type AccountsAvailabilityTokenRetrieveData = {
    uuid: string;
};

export type AccountsAvailabilityTokenRetrieveResponse = TAccount;

export type AiAnalysisListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAnalysisListResponse = PaginatedTAiAnalysisList;

export type AiAnalysisCreateData = {
    requestBody?: TAiAnalysisRequest;
};

export type AiAnalysisCreateResponse = TAiAnalysis;

export type AiAnalysisRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiAnalysisRetrieveResponse = TAiAnalysis;

export type AiAnalysisUpdateData = {
    requestBody?: TAiAnalysisRequest;
    uuid: string;
};

export type AiAnalysisUpdateResponse = TAiAnalysis;

export type AiAnalysisPartialUpdateData = {
    requestBody?: PatchedTAiAnalysisRequest;
    uuid: string;
};

export type AiAnalysisPartialUpdateResponse = TAiAnalysis;

export type AiAnalysisDestroyData = {
    uuid: string;
};

export type AiAnalysisDestroyResponse = TAiAnalysis;

export type AiAnalysisByDocumentUuidListData = {
    documentUuid: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAnalysisByDocumentUuidListResponse = PaginatedTAiAnalysisList;

export type AiAugmentationListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAugmentationListResponse = PaginatedTAiAugmentationList;

export type AiAugmentationCreateData = {
    requestBody?: TAiAugmentationRequest;
};

export type AiAugmentationCreateResponse = TAiAugmentation;

export type AiAugmentationRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiAugmentationRetrieveResponse = TAiAugmentation;

export type AiAugmentationUpdateData = {
    requestBody?: TAiAugmentationRequest;
    uuid: string;
};

export type AiAugmentationUpdateResponse = TAiAugmentation;

export type AiAugmentationPartialUpdateData = {
    requestBody?: PatchedTAiAugmentationRequest;
    uuid: string;
};

export type AiAugmentationPartialUpdateResponse = TAiAugmentation;

export type AiAugmentationDestroyData = {
    uuid: string;
};

export type AiAugmentationDestroyResponse = TAiAugmentation;

export type AiAugmentationByDocumentUuidListData = {
    documentUuid: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAugmentationByDocumentUuidListResponse = PaginatedTAiAugmentationList;

export type AiChatQuestionTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiChatQuestionTemplatesListResponse = PaginatedTAiChatQuestionTemplateList;

export type AiChatQuestionTemplatesCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
};

export type AiChatQuestionTemplatesCreateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiChatQuestionTemplatesRetrieveResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesUpdateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesUpdateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesPartialUpdateData = {
    requestBody?: PatchedTAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesPartialUpdateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesDestroyData = {
    uuid: string;
};

export type AiChatQuestionTemplatesDestroyResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesCopyCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesCopyCreateResponse = TAiChatQuestionTemplate;

export type AiChatSessionsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
};

export type AiChatSessionsListResponse = PaginatedTAIChatSessionList;

export type AiChatSessionsCreateData = {
    requestBody?: TAIChatSessionRequest;
};

export type AiChatSessionsCreateResponse = TAIChatSession;

export type AiChatSessionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiChatSessionsRetrieveResponse = TAIChatSession;

export type AiChatSessionsUpdateData = {
    requestBody?: TAIChatSessionRequest;
    uuid: string;
};

export type AiChatSessionsUpdateResponse = TAIChatSession;

export type AiChatSessionsPartialUpdateData = {
    requestBody?: PatchedTAIChatSessionRequest;
    uuid: string;
};

export type AiChatSessionsPartialUpdateResponse = TAIChatSession;

export type AiChatSessionsDestroyData = {
    uuid: string;
};

export type AiChatSessionsDestroyResponse = TAIChatSession;

export type AiChatSessionsSendMessageCreateData = {
    requestBody: AIChatSessionSendMessageRequestRequest;
    uuid: string;
};

export type AiChatSessionsSendMessageCreateResponse = AIChatSessionSendMessageResponse;

export type AppointmentProposalsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AppointmentProposalsListResponse = PaginatedTAppointmentProposalList;

export type AppointmentProposalsCreateData = {
    requestBody?: TAppointmentProposalRequest;
};

export type AppointmentProposalsCreateResponse = TAppointmentProposal;

export type AppointmentProposalsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AppointmentProposalsRetrieveResponse = TAppointmentProposal;

export type AppointmentProposalsUpdateData = {
    requestBody?: TAppointmentProposalRequest;
    uuid: string;
};

export type AppointmentProposalsUpdateResponse = TAppointmentProposal;

export type AppointmentProposalsPartialUpdateData = {
    requestBody?: PatchedTAppointmentProposalRequest;
    uuid: string;
};

export type AppointmentProposalsPartialUpdateResponse = TAppointmentProposal;

export type AppointmentProposalsDestroyData = {
    uuid: string;
};

export type AppointmentProposalsDestroyResponse = TAppointmentProposal;

export type AppointmentSettingsRetrieveResponse = AppointmentSettings;

export type AppointmentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AppointmentsListResponse = PaginatedTAppointmentList;

export type AppointmentsCreateData = {
    requestBody?: TAppointmentRequest;
};

export type AppointmentsCreateResponse = TAppointment;

export type AppointmentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AppointmentsRetrieveResponse = TAppointment;

export type AppointmentsUpdateData = {
    requestBody?: TAppointmentRequest;
    uuid: string;
};

export type AppointmentsUpdateResponse = TAppointment;

export type AppointmentsPartialUpdateData = {
    requestBody?: PatchedTAppointmentRequest;
    uuid: string;
};

export type AppointmentsPartialUpdateResponse = TAppointment;

export type AppointmentsDestroyData = {
    uuid: string;
};

export type AppointmentsDestroyResponse = TAppointment;

export type AppointmentsCancelCreateData = {
    requestBody?: TAppointmentRequest;
    uuid: string;
};

export type AppointmentsCancelCreateResponse = TAppointment;

export type AppointmentsCreateCaseAppointmentCreateData = {
    requestBody?: TAppointmentRequest;
};

export type AppointmentsCreateCaseAppointmentCreateResponse = TAppointment;

export type CalendarsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CalendarsListResponse = PaginatedTCalendarList;

export type CalendarsCreateData = {
    requestBody?: TCalendarRequest;
};

export type CalendarsCreateResponse = TCalendar;

export type CalendarsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CalendarsRetrieveResponse = TCalendar;

export type CalendarsUpdateData = {
    requestBody?: TCalendarRequest;
    uuid: string;
};

export type CalendarsUpdateResponse = TCalendar;

export type CalendarsPartialUpdateData = {
    requestBody?: PatchedTCalendarRequest;
    uuid: string;
};

export type CalendarsPartialUpdateResponse = TCalendar;

export type CalendarsDestroyData = {
    uuid: string;
};

export type CalendarsDestroyResponse = TCalendar;

export type CallsListData = {
    /**
     * ai_ratings
     */
    aiRatings?: string;
    /**
     * duration_ranges
     */
    durationRanges?: string;
    excludeNotCompleted?: boolean;
    hasResult?: boolean;
    /**
     * human_ratings
     */
    humanRatings?: string;
    isDeleted?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    resultDataLawField?: string;
    /**
     * retell_call_id
     */
    retellCallId?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * twilio_call_sid
     */
    twilioCallSid?: string;
};

export type CallsListResponse = PaginatedTCallList;

export type CallsCreateData = {
    requestBody?: TCallRequest;
};

export type CallsCreateResponse = TCall;

export type CallsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CallsRetrieveResponse = TCall;

export type CallsUpdateData = {
    requestBody?: TCallRequest;
    uuid: string;
};

export type CallsUpdateResponse = TCall;

export type CallsPartialUpdateData = {
    requestBody?: PatchedTCallRequest;
    uuid: string;
};

export type CallsPartialUpdateResponse = TCall;

export type CallsDestroyData = {
    uuid: string;
};

export type CallsDestroyResponse = TCall;

export type CallsCreateCaseCreateData = {
    requestBody?: TCallRequest;
    uuid: string;
};

export type CallsCreateCaseCreateResponse = TCall;

export type CallsLawyerFeedbackListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CallsLawyerFeedbackListResponse = PaginatedTLawyerFeedbackList;

export type CallsLawyerFeedbackCreateData = {
    requestBody?: TLawyerFeedbackRequest;
};

export type CallsLawyerFeedbackCreateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CallsLawyerFeedbackRetrieveResponse = TLawyerFeedback;

export type CallsLawyerFeedbackUpdateData = {
    requestBody?: TLawyerFeedbackRequest;
    uuid: string;
};

export type CallsLawyerFeedbackUpdateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackPartialUpdateData = {
    requestBody?: PatchedTLawyerFeedbackRequest;
    uuid: string;
};

export type CallsLawyerFeedbackPartialUpdateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackDestroyData = {
    uuid: string;
};

export type CallsLawyerFeedbackDestroyResponse = TLawyerFeedback;

export type CaseCreationIntegrationCreateData = {
    requestBody: SchemaExternalIntegrationCaseCreationRequest;
};

export type CaseCreationIntegrationCreateResponse = ExternalIntegrationFileDownloadResponse | ExternalIntegrationCaseCreationResponse;

export type CaseCreatorTempDocumentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CaseCreatorTempDocumentsListResponse = PaginatedTCaseCreatorTempDocumentList;

export type CaseCreatorTempDocumentsCreateData = {
    formData?: TCaseCreatorTempDocumentRequest;
};

export type CaseCreatorTempDocumentsCreateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CaseCreatorTempDocumentsRetrieveResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsUpdateData = {
    formData?: TCaseCreatorTempDocumentRequest;
    uuid: string;
};

export type CaseCreatorTempDocumentsUpdateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsPartialUpdateData = {
    formData?: PatchedTCaseCreatorTempDocumentRequest;
    uuid: string;
};

export type CaseCreatorTempDocumentsPartialUpdateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsDestroyData = {
    uuid: string;
};

export type CaseCreatorTempDocumentsDestroyResponse = TCaseCreatorTempDocument;

export type CasesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CasesListResponse = PaginatedTCaseList;

export type CasesCreateData = {
    requestBody: CaseCreateRequest;
};

export type CasesCreateResponse = TCase;

export type CasesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CasesRetrieveResponse = TCase;

export type CasesUpdateData = {
    requestBody?: TCaseRequest;
    uuid: string;
};

export type CasesUpdateResponse = TCase;

export type CasesPartialUpdateData = {
    requestBody?: PatchedTCaseRequest;
    uuid: string;
};

export type CasesPartialUpdateResponse = TCase;

export type CasesDestroyData = {
    uuid: string;
};

export type CasesDestroyResponse = TCase;

export type CasesCreateWordDocumentCreateData = {
    requestBody: CreateWordDocumentRequestRequest;
    uuid: string;
};

export type CasesCreateWordDocumentCreateResponse = CreateWordDocumentResponse;

export type CasesCreateWordDocumentFromPlaceholderValuesCreateData = {
    requestBody: CreateWordDocumentFromPlaceholderValuesRequestRequest;
    uuid: string;
};

export type CasesCreateWordDocumentFromPlaceholderValuesCreateResponse = CreateWordDocumentFromPlaceholderValuesResponse;

export type CasesCreateWordDocumentPreviewBlobCreateData = {
    requestBody: CreateWordDocumentPreviewBlobRequest;
    uuid: string;
};

export type CasesCreateWordDocumentPreviewBlobCreateResponse = (Blob | File);

export type CasesFindWordDocumentTemplatePlaceholderValuesCreateData = {
    requestBody: FindWordDocumentTemplatePlaceholderValuesRequestRequest;
    uuid: string;
};

export type CasesFindWordDocumentTemplatePlaceholderValuesCreateResponse = FindWordDocumentTemplatePlaceholderValuesResponse;

export type CasesGenerateDocumentHtmlStreamCreateData = {
    requestBody: GenerateDocumentRequestRequest;
    uuid: string;
};

export type CasesGenerateDocumentHtmlStreamCreateResponse = string;

export type CasesGenericDatamappersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CasesGenericDatamappersListResponse = PaginatedTGenericDataMapperList;

export type DocumentTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type DocumentTemplatesListResponse = PaginatedTDocumentTemplateList;

export type DocumentTemplatesCreateData = {
    requestBody?: TDocumentTemplateRequest;
};

export type DocumentTemplatesCreateResponse = TDocumentTemplate;

export type DocumentTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type DocumentTemplatesRetrieveResponse = TDocumentTemplate;

export type DocumentTemplatesUpdateData = {
    requestBody?: TDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesUpdateResponse = TDocumentTemplate;

export type DocumentTemplatesPartialUpdateData = {
    requestBody?: PatchedTDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesPartialUpdateResponse = TDocumentTemplate;

export type DocumentTemplatesDestroyData = {
    uuid: string;
};

export type DocumentTemplatesDestroyResponse = TDocumentTemplate;

export type DocumentTemplatesCopyCreateData = {
    requestBody?: TDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesCopyCreateResponse = TDocumentTemplate;

export type DocumentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type DocumentsListResponse = PaginatedTDocumentList;

export type DocumentsCreateData = {
    requestBody?: TDocumentRequest;
};

export type DocumentsCreateResponse = TDocument;

export type DocumentsUploadCreateData = {
    /**
     * UUID of the case
     */
    caseUuid: string;
    formData: DocumentUploadRequest;
};

export type DocumentsUploadCreateResponse = Document;

export type DocumentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type DocumentsRetrieveResponse = TDocument;

export type DocumentsUpdateData = {
    requestBody?: TDocumentRequest;
    uuid: string;
};

export type DocumentsUpdateResponse = TDocument;

export type DocumentsPartialUpdateData = {
    requestBody?: PatchedTDocumentRequest;
    uuid: string;
};

export type DocumentsPartialUpdateResponse = TDocument;

export type DocumentsDestroyData = {
    uuid: string;
};

export type DocumentsDestroyResponse = TDocument;

export type EditorUploadCreateData = {
    requestBody: EditorUploadRequest;
};

export type EditorUploadCreateResponse = EditorUploadResponse;

export type EmailTemplatesListData = {
    lawField?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    type?: string;
};

export type EmailTemplatesListResponse = PaginatedTEmailTemplateList;

export type EmailTemplatesCreateData = {
    requestBody?: TEmailTemplateRequest;
};

export type EmailTemplatesCreateResponse = TEmailTemplate;

export type EmailTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type EmailTemplatesRetrieveResponse = TEmailTemplate;

export type EmailTemplatesUpdateData = {
    requestBody?: TEmailTemplateRequest;
    uuid: string;
};

export type EmailTemplatesUpdateResponse = TEmailTemplate;

export type EmailTemplatesPartialUpdateData = {
    requestBody?: PatchedTEmailTemplateRequest;
    uuid: string;
};

export type EmailTemplatesPartialUpdateResponse = TEmailTemplate;

export type EmailTemplatesDestroyData = {
    uuid: string;
};

export type EmailTemplatesDestroyResponse = TEmailTemplate;

export type EmailsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type EmailsListResponse = PaginatedTEmailList;

export type EmailsCreateData = {
    requestBody?: EmailRequest;
};

export type EmailsCreateResponse = TEmail;

export type EmailsRetrieveData = {
    /**
     * A unique integer value identifying this email.
     */
    id: number;
};

export type EmailsRetrieveResponse = TEmail;

export type EmailsUpdateData = {
    /**
     * A unique integer value identifying this email.
     */
    id: number;
    requestBody?: EmailRequest;
};

export type EmailsUpdateResponse = TEmail;

export type EmailsPartialUpdateData = {
    /**
     * A unique integer value identifying this email.
     */
    id: number;
    requestBody?: PatchedEmailRequest;
};

export type EmailsPartialUpdateResponse = TEmail;

export type EmailsDestroyData = {
    /**
     * A unique integer value identifying this email.
     */
    id: number;
};

export type EmailsDestroyResponse = TEmail;

export type EmailsRenderTemplateCreateData = {
    requestBody: EmailRenderTemplateRequestRequest;
};

export type EmailsRenderTemplateCreateResponse = EmailRenderTemplateResponse;

export type EntitiesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type EntitiesListResponse = PaginatedTEntityList;

export type EntitiesCreateData = {
    requestBody?: TEntityRequest;
};

export type EntitiesCreateResponse = TEntity;

export type EntitiesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type EntitiesRetrieveResponse = TEntity;

export type EntitiesUpdateData = {
    requestBody?: TEntityRequest;
    uuid: string;
};

export type EntitiesUpdateResponse = TEntity;

export type EntitiesPartialUpdateData = {
    requestBody?: PatchedTEntityRequest;
    uuid: string;
};

export type EntitiesPartialUpdateResponse = TEntity;

export type EntitiesDestroyData = {
    uuid: string;
};

export type EntitiesDestroyResponse = TEntity;

export type EntitiesAddCaseDataRelationshipCreateData = {
    requestBody: EntityAddCaseDataRelationshipRequest;
    uuid: string;
};

export type EntitiesAddCaseDataRelationshipCreateResponse = TEntityWithRelationship;

export type EntitiesRemoveCaseDataRelationshipCreateData = {
    requestBody: EntityRemoveCaseDataRelationshipRequestRequest;
    uuid: string;
};

export type EntitiesRemoveCaseDataRelationshipCreateResponse = TEntityRemoveCaseDataRelationshipResponse;

export type EntitiesSwitchUniqueCaseDataRelationshipCreateData = {
    requestBody: SwitchUniqueCaseDataRelationshipRequestRequest;
};

export type EntitiesSwitchUniqueCaseDataRelationshipCreateResponse = TSwitchUniqueCaseDataRelationshipResponse;

export type EventCreateData = {
    requestBody: TrackingEventRequest;
};

export type EventCreateResponse = unknown;

export type FeedbackListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
};

export type FeedbackListResponse = PaginatedTFeedbackList;

export type FeedbackCreateData = {
    requestBody?: TFeedbackRequest;
};

export type FeedbackCreateResponse = TFeedback;

export type FeedbackRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type FeedbackRetrieveResponse = TFeedback;

export type FeedbackUpdateData = {
    requestBody?: TFeedbackRequest;
    uuid: string;
};

export type FeedbackUpdateResponse = TFeedback;

export type FeedbackPartialUpdateData = {
    requestBody?: PatchedTFeedbackRequest;
    uuid: string;
};

export type FeedbackPartialUpdateResponse = TFeedback;

export type FeedbackDestroyData = {
    uuid: string;
};

export type FeedbackDestroyResponse = TFeedback;

export type FormsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
    /**
     * * `MASTER` - Master
     * * `PREFILLED` - Prefilled
     * * `SIGNED` - Signed
     */
    tag?: 'MASTER' | 'PREFILLED' | 'SIGNED';
};

export type FormsListResponse = PaginatedTFormList;

export type FormsCreateData = {
    formData?: TFormRequest;
};

export type FormsCreateResponse = TForm;

export type FormsRetrieveData = {
    /**
     * Record UUID
     */
    id: string;
};

export type FormsRetrieveResponse = TForm;

export type FormsUpdateData = {
    formData?: TFormRequest;
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsUpdateResponse = TForm;

export type FormsPartialUpdateData = {
    formData?: PatchedTFormRequest;
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsPartialUpdateResponse = TForm;

export type FormsDestroyData = {
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsDestroyResponse = TForm;

export type HubspotCompaniesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type HubspotCompaniesListResponse = PaginatedSuperUserHubSpotCompanyList;

export type HubspotCompaniesCreateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type HubspotCompaniesRetrieveResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesUpdateData = {
    uuid: string;
};

export type HubspotCompaniesUpdateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesPartialUpdateData = {
    uuid: string;
};

export type HubspotCompaniesPartialUpdateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesDestroyData = {
    uuid: string;
};

export type HubspotCompaniesDestroyResponse = SuperUserHubSpotCompany;

export type HubspotContactsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type HubspotContactsListResponse = PaginatedSuperUserHubSpotContactList;

export type HubspotContactsCreateResponse = SuperUserHubSpotContact;

export type HubspotContactsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type HubspotContactsRetrieveResponse = SuperUserHubSpotContact;

export type HubspotContactsUpdateData = {
    uuid: string;
};

export type HubspotContactsUpdateResponse = SuperUserHubSpotContact;

export type HubspotContactsPartialUpdateData = {
    uuid: string;
};

export type HubspotContactsPartialUpdateResponse = SuperUserHubSpotContact;

export type HubspotContactsDestroyData = {
    uuid: string;
};

export type HubspotContactsDestroyResponse = SuperUserHubSpotContact;

export type InboundEmailsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type InboundEmailsListResponse = PaginatedTInboundEmailList;

export type InboundEmailsCreateData = {
    requestBody?: InboundEmailRequest;
};

export type InboundEmailsCreateResponse = TInboundEmail;

export type InboundEmailsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type InboundEmailsRetrieveResponse = TInboundEmail;

export type InboundEmailsUpdateData = {
    requestBody?: InboundEmailRequest;
    uuid: string;
};

export type InboundEmailsUpdateResponse = TInboundEmail;

export type InboundEmailsPartialUpdateData = {
    requestBody?: PatchedInboundEmailRequest;
    uuid: string;
};

export type InboundEmailsPartialUpdateResponse = TInboundEmail;

export type InboundEmailsDestroyData = {
    uuid: string;
};

export type InboundEmailsDestroyResponse = TInboundEmail;

export type InboundEmailsCreateCaseCreateData = {
    requestBody: CreateCaseFromInboundEmailRequest;
    uuid: string;
};

export type InboundEmailsCreateCaseCreateResponse = {
    [key: string]: unknown;
};

export type JurnodesLawCategoriesListResponse = Array<JurnodesLawCategory>;

export type JurnodesRecordSchemasListResponse = Array<JurnodesRecordSchema>;

export type JurnodesUsersListResponse = Array<JurnodesUser>;

export type KleosCaseTypesRetrieveResponse = KleosCaseTypes;

export type LawFieldsRetrieveResponse = LawFields;

export type OrganisationsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type OrganisationsListResponse = PaginatedTOrganisationList;

export type OrganisationsCreateData = {
    requestBody?: TOrganisationRequest;
};

export type OrganisationsCreateResponse = TOrganisation;

export type OrganisationsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type OrganisationsRetrieveResponse = TOrganisation;

export type OrganisationsUpdateData = {
    requestBody?: TOrganisationRequest;
    uuid: string;
};

export type OrganisationsUpdateResponse = TOrganisation;

export type OrganisationsPartialUpdateData = {
    requestBody?: PatchedTOrganisationRequest;
    uuid: string;
};

export type OrganisationsPartialUpdateResponse = TOrganisation;

export type OrganisationsDestroyData = {
    uuid: string;
};

export type OrganisationsDestroyResponse = TOrganisation;

export type PhoneNumbersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type PhoneNumbersListResponse = PaginatedTPhoneNumberList;

export type PhoneNumbersCreateData = {
    requestBody?: TPhoneNumberRequest;
};

export type PhoneNumbersCreateResponse = TPhoneNumber;

export type PhoneNumbersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type PhoneNumbersRetrieveResponse = TPhoneNumber;

export type PhoneNumbersUpdateData = {
    requestBody?: TPhoneNumberRequest;
    uuid: string;
};

export type PhoneNumbersUpdateResponse = TPhoneNumber;

export type PhoneNumbersPartialUpdateData = {
    requestBody?: PatchedTPhoneNumberRequest;
    uuid: string;
};

export type PhoneNumbersPartialUpdateResponse = TPhoneNumber;

export type PhoneNumbersDestroyData = {
    uuid: string;
};

export type PhoneNumbersDestroyResponse = TPhoneNumber;

export type PlaceholdersListResponse = Array<Placeholder>;

export type QuestionnaireSubmissionsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type QuestionnaireSubmissionsListResponse = PaginatedTQuestionnaireSubmissionList;

export type QuestionnaireSubmissionsCreateData = {
    requestBody?: TQuestionnaireSubmissionRequest;
};

export type QuestionnaireSubmissionsCreateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type QuestionnaireSubmissionsRetrieveResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsUpdateData = {
    requestBody?: TQuestionnaireSubmissionRequest;
    uuid: string;
};

export type QuestionnaireSubmissionsUpdateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsPartialUpdateData = {
    requestBody?: PatchedTQuestionnaireSubmissionRequest;
    uuid: string;
};

export type QuestionnaireSubmissionsPartialUpdateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsDestroyData = {
    uuid: string;
};

export type QuestionnaireSubmissionsDestroyResponse = TQuestionnaireSubmission;

export type QuestionnairesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type QuestionnairesListResponse = PaginatedTQuestionnaireList;

export type QuestionnairesCreateData = {
    requestBody?: TQuestionnaireRequest;
};

export type QuestionnairesCreateResponse = TQuestionnaire;

export type QuestionnairesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type QuestionnairesRetrieveResponse = TQuestionnaire;

export type QuestionnairesUpdateData = {
    requestBody?: TQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesUpdateResponse = TQuestionnaire;

export type QuestionnairesPartialUpdateData = {
    requestBody?: PatchedTQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesPartialUpdateResponse = TQuestionnaire;

export type QuestionnairesDestroyData = {
    uuid: string;
};

export type QuestionnairesDestroyResponse = TQuestionnaire;

export type QuestionnairesCopyCreateData = {
    requestBody?: TQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesCopyCreateResponse = TQuestionnaire;

export type QuestionnairesGenerateCreateData = {
    formData?: QuestionnaireGenerateRequest;
    uuid: string;
};

export type QuestionnairesGenerateCreateResponse = TQuestionnaire;

export type RetellAgentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type RetellAgentsListResponse = PaginatedTRetellAgentList;

export type RetellAgentsCreateData = {
    requestBody?: TRetellAgentRequest;
};

export type RetellAgentsCreateResponse = TRetellAgent;

export type RetellAgentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type RetellAgentsRetrieveResponse = TRetellAgent;

export type RetellAgentsUpdateData = {
    requestBody?: TRetellAgentRequest;
    uuid: string;
};

export type RetellAgentsUpdateResponse = TRetellAgent;

export type RetellAgentsPartialUpdateData = {
    requestBody?: PatchedTRetellAgentRequest;
    uuid: string;
};

export type RetellAgentsPartialUpdateResponse = TRetellAgent;

export type RetellAgentsDestroyData = {
    uuid: string;
};

export type RetellAgentsDestroyResponse = TRetellAgent;

export type ServicesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    orgSlug?: string;
};

export type ServicesListResponse = PaginatedTServiceList;

export type ServicesCreateData = {
    requestBody?: TServiceRequest;
};

export type ServicesCreateResponse = TService;

export type ServicesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type ServicesRetrieveResponse = TService;

export type ServicesUpdateData = {
    requestBody?: TServiceRequest;
    uuid: string;
};

export type ServicesUpdateResponse = TService;

export type ServicesPartialUpdateData = {
    requestBody?: PatchedTServiceRequest;
    uuid: string;
};

export type ServicesPartialUpdateResponse = TService;

export type ServicesDestroyData = {
    uuid: string;
};

export type ServicesDestroyResponse = TService;

export type ServicesAvailabilitiesCreateData = {
    calendarSlug: string;
    requestBody?: TServiceRequest;
    uuid: string;
};

export type ServicesAvailabilitiesCreateResponse = TService;

export type StripeCustomersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type StripeCustomersListResponse = PaginatedTStripeCustomerList;

export type StripeCustomersCreateData = {
    requestBody?: TStripeCustomerRequest;
};

export type StripeCustomersCreateResponse = TStripeCustomer;

export type StripeCustomersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type StripeCustomersRetrieveResponse = TStripeCustomer;

export type StripeCustomersUpdateData = {
    requestBody?: TStripeCustomerRequest;
    uuid: string;
};

export type StripeCustomersUpdateResponse = TStripeCustomer;

export type StripeCustomersPartialUpdateData = {
    requestBody?: PatchedTStripeCustomerRequest;
    uuid: string;
};

export type StripeCustomersPartialUpdateResponse = TStripeCustomer;

export type StripeCustomersDestroyData = {
    uuid: string;
};

export type StripeCustomersDestroyResponse = TStripeCustomer;

export type StripeInvoicesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type StripeInvoicesListResponse = PaginatedTStripeInvoiceList;

export type StripeInvoicesCreateData = {
    requestBody?: TStripeInvoiceRequest;
};

export type StripeInvoicesCreateResponse = TStripeInvoice;

export type StripeInvoicesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type StripeInvoicesRetrieveResponse = TStripeInvoice;

export type StripeInvoicesUpdateData = {
    requestBody?: TStripeInvoiceRequest;
    uuid: string;
};

export type StripeInvoicesUpdateResponse = TStripeInvoice;

export type StripeInvoicesPartialUpdateData = {
    requestBody?: PatchedTStripeInvoiceRequest;
    uuid: string;
};

export type StripeInvoicesPartialUpdateResponse = TStripeInvoice;

export type StripeInvoicesDestroyData = {
    uuid: string;
};

export type StripeInvoicesDestroyResponse = TStripeInvoice;

export type StripeInvoicesExportCreateData = {
    requestBody: StripeInvoiceExportRequestRequest;
};

export type StripeInvoicesExportCreateResponse = StripeInvoiceExportResponse;

export type UsersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type UsersListResponse = PaginatedTUserList;

export type UsersCreateData = {
    requestBody?: TUserRequest;
};

export type UsersCreateResponse = TUser;

export type UsersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type UsersRetrieveResponse = TUser;

export type UsersUpdateData = {
    requestBody?: TUserRequest;
    uuid: string;
};

export type UsersUpdateResponse = TUser;

export type UsersPartialUpdateData = {
    requestBody?: PatchedTUserRequest;
    uuid: string;
};

export type UsersPartialUpdateResponse = TUser;

export type UsersDestroyData = {
    uuid: string;
};

export type UsersDestroyResponse = TUser;

export type WordDocumentTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: 'approved' | 'draft' | 'in_review';
};

export type WordDocumentTemplatesListResponse = PaginatedTWordDocumentTemplateList;

export type WordDocumentTemplatesCreateData = {
    formData?: TWordDocumentTemplateRequest;
};

export type WordDocumentTemplatesCreateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type WordDocumentTemplatesRetrieveResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesUpdateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesUpdateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesPartialUpdateData = {
    formData?: PatchedTWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesPartialUpdateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesDestroyData = {
    uuid: string;
};

export type WordDocumentTemplatesDestroyResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesCopyCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesCopyCreateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData = {
    requestBody: CreateWordDocumentPreviewBlobRequest;
    uuid: string;
};

export type WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateResponse = (Blob | File);

export type WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData = {
    requestBody: CreateWordDocumentTemplateDocxWithPlaceholdersRequest;
    uuid: string;
};

export type WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateResponse = (Blob | File);

export type WordDocumentTemplatesDeleteDocumentCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesDeleteDocumentCreateResponse = TWordDocumentTemplate;

export type $OpenApiTs = {
    '/api/v3/accounts/': {
        get: {
            req: AccountsListData;
            res: {
                200: PaginatedTAccountList;
            };
        };
        post: {
            req: AccountsCreateData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/accounts/{uuid}/': {
        get: {
            req: AccountsRetrieveData;
            res: {
                200: TAccount;
            };
        };
        put: {
            req: AccountsUpdateData;
            res: {
                200: TAccount;
            };
        };
        patch: {
            req: AccountsPartialUpdateData;
            res: {
                200: TAccount;
            };
        };
        delete: {
            req: AccountsDestroyData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/accounts/{uuid}/availability_token/': {
        get: {
            req: AccountsAvailabilityTokenRetrieveData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/ai_analysis/': {
        get: {
            req: AiAnalysisListData;
            res: {
                200: PaginatedTAiAnalysisList;
            };
        };
        post: {
            req: AiAnalysisCreateData;
            res: {
                200: TAiAnalysis;
            };
        };
    };
    '/api/v3/ai_analysis/{uuid}/': {
        get: {
            req: AiAnalysisRetrieveData;
            res: {
                200: TAiAnalysis;
            };
        };
        put: {
            req: AiAnalysisUpdateData;
            res: {
                200: TAiAnalysis;
            };
        };
        patch: {
            req: AiAnalysisPartialUpdateData;
            res: {
                200: TAiAnalysis;
            };
        };
        delete: {
            req: AiAnalysisDestroyData;
            res: {
                200: TAiAnalysis;
            };
        };
    };
    '/api/v3/ai_analysis/by-document-uuid/{document_uuid}/': {
        get: {
            req: AiAnalysisByDocumentUuidListData;
            res: {
                200: PaginatedTAiAnalysisList;
            };
        };
    };
    '/api/v3/ai_augmentation/': {
        get: {
            req: AiAugmentationListData;
            res: {
                200: PaginatedTAiAugmentationList;
            };
        };
        post: {
            req: AiAugmentationCreateData;
            res: {
                200: TAiAugmentation;
            };
        };
    };
    '/api/v3/ai_augmentation/{uuid}/': {
        get: {
            req: AiAugmentationRetrieveData;
            res: {
                200: TAiAugmentation;
            };
        };
        put: {
            req: AiAugmentationUpdateData;
            res: {
                200: TAiAugmentation;
            };
        };
        patch: {
            req: AiAugmentationPartialUpdateData;
            res: {
                200: TAiAugmentation;
            };
        };
        delete: {
            req: AiAugmentationDestroyData;
            res: {
                200: TAiAugmentation;
            };
        };
    };
    '/api/v3/ai_augmentation/by-document-uuid/{document_uuid}/': {
        get: {
            req: AiAugmentationByDocumentUuidListData;
            res: {
                200: PaginatedTAiAugmentationList;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/': {
        get: {
            req: AiChatQuestionTemplatesListData;
            res: {
                200: PaginatedTAiChatQuestionTemplateList;
            };
        };
        post: {
            req: AiChatQuestionTemplatesCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/': {
        get: {
            req: AiChatQuestionTemplatesRetrieveData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        put: {
            req: AiChatQuestionTemplatesUpdateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        patch: {
            req: AiChatQuestionTemplatesPartialUpdateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        delete: {
            req: AiChatQuestionTemplatesDestroyData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/copy/': {
        post: {
            req: AiChatQuestionTemplatesCopyCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_sessions/': {
        get: {
            req: AiChatSessionsListData;
            res: {
                200: PaginatedTAIChatSessionList;
            };
        };
        post: {
            req: AiChatSessionsCreateData;
            res: {
                200: TAIChatSession;
            };
        };
    };
    '/api/v3/ai_chat_sessions/{uuid}/': {
        get: {
            req: AiChatSessionsRetrieveData;
            res: {
                200: TAIChatSession;
            };
        };
        put: {
            req: AiChatSessionsUpdateData;
            res: {
                200: TAIChatSession;
            };
        };
        patch: {
            req: AiChatSessionsPartialUpdateData;
            res: {
                200: TAIChatSession;
            };
        };
        delete: {
            req: AiChatSessionsDestroyData;
            res: {
                200: TAIChatSession;
            };
        };
    };
    '/api/v3/ai_chat_sessions/{uuid}/send_message/': {
        post: {
            req: AiChatSessionsSendMessageCreateData;
            res: {
                200: AIChatSessionSendMessageResponse;
            };
        };
    };
    '/api/v3/appointment_proposals/': {
        get: {
            req: AppointmentProposalsListData;
            res: {
                200: PaginatedTAppointmentProposalList;
            };
        };
        post: {
            req: AppointmentProposalsCreateData;
            res: {
                200: TAppointmentProposal;
            };
        };
    };
    '/api/v3/appointment_proposals/{uuid}/': {
        get: {
            req: AppointmentProposalsRetrieveData;
            res: {
                200: TAppointmentProposal;
            };
        };
        put: {
            req: AppointmentProposalsUpdateData;
            res: {
                200: TAppointmentProposal;
            };
        };
        patch: {
            req: AppointmentProposalsPartialUpdateData;
            res: {
                200: TAppointmentProposal;
            };
        };
        delete: {
            req: AppointmentProposalsDestroyData;
            res: {
                200: TAppointmentProposal;
            };
        };
    };
    '/api/v3/appointment_settings/': {
        get: {
            res: {
                200: AppointmentSettings;
                403: {
                    [key: string]: unknown;
                };
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/appointments/': {
        get: {
            req: AppointmentsListData;
            res: {
                200: PaginatedTAppointmentList;
            };
        };
        post: {
            req: AppointmentsCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/{uuid}/': {
        get: {
            req: AppointmentsRetrieveData;
            res: {
                200: TAppointment;
            };
        };
        put: {
            req: AppointmentsUpdateData;
            res: {
                200: TAppointment;
            };
        };
        patch: {
            req: AppointmentsPartialUpdateData;
            res: {
                200: TAppointment;
            };
        };
        delete: {
            req: AppointmentsDestroyData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/{uuid}/cancel/': {
        post: {
            req: AppointmentsCancelCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/create_case_appointment/': {
        post: {
            req: AppointmentsCreateCaseAppointmentCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/calendars/': {
        get: {
            req: CalendarsListData;
            res: {
                200: PaginatedTCalendarList;
            };
        };
        post: {
            req: CalendarsCreateData;
            res: {
                200: TCalendar;
            };
        };
    };
    '/api/v3/calendars/{uuid}/': {
        get: {
            req: CalendarsRetrieveData;
            res: {
                200: TCalendar;
            };
        };
        put: {
            req: CalendarsUpdateData;
            res: {
                200: TCalendar;
            };
        };
        patch: {
            req: CalendarsPartialUpdateData;
            res: {
                200: TCalendar;
            };
        };
        delete: {
            req: CalendarsDestroyData;
            res: {
                200: TCalendar;
            };
        };
    };
    '/api/v3/calls/': {
        get: {
            req: CallsListData;
            res: {
                200: PaginatedTCallList;
            };
        };
        post: {
            req: CallsCreateData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/{uuid}/': {
        get: {
            req: CallsRetrieveData;
            res: {
                200: TCall;
            };
        };
        put: {
            req: CallsUpdateData;
            res: {
                200: TCall;
            };
        };
        patch: {
            req: CallsPartialUpdateData;
            res: {
                200: TCall;
            };
        };
        delete: {
            req: CallsDestroyData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/{uuid}/create_case/': {
        post: {
            req: CallsCreateCaseCreateData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/lawyer_feedback/': {
        get: {
            req: CallsLawyerFeedbackListData;
            res: {
                200: PaginatedTLawyerFeedbackList;
            };
        };
        post: {
            req: CallsLawyerFeedbackCreateData;
            res: {
                200: TLawyerFeedback;
            };
        };
    };
    '/api/v3/calls/lawyer_feedback/{uuid}/': {
        get: {
            req: CallsLawyerFeedbackRetrieveData;
            res: {
                200: TLawyerFeedback;
            };
        };
        put: {
            req: CallsLawyerFeedbackUpdateData;
            res: {
                200: TLawyerFeedback;
            };
        };
        patch: {
            req: CallsLawyerFeedbackPartialUpdateData;
            res: {
                200: TLawyerFeedback;
            };
        };
        delete: {
            req: CallsLawyerFeedbackDestroyData;
            res: {
                200: TLawyerFeedback;
            };
        };
    };
    '/api/v3/case_creation_integration/': {
        post: {
            req: CaseCreationIntegrationCreateData;
            res: {
                200: ExternalIntegrationFileDownloadResponse;
                201: ExternalIntegrationCaseCreationResponse;
            };
        };
    };
    '/api/v3/case_creator_temp_documents/': {
        get: {
            req: CaseCreatorTempDocumentsListData;
            res: {
                200: PaginatedTCaseCreatorTempDocumentList;
            };
        };
        post: {
            req: CaseCreatorTempDocumentsCreateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
    };
    '/api/v3/case_creator_temp_documents/{uuid}/': {
        get: {
            req: CaseCreatorTempDocumentsRetrieveData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        put: {
            req: CaseCreatorTempDocumentsUpdateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        patch: {
            req: CaseCreatorTempDocumentsPartialUpdateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        delete: {
            req: CaseCreatorTempDocumentsDestroyData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
    };
    '/api/v3/cases/': {
        get: {
            req: CasesListData;
            res: {
                200: PaginatedTCaseList;
            };
        };
        post: {
            req: CasesCreateData;
            res: {
                201: TCase;
            };
        };
    };
    '/api/v3/cases/{uuid}/': {
        get: {
            req: CasesRetrieveData;
            res: {
                200: TCase;
            };
        };
        put: {
            req: CasesUpdateData;
            res: {
                200: TCase;
            };
        };
        patch: {
            req: CasesPartialUpdateData;
            res: {
                200: TCase;
            };
        };
        delete: {
            req: CasesDestroyData;
            res: {
                200: TCase;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document/': {
        post: {
            req: CasesCreateWordDocumentCreateData;
            res: {
                200: CreateWordDocumentResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document_from_placeholder_values/': {
        post: {
            req: CasesCreateWordDocumentFromPlaceholderValuesCreateData;
            res: {
                200: CreateWordDocumentFromPlaceholderValuesResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document_preview_blob/': {
        post: {
            req: CasesCreateWordDocumentPreviewBlobCreateData;
            res: {
                200: (Blob | File);
            };
        };
    };
    '/api/v3/cases/{uuid}/find_word_document_template_placeholder_values/': {
        post: {
            req: CasesFindWordDocumentTemplatePlaceholderValuesCreateData;
            res: {
                200: FindWordDocumentTemplatePlaceholderValuesResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/generate_document_html_stream/': {
        post: {
            req: CasesGenerateDocumentHtmlStreamCreateData;
            res: {
                /**
                 * Streaming response that delivers chunks of the document incrementally in `text/plain` format. Clients should consume the response progressively.
                 */
                200: string;
            };
        };
    };
    '/api/v3/cases/generic_datamappers/': {
        get: {
            req: CasesGenericDatamappersListData;
            res: {
                200: PaginatedTGenericDataMapperList;
            };
        };
    };
    '/api/v3/document_templates/': {
        get: {
            req: DocumentTemplatesListData;
            res: {
                200: PaginatedTDocumentTemplateList;
            };
        };
        post: {
            req: DocumentTemplatesCreateData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/document_templates/{uuid}/': {
        get: {
            req: DocumentTemplatesRetrieveData;
            res: {
                200: TDocumentTemplate;
            };
        };
        put: {
            req: DocumentTemplatesUpdateData;
            res: {
                200: TDocumentTemplate;
            };
        };
        patch: {
            req: DocumentTemplatesPartialUpdateData;
            res: {
                200: TDocumentTemplate;
            };
        };
        delete: {
            req: DocumentTemplatesDestroyData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/document_templates/{uuid}/copy/': {
        post: {
            req: DocumentTemplatesCopyCreateData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/documents/': {
        get: {
            req: DocumentsListData;
            res: {
                200: PaginatedTDocumentList;
            };
        };
        post: {
            req: DocumentsCreateData;
            res: {
                200: TDocument;
            };
        };
    };
    '/api/v3/documents/{case_uuid}/upload/': {
        post: {
            req: DocumentsUploadCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{uuid}/': {
        get: {
            req: DocumentsRetrieveData;
            res: {
                200: TDocument;
            };
        };
        put: {
            req: DocumentsUpdateData;
            res: {
                200: TDocument;
            };
        };
        patch: {
            req: DocumentsPartialUpdateData;
            res: {
                200: TDocument;
            };
        };
        delete: {
            req: DocumentsDestroyData;
            res: {
                200: TDocument;
            };
        };
    };
    '/api/v3/editor/upload': {
        post: {
            req: EditorUploadCreateData;
            res: {
                201: EditorUploadResponse;
                /**
                 * No response body
                 */
                400: unknown;
                /**
                 * No response body
                 */
                403: unknown;
            };
        };
    };
    '/api/v3/email_templates/': {
        get: {
            req: EmailTemplatesListData;
            res: {
                200: PaginatedTEmailTemplateList;
            };
        };
        post: {
            req: EmailTemplatesCreateData;
            res: {
                200: TEmailTemplate;
            };
        };
    };
    '/api/v3/email_templates/{uuid}/': {
        get: {
            req: EmailTemplatesRetrieveData;
            res: {
                200: TEmailTemplate;
            };
        };
        put: {
            req: EmailTemplatesUpdateData;
            res: {
                200: TEmailTemplate;
            };
        };
        patch: {
            req: EmailTemplatesPartialUpdateData;
            res: {
                200: TEmailTemplate;
            };
        };
        delete: {
            req: EmailTemplatesDestroyData;
            res: {
                200: TEmailTemplate;
            };
        };
    };
    '/api/v3/emails/': {
        get: {
            req: EmailsListData;
            res: {
                200: PaginatedTEmailList;
            };
        };
        post: {
            req: EmailsCreateData;
            res: {
                200: TEmail;
            };
        };
    };
    '/api/v3/emails/{id}/': {
        get: {
            req: EmailsRetrieveData;
            res: {
                200: TEmail;
            };
        };
        put: {
            req: EmailsUpdateData;
            res: {
                200: TEmail;
            };
        };
        patch: {
            req: EmailsPartialUpdateData;
            res: {
                200: TEmail;
            };
        };
        delete: {
            req: EmailsDestroyData;
            res: {
                200: TEmail;
            };
        };
    };
    '/api/v3/emails/render_template/': {
        post: {
            req: EmailsRenderTemplateCreateData;
            res: {
                200: EmailRenderTemplateResponse;
            };
        };
    };
    '/api/v3/entities/': {
        get: {
            req: EntitiesListData;
            res: {
                200: PaginatedTEntityList;
            };
        };
        post: {
            req: EntitiesCreateData;
            res: {
                200: TEntity;
            };
        };
    };
    '/api/v3/entities/{uuid}/': {
        get: {
            req: EntitiesRetrieveData;
            res: {
                200: TEntity;
            };
        };
        put: {
            req: EntitiesUpdateData;
            res: {
                200: TEntity;
            };
        };
        patch: {
            req: EntitiesPartialUpdateData;
            res: {
                200: TEntity;
            };
        };
        delete: {
            req: EntitiesDestroyData;
            res: {
                200: TEntity;
            };
        };
    };
    '/api/v3/entities/{uuid}/add_case_data_relationship/': {
        post: {
            req: EntitiesAddCaseDataRelationshipCreateData;
            res: {
                200: TEntityWithRelationship;
            };
        };
    };
    '/api/v3/entities/{uuid}/remove_case_data_relationship/': {
        post: {
            req: EntitiesRemoveCaseDataRelationshipCreateData;
            res: {
                200: TEntityRemoveCaseDataRelationshipResponse;
            };
        };
    };
    '/api/v3/entities/switch_unique_case_data_relationship/': {
        post: {
            req: EntitiesSwitchUniqueCaseDataRelationshipCreateData;
            res: {
                200: TSwitchUniqueCaseDataRelationshipResponse;
            };
        };
    };
    '/api/v3/event/': {
        post: {
            req: EventCreateData;
            res: {
                /**
                 * No response body
                 */
                201: unknown;
            };
        };
    };
    '/api/v3/feedback/': {
        get: {
            req: FeedbackListData;
            res: {
                200: PaginatedTFeedbackList;
            };
        };
        post: {
            req: FeedbackCreateData;
            res: {
                200: TFeedback;
            };
        };
    };
    '/api/v3/feedback/{uuid}/': {
        get: {
            req: FeedbackRetrieveData;
            res: {
                200: TFeedback;
            };
        };
        put: {
            req: FeedbackUpdateData;
            res: {
                200: TFeedback;
            };
        };
        patch: {
            req: FeedbackPartialUpdateData;
            res: {
                200: TFeedback;
            };
        };
        delete: {
            req: FeedbackDestroyData;
            res: {
                200: TFeedback;
            };
        };
    };
    '/api/v3/forms/': {
        get: {
            req: FormsListData;
            res: {
                200: PaginatedTFormList;
            };
        };
        post: {
            req: FormsCreateData;
            res: {
                200: TForm;
            };
        };
    };
    '/api/v3/forms/{id}/': {
        get: {
            req: FormsRetrieveData;
            res: {
                200: TForm;
            };
        };
        put: {
            req: FormsUpdateData;
            res: {
                200: TForm;
            };
        };
        patch: {
            req: FormsPartialUpdateData;
            res: {
                200: TForm;
            };
        };
        delete: {
            req: FormsDestroyData;
            res: {
                200: TForm;
            };
        };
    };
    '/api/v3/hubspot/companies/': {
        get: {
            req: HubspotCompaniesListData;
            res: {
                200: PaginatedSuperUserHubSpotCompanyList;
            };
        };
        post: {
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
    };
    '/api/v3/hubspot/companies/{uuid}/': {
        get: {
            req: HubspotCompaniesRetrieveData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        put: {
            req: HubspotCompaniesUpdateData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        patch: {
            req: HubspotCompaniesPartialUpdateData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        delete: {
            req: HubspotCompaniesDestroyData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
    };
    '/api/v3/hubspot/contacts/': {
        get: {
            req: HubspotContactsListData;
            res: {
                200: PaginatedSuperUserHubSpotContactList;
            };
        };
        post: {
            res: {
                200: SuperUserHubSpotContact;
            };
        };
    };
    '/api/v3/hubspot/contacts/{uuid}/': {
        get: {
            req: HubspotContactsRetrieveData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        put: {
            req: HubspotContactsUpdateData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        patch: {
            req: HubspotContactsPartialUpdateData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        delete: {
            req: HubspotContactsDestroyData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
    };
    '/api/v3/inbound_emails/': {
        get: {
            req: InboundEmailsListData;
            res: {
                200: PaginatedTInboundEmailList;
            };
        };
        post: {
            req: InboundEmailsCreateData;
            res: {
                200: TInboundEmail;
            };
        };
    };
    '/api/v3/inbound_emails/{uuid}/': {
        get: {
            req: InboundEmailsRetrieveData;
            res: {
                200: TInboundEmail;
            };
        };
        put: {
            req: InboundEmailsUpdateData;
            res: {
                200: TInboundEmail;
            };
        };
        patch: {
            req: InboundEmailsPartialUpdateData;
            res: {
                200: TInboundEmail;
            };
        };
        delete: {
            req: InboundEmailsDestroyData;
            res: {
                200: TInboundEmail;
            };
        };
    };
    '/api/v3/inbound_emails/{uuid}/create_case/': {
        post: {
            req: InboundEmailsCreateCaseCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/jurnodes/law-categories/': {
        get: {
            res: {
                200: Array<JurnodesLawCategory>;
            };
        };
    };
    '/api/v3/jurnodes/record-schemas/': {
        get: {
            res: {
                200: Array<JurnodesRecordSchema>;
            };
        };
    };
    '/api/v3/jurnodes/users/': {
        get: {
            res: {
                200: Array<JurnodesUser>;
            };
        };
    };
    '/api/v3/kleos/case-types/': {
        get: {
            res: {
                200: KleosCaseTypes;
            };
        };
    };
    '/api/v3/law_fields/': {
        get: {
            res: {
                200: LawFields;
            };
        };
    };
    '/api/v3/organisations/': {
        get: {
            req: OrganisationsListData;
            res: {
                200: PaginatedTOrganisationList;
            };
        };
        post: {
            req: OrganisationsCreateData;
            res: {
                200: TOrganisation;
            };
        };
    };
    '/api/v3/organisations/{uuid}/': {
        get: {
            req: OrganisationsRetrieveData;
            res: {
                200: TOrganisation;
            };
        };
        put: {
            req: OrganisationsUpdateData;
            res: {
                200: TOrganisation;
            };
        };
        patch: {
            req: OrganisationsPartialUpdateData;
            res: {
                200: TOrganisation;
            };
        };
        delete: {
            req: OrganisationsDestroyData;
            res: {
                200: TOrganisation;
            };
        };
    };
    '/api/v3/phone_numbers/': {
        get: {
            req: PhoneNumbersListData;
            res: {
                200: PaginatedTPhoneNumberList;
            };
        };
        post: {
            req: PhoneNumbersCreateData;
            res: {
                200: TPhoneNumber;
            };
        };
    };
    '/api/v3/phone_numbers/{uuid}/': {
        get: {
            req: PhoneNumbersRetrieveData;
            res: {
                200: TPhoneNumber;
            };
        };
        put: {
            req: PhoneNumbersUpdateData;
            res: {
                200: TPhoneNumber;
            };
        };
        patch: {
            req: PhoneNumbersPartialUpdateData;
            res: {
                200: TPhoneNumber;
            };
        };
        delete: {
            req: PhoneNumbersDestroyData;
            res: {
                200: TPhoneNumber;
            };
        };
    };
    '/api/v3/placeholders': {
        get: {
            res: {
                200: Array<Placeholder>;
            };
        };
    };
    '/api/v3/questionnaire_submissions/': {
        get: {
            req: QuestionnaireSubmissionsListData;
            res: {
                200: PaginatedTQuestionnaireSubmissionList;
            };
        };
        post: {
            req: QuestionnaireSubmissionsCreateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
    };
    '/api/v3/questionnaire_submissions/{uuid}/': {
        get: {
            req: QuestionnaireSubmissionsRetrieveData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        put: {
            req: QuestionnaireSubmissionsUpdateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        patch: {
            req: QuestionnaireSubmissionsPartialUpdateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        delete: {
            req: QuestionnaireSubmissionsDestroyData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
    };
    '/api/v3/questionnaires/': {
        get: {
            req: QuestionnairesListData;
            res: {
                200: PaginatedTQuestionnaireList;
            };
        };
        post: {
            req: QuestionnairesCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/': {
        get: {
            req: QuestionnairesRetrieveData;
            res: {
                200: TQuestionnaire;
            };
        };
        put: {
            req: QuestionnairesUpdateData;
            res: {
                200: TQuestionnaire;
            };
        };
        patch: {
            req: QuestionnairesPartialUpdateData;
            res: {
                200: TQuestionnaire;
            };
        };
        delete: {
            req: QuestionnairesDestroyData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/copy/': {
        post: {
            req: QuestionnairesCopyCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/generate/': {
        post: {
            req: QuestionnairesGenerateCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/retell_agents/': {
        get: {
            req: RetellAgentsListData;
            res: {
                200: PaginatedTRetellAgentList;
            };
        };
        post: {
            req: RetellAgentsCreateData;
            res: {
                200: TRetellAgent;
            };
        };
    };
    '/api/v3/retell_agents/{uuid}/': {
        get: {
            req: RetellAgentsRetrieveData;
            res: {
                200: TRetellAgent;
            };
        };
        put: {
            req: RetellAgentsUpdateData;
            res: {
                200: TRetellAgent;
            };
        };
        patch: {
            req: RetellAgentsPartialUpdateData;
            res: {
                200: TRetellAgent;
            };
        };
        delete: {
            req: RetellAgentsDestroyData;
            res: {
                200: TRetellAgent;
            };
        };
    };
    '/api/v3/services/': {
        get: {
            req: ServicesListData;
            res: {
                200: PaginatedTServiceList;
            };
        };
        post: {
            req: ServicesCreateData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/services/{uuid}/': {
        get: {
            req: ServicesRetrieveData;
            res: {
                200: TService;
            };
        };
        put: {
            req: ServicesUpdateData;
            res: {
                200: TService;
            };
        };
        patch: {
            req: ServicesPartialUpdateData;
            res: {
                200: TService;
            };
        };
        delete: {
            req: ServicesDestroyData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/services/{uuid}/{calendar_slug}/availabilities/': {
        post: {
            req: ServicesAvailabilitiesCreateData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/stripe_customers/': {
        get: {
            req: StripeCustomersListData;
            res: {
                200: PaginatedTStripeCustomerList;
            };
        };
        post: {
            req: StripeCustomersCreateData;
            res: {
                200: TStripeCustomer;
            };
        };
    };
    '/api/v3/stripe_customers/{uuid}/': {
        get: {
            req: StripeCustomersRetrieveData;
            res: {
                200: TStripeCustomer;
            };
        };
        put: {
            req: StripeCustomersUpdateData;
            res: {
                200: TStripeCustomer;
            };
        };
        patch: {
            req: StripeCustomersPartialUpdateData;
            res: {
                200: TStripeCustomer;
            };
        };
        delete: {
            req: StripeCustomersDestroyData;
            res: {
                200: TStripeCustomer;
            };
        };
    };
    '/api/v3/stripe_invoices/': {
        get: {
            req: StripeInvoicesListData;
            res: {
                200: PaginatedTStripeInvoiceList;
            };
        };
        post: {
            req: StripeInvoicesCreateData;
            res: {
                200: TStripeInvoice;
            };
        };
    };
    '/api/v3/stripe_invoices/{uuid}/': {
        get: {
            req: StripeInvoicesRetrieveData;
            res: {
                200: TStripeInvoice;
            };
        };
        put: {
            req: StripeInvoicesUpdateData;
            res: {
                200: TStripeInvoice;
            };
        };
        patch: {
            req: StripeInvoicesPartialUpdateData;
            res: {
                200: TStripeInvoice;
            };
        };
        delete: {
            req: StripeInvoicesDestroyData;
            res: {
                200: TStripeInvoice;
            };
        };
    };
    '/api/v3/stripe_invoices/export/': {
        post: {
            req: StripeInvoicesExportCreateData;
            res: {
                200: StripeInvoiceExportResponse;
            };
        };
    };
    '/api/v3/users/': {
        get: {
            req: UsersListData;
            res: {
                200: PaginatedTUserList;
            };
        };
        post: {
            req: UsersCreateData;
            res: {
                200: TUser;
            };
        };
    };
    '/api/v3/users/{uuid}/': {
        get: {
            req: UsersRetrieveData;
            res: {
                200: TUser;
            };
        };
        put: {
            req: UsersUpdateData;
            res: {
                200: TUser;
            };
        };
        patch: {
            req: UsersPartialUpdateData;
            res: {
                200: TUser;
            };
        };
        delete: {
            req: UsersDestroyData;
            res: {
                200: TUser;
            };
        };
    };
    '/api/v3/word_document_templates/': {
        get: {
            req: WordDocumentTemplatesListData;
            res: {
                200: PaginatedTWordDocumentTemplateList;
            };
        };
        post: {
            req: WordDocumentTemplatesCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/': {
        get: {
            req: WordDocumentTemplatesRetrieveData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        put: {
            req: WordDocumentTemplatesUpdateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        patch: {
            req: WordDocumentTemplatesPartialUpdateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        delete: {
            req: WordDocumentTemplatesDestroyData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/copy/': {
        post: {
            req: WordDocumentTemplatesCopyCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/create_word_document_preview_blob/': {
        post: {
            req: WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData;
            res: {
                200: (Blob | File);
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/create_word_document_template_docx_with_placeholders/': {
        post: {
            req: WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData;
            res: {
                200: (Blob | File);
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/delete_document/': {
        post: {
            req: WordDocumentTemplatesDeleteDocumentCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
};